var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/components/Icons/index.tsx
var Icons_exports = {};
__export(Icons_exports, {
  AddAssignee: () => AddAssignee_default,
  Addition: () => Addition_default,
  Alert: () => Alert_default,
  ArrowDown: () => ArrowDown_default,
  ArrowLeft: () => ArrowLeft_default,
  ArrowRight: () => ArrowRight_default,
  Assignee: () => Assignee_default,
  Calendar: () => Calendar_default,
  Chat: () => Chat_default,
  Clear: () => Clear_default,
  Clip: () => Clip_default,
  Clock: () => Clock_default,
  Close: () => Close_default,
  Copy: () => Copy_default,
  Description: () => Description_default,
  Document: () => Document_default,
  DoubleArrow: () => DoubleArrow_default,
  Edit: () => Edit_default,
  Id: () => Id_default,
  Link: () => Link_default,
  Lock: () => Lock_default,
  Mail: () => Mail_default,
  MarkAsDone: () => MarkAsDone_default,
  Minus: () => Minus_default,
  Phone: () => Phone_default,
  Plus: () => Plus_default,
  Popout: () => Popout_default,
  QuestionMarkOutline: () => QuestionMarkOutline_default,
  Questionmark: () => Questionmark_default,
  Revert: () => Revert_default,
  RoundPlus: () => RoundPlus_default,
  RoundedPlus: () => RoundedPlus_default,
  Search: () => Search_default,
  Spinner: () => Spinner_default,
  Star: () => Star_default,
  Tag: () => Tag_default,
  Tick: () => Tick_default,
  Trash: () => Trash_default,
  X: () => X_default
});

// src/components/Icons/Base.tsx
import styled2 from "styled-components";
import { style as style2 } from "styled-system";

// src/components/View.tsx
import React2 from "react";
import styled from "styled-components";

// src/utils/styledSystem.ts
import {
  space,
  color,
  typography,
  layout,
  flexbox,
  grid,
  background,
  border,
  position,
  shadow,
  style,
  compose
} from "styled-system";

// src/utils/pseudoStyles.ts
import css from "@styled-system/css";
var hover = "&:hover";
var active = "&:active, &[data-active=true]";
var focus = "&:focus";
var visited = "&:visited";
var even = "&:nth-of-type(even)";
var odd = "&:nth-of-type(odd)";
var disabled = "&:disabled, &:disabled:focus, &:disabled:hover, &[aria-disabled=true], &[aria-disabled=true]:focus, &[aria-disabled=true]:hover";
var checked = "&[aria-checked=true]";
var mixed = "&[aria-checked=mixed]";
var selected = "&[aria-selected=true]";
var invalid = "&[aria-invalid=true]";
var pressed = "&[aria-pressed=true]";
var readOnly = "&[aria-readonly=true], &[readonly]";
var first = "&:first-of-type";
var last = "&:last-of-type";
var expanded = "&[aria-expanded=true]";
var grabbed = "&[aria-grabbed=true]";
var notFirst = "&:not(:first-of-type)";
var notLast = "&:not(:last-of-type)";
var groupHover = "[role=group]:hover &";
function pseudoStyles({
  _after,
  _focus,
  _selected,
  _focusWithin,
  _hover,
  _invalid,
  _active,
  _disabled,
  _grabbed,
  _pressed,
  _expanded,
  _visited,
  _before,
  _readOnly,
  _first,
  _notFirst,
  _notLast,
  _last,
  _placeholder,
  _checked,
  _groupHover,
  _mixed,
  _odd,
  _even,
  theme: theme2
}) {
  return css({
    [hover]: _hover,
    [focus]: _focus,
    [active]: _active,
    [visited]: _visited,
    [disabled]: _disabled,
    [selected]: _selected,
    [invalid]: _invalid,
    [expanded]: _expanded,
    [grabbed]: _grabbed,
    [readOnly]: _readOnly,
    [first]: _first,
    [notFirst]: _notFirst,
    [notLast]: _notLast,
    [last]: _last,
    [odd]: _odd,
    [even]: _even,
    [mixed]: _mixed,
    [checked]: _checked,
    [pressed]: _pressed,
    [groupHover]: _groupHover,
    "&:before": _before,
    "&:after": _after,
    "&:focus-within": _focusWithin,
    "&::placeholder": _placeholder
  })({ theme: theme2 });
}
var pseudoStyles_default = pseudoStyles;

// src/utils/styledSystem.ts
var cursor = style({
  prop: "cursor",
  cssProperty: "cursor"
});
var transform = style({
  prop: "transform"
});
var transition = style({
  prop: "transition"
});
var boxSizing = style({
  prop: "boxSizing"
});
var filter = style({
  prop: "filter"
});
var visibility = style({
  prop: "visibility"
});
var whiteSpace = style({
  prop: "whiteSpace"
});
var textOverflow = style({
  prop: "textOverflow"
});
var systemStyles = compose(
  // styled-system
  space,
  color,
  typography,
  layout,
  flexbox,
  grid,
  background,
  border,
  position,
  shadow,
  // custom
  cursor,
  transform,
  transition,
  boxSizing,
  filter,
  visibility,
  whiteSpace,
  textOverflow
);
var styledSystem = (props) => ({
  ...systemStyles(props),
  ...pseudoStyles_default(props)
});
var styledSystem_default = styledSystem;

// src/utils/CleanTag/index.ts
import React from "react";

// src/utils/CleanTag/scarfProps.js
import propTypes from "@styled-system/prop-types";
var allPropTypes = Object.keys(propTypes).reduce(
  (a, key) => Object.assign(a, propTypes[key]),
  {}
);
var styledSystemProps = Object.keys(allPropTypes);
var customProps = [
  "theme",
  "blacklist",
  "isPreviousActive",
  "isFocused",
  "isOpen",
  "spinning",
  "active",
  "alignPopupToTop",
  "outline",
  "horizontal",
  "index",
  "gap",
  "light",
  "strokeWidth",
  "fill",
  "loading",
  "cursor",
  "transform",
  "transition",
  "boxSizing",
  "focus",
  "sizeVariant",
  "small",
  "templateColumns",
  "_after",
  "_focus",
  "_selected",
  "_focusWithin",
  "_hover",
  "_invalid",
  "_active",
  "_disabled",
  "_grabbed",
  "_pressed",
  "_expanded",
  "_visited",
  "_before",
  "_readOnly",
  "_first",
  "_notFirst",
  "_notLast",
  "_last",
  "_placeholder",
  "_checked",
  "_groupHover",
  "_mixed",
  "_odd",
  "_even",
  "whiteSpace",
  "textOverflow"
];
var scarfProps = [...styledSystemProps, ...customProps];
var scarfProps_default = scarfProps;

// src/utils/CleanTag/index.ts
var omit = (obj, keys) => {
  const next = {};
  for (const key in obj) {
    if (keys.indexOf(key) > -1)
      continue;
    next[key] = obj[key];
  }
  return next;
};
var CleanTag = React.forwardRef(
  ({ as: component, omitProps = [], ...props }, ref) => {
    const Component17 = component || "div";
    const safeOmitProps = Array.isArray(omitProps) ? omitProps : [];
    return React.createElement(Component17, {
      ref,
      ...omit(props, [...scarfProps_default, ...safeOmitProps])
    });
  }
);
CleanTag.displayName = "CleanTag";
var CleanTag_default = CleanTag;

// src/components/View.tsx
import { jsx } from "react/jsx-runtime";
var Wrapper = React2.forwardRef(
  ({ forwardedAs, ...rest }, ref) => /* @__PURE__ */ jsx(CleanTag_default, { ref, as: forwardedAs, ...rest })
);
var View = styled(CleanTag_default).attrs(
  ({ as, ...rest }) => as ? {
    ...rest,
    as: Wrapper,
    forwardedAs: as
  } : {}
)(({ boxSizing: boxSizing2 = "border-box", ...rest }) => {
  const props = { boxSizing: boxSizing2, ...rest };
  return styledSystem_default(props);
});
var View_default = View;

// src/components/Icons/Base.tsx
var fill = style2({
  prop: "fill",
  cssProperty: "fill",
  key: "colors"
});
var stroke = style2({
  prop: "stroke",
  cssProperty: "stroke",
  key: "colors"
});
var Svg = styled2(View_default)`
  ${fill};
`;
Svg.defaultProps = {
  as: "svg",
  fill: "default.primary",
  width: "22px",
  height: "22px",
  viewBox: "0 0 22 22",
  flex: "0 0 auto",
  display: "inherit"
};
var Path = styled2("path")`
  ${stroke};
  ${fill}
`;
Path.defaultProps = {
  stroke: "default.primary",
  fill: "default.primary"
};
var G = styled2("g")`
  ${stroke}
  ${fill}
`;
G.defaultProps = {
  stroke: "default.primary",
  fill: "default.primary"
};
var Circle = styled2("circle")`
  ${fill}
  ${stroke}
`;
Circle.defaultProps = {
  fill: "default.primary",
  stroke: "default.primary"
};
var Rect = styled2("rect")`
  ${fill}
`;
Rect.defaultProps = {
  fill: "default.primary"
};
var Base_default = Svg;

// src/components/Icons/AddAssignee.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
function AddAssignee({ fill: fill2, ...props }) {
  return /* @__PURE__ */ jsx2(Base_default, { ...props, children: /* @__PURE__ */ jsxs(
    G,
    {
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: fill2,
      children: [
        /* @__PURE__ */ jsx2("path", { d: "M11.814 15.027v-1.01c0-1.114-.933-2.017-2.083-2.017H6.084C4.933 12 4 12.903 4 14.018v1.009" }),
        /* @__PURE__ */ jsx2("circle", { cx: 7.907, cy: 8.783, r: 1.783 }),
        /* @__PURE__ */ jsx2("path", { d: "M15.493 9v4.755M17.871 11.377h-4.755" })
      ]
    }
  ) });
}
var AddAssignee_default = AddAssignee;

// src/components/Icons/Alert.tsx
import styled3 from "styled-components";
import { jsx as jsx3 } from "react/jsx-runtime";
var Alert = (props) => /* @__PURE__ */ jsx3(Base_default, { ...props, children: /* @__PURE__ */ jsx3("g", { children: /* @__PURE__ */ jsx3("path", { d: "M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-13a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1zm0 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" }) }) });
var Alert_default = styled3(Alert)``;

// src/components/Icons/ArrowDown.tsx
import styled4 from "styled-components";
import { jsx as jsx4 } from "react/jsx-runtime";
var ArrowDown = ({ ...rest }) => /* @__PURE__ */ jsx4(Base_default, { ...rest, children: /* @__PURE__ */ jsx4("g", { children: /* @__PURE__ */ jsx4("path", { d: "M10.383 14.704L5.3 9.474a.938.938 0 0 1 0-1.305l.845-.869a.876.876 0 0 1 1.267 0l3.604 3.708L14.619 7.3a.876.876 0 0 1 1.267 0l.845.87a.938.938 0 0 1 0 1.303l-5.084 5.23a.872.872 0 0 1-1.264 0z" }) }) });
var ArrowDown_default = styled4(ArrowDown)``;

// src/components/Icons/ArrowLeft.tsx
import styled5 from "styled-components";
import { jsx as jsx5 } from "react/jsx-runtime";
var ArrowLeft = (props) => /* @__PURE__ */ jsx5(Base_default, { ...props, children: /* @__PURE__ */ jsx5("g", { children: /* @__PURE__ */ jsx5(
  "path",
  {
    d: "M9.38317757,14.7038462 L4.29906542,9.47307692 C3.94766355,9.11153846 3.94766355,8.52692308 4.29906542,8.16923077 L5.14392523,7.3 C5.4953271,6.93846154 6.0635514,6.93846154 6.41121495,7.3 L10.0149533,11.0076923 L13.6186916,7.3 C13.9700935,6.93846154 14.5383178,6.93846154 14.8859813,7.3 L15.7308411,8.16923077 C16.082243,8.53076923 16.082243,9.11538462 15.7308411,9.47307692 L10.646729,14.7038462 C10.3028037,15.0653846 9.73457944,15.0653846 9.38317757,14.7038462 Z",
    id: "path-1",
    transform: "translate(10.014953, 11.001923) rotate(90.000000) translate(-10.014953, -11.001923)"
  }
) }) });
var ArrowLeft_default = styled5(ArrowLeft)``;

// src/components/Icons/ArrowRight.tsx
import styled6 from "styled-components";
import { jsx as jsx6 } from "react/jsx-runtime";
var ArrowRight = (props) => /* @__PURE__ */ jsx6(Base_default, { ...props, children: /* @__PURE__ */ jsx6("g", { children: /* @__PURE__ */ jsx6(
  "path",
  {
    d: "M9.38317757,14.7038462 L4.29906542,9.47307692 C3.94766355,9.11153846 3.94766355,8.52692308 4.29906542,8.16923077 L5.14392523,7.3 C5.4953271,6.93846154 6.0635514,6.93846154 6.41121495,7.3 L10.0149533,11.0076923 L13.6186916,7.3 C13.9700935,6.93846154 14.5383178,6.93846154 14.8859813,7.3 L15.7308411,8.16923077 C16.082243,8.53076923 16.082243,9.11538462 15.7308411,9.47307692 L10.646729,14.7038462 C10.3028037,15.0653846 9.73457944,15.0653846 9.38317757,14.7038462 Z",
    id: "path-1",
    transform: "translate(10.014953, 11.001923) rotate(-90.000000) translate(-10.014953, -11.001923)"
  }
) }) });
var ArrowRight_default = styled6(ArrowRight)``;

// src/components/Icons/Assignee.tsx
import { jsx as jsx7, jsxs as jsxs2 } from "react/jsx-runtime";
function Assignee({ fill: fill2, ...props }) {
  return /* @__PURE__ */ jsx7(Base_default, { ...props, children: /* @__PURE__ */ jsxs2(
    G,
    {
      fill: "none",
      fillRule: "evenodd",
      stroke: fill2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transform: "translate(0 .5)",
      children: [
        /* @__PURE__ */ jsx7("path", { d: "M15.907 16.013V14.68a2.667 2.667 0 00-2.667-2.667H8.574a2.667 2.667 0 00-2.667 2.667v1.333" }),
        /* @__PURE__ */ jsx7("circle", { cx: 10.907, cy: 8.013, r: 2 })
      ]
    }
  ) });
}
var Assignee_default = Assignee;

// src/components/Icons/Calendar.tsx
import { jsx as jsx8, jsxs as jsxs3 } from "react/jsx-runtime";
function Calendar({ fill: fill2, ...props }) {
  return /* @__PURE__ */ jsx8(Base_default, { ...props, children: /* @__PURE__ */ jsxs3(
    G,
    {
      transform: "translate(5.5 5.5)",
      stroke: fill2,
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx8("rect", { y: 1.1, width: 11, height: 9.9, rx: 2 }),
        /* @__PURE__ */ jsx8("path", { d: "M8.25 0v3.3M2.75 0v3.3M0 3.85h11" })
      ]
    }
  ) });
}
var Calendar_default = Calendar;

// src/components/Icons/Chat.tsx
import { jsx as jsx9, jsxs as jsxs4 } from "react/jsx-runtime";
function Chat({ fill: fill2, ...rest }) {
  return /* @__PURE__ */ jsx9(Base_default, { viewBox: "0 0 25 24", ...rest, children: /* @__PURE__ */ jsxs4("g", { transform: "translate(.5)", fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ jsx9(
      Path,
      {
        fill: "none",
        stroke: fill2,
        d: "M6.24 16.404c.123.112.161.29.095.442-.1.238-.183.48-.305.709-.295.549-.738.96-1.184 1.372-.205.195-.422.39-.613.598-.19.208-.142.3.122.368.686.175 1.371.112 2.05-.02 1.28-.252 2.497-.743 3.68-1.303.134-.07.288-.094.437-.07a8.712 8.712 0 003.442-.095c2.126-.511 3.85-1.646 5.037-3.57a6.503 6.503 0 00.9-4.593c-.33-1.984-1.374-3.513-2.942-4.641A8.231 8.231 0 0012.096 4c-.416.028-.836.03-1.248.088-1.788.246-3.38.96-4.695 2.249-1.234 1.213-1.992 2.682-2.13 4.46a6.653 6.653 0 001.292 4.53c.29.375.598.734.926 1.077h0z"
      }
    ),
    /* @__PURE__ */ jsx9(
      Path,
      {
        stroke: "none",
        fill: fill2,
        d: "M9.3 10.6a1 1 0 110 2 1 1 0 010-2zm3 0a1 1 0 110 2 1 1 0 010-2zm3 0a1 1 0 110 2 1 1 0 010-2z"
      }
    )
  ] }) });
}
var Chat_default = Chat;

// src/components/Icons/Clip.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
function Clip({ fill: fill2, ...props }) {
  return /* @__PURE__ */ jsx10(Base_default, { width: 22, height: 23, viewBox: "0 0 22 23", ...props, children: /* @__PURE__ */ jsx10(
    Path,
    {
      fill: "none",
      stroke: fill2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M16 11.188l-4.728 4.459c-1.206 1.137-3.161 1.137-4.367 0a2.797 2.797 0 010-4.12l4.727-4.458a2.147 2.147 0 012.912 0 1.865 1.865 0 010 2.746l-4.733 4.459a1.074 1.074 0 01-1.456 0 .932.932 0 010-1.373l4.368-4.115"
    }
  ) });
}
var Clip_default = Clip;

// src/components/Icons/Clock.tsx
import { jsx as jsx11, jsxs as jsxs5 } from "react/jsx-runtime";
function Clock({ fill: fill2, ...props }) {
  return /* @__PURE__ */ jsx11(Base_default, { ...props, children: /* @__PURE__ */ jsxs5(
    G,
    {
      fill: "none",
      fillRule: "evenodd",
      stroke: fill2,
      transform: "translate(4.5 5)",
      children: [
        /* @__PURE__ */ jsx11("circle", { cx: 6.5, cy: 6.5, r: 6 }),
        /* @__PURE__ */ jsx11(
          "path",
          {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6.5 3.449v3.265l2.66 2.482"
          }
        )
      ]
    }
  ) });
}
var Clock_default = Clock;

// src/components/Icons/Close.tsx
import styled7 from "styled-components";
import { jsx as jsx12 } from "react/jsx-runtime";
var Close = ({ fill: fill2, ...props }) => /* @__PURE__ */ jsx12(Base_default, { ...props, children: /* @__PURE__ */ jsx12(G, { stroke: fill2, children: /* @__PURE__ */ jsx12("path", { d: "M14.536 7.464L7.464 14.536M14.536 14.536L7.464 7.464" }) }) });
var Close_default = styled7(Close)``;

// src/components/Icons/Description.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
function Description({ fill: fill2, ...props }) {
  return /* @__PURE__ */ jsx13(Base_default, { ...props, children: /* @__PURE__ */ jsx13(
    G,
    {
      stroke: fill2,
      strokeWidth: 1.5,
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      children: /* @__PURE__ */ jsx13("path", { d: "M4.53 5.824h13.587M4.53 12.294H16.31M4.53 15.529H11M4.53 9.059h9.9" })
    }
  ) });
}
var Description_default = Description;

// src/components/Icons/Document.tsx
import { jsx as jsx14, jsxs as jsxs6 } from "react/jsx-runtime";
function Document({ fill: fill2, ...props }) {
  return /* @__PURE__ */ jsx14(Base_default, { viewBox: "0 0 25 24", ...props, children: /* @__PURE__ */ jsx14("g", { fill: "none", fillRule: "evenodd", transform: "translate(-.674)", children: /* @__PURE__ */ jsxs6(G, { stroke: fill2, fill: "none", children: [
    /* @__PURE__ */ jsx14(
      "path",
      {
        strokeWidth: 1.1,
        d: "M5.235 4v16a1 1 0 001 1h12a1 1 0 001-1V7.925a.998.998 0 00-.306-.72l-4.07-3.925a1 1 0 00-.694-.28h-7.93a1 1 0 00-1 1z"
      }
    ),
    /* @__PURE__ */ jsx14(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8.231 6.913h4.004m-4.004 3.375h7.823m-7.823 3.375h7.823m-7.823 3.375h7.823"
      }
    ),
    /* @__PURE__ */ jsx14("path", { strokeWidth: 1.1, d: "M14.568 3v3.54c0 .551.448 1 1 1h3.667" })
  ] }) }) });
}
var Document_default = Document;

// src/components/Icons/DoubleArrow.tsx
import styled8 from "styled-components";
import { jsx as jsx15 } from "react/jsx-runtime";
var DoubleArrow = (props) => /* @__PURE__ */ jsx15(Base_default, { ...props, children: /* @__PURE__ */ jsx15("g", { children: /* @__PURE__ */ jsx15("path", { d: "M11.654 16.727a1 1 0 0 1-1.31 0L7.314 14.1A.908.908 0 0 1 7 13.415c0-.23.186-.415.415-.415h7.172c.228 0 .413.185.413.413a.905.905 0 0 1-.312.684l-3.034 2.63zm0-11.454l3.034 2.63a.905.905 0 0 1 .312.684.413.413 0 0 1-.413.413H7.415A.415.415 0 0 1 7 8.585c0-.263.114-.513.313-.686l3.03-2.626a1 1 0 0 1 1.31 0z" }) }) });
var DoubleArrow_default = styled8(DoubleArrow)``;

// src/components/Icons/Id.tsx
import { jsx as jsx16, jsxs as jsxs7 } from "react/jsx-runtime";
function Id({ fill: fill2, bg = "#FFF", ...props }) {
  return /* @__PURE__ */ jsx16(Base_default, { ...props, children: /* @__PURE__ */ jsxs7("g", { transform: "translate(5 5)", fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ jsx16(Rect, { fill: fill2, width: 12, height: 12, rx: 4 }),
    /* @__PURE__ */ jsx16(
      Path,
      {
        d: "M8.727 9.069L6 7.599l-2.727 1.47v-5.45c0-.46.349-.833.779-.833h3.896c.43 0 .78.373.78.833v5.45z",
        fill: bg,
        stroke: "none"
      }
    )
  ] }) });
}
var Id_default = Id;

// src/components/Icons/Link.tsx
import { jsx as jsx17, jsxs as jsxs8 } from "react/jsx-runtime";
function Link({ fill: fill2, ...props }) {
  return /* @__PURE__ */ jsx17(Base_default, { ...props, children: /* @__PURE__ */ jsxs8(
    G,
    {
      stroke: fill2,
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx17("path", { d: "M9.917 11.824a3.135 3.135 0 002.315 1.334c.919.07 1.82-.285 2.472-.973l1.905-2.01c1.203-1.313 1.186-3.402-.039-4.694a3.058 3.058 0 00-4.45-.04l-1.092 1.145" }),
        /* @__PURE__ */ jsx17("path", { d: "M12.083 10.176a3.135 3.135 0 00-2.315-1.334 3.083 3.083 0 00-2.472.973l-1.905 2.01c-1.203 1.313-1.186 3.402.039 4.694a3.058 3.058 0 004.45.04l1.086-1.145" })
      ]
    }
  ) });
}
var Link_default = Link;

// src/components/Icons/Lock.tsx
import styled9 from "styled-components";
import { jsx as jsx18 } from "react/jsx-runtime";
var Lock = (props) => /* @__PURE__ */ jsx18(Base_default, { ...props, children: /* @__PURE__ */ jsx18("g", { children: /* @__PURE__ */ jsx18("path", { d: "M16.5 10.5h-.75V7.75A4.756 4.756 0 0 0 11 3a4.756 4.756 0 0 0-4.75 4.75v2.75H5.5A1.5 1.5 0 0 0 4 12v5.5A1.5 1.5 0 0 0 5.5 19h11a1.5 1.5 0 0 0 1.5-1.5V12a1.5 1.5 0 0 0-1.5-1.5zm-3.25 0h-4.5V7.75C8.75 6.51 9.76 5.5 11 5.5s2.25 1.01 2.25 2.25v2.75z" }) }) });
var Lock_default = styled9(Lock)``;

// src/components/Icons/Mail.tsx
import { jsx as jsx19 } from "react/jsx-runtime";
function Mail({ fill: fill2, ...rest }) {
  return /* @__PURE__ */ jsx19(Base_default, { viewBox: "0 0 25 24", ...rest, children: /* @__PURE__ */ jsx19("g", { transform: "translate(.5)", fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ jsx19(
    Path,
    {
      stroke: "none",
      fill: fill2,
      d: "M18.429 6H5.57C4.151 6 3 7.075 3 8.4v7.2C3 16.925 4.151 18 5.571 18H18.43c1.419 0 2.57-1.075 2.57-2.4V8.4C21 7.075 19.849 6 18.429 6zm0 1.2c.265.001.523.079.739.222l-6.429 4.014a1.363 1.363 0 01-1.427 0L4.884 7.422c.201-.134.44-.211.687-.222H18.43zm-7.856 5.232c.864.538 1.99.538 2.854 0l.392-.246L18.21 16.8H5.79l4.39-4.614.393.246zM4.286 8.52l4.815 3-4.565 4.8a1.148 1.148 0 01-.25-.72V8.52zm15.178 7.8l-4.565-4.8 4.815-3v7.08c0 .255-.088.503-.25.708v.012z"
    }
  ) }) });
}
var Mail_default = Mail;

// src/components/Icons/MarkAsDone.tsx
import { jsx as jsx20, jsxs as jsxs9 } from "react/jsx-runtime";
function MarkAsDone({ fill: fill2, ...props }) {
  return /* @__PURE__ */ jsx20(Base_default, { ...props, children: /* @__PURE__ */ jsxs9(
    G,
    {
      transform: "translate(4.5 4.5)",
      stroke: fill2,
      fill: "none",
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx20("circle", { cx: 6.5, cy: 6.5, r: 6 }),
        /* @__PURE__ */ jsx20(
          "path",
          {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4.063 6.806l1.969 1.725L8.937 4.47"
          }
        )
      ]
    }
  ) });
}
var MarkAsDone_default = MarkAsDone;

// src/components/Icons/Minus.tsx
import styled10 from "styled-components";
import { jsx as jsx21 } from "react/jsx-runtime";
var Minus = ({ ...rest }) => /* @__PURE__ */ jsx21(Base_default, { viewBox: "0 0 24 24", ...rest, children: /* @__PURE__ */ jsx21("g", { children: /* @__PURE__ */ jsx21(
  "path",
  {
    id: "a",
    d: "M6.167 10.833h11.666a1.167 1.167 0 0 1 0 2.334H6.167a1.167 1.167 0 0 1 0-2.334z"
  }
) }) });
var Minus_default = styled10(Minus)``;

// src/components/Icons/Phone.tsx
import { jsx as jsx22 } from "react/jsx-runtime";
function Phone({ fill: fill2, ...rest }) {
  return /* @__PURE__ */ jsx22(Base_default, { ...rest, viewBox: "0 0 25 24", children: /* @__PURE__ */ jsx22(
    "g",
    {
      transform: "translate(.5)",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: /* @__PURE__ */ jsx22(
        Path,
        {
          fill: "none",
          stroke: fill2,
          strokeWidth: 1.5,
          d: "M18.545 15.256v1.97a1.312 1.312 0 01-1.435 1.314c-2.025-.22-3.97-.91-5.68-2.017a12.828 12.828 0 01-3.95-3.941 12.989 12.989 0 01-2.02-5.695 1.312 1.312 0 011.309-1.432h1.975a1.316 1.316 0 011.317 1.13c.083.63.238 1.25.46 1.845a1.31 1.31 0 01-.296 1.386l-.836.835a10.524 10.524 0 003.95 3.941l.836-.834a1.32 1.32 0 011.388-.296 8.435 8.435 0 001.85.46 1.314 1.314 0 011.132 1.334z"
        }
      )
    }
  ) });
}
var Phone_default = Phone;

// src/components/Icons/Plus.tsx
import styled11 from "styled-components";
import { jsx as jsx23, jsxs as jsxs10 } from "react/jsx-runtime";
var Plus = ({ fill: fill2, light, ...props }) => light ? /* @__PURE__ */ jsx23(Base_default, { ...props, children: /* @__PURE__ */ jsx23(
  Path,
  {
    fill: fill2,
    d: "M10.833 10.833V6.167a1.167 1.167 0 0 1 2.334 0v4.666h4.666a1.167 1.167 0 0 1 0 2.334h-4.666v4.666a1.167 1.167 0 0 1-2.334 0v-4.666H6.167a1.167 1.167 0 0 1 0-2.334h4.666z"
  }
) }) : /* @__PURE__ */ jsxs10(Base_default, { fill: fill2, ...props, fillRule: "evenodd", viewBox: "0 0 24 24", children: [
  /* @__PURE__ */ jsx23("rect", { width: "24", height: "24", rx: "12" }),
  /* @__PURE__ */ jsx23(
    "path",
    {
      fill: "#FFF",
      d: "M10.833 10.833V6.167a1.167 1.167 0 0 1 2.334 0v4.666h4.666a1.167 1.167 0 0 1 0 2.334h-4.666v4.666a1.167 1.167 0 0 1-2.334 0v-4.666H6.167a1.167 1.167 0 0 1 0-2.334h4.666z"
    }
  )
] });
var Plus_default = styled11(Plus)``;

// src/components/Icons/Popout.tsx
import styled12 from "styled-components";
import { jsx as jsx24, jsxs as jsxs11 } from "react/jsx-runtime";
var Popout = (props) => /* @__PURE__ */ jsx24(Base_default, { ...props, children: /* @__PURE__ */ jsxs11("g", { children: [
  /* @__PURE__ */ jsx24("path", { d: "M6.352 18.782h8.743a3.151 3.151 0 0 0 3.157-3.157v-5.343a.716.716 0 0 0-.729-.729.716.716 0 0 0-.728.729v5.343c0 .947-.754 1.7-1.7 1.7H6.352a1.69 1.69 0 0 1-1.7-1.7V6.882c0-.947.753-1.7 1.7-1.7h5.343a.716.716 0 0 0 .728-.729.716.716 0 0 0-.728-.728H6.352a3.151 3.151 0 0 0-3.157 3.157v8.743a3.151 3.151 0 0 0 3.157 3.157z" }),
  /* @__PURE__ */ jsx24("path", { d: "M19.805 7.391V2.947c0-.049 0-.097-.024-.146 0-.025 0-.049-.025-.049 0-.024-.025-.048-.025-.073 0-.025-.024-.048-.048-.073 0-.025-.025-.048-.025-.048a.73.73 0 0 0-.194-.195l-.048-.024c-.048-.072-.096-.096-.145-.096l-.073-.025c-.048 0-.096-.025-.146-.025l-4.443.001a.716.716 0 0 0-.729.729c0 .413.316.729.729.729h2.696l-6.68 6.702c-.29.291-.29.753 0 1.02.292.29.754.29 1.02 0l6.703-6.679v2.696c0 .413.316.729.73.729.388 0 .704-.34.728-.729z" })
] }) });
var Popout_default = styled12(Popout)``;

// src/components/Icons/Questionmark.tsx
import styled13, { withTheme } from "styled-components";
import get from "lodash.get";
import { jsx as jsx25, jsxs as jsxs12 } from "react/jsx-runtime";
var Questionmark = ({
  fill: fill2 = "default.primary",
  theme: theme2,
  ...rest
}) => /* @__PURE__ */ jsxs12(Base_default, { ...rest, viewBox: "0 0 24 24", children: [
  /* @__PURE__ */ jsxs12("defs", { children: [
    /* @__PURE__ */ jsx25("circle", { id: "questionmark-a", cx: "12", cy: "12", r: "11" }),
    /* @__PURE__ */ jsx25(
      "path",
      {
        id: "questionmark-c",
        d: "M11.086 14.117v-.5c0-.573.104-1.05.312-1.43.209-.38.573-.773 1.094-1.18.62-.489 1.02-.869 1.2-1.14.18-.27.269-.594.269-.969 0-.437-.146-.773-.438-1.007-.291-.235-.71-.352-1.257-.352-.495 0-.953.07-1.375.211-.422.14-.834.31-1.235.508L9 6.883A6.877 6.877 0 0 1 12.398 6c1.021 0 1.831.25 2.43.75.6.5.899 1.19.899 2.07 0 .39-.058.739-.172 1.043a2.993 2.993 0 0 1-.52.871c-.232.276-.631.636-1.2 1.079-.483.38-.808.695-.972.945-.164.25-.246.586-.246 1.008v.351h-1.531zm-.32 2.492c0-.786.382-1.18 1.148-1.18.375 0 .662.104.86.31.197.205.296.495.296.87 0 .37-.1.663-.3.88-.201.215-.486.323-.856.323s-.654-.105-.851-.316c-.198-.21-.297-.506-.297-.887z"
      }
    )
  ] }),
  /* @__PURE__ */ jsxs12("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ jsx25(
      "use",
      {
        fill: "#000",
        filter: "url(#questionmark-b)",
        xlinkHref: "#questionmark-a"
      }
    ),
    /* @__PURE__ */ jsx25("use", { fill: "#F9FAFB", stroke: "#DFE3E8", xlinkHref: "#questionmark-a" }),
    /* @__PURE__ */ jsx25("mask", { id: "questionmark-d", fill: "#fff", children: /* @__PURE__ */ jsx25("use", { xlinkHref: "#questionmark-c" }) }),
    /* @__PURE__ */ jsx25(
      "g",
      {
        fill: get(theme2, `colors.${fill2}`) || fill2,
        mask: "url(#questionmark-d)",
        children: /* @__PURE__ */ jsx25("path", { d: "M0 0h24v24H0z" })
      }
    )
  ] })
] });
var StyledQuestionmark = styled13(withTheme(Questionmark))``;
var Questionmark_default = StyledQuestionmark;

// src/components/Icons/QuestionMarkOutline.tsx
import { jsx as jsx26, jsxs as jsxs13 } from "react/jsx-runtime";
function QuestionMarkOutline({ fill: fill2, ...rest }) {
  return /* @__PURE__ */ jsx26(Base_default, { viewBox: "0 0 25 24", ...rest, children: /* @__PURE__ */ jsxs13("g", { transform: "translate(.5)", fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ jsx26(Circle, { cx: 12, cy: 12, r: 8, stroke: fill2, fill: "none" }),
    /* @__PURE__ */ jsx26(
      Path,
      {
        fill: fill2,
        stroke: "none",
        d: "M12.663 13.883c.008-.61.152-1.073.431-1.39l.781-.768c.643-.669.965-1.348.965-2.038 0-.774-.238-1.377-.714-1.809-.476-.431-1.14-.647-1.99-.647-.825 0-1.489.218-1.99.654-.502.436-.757 1.028-.765 1.777h1.542c0-.351.111-.63.334-.835.222-.205.515-.308.879-.308.38 0 .67.105.866.315.197.21.295.513.295.91 0 .301-.084.58-.254.838-.11.17-.37.454-.783.854-.413.4-.69.767-.829 1.101-.14.335-.21.783-.21 1.346h1.442zm-.68 2.793c.28 0 .496-.078.648-.235a.802.802 0 00.228-.584c0-.24-.078-.44-.234-.6-.157-.158-.37-.238-.642-.238-.266 0-.478.078-.634.232a.814.814 0 00-.235.606.81.81 0 00.225.584c.15.157.365.235.644.235z"
      }
    )
  ] }) });
}
var QuestionMarkOutline_default = QuestionMarkOutline;

// src/components/Icons/Revert.tsx
import { jsx as jsx27, jsxs as jsxs14 } from "react/jsx-runtime";
function Revert({ fill: fill2, ...props }) {
  return /* @__PURE__ */ jsx27(Base_default, { ...props, children: /* @__PURE__ */ jsxs14(G, { fill: "none", fillRule: "evenodd", strokeLinecap: "round", stroke: fill2, children: [
    /* @__PURE__ */ jsx27("path", { d: "M5 9h9a3 3 0 110 6H9.998h0" }),
    /* @__PURE__ */ jsx27("path", { d: "M7.003 7l-2 2 2 2" })
  ] }) });
}
var Revert_default = Revert;

// src/components/Icons/RoundedPlus.tsx
import { jsx as jsx28, jsxs as jsxs15 } from "react/jsx-runtime";
function RoundedPlus({ fill: fill2, ...props }) {
  return /* @__PURE__ */ jsx28(Base_default, { viewBox: "0 0 27 27", ...props, children: /* @__PURE__ */ jsxs15("g", { transform: "translate(1 1)", fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ jsx28("rect", { stroke: "#DFE3E8", fill: "#F9FAFB", width: 25, height: 25, rx: 4 }),
    /* @__PURE__ */ jsx28(
      G,
      {
        stroke: fill2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none",
        children: /* @__PURE__ */ jsx28("path", { d: "M12.844 7.324v10.352M17.656 12.5H7.344" })
      }
    )
  ] }) });
}
var RoundedPlus_default = RoundedPlus;

// src/components/Icons/RoundPlus.tsx
import { jsx as jsx29, jsxs as jsxs16 } from "react/jsx-runtime";
function RoundPlus({
  fill: fill2,
  bg = "sky.3",
  border: border2 = "sky.0",
  ...props
}) {
  return /* @__PURE__ */ jsx29(Base_default, { viewBox: "0 0 27 27", ...props, children: /* @__PURE__ */ jsxs16("g", { transform: "translate(1 1)", fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ jsx29(
      Circle,
      {
        stroke: border2,
        fill: bg,
        cx: 12.5,
        cy: 12.5,
        r: 13
      }
    ),
    /* @__PURE__ */ jsx29(
      G,
      {
        stroke: fill2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none",
        children: /* @__PURE__ */ jsx29("path", { d: "M12.844 7.324v10.352M17.656 12.5H7.344" })
      }
    )
  ] }) });
}
var RoundPlus_default = RoundPlus;

// src/components/Icons/Search.tsx
import { jsx as jsx30 } from "react/jsx-runtime";
function Search({ fill: fill2, ...props }) {
  return /* @__PURE__ */ jsx30(Base_default, { viewBox: "0 0 20 20", ...props, children: /* @__PURE__ */ jsx30(
    G,
    {
      fill: fill2,
      stroke: "none",
      fillRule: "evenodd",
      transform: "translate(2 2)",
      children: /* @__PURE__ */ jsx30("path", { d: "M6.182 9.818a3.637 3.637 0 110-7.274 3.637 3.637 0 010 7.274m8.824 3.903l-4.381-4.382a5.429 5.429 0 001.011-3.157 5.455 5.455 0 10-5.454 5.454 5.429 5.429 0 003.157-1.011l4.382 4.381a.904.904 0 001.285 0 .907.907 0 000-1.285" })
    }
  ) });
}
var Search_default = Search;

// src/components/Icons/Spinner.tsx
import styled14 from "styled-components";
import { jsx as jsx31 } from "react/jsx-runtime";
var Spinner = ({
  fill: fill2 = "default.primary",
  strokeWidth = 9,
  ...rest
}) => /* @__PURE__ */ jsx31(Base_default, { width: "22px", height: "22px", ...rest, viewBox: "0 0 120 120", children: /* @__PURE__ */ jsx31("g", { children: /* @__PURE__ */ jsx31(
  Path,
  {
    fill: "none",
    fillRule: "evenodd",
    stroke: fill2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: "1",
    strokeWidth,
    d: "M60 10c-27.614 0-50 22.386-50 50s22.386 50 50 50 50-22.386 50-50"
  }
) }) });
var AnimatedSpinner = styled14(Spinner)`
  animation-name: ${(p) => p.spinning ? "spin" : "none"};
  animation-duration: 500ms;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.27, 0.54, 0.6, 0.41);

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
var Spinner_default = AnimatedSpinner;

// src/components/Icons/Star.tsx
import { jsx as jsx32 } from "react/jsx-runtime";
function Star({ fill: fill2, active: active2, ...props }) {
  return /* @__PURE__ */ jsx32(Base_default, { ...props, children: !active2 ? /* @__PURE__ */ jsx32(
    Path,
    {
      d: "M10.785 5.418L8.714 9.145 4.56 9.85l3.129 3.362-.613 4.168 4.164-1.937 3.774 1.871-.555-4.558 2.946-3.012-4.485-.877-2.135-3.449z",
      stroke: fill2,
      fill: "none",
      fillRule: "evenodd"
    }
  ) : /* @__PURE__ */ jsx32(
    Path,
    {
      d: "M10.772 16l-3.564 1.874a.5.5 0 01-.725-.528l.68-3.968a.5.5 0 00-.143-.443l-2.884-2.81a.5.5 0 01.277-.853l3.985-.58a.5.5 0 00.377-.273l1.782-3.61a.5.5 0 01.896 0l1.782 3.61a.5.5 0 00.377.274l3.985.579a.5.5 0 01.277.853l-2.884 2.81a.5.5 0 00-.143.443l.68 3.968a.5.5 0 01-.725.528L11.238 16a.5.5 0 00-.466 0z",
      stroke: "none",
      fill: fill2,
      fillRule: "evenodd"
    }
  ) });
}
var Star_default = Star;

// src/components/Icons/Tag.tsx
import { jsx as jsx33, jsxs as jsxs17 } from "react/jsx-runtime";
function Tag({ fill: fill2, ...props }) {
  return /* @__PURE__ */ jsx33(Base_default, { ...props, children: /* @__PURE__ */ jsxs17("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ jsx33(
      Path,
      {
        d: "M15.45 5.528h-3.304a1 1 0 00-.711.297L5.72 11.607a.997.997 0 00-.007 1.399l3.115 3.212a.997.997 0 001.407-.014l5.924-5.983a1 1 0 00.29-.704v-2.99a.997.997 0 00-1-1z",
        stroke: fill2,
        fill: "none"
      }
    ),
    /* @__PURE__ */ jsx33(Circle, { fill: fill2, cx: 13.972, cy: 8.007, r: 1, stroke: "none" })
  ] }) });
}
var Tag_default = Tag;

// src/components/Icons/Tick.tsx
import styled15 from "styled-components";
import { jsx as jsx34 } from "react/jsx-runtime";
var Tick = ({ light, ...rest }) => /* @__PURE__ */ jsx34(Base_default, { ...rest, children: /* @__PURE__ */ jsx34("g", { children: light ? /* @__PURE__ */ jsx34("path", { d: "M9.286 15.227l-4.101-4.1a.63.63 0 0 1 0-.893l.892-.892a.63.63 0 0 1 .892 0l2.763 2.762 5.917-5.917a.63.63 0 0 1 .892 0l.892.892a.63.63 0 0 1 0 .893l-7.255 7.255a.63.63 0 0 1-.892 0z" }) : /* @__PURE__ */ jsx34("path", { d: "M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm2.646-10.177l-3.905 3.749-1.403-1.275a.8.8 0 0 0-1.076 1.184l1.955 1.778a.8.8 0 0 0 1.093-.015l4.444-4.267a.8.8 0 0 0-1.108-1.154z" }) }) });
var Tick_default = styled15(Tick)``;

// src/components/Icons/Trash.tsx
import { jsx as jsx35 } from "react/jsx-runtime";
function Trash({ fill: fill2, ...props }) {
  return /* @__PURE__ */ jsx35(Base_default, { ...props, children: /* @__PURE__ */ jsx35(
    G,
    {
      stroke: fill2,
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: /* @__PURE__ */ jsx35("path", { d: "M5.5 7.455H16.136M14.955 8.282V16.2c0 .718-.53 1.3-1.182 1.3h-5.91c-.652 0-1.181-.582-1.181-1.3V8.282M8.455 7.1V5.8c0-.718.529-1.3 1.181-1.3H12c.653 0 1.182.582 1.182 1.3v1.3M9.636 10.409v4.727M12 10.409v4.727" })
    }
  ) });
}
var Trash_default = Trash;

// src/components/Icons/Edit.tsx
import { jsx as jsx36 } from "react/jsx-runtime";
function Edit({ fill: fill2, ...props }) {
  return /* @__PURE__ */ jsx36(Base_default, { viewBox: "0 0 20 20", ...props, children: /* @__PURE__ */ jsx36(
    Path,
    {
      d: "M12.13 4.778l2.857 3.095-8.21 8.547L2.5 17.5l1.085-4.343 8.546-8.379zm3.414-1.994l1.697 1.76a.921.921 0 01-.026 1.307L15.93 7.079l-2.983-3.093 1.285-1.229a.93.93 0 011.312.027z",
      fill: fill2,
      stroke: "none",
      fillRule: "evenodd"
    }
  ) });
}
var Edit_default = Edit;

// src/components/Icons/X.tsx
import styled16 from "styled-components";
import { jsx as jsx37 } from "react/jsx-runtime";
var X = (props) => /* @__PURE__ */ jsx37(Base_default, { ...props, children: /* @__PURE__ */ jsx37("g", { children: /* @__PURE__ */ jsx37("path", { d: "M11 8.96l4.08-4.081a1.443 1.443 0 1 1 2.041 2.04L13.041 11l4.08 4.08a1.443 1.443 0 1 1-2.04 2.041L11 13.041l-4.08 4.08a1.443 1.443 0 1 1-2.041-2.04L8.959 11 4.88 6.92a1.443 1.443 0 1 1 2.04-2.041L11 8.959z" }) }) });
var X_default = styled16(X)``;

// src/components/Icons/Addition.tsx
import { jsx as jsx38 } from "react/jsx-runtime";
function Addition({ fill: fill2, ...props }) {
  return /* @__PURE__ */ jsx38(Base_default, { ...props, children: /* @__PURE__ */ jsx38(
    G,
    {
      stroke: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: fill2,
      children: /* @__PURE__ */ jsx38("path", { d: "M12.163,9.65l9.193,0l0,2.347l-9.193,0l-0,10.003l-2.49,0l-0,-10.003l-9.029,0l-0,-2.347l9.029,0l-0,-9.65l2.49,0l-0,9.65Z" })
    }
  ) });
}
var Addition_default = Addition;

// src/components/Icons/Clear.tsx
import { jsx as jsx39 } from "react/jsx-runtime";
function Clear({ fill: fill2, ...props }) {
  return /* @__PURE__ */ jsx39(Base_default, { ...props, children: /* @__PURE__ */ jsx39(
    G,
    {
      stroke: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: fill2,
      children: /* @__PURE__ */ jsx39("path", { d: "M0,11c0,-6.075 4.925,-11 11,-11c6.075,0 11,4.925 11,11c0,6.075 -4.925,11 -11,11c-6.075,0 -11,-4.925 -11,-11Zm11,-1.111l-2.98,-2.98c-0.307,-0.307 -0.805,-0.307 -1.111,0c-0.307,0.307 -0.307,0.804 0,1.111l2.98,2.98l-2.98,2.98c-0.307,0.307 -0.307,0.804 0,1.111c0.306,0.307 0.804,0.307 1.111,-0l2.98,-2.98l2.98,2.98c0.307,0.307 0.804,0.307 1.111,-0c0.307,-0.307 0.307,-0.804 -0,-1.111l-2.98,-2.98l2.98,-2.98c0.307,-0.307 0.307,-0.804 -0,-1.111c-0.307,-0.307 -0.804,-0.307 -1.111,0l-2.98,2.98Z" })
    }
  ) });
}
var Clear_default = Clear;

// src/components/Icons/Copy.tsx
import { jsx as jsx40 } from "react/jsx-runtime";
function Copy({ fill: fill2, ...props }) {
  return /* @__PURE__ */ jsx40(Base_default, { ...props, children: /* @__PURE__ */ jsx40(
    G,
    {
      stroke: fill2,
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      children: /* @__PURE__ */ jsx40("path", { d: "M6.5,15.5l-2.25,0c-1.243,0 -2.25,-1.007 -2.25,-2.25l0,-9c0,-1.243 1.007,-2.25 2.25,-2.25l9,-0c1.243,-0 2.25,1.007 2.25,2.25l0,2.25m-6.75,13.5l9,0c1.243,0 2.25,-1.007 2.25,-2.25l0,-9c0,-1.243 -1.007,-2.25 -2.25,-2.25l-9,0c-1.243,0 -2.25,1.007 -2.25,2.25l0,9c0,1.243 1.007,2.25 2.25,2.25Z" })
    }
  ) });
}
var Copy_default = Copy;

// src/components/TableCard.tsx
var TableCard_exports = {};
__export(TableCard_exports, {
  Card: () => Card,
  Row: () => Row
});
import { themeGet } from "@styled-system/theme-get";
import styled17 from "styled-components";
import { jsx as jsx41 } from "react/jsx-runtime";
var Row = styled17(View_default)`
  display: flex;
  flex-direction: column;
  @media (min-width: ${themeGet("breakpoints.0")}) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;
var CardWrap = styled17(View_default)`
  flex: 1 0;

  &:after {
    margin-left: 20px;
    margin-right: 20px;
  }

  // Mobile
  border-bottom: 1px solid ${themeGet("colors.sky.1")};
  ${Row}:last-of-type &:last-of-type {
    border-bottom: none;
  }

  @media (min-width: ${themeGet("breakpoints.0")}) {
    border-bottom: none;
    &:not(:last-of-type) {
      border-right: 1px solid ${themeGet("colors.sky.1")};
    }
  }

  @media (min-width: ${themeGet("breakpoints.0")}) {
    /* prettier-ignore */
    ${Row}:not(:last-of-type) &:after {
      content: '';
      height: 1px;
      background: ${themeGet("colors.sky.1")};
      display: block;
    }
  }
  /* prettier-ignore */
  ${Row}:not(:last-of-type) &:first-of-type:after {
    margin-left: 0;
  }
  /* prettier-ignore */
  ${Row}:not(:last-of-type) &:last-of-type:after {
    margin-right: 0;
  }
`;
var CardContent = styled17(View_default)`
  padding: 12px 0;
  height: 100%;
  @media (max-width: ${themeGet("breakpoints.0")}) {
    ${Row}:first-of-type ${CardWrap}:first-of-type & {
      padding-top: 0;
    }

    ${Row}:last-of-type ${CardWrap}:last-of-type & {
      padding-bottom: 0;
    }
  }

  @media (min-width: ${themeGet("breakpoints.0")}) {
    padding: 12px 20px;
    ${Row}:first-of-type & {
      padding-top: 0;
    }

    ${Row}:last-of-type & {
      padding-bottom: 0;
    }

    ${CardWrap}:first-of-type & {
      padding-left: 0;
    }

    ${CardWrap}:last-of-type & {
      padding-right: 0;
    }
  }
`;
var Card = ({ children: children2, ...rest }) => /* @__PURE__ */ jsx41(CardWrap, { ...rest, children: /* @__PURE__ */ jsx41(CardContent, { children: children2 }) });

// src/index.ts
import { themeGet as themeGet24 } from "@styled-system/theme-get";
import { default as default2 } from "react-day-picker-v7";

// src/ScarfProvider.tsx
import get3 from "lodash.get";
import { createContext, useContext, useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import {
  createGlobalStyle,
  ThemeProvider
} from "styled-components";

// src/i18n/index.js
import i18n from "i18next";

// src/i18n/locales/de-DE/translation.json
var translation_default = {
  "Choose file": "Datei ausw\xE4hlen",
  Close: "Schlie\xDFen",
  "Contains at least 1 lower case letter": "Enth\xE4lt mindestens 1 Kleinbuchstaben",
  "Contains at least 1 number": "Enth\xE4lt mindestens 1 Zahl",
  "Contains at least 1 upper case letter": "Enth\xE4lt mindestens 1 Gro\xDFbuchstaben",
  "DD / MM / YYYY": "DD / MM / JJJJ",
  "Enter address or postcode here...": "Adresse oder PLZ hier eingeben...",
  "Enter company name": "Firmennamen eingeben",
  HIDE: "VERBERGEN",
  "Is 8 characters long": "Besteht aus 8 Zeichen",
  "Loading...": "Wird geladen...",
  "No results found": "Keine Suchergebnisse",
  "Select from the list...": "Aus der Liste ausw\xE4hlen...",
  SHOW: "ANZEIGEN",
  "Showing {{visibleItems}} of {{totalItems}} results": "{{visibleItems}} von {{totalItems}} Resultaten angezeigt",
  "Type to search": "Suchbegriff eingeben"
};

// src/i18n/locales/en-GB/translation.json
var translation_default2 = {
  "Choose file": "Choose file",
  Close: "Close",
  "Contains at least 1 lower case letter": "Contains at least 1 lower case letter",
  "Contains at least 1 number": "Contains at least 1 number",
  "Contains at least 1 upper case letter": "Contains at least 1 upper case letter",
  "DD / MM / YYYY": "DD / MM / YYYY",
  "Enter address or postcode here...": "Enter address or postcode here...",
  "Enter company name": "Enter company name",
  HIDE: "HIDE",
  "Is 8 characters long": "Is 8 characters long",
  "Loading...": "Loading...",
  "No results found": "No results found",
  "Select from the list...": "Select from the list...",
  SHOW: "SHOW",
  "Showing {{visibleItems}} of {{totalItems}} results": "Showing {{visibleItems}} of {{totalItems}} results",
  "Type to search": "Type to search"
};

// src/i18n/locales/es-ES/translation.json
var translation_default3 = {
  "Choose file": "Elija un archivo",
  Close: "Cerrar",
  "Contains at least 1 lower case letter": "Contiene al menos 1 letra min\xFAscula",
  "Contains at least 1 number": "Contiene al menos 1 n\xFAmero",
  "Contains at least 1 upper case letter": "Contiene al menos 1 letra may\xFAscula",
  "DD / MM / YYYY": "DD / MM / AAAA",
  "Enter address or postcode here...": "Escriba aqu\xED la direcci\xF3n o el c\xF3digo postal...",
  "Enter company name": "Introduzca el nombre de la empresa",
  HIDE: "OCULTAR",
  "Is 8 characters long": "Tiene 8 caracteres",
  "Loading...": "Cargando...",
  "No results found": "No se han encontrado resultados",
  "Select from the list...": "Seleccione en la lista...",
  SHOW: "MOSTRAR",
  "Showing {{visibleItems}} of {{totalItems}} results": "Mostrando {{visibleItems}} de {{totalItems}} resultados",
  "Type to search": "Escriba para buscar"
};

// src/i18n/locales/fr-FR/translation.json
var translation_default4 = {
  "Choose file": "Choisir le fichier",
  Close: "Fermer",
  "Contains at least 1 lower case letter": "Contient au moins 1\xA0lettre minuscule",
  "Contains at least 1 number": "Contient au moins 1\xA0num\xE9ro",
  "Contains at least 1 upper case letter": "Contient au moins 1\xA0lettre majuscule",
  "DD / MM / YYYY": "JJ / MM / AAAA",
  "Enter address or postcode here...": "Entrer l'adresse ou le code postal ici...",
  "Enter company name": "Entrer le nom de l'entreprise",
  HIDE: "MASQUER",
  "Is 8 characters long": "Comporte 8\xA0caract\xE8res",
  "Loading...": "Chargement...",
  "No results found": "Aucun r\xE9sultat trouv\xE9",
  "Select from the list...": "S\xE9lectionner dans la liste...",
  SHOW: "AFFICHER",
  "Showing {{visibleItems}} of {{totalItems}} results": "Affichage de {{visibleItems}} sur {{totalItems}} r\xE9sultats",
  "Type to search": "Taper pour rechercher"
};

// src/i18n/locales/it-IT/translation.json
var translation_default5 = {
  "Choose file": "Scegli un file",
  Close: "Chiudi",
  "Contains at least 1 lower case letter": "Contiene almeno 1 lettera minuscola",
  "Contains at least 1 number": "Contiene almeno 1 numero",
  "Contains at least 1 upper case letter": "Contiene almeno 1 lettera maiuscola",
  "DD / MM / YYYY": "GG / MM / AAAA",
  "Enter address or postcode here...": "Inserisci qui l'indirizzo o il CAP...",
  "Enter company name": "Inserisci il nome dell'azienda",
  HIDE: "NASCONDI",
  "Is 8 characters long": "Ha una lunghezza di 8 caratteri",
  "Loading...": "Caricamento in corso...",
  "No results found": "Nessun risultato trovato",
  "Select from the list...": "Seleziona dall'elenco...",
  SHOW: "MOSTRA",
  "Showing {{visibleItems}} of {{totalItems}} results": "Visualizzazione di {{visibleItems}} di {{totalItems}} risultati",
  "Type to search": "Digita per eseguire la ricerca"
};

// src/i18n/locales/nl-NL/translation.json
var translation_default6 = {
  "Choose file": "Bestand kiezen",
  Close: "Sluiten",
  "Contains at least 1 lower case letter": "Bevat ten minste 1 kleine letter",
  "Contains at least 1 number": "Bevat ten minste 1 cijfer",
  "Contains at least 1 upper case letter": "Bevat ten minste 1 hoofdletter",
  "DD / MM / YYYY": "DD / MM / JJJJ",
  "Enter address or postcode here...": "Voer hier het adres of de postcode in...",
  "Enter company name": "Voer bedrijfsnaam in",
  HIDE: "VERBERGEN",
  "Is 8 characters long": "Is 8 tekens lang",
  "Loading...": "Laden...",
  "No results found": "Geen resultaten gevonden",
  "Select from the list...": "Selecteer uit de lijst...",
  SHOW: "WEERGEVEN",
  "Showing {{visibleItems}} of {{totalItems}} results": "Er worden {{visibleItems}} van {{totalItems}} resultaten weergegeven",
  "Type to search": "Typ om te zoeken"
};

// src/i18n/index.js
if (!i18n.isInitialized) {
  i18n.init({
    fallbackLng: "en-GB",
    supportedLngs: [
      "en",
      "en-GB",
      "nl",
      "nl-NL",
      "it",
      "it-IT",
      "fr",
      "fr-FR",
      "es",
      "es-ES",
      "de",
      "de-DE"
    ],
    interpolation: {
      escapeValue: false
    },
    keySeparator: false,
    nsSeparator: false,
    debug: false,
    react: {
      useSuspense: false,
      transKeepBasicHtmlNodesFor: []
    },
    initImmediate: false
  });
}
if (i18n.isInitialized) {
  i18n.addResourceBundle("en-GB", "translation", translation_default2, true, true);
  i18n.addResourceBundle("nl-NL", "translation", translation_default6, true, true);
  i18n.addResourceBundle("it-IT", "translation", translation_default5, true, true);
  i18n.addResourceBundle("fr-FR", "translation", translation_default4, true, true);
  i18n.addResourceBundle("es-ES", "translation", translation_default3, true, true);
  i18n.addResourceBundle("de-DE", "translation", translation_default, true, true);
}
var i18n_default = i18n;
var t = i18n.t.bind(i18n);

// src/utils/alterColor.js
import get2 from "lodash.get";
function shadeColor(c, percent) {
  const color2 = c || "#222222";
  const f = parseInt(color2.slice(1), 16);
  const t2 = percent < 0 ? 0 : 255;
  const p = percent < 0 ? percent * -1 : percent;
  const R = f >> 16;
  const G2 = f >> 8 & 255;
  const B = f & 255;
  return `#${(16777216 + (Math.round((t2 - R) * p) + R) * 65536 + (Math.round((t2 - G2) * p) + G2) * 256 + (Math.round((t2 - B) * p) + B)).toString(16).slice(1)}`;
}
var alterColor = (colorKey, amount) => ({ theme: theme2 }) => {
  const color2 = get2(theme2, `colors.${colorKey}`);
  return shadeColor(color2, amount);
};
var alterColor_default = alterColor;

// src/theme/colors.js
var ink = ["#212B36", "#454F5B", "#637381", "#637381"];
var sky = ["#C4CDD5", "#DFE3E8", "#F4F6F8", "#F9FAFB", "#FBFBFB"];
var generatePalette = (color2) => {
  const versions = [-0.7, -0.45, -0.2, 0, 0.4, 0.7, 0.85];
  return versions.map((shade) => shadeColor(color2, shade));
};
var blue = generatePalette("#3292ff");
var teal = generatePalette("#2c9fa5");
var sea = generatePalette("#0DAB76");
var green = generatePalette("#a5d606");
var yellow = generatePalette("#ffcd37");
var red = generatePalette("#ff6966");
var orange = generatePalette("#ff7010");
var coal = generatePalette("#212B36");
var colors = {
  default: {
    ink: ink[0],
    sky: sky[2],
    blue: blue[3],
    teal: teal[3],
    sea: sea[3],
    green: green[3],
    yellow: yellow[3],
    red: red[3],
    orange: orange[3],
    coal: coal[3]
  },
  ink,
  sky,
  blue,
  teal,
  sea,
  green,
  yellow,
  red,
  orange,
  coal
};
var colors_default = colors;

// src/theme/index.ts
var breakpoints = ["960px"];
var maxWidths = breakpoints;
var space2 = [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40];
var fontSizes = [12, 14, 16, 18, 22, 26, 28];
var lineHeights = [1, 1.125, 1.25, 1.5];
var fontWeights = {
  light: 300,
  regular: 400,
  normal: 500,
  semibold: 500
};
var letterSpacings = {
  normal: "normal",
  medium: "0.5px"
};
var radii = [0, "4px"];
var borders = [0, `1px solid ${colors_default.sky[1]}`];
var shadows = [
  `0 6px 5px -4px rgba(0, 0, 0, 0.2)`,
  `0 4px 8px -4px rgba(0, 0, 0, 0.2)`,
  `0 4px 3px -4px rgba(0, 0, 0, 0.2)`
];
var font = `var(--font-sans, sans-serif)`;
var monospace = `var(--font-mono, monospace)`;
var theme = {
  font,
  monospace,
  breakpoints,
  colors: colors_default,
  space: space2,
  fontSizes,
  lineHeights,
  fontWeights,
  letterSpacings,
  radii,
  borders,
  shadows,
  maxWidths
};
var theme_default = theme;

// src/ScarfProvider.tsx
import { jsx as jsx42, jsxs as jsxs18 } from "react/jsx-runtime";
var GlobalStyle = createGlobalStyle`
  ${// SC v5 bug, use external css file instead
""}
  html, body, #root {
    min-height: 100%;
  }
`;
var setPrimaryColor = (palette = "teal", theme2) => {
  const primary = get3(theme2, `colors.${palette}`) || generatePalette(palette);
  return {
    ...theme2,
    colors: {
      ...theme2.colors,
      primary,
      default: {
        ...theme2.colors.default,
        primary: primary[3]
      }
    }
  };
};
var FALLBACK_PCA_KEY = "UA97-PP22-CG98-HT84";
var Context = createContext({
  locale: "en-GB",
  countryCode: "gb",
  pcaKey: FALLBACK_PCA_KEY
});
var useLocale = () => {
  const { locale } = useContext(Context);
  return locale;
};
var useScarfContext = () => useContext(Context);
var ScarfProvider = ({
  theme: propsTheme,
  primaryColor,
  locale = "en-GB",
  countryCode = "gb",
  children: children2,
  pcaKey
}) => {
  const mergedTheme = { ...theme_default, ...propsTheme };
  useEffect(() => {
    if (i18n_default.language !== locale) {
      i18n_default.changeLanguage(locale);
    }
  }, [locale]);
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    /* @__PURE__ */ jsx42(Context.Provider, { value: { locale, countryCode, primaryColor, pcaKey }, children: /* @__PURE__ */ jsx42(Context.Consumer, { children: ({ primaryColor: primaryColor2 }) => {
      const themeWithPrimaryColor = setPrimaryColor(
        primaryColor2,
        mergedTheme
      );
      return /* @__PURE__ */ jsx42(I18nextProvider, { i18n: i18n_default, children: /* @__PURE__ */ jsxs18(ThemeProvider, { theme: themeWithPrimaryColor, children: [
        /* @__PURE__ */ jsx42(GlobalStyle, {}),
        children2
      ] }) });
    } }) })
  );
};
var ScarfProvider_default = ScarfProvider;

// src/components/Accordion.tsx
import React6 from "react";

// src/hooks/useIntersection.ts
import { useEffect as useEffect2, useRef, useState } from "react";
function useIntersection({
  root,
  rootMargin,
  threshold,
  once
} = {}) {
  const ref = useRef();
  const [isIntersecting, setIntersecting] = useState(false);
  useEffect2(() => {
    const r = ref.current;
    let observer;
    if (window.IntersectionObserver) {
      observer = new IntersectionObserver(
        ([entry]) => {
          setIntersecting(entry.isIntersecting);
          if (once && entry.isIntersecting && r) {
            observer.unobserve(r);
          }
        },
        { root, rootMargin, threshold }
      );
      if (r) {
        observer?.observe(r);
      }
    } else {
      setIntersecting(true);
    }
    return () => {
      if (r) {
        observer?.unobserve(r);
      }
    };
  }, [once, root, rootMargin, threshold]);
  return [ref, isIntersecting];
}
var useIntersection_default = useIntersection;

// src/components/AnimateHeight.tsx
import React4 from "react";
import cx from "classnames";
import { jsx as jsx43 } from "react/jsx-runtime";
var ANIMATION_STATE_CLASSES = {
  animating: "rah-animating",
  animatingUp: "rah-animating--up",
  animatingDown: "rah-animating--down",
  animatingToHeightZero: "rah-animating--to-height-zero",
  animatingToHeightAuto: "rah-animating--to-height-auto",
  animatingToHeightSpecific: "rah-animating--to-height-specific",
  static: "rah-static",
  staticHeightZero: "rah-static--height-zero",
  staticHeightAuto: "rah-static--height-auto",
  staticHeightSpecific: "rah-static--height-specific"
};
function omit2(obj, ...keys) {
  if (!keys.length) {
    return obj;
  }
  const res = {};
  const objectKeys = Object.keys(obj);
  for (let i = 0; i < objectKeys.length; i += 1) {
    const key = objectKeys[i];
    if (keys.indexOf(key) === -1) {
      res[key] = obj[key];
    }
  }
  return res;
}
function startAnimationHelper(callback) {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      callback();
    });
  });
}
function isNumber(n) {
  return !Number.isNaN(Number(parseFloat(n))) && Number.isFinite(parseInt(n, 10));
}
function runCallback(callback) {
  if (callback && typeof callback === "function") {
    callback();
  }
}
var AnimateHeight = class extends React4.Component {
  constructor(props) {
    super(props);
    let height = "auto";
    let overflow = "visible";
    if (isNumber(props.height)) {
      height = props.height < 0 ? 0 : props.height;
      overflow = "hidden";
    } else if (
      // Percentage height
      typeof props.height === "string" && props.height.search("%") === props.height.length - 1 && isNumber(props.height.substr(0, props.height.length - 1))
    ) {
      height = props.height;
      overflow = "hidden";
    }
    this.animationStateClasses = {
      ...ANIMATION_STATE_CLASSES,
      ...props.animationStateClasses
    };
    const animationStateClasses = this.getStaticStateClasses(height);
    this.state = {
      animationStateClasses,
      height,
      overflow,
      shouldUseTransitions: false
    };
  }
  componentDidMount() {
    const { height } = this.state;
    if (this.contentElement && this.contentElement.style) {
      this.contentElement.style.width = "100%";
      this.hideContent(height);
    }
  }
  componentDidUpdate(prevProps) {
    const { delay, duration, height, onAnimationEnd, onAnimationStart } = this.props;
    if (this.contentElement && height !== prevProps.height) {
      this.showContent();
      this.contentElement.style.overflow = "hidden";
      const contentHeight = this.contentElement.offsetHeight;
      this.contentElement.style.overflow = "";
      const totalDuration = duration + delay;
      let newHeight = null;
      const timeoutState = {
        height: null,
        // it will be always set to either 'auto' or specific number
        overflow: "hidden"
      };
      const isCurrentHeightAuto = this.state.height === "auto";
      if (isNumber(height)) {
        newHeight = height < 0 ? 0 : height;
        timeoutState.height = newHeight;
      } else if (
        // Percentage height
        typeof height === "string" && height.search("%") === height.length - 1 && isNumber(height.substr(0, height.length - 1))
      ) {
        newHeight = height;
        timeoutState.height = newHeight;
      } else {
        newHeight = contentHeight;
        timeoutState.height = "auto";
        timeoutState.overflow = null;
      }
      if (isCurrentHeightAuto) {
        timeoutState.height = newHeight;
        newHeight = contentHeight;
      }
      const animationStateClasses = cx({
        [this.animationStateClasses.animating]: true,
        [this.animationStateClasses.animatingUp]: prevProps.height === "auto" || height < prevProps.height,
        [this.animationStateClasses.animatingDown]: height === "auto" || height > prevProps.height,
        [this.animationStateClasses.animatingToHeightZero]: timeoutState.height === 0,
        [this.animationStateClasses.animatingToHeightAuto]: timeoutState.height === "auto",
        [this.animationStateClasses.animatingToHeightSpecific]: timeoutState.height > 0
      });
      const timeoutAnimationStateClasses = this.getStaticStateClasses(
        timeoutState.height
      );
      this.setState({
        // eslint-disable-line react/no-did-update-set-state
        animationStateClasses,
        height: newHeight,
        overflow: "hidden",
        // When animating from 'auto' we first need to set fixed height
        // that change should be animated
        shouldUseTransitions: !isCurrentHeightAuto
      });
      clearTimeout(this.timeoutID);
      clearTimeout(this.animationClassesTimeoutID);
      if (isCurrentHeightAuto) {
        timeoutState.shouldUseTransitions = true;
        startAnimationHelper(() => {
          this.setState(timeoutState);
          runCallback(onAnimationStart);
        });
        this.animationClassesTimeoutID = setTimeout(() => {
          this.setState({
            animationStateClasses: timeoutAnimationStateClasses,
            shouldUseTransitions: false
          });
          this.hideContent(timeoutState.height);
          runCallback(onAnimationEnd);
        }, totalDuration);
      } else {
        runCallback(onAnimationStart);
        this.timeoutID = setTimeout(() => {
          timeoutState.animationStateClasses = timeoutAnimationStateClasses;
          timeoutState.shouldUseTransitions = false;
          this.setState(timeoutState);
          this.hideContent(newHeight);
          runCallback(onAnimationEnd);
        }, totalDuration);
      }
    }
  }
  componentWillUnmount() {
    clearTimeout(this.timeoutID);
    clearTimeout(this.animationClassesTimeoutID);
    this.timeoutID = null;
    this.animationClassesTimeoutID = null;
    this.animationStateClasses = null;
  }
  getStaticStateClasses(height) {
    return cx({
      [this.animationStateClasses.static]: true,
      [this.animationStateClasses.staticHeightZero]: height === 0,
      [this.animationStateClasses.staticHeightSpecific]: height > 0,
      [this.animationStateClasses.staticHeightAuto]: height === "auto"
    });
  }
  showContent() {
    const { height } = this.state;
    if (height === 0) {
      this.contentElement.style.position = "relative";
      this.contentElement.style.left = "0px";
    }
  }
  hideContent(newHeight) {
    if (newHeight === 0) {
      this.contentElement.style.position = "absolute";
      this.contentElement.style.left = "-9999px";
    }
  }
  render() {
    const {
      animateOpacity,
      applyInlineTransitions,
      children: children2,
      className,
      contentClassName,
      duration,
      easing,
      delay,
      style: style6
    } = this.props;
    const { height, overflow, animationStateClasses, shouldUseTransitions } = this.state;
    const componentStyle = {
      ...style6,
      height,
      position: "relative",
      overflow: overflow || style6.overflow
    };
    if (shouldUseTransitions && applyInlineTransitions) {
      componentStyle.transition = `height ${duration}ms ${easing} ${delay}ms`;
      if (style6.transition) {
        componentStyle.transition = `${style6.transition}, ${componentStyle.transition}`;
      }
      componentStyle.WebkitTransition = componentStyle.transition;
    }
    const contentStyle = {};
    if (animateOpacity) {
      contentStyle.transition = `opacity ${duration}ms ${easing} ${delay}ms`;
      contentStyle.WebkitTransition = contentStyle.transition;
      if (height === 0) {
        contentStyle.opacity = 0;
      }
    }
    const componentClasses = cx({
      [animationStateClasses]: true,
      [className]: className
    });
    const propsToOmit = [
      "animateOpacity",
      "animationStateClasses",
      "applyInlineTransitions",
      "contentClassName",
      "duration",
      "easing",
      "height",
      "delay"
    ];
    return /* @__PURE__ */ jsx43(
      "div",
      {
        ...omit2(this.props, ...propsToOmit),
        "aria-hidden": height === 0,
        className: componentClasses,
        style: componentStyle,
        children: /* @__PURE__ */ jsx43(
          "div",
          {
            className: contentClassName,
            style: contentStyle,
            ref: (el) => {
              this.contentElement = el;
            },
            children: children2
          }
        )
      }
    );
  }
};
AnimateHeight.defaultProps = {
  animateOpacity: false,
  animationStateClasses: ANIMATION_STATE_CLASSES,
  applyInlineTransitions: true,
  duration: 250,
  delay: 0,
  easing: "ease",
  style: {}
};
var AnimateHeight_default = AnimateHeight;

// src/components/Flex.tsx
import styled18 from "styled-components";
var Flex = styled18(View_default)``;
Flex.defaultProps = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
};
var Flex_default = Flex;

// src/components/Tag.tsx
import React5 from "react";
import styled20 from "styled-components";

// src/components/Text.tsx
import { themeGet as themeGet2 } from "@styled-system/theme-get";
import styled19 from "styled-components";
import { style as style3 } from "styled-system";
var textDecoration = style3({
  prop: "textDecoration"
});
var Base = styled19(View_default)`
  ${textDecoration}
  font-family: ${themeGet2("font", "Arial")};
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;
Base.defaultProps = {
  fontWeight: "regular",
  color: "default.ink"
};
var Title = styled19(Base)``;
Title.defaultProps = {
  fontSize: [5, 6],
  fontWeight: "semibold",
  // @ts-ignore
  "data-testid": "title"
};
var Subtitle = styled19(Base)``;
Subtitle.defaultProps = {
  fontSize: [4],
  // @ts-ignore
  "data-testid": "subtitle"
};
var Heading = styled19(Base)``;
Heading.defaultProps = {
  fontSize: [2, 3]
};
var Subheading = styled19(Base)`
  text-transform: uppercase;
`;
Subheading.defaultProps = {
  fontSize: 0,
  letterSpacing: "medium",
  fontWeight: "semibold"
};
var Prompt = styled19(Base)``;
Prompt.defaultProps = {
  fontSize: [2],
  lineHeight: 3
};
var Paragraph = styled19(Base)``;
Paragraph.defaultProps = {
  fontSize: 2,
  fontWeight: "regular",
  lineHeight: 3
};
var Caption = styled19(Base)``;
Caption.defaultProps = {
  fontSize: 1,
  fontWeight: "regular",
  color: "ink.2",
  lineHeight: 3
};
var Clickable = styled19(Base)`
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
Clickable.defaultProps = {
  color: "default.primary",
  fontWeight: "semibold",
  cursor: "pointer"
};
var Text_default = Paragraph;

// src/components/Tag.tsx
import { jsx as jsx44 } from "react/jsx-runtime";
var colorStyles = {
  grey: {
    color: colors_default.ink[1],
    background: colors_default.sky[1]
  },
  green: {
    color: colors_default.green[1],
    background: colors_default.green[5]
  },
  yellow: {
    color: colors_default.yellow[1],
    background: colors_default.yellow[5]
  },
  red: {
    color: colors_default.red[1],
    background: colors_default.red[5]
  },
  teal: {
    color: colors_default.teal[2],
    background: colors_default.teal[5]
  },
  sea: {
    color: colors_default.sea[2],
    background: colors_default.sea[5]
  },
  blue: {
    color: colors_default.blue[2],
    background: colors_default.blue[5]
  },
  orange: {
    color: colors_default.orange[1],
    background: colors_default.orange[5]
  },
  darkGrey: {
    color: "white",
    background: colors_default.ink[2]
  }
};
var Tag2 = styled20(Subheading).attrs(
  ({ small, py, px, fontSize }) => ({
    py: py || (small ? 0 : 1),
    px: px || (small ? 2 : 3),
    fontSize: fontSize || (small ? "10px" : 0)
  })
)`
  display: inline-flex;
  border-radius: 16px;
  white-space: nowrap;
  ${(p) => p.small && `
    letter-spacing: 0.5px;
  `}
`;
Tag2.defaultProps = {
  lineHeight: "20px"
};
var Wrap = React5.forwardRef(
  ({
    /* eslint-disable react/prop-types */
    small,
    yellow: yellow2,
    red: red2,
    green: green2,
    blue: blue2,
    sea: sea2,
    teal: teal2,
    grey,
    orange: orange2,
    darkGrey,
    color: color2,
    children: children2,
    /* eslint-enable react/prop-types */
    ...rest
  }, ref) => {
    const style6 = [
      yellow2 ? colorStyles.yellow : false,
      red2 ? colorStyles.red : false,
      green2 ? colorStyles.green : false,
      blue2 ? colorStyles.blue : false,
      sea2 ? colorStyles.sea : false,
      teal2 ? colorStyles.teal : false,
      orange2 ? colorStyles.orange : false,
      darkGrey ? colorStyles.darkGrey : false
    ].find((i) => i !== false) || (color2 ? colorStyles[color2] : void 0) || colorStyles.grey;
    return /* @__PURE__ */ jsx44(
      Tag2,
      {
        ref,
        color: style6.color,
        bg: style6.background,
        small,
        ...rest,
        children: children2
      }
    );
  }
);
var Tag_default2 = Wrap;

// src/components/Accordion.tsx
import { jsx as jsx45, jsxs as jsxs19 } from "react/jsx-runtime";
function Accordion({
  title,
  subtitle,
  status,
  statusColor,
  children: children2,
  isOpenByDefault = false,
  isTight = false,
  iconActiveColor = "ink.2",
  header,
  ...rest
}) {
  const [isOpen, setOpen] = React6.useState(isOpenByDefault);
  const [ref, isVisible] = useIntersection_default({ once: true });
  const height = isOpen ? "auto" : 0;
  return /* @__PURE__ */ jsxs19(
    Flex_default,
    {
      ref,
      pt: !isTight ? 3 : void 0,
      pr: !isTight ? [3, 5] : void 0,
      bg: "white",
      alignItems: "flex-start",
      "data-testid": "accordion-panel",
      ...rest,
      children: [
        /* @__PURE__ */ jsx45(View_default, { children: /* @__PURE__ */ jsx45(
          View_default,
          {
            transform: isOpen ? `rotate(90deg)` : `rotate(0deg)`,
            transition: "transform 200ms linear",
            ml: !isTight ? [1, 3] : void 0,
            mr: [1, 2],
            onClick: () => setOpen(!isOpen),
            cursor: "pointer",
            children: /* @__PURE__ */ jsx45(ArrowRight_default, { fill: isOpen ? iconActiveColor : "ink.2" })
          }
        ) }),
        /* @__PURE__ */ jsxs19(View_default, { flex: "1", maxWidth: "calc(100% - 26px)", children: [
          header ? typeof header === "function" ? header({ toggle: () => setOpen(!isOpen), isOpen }) : header : /* @__PURE__ */ jsxs19(View_default, { mb: !isTight ? 3 : void 0, children: [
            /* @__PURE__ */ jsxs19(
              Flex_default,
              {
                justifyContent: "flex-start",
                alignItems: "flex-start",
                flexWrap: "wrap",
                children: [
                  title ? /* @__PURE__ */ jsx45(
                    Caption,
                    {
                      fontWeight: "semibold",
                      color: "ink.0",
                      mr: 2,
                      onClick: () => setOpen(!isOpen),
                      cursor: "pointer",
                      "data-testid": "accordion-title",
                      children: title
                    }
                  ) : null,
                  status ? /* @__PURE__ */ jsx45(Tag_default2, { small: true, color: statusColor, children: status }) : null
                ]
              }
            ),
            subtitle ? /* @__PURE__ */ jsx45(Caption, { color: "ink.2", children: subtitle }) : null
          ] }),
          (isOpen || isVisible) && /* @__PURE__ */ jsx45(AnimateHeight_default, { duration: 200, height, children: /* @__PURE__ */ jsx45(View_default, { pt: !isTight ? 2 : void 0, pb: !isTight ? 5 : void 0, children: children2 }) })
        ] })
      ]
    }
  );
}
var Accordion_default = Accordion;

// src/components/Button.tsx
import React9 from "react";
import styled22 from "styled-components";

// src/utils/variants.js
import css2 from "@styled-system/css";
var omit3 = (obj, keys) => {
  const next = {};
  for (const key in obj) {
    if (!keys.includes(key) && key[0] !== "&")
      continue;
    next[key] = obj[key];
  }
  return next;
};
var variants = (variants2 = {}, defaultProps = {}) => (props) => {
  const variantKeys = Object.keys(variants2);
  const variantProps = variantKeys.reduce(
    (mem, key) => ({
      ...mem,
      ...variants2[key][props[key]] || {}
    }),
    {}
  );
  const nonDefaultProps = Object.keys(props).reduce((mem, propKey) => {
    if (defaultProps[propKey] !== props[propKey] && Object.keys(variantProps).includes(propKey)) {
      return {
        ...mem,
        [propKey]: props[propKey]
      };
    }
    return mem;
  }, {});
  const merged = {
    ...variantProps,
    ...nonDefaultProps
  };
  const cleaned = omit3(merged, styledSystemProps);
  return css2(cleaned);
};
var variants_default = variants;

// src/components/Tooltip2.tsx
import React8, { useRef as useRef2, useState as useState4 } from "react";

// src/components/Popover.tsx
import { useEffect as useEffect4, useState as useState3 } from "react";
import { usePopper } from "react-popper";
import styled21 from "styled-components";

// src/components/Portal.tsx
import { useEffect as useEffect3, useState as useState2 } from "react";
import { createPortal } from "react-dom";
function Portal({
  children: children2
}) {
  const [node2] = useState2(() => {
    const element = document.createElement("div");
    document.body.appendChild(element);
    return element;
  });
  useEffect3(
    () => () => {
      document.body.removeChild(node2);
    },
    [node2]
  );
  return createPortal(children2, node2);
}
var Portal_default = Portal;

// src/components/Popover.tsx
import { jsx as jsx46 } from "react/jsx-runtime";
var Arrow = styled21(View_default)`
  position: absolute;
  width: 16px;
  height: 16px;

  background: transparent;

  &[placement*='bottom'] {
    top: -8px;
    &::before {
      transform: translateX(0px) rotate(45deg);
    }
  }
  &[placement*='top'] {
    bottom: -8px;
    &::before {
      transform: translateX(0px) rotate(225deg);
    }
  }
  &[placement*='right'] {
    left: -8px;
    &::before {
      transform: translateX(0px) rotate(315deg);
    }
  }
  &[placement*='left'] {
    right: -8px;
    &::before {
      transform: translateX(0px) rotate(135deg);
    }
  }
  &:before {
    /** 
        Rotated object will stay in the parent container...
        It resolves issue with start and end placement on left and right side.
    */
    width: ${100 / Math.sqrt(2)}%;
    height: ${100 / Math.sqrt(2)}%;
    position: absolute;

    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;

    content: '';
    transform-origin: center center;
  }
`;
Arrow.defaultProps = {};
function Popover({
  children: children2,
  open,
  onClickOut,
  referenceElement,
  placement = "auto",
  offset = [0, 0]
}) {
  const [popperElement, setPopperElement] = useState3(null);
  const [arrowElement, setArrowElement] = useState3(null);
  const { styles, attributes, ...rest } = usePopper(
    referenceElement.current,
    popperElement,
    {
      placement,
      modifiers: [
        { name: "arrow", options: { element: arrowElement } },
        {
          name: "offset",
          options: {
            // @ts-ignore
            offset: arrowElement ? [offset[0], offset[1] + 8] : offset
          }
        }
      ]
    }
  );
  useEffect4(() => {
    const onClick = (e) => {
      if (open && // @ts-ignore
      !popperElement?.contains(e.target) && // @ts-ignore
      !referenceElement.current?.contains(e.target)) {
        onClickOut && onClickOut();
      }
    };
    if (open) {
      window.addEventListener("click", onClick);
    }
    return () => window.removeEventListener("click", onClick);
  }, [onClickOut, open, popperElement, referenceElement]);
  return open ? /* @__PURE__ */ jsx46(Portal_default, { children: children2({
    ref: setPopperElement,
    style: { zIndex: 1e3, ...styles.popper },
    attributes: attributes.popper,
    ...attributes.popper,
    arrowProps: {
      ref: setArrowElement,
      style: { ...styles.arrow },
      // @ts-ignore
      placement: attributes.popper?.["data-popper-placement"]
    },
    ...rest
  }) }) : null;
}
Popover.Arrow = Arrow;
var Popover_default = Popover;

// src/components/Tooltip2.tsx
import { Fragment, jsx as jsx47, jsxs as jsxs20 } from "react/jsx-runtime";
function Tooltip2({
  children: children2,
  title,
  content,
  placement = "bottom",
  maxWidth = "100%"
}) {
  const childRef = useRef2();
  const [state, setState] = useState4({ hover: false });
  const { hover: hover2 } = state;
  return /* @__PURE__ */ jsxs20(Fragment, { children: [
    (title || content) && /* @__PURE__ */ jsx47(
      Popover_default,
      {
        open: hover2,
        referenceElement: childRef,
        placement,
        offset: [0, 4],
        children: ({ ref, style: style6, placement: placement2 }) => title ? /* @__PURE__ */ jsx47(
          View_default,
          {
            ref,
            style: style6,
            "data-placement": placement2,
            bg: "ink.1",
            p: "6px",
            borderRadius: "2px",
            boxShadow: 1,
            maxWidth,
            children: /* @__PURE__ */ jsx47(Text_default, { fontSize: "12px", color: "white", children: title })
          }
        ) : content?.({ ref, style: style6, placement: placement2 })
      }
    ),
    React8.cloneElement(children2, {
      ref: (node2) => {
        childRef.current = node2;
        const { ref } = children2;
        if (typeof ref === "function") {
          ref(node2);
        } else if (ref) {
          ref.current = node2;
        }
        return node2;
      },
      onPointerEnter: () => setState({ ...state, hover: true }),
      onPointerLeave: () => setState({ ...state, hover: false })
    })
  ] });
}
var Tooltip2_default = Tooltip2;

// src/components/Button.tsx
import { jsx as jsx48, jsxs as jsxs21 } from "react/jsx-runtime";
var LoadingIcon = styled22(Spinner_default)`
  width: 22px;
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;
var primaryVariant = {
  bg: "default.primary",
  color: "white",
  boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.1)",
  borderColor: "default.primary",
  "&:hover:not(:disabled)": {
    filter: "brightness(102%)"
  },
  "&:active:not(:disabled)": {
    filter: "brightness(95%)"
  },
  "&:focus:not(:disabled)": {
    boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.35)"
  }
};
var Button = styled22(Text_default)`
  ${variants_default(
  {
    variant: {
      primary: primaryVariant,
      secondary: {
        color: "default.primary",
        backgroundImage: "linear-gradient(to bottom, #f9fafb, #f4f6f8)",
        boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.1)",
        borderColor: "#c4cdd5",
        "&:hover:not(:disabled)": {
          backgroundImage: "linear-gradient(to bottom, #ffffff, #f9fafb)"
        },
        "&:active:not(:disabled)": {
          backgroundImage: "linear-gradient(to top, #f9fafb, #f4f6f8)"
        },
        "&:focus:not(:disabled)": {
          boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.35)"
        }
      },
      warning: {
        ...primaryVariant,
        bg: "default.red",
        borderColor: "default.red"
      },
      transparent: {
        color: "default.primary",
        bg: "transparent",
        borderColor: "transparent",
        "&:not(:disabled)": {
          textDecoration: "underline"
        }
      }
    },
    sizeVariant: {
      xs: {
        fontSize: ["18px", "14px"],
        pl: [4],
        pr: [4],
        height: ["48px", "32px"]
      },
      sm: {
        // minWidth: 'auto',
        fontSize: "14px",
        pl: [4],
        pr: [4],
        height: "36px"
      },
      md: {
        minWidth: "150px",
        pl: [6],
        pr: [6],
        width: ["100%", "unset"],
        fontSize: ["18px", "16px"],
        height: ["48px", "40px"]
      }
    }
  },
  Text_default.defaultProps
)}
  outline: none;
  white-space: nowrap;
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;
Button.defaultProps = {
  // Default variants
  sizeVariant: "md",
  variant: "primary",
  // Shared default properties
  as: "button",
  cursor: "pointer",
  display: "inline-block",
  borderRadius: 1,
  borderWidth: "1px",
  borderStyle: "solid",
  textAlign: "center"
};
function getSpacingPropsForButton({
  left,
  right,
  leftIcon,
  rightIcon,
  px,
  pl,
  pr
}) {
  const spacingProps = {};
  if (left || leftIcon) {
    spacingProps.pl = 0;
  }
  if (right || rightIcon) {
    spacingProps.pr = 0;
  }
  if (px) {
    spacingProps.pl = pl || px;
    spacingProps.pr = pr || px;
  }
  return spacingProps;
}
function getIconProps(place, { sizeVariant }) {
  const iconProps = {
    fill: "currentColor"
  };
  const isRight = place === "right";
  const marginLarge = isRight ? "mr" : "ml";
  const marginSmall = isRight ? "ml" : "mr";
  switch (sizeVariant) {
    case "sm":
      iconProps[marginLarge] = "6px";
      iconProps[marginSmall] = 1;
      iconProps.width = "20px";
      iconProps.height = "20px";
      break;
    case "xs":
      iconProps[marginLarge] = 2;
      iconProps[marginSmall] = 1;
      iconProps.width = ["28px", "18px"];
      iconProps.height = ["28px", "18px"];
      break;
    default:
      iconProps[marginLarge] = 4;
      iconProps[marginSmall] = 2;
      iconProps.width = "22px";
      iconProps.height = "22px";
      break;
  }
  return iconProps;
}
var Wrap2 = React9.forwardRef((props, ref) => {
  const {
    /* eslint-disable react/prop-types */
    children: children2,
    loading,
    disabled: disabled2,
    left = null,
    right = null,
    leftIcon,
    rightIcon,
    textAlign,
    contentWrapperProps,
    childrenWrapperProps,
    hint,
    tooltipProps,
    /* eslint-enable react/prop-types */
    ...rest
  } = props;
  const buttonSpacingProps = getSpacingPropsForButton(props);
  const Component17 = /* @__PURE__ */ jsxs21(
    Button,
    {
      ref,
      disabled: disabled2 || loading,
      position: "relative",
      ...buttonSpacingProps,
      ...rest,
      children: [
        loading && /* @__PURE__ */ jsx48(LoadingIcon, { fill: "currentColor", spinning: true, size: "22px" }),
        /* @__PURE__ */ jsx48(Flex_default, { justifyContent: "center", height: "100%", children: /* @__PURE__ */ jsxs21(
          Flex_default,
          {
            visibility: loading ? "hidden" : "visible",
            flex: "1",
            lineHeight: "normal",
            ...contentWrapperProps,
            children: [
              left,
              leftIcon && leftIcon(getIconProps("left", props)),
              /* @__PURE__ */ jsx48(View_default, { flex: "1", textAlign, ...childrenWrapperProps, children: children2 }),
              rightIcon && rightIcon(getIconProps("right", props)),
              right
            ]
          }
        ) })
      ]
    }
  );
  if (hint || tooltipProps) {
    const props2 = tooltipProps || {
      title: hint
    };
    return /* @__PURE__ */ jsx48(Tooltip2_default, { placement: "auto", ...props2, children: Component17 });
  }
  return Component17;
});
var Button_default = Wrap2;

// src/components/AddButton.tsx
import { jsx as jsx49 } from "react/jsx-runtime";
function AddButton(props) {
  return /* @__PURE__ */ jsx49(
    Button_default,
    {
      leftIcon: (p) => /* @__PURE__ */ jsx49(Plus_default, { fill: "primary.3", ...p, ml: 0 }),
      variant: "transparent",
      textAlign: "left",
      px: 0,
      ...props
    }
  );
}
var AddButton_default = AddButton;

// src/components/Alert.tsx
import React10, { useContext as useContext2, useMemo } from "react";
import { jsx as jsx50 } from "react/jsx-runtime";
var AlertContext = React10.createContext({});
var icons = {
  warning: {
    Icon: Alert_default,
    iconColor: "yellow.3"
  },
  error: {
    Icon: Alert_default,
    iconColor: "red.3"
  },
  default: {
    Icon: Questionmark_default,
    iconColor: "blue.5"
  }
};
function Icon({ ...rest }) {
  const { status } = useContext2(AlertContext);
  const { Icon: Icon3, iconColor } = icons[status] || {};
  if (!Icon3) {
    return null;
  }
  return /* @__PURE__ */ jsx50(Icon3, { fill: iconColor, height: "28px", width: "28px", mr: 2, ...rest });
}
var colors2 = {
  warning: {
    bg: "yellow.6",
    color: "yellow.2",
    borderColor: "yellow.5"
  },
  error: {
    bg: "red.6",
    color: "red.2",
    borderColor: "red.5"
  },
  default: {
    bg: "blue.6",
    color: "blue.2",
    borderColor: "blue.5"
  }
};
function Alert2({ status = "default", children: children2, ...rest }) {
  const value = useMemo(() => ({ status }), [status]);
  return /* @__PURE__ */ jsx50(AlertContext.Provider, { value, children: /* @__PURE__ */ jsx50(
    Text_default,
    {
      fontWeight: "semibold",
      fontSize: "14px",
      display: "flex",
      alignItems: "center",
      p: 3,
      border: 1,
      borderRadius: 1,
      ...colors2[status] || { color: "currentColor" },
      ...rest,
      children: children2
    }
  ) });
}
Alert2.Icon = Icon;
var Alert_default2 = Alert2;

// src/components/Attributes.tsx
import { themeGet as themeGet3 } from "@styled-system/theme-get";
import React11 from "react";
import styled23 from "styled-components";
import { jsx as jsx51, jsxs as jsxs22 } from "react/jsx-runtime";
var StyledFlex = styled23(Flex_default)`
  &:not(:last-of-type) {
    margin-bottom: ${themeGet3("space.2")}px;
  }
`;
var notAvailable = [void 0, null, false, ""];
function shouldRenderItem({
  value,
  placeholder
}) {
  return !notAvailable.includes(value) || placeholder;
}
function Attributes({
  sections = [],
  defaultWidth,
  labelWidth,
  ...rest
}) {
  if (defaultWidth) {
    console.warn(
      "Attributes: `defaultWidth` prop is no longer needed as we use `useLayoutEffect` to prevent flickering after first paint. Please remove it."
    );
  }
  const [width, setWidth] = React11.useState("small");
  const container = React11.useRef();
  function handleContainerSizeChange() {
    if (container.current) {
      setWidth(
        container.current.offsetWidth > 577 ? "large" : container.current.offsetWidth > 400 ? "medium" : "small"
      );
    }
  }
  React11.useLayoutEffect(() => {
    handleContainerSizeChange();
    window.addEventListener("resize", handleContainerSizeChange);
    return () => window.removeEventListener("resize", handleContainerSizeChange);
  }, [width]);
  const shouldRenderComponent = sections.find(
    (attributes) => attributes.find(shouldRenderItem)
  );
  return shouldRenderComponent ? /* @__PURE__ */ jsx51(View_default, { ref: container, ...rest, children: sections.map(
    (attributes, index) => !attributes.find(shouldRenderItem) ? null : /* @__PURE__ */ jsx51(View_default, { mb: index < sections.length - 1 ? 5 : 0, children: attributes.map(
      ({ label, value, formattedValue, placeholder }) => shouldRenderItem({ value, placeholder }) ? /* @__PURE__ */ jsxs22(
        StyledFlex,
        {
          justifyContent: "flex-start",
          flexDirection: [
            "column",
            width !== "small" ? "row" : "column"
          ],
          alignItems: [
            "stretch",
            width !== "small" ? "flex-start" : "stretch"
          ],
          children: [
            /* @__PURE__ */ jsx51(
              Caption,
              {
                width: [
                  "100%",
                  labelWidth || (width === "large" ? "220px" : width === "medium" ? "200px" : "100%")
                ],
                mr: [0, 5],
                color: "ink.2",
                "data-testid": "attribute-label",
                children: label
              }
            ),
            /* @__PURE__ */ jsx51(
              Caption,
              {
                color: "ink.0",
                flex: "1",
                fontSize: [2, 1],
                style: {
                  wordBreak: "break-word",
                  whiteSpace: "pre-wrap"
                },
                "data-testid": "attribute-value",
                children: !notAvailable.includes(value) ? formattedValue || value : placeholder
              }
            )
          ]
        },
        `${label}${value}`
      ) : null
    ) }, index)
  ) }) : null;
}
var Attributes_default = Attributes;

// src/components/Avatar/index.tsx
import styled24 from "styled-components";
import { jsx as jsx52 } from "react/jsx-runtime";
var Circle2 = styled24(View_default)`
  ${variants_default({
  sizeVariant: {
    small: {
      width: "18px",
      height: "18px",
      fontSize: "8px"
    },
    normal: {
      width: ["36px", "25px"],
      height: ["36px", "25px"],
      fontSize: ["14px", "10px"]
    },
    fixed: {
      width: ["25px"],
      height: ["25px"],
      fontSize: ["10px"]
    }
  }
})}
`;
Circle2.defaultProps = {
  borderWidth: 1,
  borderStyle: "solid",
  borderRadius: "50%",
  borderColor: "sky.0",
  bg: "white",
  sizeVariant: "normal"
};
function Avatar({
  children: children2,
  name,
  color: color2 = "ink.2",
  sizeVariant,
  ...rest
}) {
  return /* @__PURE__ */ jsx52(Tooltip2_default, { title: name, children: /* @__PURE__ */ jsx52(
    Circle2,
    {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "default",
      sizeVariant,
      color: color2,
      ...rest,
      children: /* @__PURE__ */ jsx52(Text_default, { fontSize: "inherit", color: "inherit", lineHeight: "1", children: children2 || name?.toUpperCase().split(" ").map((s) => s.charAt(0)).join("").slice(0, 2) })
    }
  ) });
}
var StyledAvatar = styled24(Avatar)``;
var Avatar_default = StyledAvatar;

// src/components/Avatar/AvatarList.tsx
import { themeGet as themeGet4 } from "@styled-system/theme-get";
import React12, { useEffect as useEffect5, useState as useState5 } from "react";
import styled25 from "styled-components";
import { jsx as jsx53 } from "react/jsx-runtime";
import { createElement } from "react";
var AvatarList = styled25(View_default)`
  ${Avatar_default}:not(:first-of-type) {
    margin-left: -${themeGet4("space.1")}px;
  }

  ${Avatar_default}:hover {
    z-index: ${(p) => React12.Children.toArray(p.children)?.length};
  }

  ${({ children: children2 }) => React12.Children.map(
  children2,
  (_, i) => `
        ${Avatar_default}:not(:hover):nth-of-type(${i + 1}) {
          z-index: ${React12.Children.toArray(children2)?.length - (i + 1)};
        }
      `
)}
`;
AvatarList.defaultProps = {
  display: "flex",
  bg: "inherit"
};
function getAvatarsToDisplay(hover2, children2, maxAvatars) {
  const avatars = React12.Children.toArray(children2);
  if (!hover2 && avatars?.length > maxAvatars) {
    const plusText = `+${avatars?.length - maxAvatars}`;
    const plusProps = avatars[0].props;
    return [
      ...avatars.slice(0, maxAvatars),
      /* @__PURE__ */ createElement(Avatar_default, { ...plusProps, key: plusText }, plusText)
    ];
  }
  return children2;
}
function CollapsibleAvatarList({
  maxAvatars = 4,
  children: children2,
  ...rest
}) {
  const [hover2, setHover] = useState5(false);
  const [avatars, setAvatars] = useState5(
    () => getAvatarsToDisplay(hover2, children2, maxAvatars)
  );
  useEffect5(() => {
    setAvatars(getAvatarsToDisplay(hover2, children2, maxAvatars));
  }, [children2, hover2, maxAvatars]);
  return /* @__PURE__ */ jsx53(
    AvatarList,
    {
      ...rest,
      onMouseEnter: () => setHover(true),
      onMouseLeave: () => setHover(false),
      children: avatars
    }
  );
}
var AvatarList_default = CollapsibleAvatarList;

// src/components/Banner.tsx
import styled27 from "styled-components";

// src/components/Box.tsx
import { themeGet as themeGet5 } from "@styled-system/theme-get";
import styled26, { css as css3 } from "styled-components";
var Box = styled26(View_default)`
  ${variants_default({
  variant: {
    content: {
      p: [0, 10],
      border: [0, 1],
      bg: ["transparent", "white"],
      boxShadow: ["none", 1],
      borderRadius: [0, 1]
    },
    normal: {
      p: 5,
      border: 1,
      bg: "white",
      boxShadow: void 0,
      borderRadius: 1
    }
  }
})}
  ${(p) => p.variant === "content" && css3`
      @media (max-width: ${themeGet5("breakpoints.0")}) {
        position: relative;
        padding-bottom: 40px;
        &:not(:last-of-type):after {
          width: 86%;
          height: 1px;
          background-color: ${themeGet5("colors.sky.1")};
          content: '';
          position: absolute;
          bottom: 0;
          left: 7%;
        }
      }
    `}
`;
Box.defaultProps = {
  variant: "normal",
  width: "100%"
};
var Box_default = Box;

// src/components/Banner.tsx
import { jsx as jsx54, jsxs as jsxs23 } from "react/jsx-runtime";
var customColor = {
  green: {
    bg: "green.3",
    color: "green.2"
  },
  yellow: {
    bg: "yellow.3",
    color: "yellow.2"
  }
};
var Line = styled27(View_default)`
  position: absolute;
  top: 0;
  left: 0;
  height: 4px;
  border-radius: 4px 4px 0 0;
`;
Line.defaultProps = {
  width: "100%",
  bg: "sky.0"
};
var Container = styled27(Box_default)`
  position: relative;
  border-top: none;
`;
Container.defaultProps = {
  p: [4, 5],
  bg: "white",
  boxShadow: 1,
  width: "auto"
};
var Title2 = styled27(Heading)``;
Title2.defaultProps = {
  color: "ink.2",
  mb: 1
};
var Banner = ({ title, color: color2, children: children2, ...rest }) => {
  const custom = color2 ? customColor[color2] : void 0;
  const line = custom ? custom.bg : `${color2}.3`;
  const text = custom ? custom.color : `${color2}.3`;
  return /* @__PURE__ */ jsxs23(Container, { ...rest, children: [
    /* @__PURE__ */ jsx54(Line, { bg: color2 ? line : void 0 }),
    title && /* @__PURE__ */ jsx54(Title2, { color: color2 ? text : void 0, children: title }),
    children2
  ] });
};
var Banner_default = Banner;

// src/components/Breadcrumb/index.tsx
import React14 from "react";

// src/components/Breadcrumb/assets/ArrowLeft.tsx
import { jsx as jsx55 } from "react/jsx-runtime";
var ArrowLeft2 = (props) => /* @__PURE__ */ jsx55(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    ...props,
    children: /* @__PURE__ */ jsx55(
      "g",
      {
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /* @__PURE__ */ jsx55("g", { children: /* @__PURE__ */ jsx55("g", { transform: "translate(-228 -24) translate(220 16)", children: /* @__PURE__ */ jsx55("g", { children: /* @__PURE__ */ jsx55("g", { stroke: "currentColor", strokeWidth: "2", children: /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M5.833 11.667L0 5.833m0 0L5.833 0M0 5.833h15",
            transform: "translate(8 8) translate(2.5 4.166667)"
          }
        ) }) }) }) })
      }
    )
  }
);
var ArrowLeft_default2 = ArrowLeft2;

// src/components/Breadcrumb/Item.tsx
import { useMemo as useMemo2 } from "react";
import { jsx as jsx56 } from "react/jsx-runtime";
function Item({
  children: children2,
  isLast,
  isFirst,
  innerProps,
  ...rest
}) {
  const clipPath = useMemo2(() => {
    if (isLast) {
      return "polygon(0% 0%, 100% 0%, 100% 50%, 100% 100%, 0% 100%, 12px 50%)";
    }
    if (isFirst) {
      return "polygon(0% 0%, calc(100% - 12px) 0%, 100% 50%, calc(100% - 12px) 100%, 0% 100%, 0px 50%)";
    }
    return "polygon(0% 0%, calc(100% - 12px) 0%, 100% 50%, calc(100% - 12px) 100%, 0% 100%, 12px 50%)";
  }, [isLast, isFirst]);
  return /* @__PURE__ */ jsx56(View_default, { ...rest, children: /* @__PURE__ */ jsx56(
    View_default,
    {
      as: "li",
      py: 2,
      pl: isFirst ? 3 : 6,
      pr: isLast ? 3 : 5,
      bg: "white",
      mr: isLast ? 0 : "-11px",
      style: {
        clipPath
      },
      cursor: "pointer",
      _hover: { bg: "sky.3" },
      transition: "0.2s all",
      ...innerProps,
      children: /* @__PURE__ */ jsx56(Caption, { color: "ink.0", children: children2 })
    }
  ) });
}
var Item_default = Item;

// src/components/Breadcrumb/index.tsx
import { jsx as jsx57, jsxs as jsxs24 } from "react/jsx-runtime";
function Breadcrumb({ onBackClick, children: children2, ...rest }) {
  const items = React14.Children.toArray(children2);
  return /* @__PURE__ */ jsxs24(
    View_default,
    {
      as: "nav",
      display: "flex",
      bg: "white",
      border: 1,
      borderColor: "sky.0",
      boxShadow: 2,
      borderRadius: 1,
      width: "fit-content",
      overflow: "hidden",
      ...rest,
      children: [
        /* @__PURE__ */ jsx57(
          Flex_default,
          {
            borderRight: 1,
            borderColor: "sky.0",
            p: 2,
            color: "ink.0",
            transition: "0.2s background",
            _hover: { bg: "sky.3" },
            cursor: "pointer",
            onClick: () => onBackClick(),
            children: /* @__PURE__ */ jsx57(View_default, { as: ArrowLeft_default2 })
          }
        ),
        /* @__PURE__ */ jsx57(View_default, { as: "ol", display: "flex", bg: "sky.0", children: items.map(
          (item, i) => (
            // @ts-ignore
            React14.cloneElement(item, {
              isLast: i === items.length - 1,
              isFirst: i === 0
            })
          )
        ) })
      ]
    }
  );
}
Breadcrumb.Item = Item_default;
var Breadcrumb_default = Breadcrumb;

// src/components/ButtonGroup.tsx
import { Children, cloneElement, isValidElement } from "react";
import { jsx as jsx58 } from "react/jsx-runtime";
import { createElement as createElement2 } from "react";
var ButtonGroup = ({
  children: children2,
  spacing = 4,
  shouldWrapChildren,
  ...rest
}) => {
  const validChildrenArray = Children.toArray(children2).filter(isValidElement);
  return /* @__PURE__ */ jsx58(
    Flex_default,
    {
      justifyContent: ["stretch", "flex-start"],
      alignItems: ["stretch", "center"],
      flexDirection: ["column", "row"],
      flex: [1, null],
      ...rest,
      children: validChildrenArray.map((child, index) => {
        const isLastChild = validChildrenArray.length === index + 1;
        const isFirstChlid = index === 0;
        const spacingProps = {
          mr: isLastChild ? null : [0, spacing],
          mb: isLastChild ? null : [spacing, 0],
          borderRightWidth: spacing === 0 && !isLastChild ? ["1px !important", "0px !important"] : null,
          borderBottomWidth: spacing === 0 && !isLastChild ? ["0px !important", "1px !important"] : null,
          borderRadius: spacing !== 0 ? 1 : isLastChild ? ["0 0 4px 4px", "0 4px 4px 0"] : isFirstChlid ? ["4px 4px 0 0", "4px 0 0 4px"] : 0
        };
        if (shouldWrapChildren) {
          return /* @__PURE__ */ createElement2(
            View_default,
            {
              display: "inline-block",
              ...spacingProps,
              key: `buttongroup-view-wrapper-${index}`
            },
            child
          );
        }
        return cloneElement(child, spacingProps);
      })
    }
  );
};
var ButtonGroup_default = ButtonGroup;

// src/components/Card.tsx
import React16, { useContext as useContext3 } from "react";
import styled28 from "styled-components";
import { jsx as jsx59, jsxs as jsxs25 } from "react/jsx-runtime";
var CardContext = React16.createContext({ color: "default" });
var customColor2 = {
  default: {
    bg: "white",
    border: "sky.1"
  },
  green: {
    bg: "green.6",
    border: "green.3"
  },
  yellow: {
    bg: "yellow.6",
    border: "yellow.3"
  }
};
var Title3 = styled28(Heading)``;
Title3.defaultProps = {
  color: "ink.0",
  mb: 1,
  fontWeight: "semibold"
};
function Footer(props) {
  const { color: color2 } = useContext3(CardContext);
  const custom = customColor2[color2];
  const borderColor = custom ? custom.border : `${color2}.4`;
  return /* @__PURE__ */ jsx59(View_default, { borderTopColor: borderColor, ...props });
}
Footer.defaultProps = {
  borderTopWidth: "1px",
  borderTopStyle: "solid",
  mt: "16px",
  mx: "-16px",
  mb: "-16px",
  borderRadius: "0 0 4px 4px"
};
function Button2(props) {
  const { color: color2 } = useContext3(CardContext);
  return /* @__PURE__ */ jsx59(
    Button_default,
    {
      variant: "transparent",
      width: "100%",
      color: `${color2 === "default" ? "primary" : color2}.3`,
      textDecoration: "none !important",
      _hover: {
        bg: "sky.3"
      },
      _active: {
        bg: "sky.2"
      },
      ...props
    }
  );
}
var Card2 = ({
  title,
  color: color2 = "default",
  children: children2,
  footer,
  ...rest
}) => {
  const custom = customColor2[color2];
  const borderColor = custom ? custom.border : `${color2}.4`;
  const bg = custom ? custom.bg : `${color2}.6`;
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    /* @__PURE__ */ jsx59(CardContext.Provider, { value: { color: color2 }, children: /* @__PURE__ */ jsxs25(
      View_default,
      {
        boxShadow: 1,
        borderRadius: 1,
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor,
        bg,
        p: 4,
        ...rest,
        children: [
          title && /* @__PURE__ */ jsx59(Title3, { fontWeight: "normal", children: title }),
          children2,
          footer && /* @__PURE__ */ jsx59(Footer, { children: footer })
        ]
      }
    ) })
  );
};
Card2.Title = Title3;
Card2.Footer = Footer;
Card2.Button = Button2;
var Card_default = Card2;

// src/components/CollapseSection.tsx
import React17 from "react";
import { jsx as jsx60, jsxs as jsxs26 } from "react/jsx-runtime";
function CollapseSection({
  children: children2,
  isOpenByDefault = false,
  openText = "Open",
  closeText = "Close",
  ...rest
}) {
  const [isOpen, setOpen] = React17.useState(isOpenByDefault);
  const height = isOpen ? "auto" : 0;
  return children2 ? /* @__PURE__ */ jsxs26(View_default, { ...rest, children: [
    /* @__PURE__ */ jsxs26(Flex_default, { children: [
      /* @__PURE__ */ jsx60(View_default, { bg: "sky.0", width: "100%", height: "1px" }),
      /* @__PURE__ */ jsxs26(Flex_default, { cursor: "pointer", onClick: () => setOpen(!isOpen), ml: 4, mr: 3, children: [
        /* @__PURE__ */ jsx60(Caption, { whiteSpace: "nowrap", children: isOpen ? closeText : openText }),
        /* @__PURE__ */ jsx60(
          Flex_default,
          {
            transform: isOpen ? `rotate(180deg)` : `rotate(0deg)`,
            transition: "transform 0.2s",
            ml: 2,
            children: /* @__PURE__ */ jsx60(ArrowDown_default, { fill: "ink.2" })
          }
        )
      ] }),
      /* @__PURE__ */ jsx60(View_default, { bg: "sky.0", width: "100%", height: "1px" })
    ] }),
    /* @__PURE__ */ jsx60(AnimateHeight_default, { duration: 200, height, children: children2 })
  ] }) : null;
}
var CollapseSection_default = CollapseSection;

// src/components/Comments/Comment.tsx
import styled29 from "styled-components";

// src/hooks/usePromise.ts
import { useCallback, useEffect as useEffect6, useRef as useRef3, useState as useState6 } from "react";
var initialState = {
  success: false,
  pending: false,
  error: null,
  value: null,
  args: []
};
function usePromise(promise, options = {}) {
  const mounted = useRef3(true);
  useEffect6(
    () => () => {
      mounted.current = false;
    },
    []
  );
  const onSuccess = useCallback((value) => {
    options.onSuccess?.(value);
  }, []);
  const onError = useCallback((error) => {
    options.onError?.(error);
  }, []);
  const [state, setState] = useState6(initialState);
  const trigger = useCallback(
    async (...args) => {
      mounted.current && setState({
        ...initialState,
        pending: true,
        args
      });
      try {
        const value = await promise(...args);
        mounted.current && setState({
          ...initialState,
          pending: false,
          success: true,
          value,
          args
        });
        onSuccess(value);
      } catch (e) {
        mounted.current && setState({
          ...initialState,
          error: e,
          args
        });
        onError(e);
      }
    },
    [promise, onSuccess, onError]
  );
  const reset = useCallback(() => {
    mounted.current && setState(initialState);
  }, []);
  return [trigger, state, reset];
}
var usePromise_default = usePromise;

// src/utils/formatDate.js
function formatDate(date, withTime) {
  const dtf = new Intl.DateTimeFormat("en", {
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour12: true
  });
  const dateObject = new Date(date);
  const [
    { value: MMM },
    ,
    { value: DD2 },
    ,
    { value: YYYY },
    ,
    { value: hh },
    ,
    { value: mm },
    ,
    ,
    ,
    { value: dayPeriod }
  ] = dtf.formatToParts(dateObject);
  return `${DD2} ${MMM} ${YYYY}${withTime ? ` at ${`0${hh}`.slice(-2)}:${mm} ${dayPeriod.toLocaleLowerCase()}` : ""}`;
}
var formatDate_default = formatDate;

// src/components/Comments/Comment.tsx
import { jsx as jsx61, jsxs as jsxs27 } from "react/jsx-runtime";
var Header = styled29(Flex_default)``;
Header.defaultProps = {
  justifyContent: "flex-start",
  alignItems: "baseline",
  mb: 1
};
var AuthorName = styled29(Text_default)``;
AuthorName.defaultProps = {
  fontSize: "14px",
  lineHeight: "16px",
  color: "ink.1",
  fontWeight: "semibold"
};
var CreatedAt = styled29(Text_default)``;
CreatedAt.defaultProps = {
  fontSize: "14px",
  color: "ink.2",
  ml: 2
};
var Body = styled29(Text_default)`
  white-space: pre-line;

  /* Forcing break */
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  word-break: break-all;
  word-break: break-word;
`;
Body.defaultProps = {
  fontSize: "14px",
  lineHeight: "24px",
  color: "ink.1",
  px: 3,
  py: 2,
  borderRadius: 1,
  border: 1,
  bg: "white"
};
var Actions = styled29(Flex_default)``;
Actions.defaultProps = {
  justifyContent: "flex-start",
  mt: 1
};
var ActionLabel = styled29(Clickable)``;
ActionLabel.defaultProps = {
  fontSize: "14px",
  color: "ink.2",
  fontWeight: "regular",
  mr: 2
};
function linkify(text) {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.split(urlRegex).map((part) => {
    if (part.match(urlRegex)) {
      return /* @__PURE__ */ jsx61(Clickable, { as: "a", href: part, target: "_blank", rel: "noopener noreferrer", children: part });
    }
    return part;
  });
}
function Comment({ data, onDelete, ...rest }) {
  const [trigger, { pending, error }] = usePromise_default(onDelete || (() => null));
  const date = new Date(data.createdAt);
  const formattedDate = formatDate_default(date, true);
  return /* @__PURE__ */ jsxs27(View_default, { ...rest, children: [
    /* @__PURE__ */ jsxs27(Header, { children: [
      /* @__PURE__ */ jsx61(AuthorName, { "data-testid": "comment-author", children: data?.userName }),
      /* @__PURE__ */ jsx61(CreatedAt, { "data-testid": "comment-created-at", children: formattedDate })
    ] }),
    /* @__PURE__ */ jsx61(Body, { "data-testid": "comment-body", children: linkify(data?.content) }),
    onDelete && /* @__PURE__ */ jsx61(Actions, { children: /* @__PURE__ */ jsx61(
      ActionLabel,
      {
        onClick: pending ? void 0 : () => trigger(data),
        cursor: pending ? "progress" : void 0,
        children: "Delete"
      }
    ) }),
    !!error && /* @__PURE__ */ jsx61(Caption, { color: "red.2", my: 2, children: error?.message || "Woops, there was an error." })
  ] });
}
Comment.Header = Header;
Comment.AuthorName = AuthorName;
Comment.CreatedAt = CreatedAt;
Comment.Body = Body;
var Comment_default = Comment;

// src/components/Comments/CommentList.tsx
import { jsx as jsx62, jsxs as jsxs28 } from "react/jsx-runtime";
function CommentList({
  data = [],
  onDelete,
  shouldDisplayDelete,
  ...rest
}) {
  return /* @__PURE__ */ jsx62(View_default, { ...rest, children: data.map((comment, index) => {
    const isLastItem = index === data.length - 1;
    return /* @__PURE__ */ jsxs28(Flex_default, { alignItems: "stretch", mt: 3, children: [
      /* @__PURE__ */ jsxs28(Flex_default, { flexDirection: "column", mr: 3, children: [
        /* @__PURE__ */ jsx62(Avatar_default, { name: comment.userName, mb: 2 }),
        !isLastItem && /* @__PURE__ */ jsx62(View_default, { width: "1px", bg: "#e2e5e7", flex: "1" })
      ] }),
      /* @__PURE__ */ jsx62(
        Comment_default,
        {
          flex: "1",
          data: comment,
          onDelete: onDelete && shouldDisplayDelete?.(comment) ? onDelete : void 0,
          "data-testid": "comment-item"
        }
      )
    ] }, comment.id);
  }) });
}
var CommentList_default = CommentList;

// src/components/Comments/Create.tsx
import { useCallback as useCallback3, useReducer } from "react";

// src/components/Form/Textarea/TextareaAutosize.tsx
import React19, { useEffect as useEffect7, useCallback as useCallback2 } from "react";

// src/components/Form/Textarea/index.tsx
import { themeGet as themeGet6 } from "@styled-system/theme-get";
import React18 from "react";
import styled30, { css as css4 } from "styled-components";
import { jsx as jsx63 } from "react/jsx-runtime";
var Base2 = styled30(Text_default)`
  cursor: text;
  position: relative;
  outline: none;
  overflow: auto;

  ${(p) => p.disabled && css4`
      background-color: ${themeGet6("colors.sky.3")};
      cursor: not-allowed;
    `}

  resize: ${(p) => p.resize};

  &::placeholder {
    color: ${themeGet6("colors.ink.2")};
  }
  &:disabled {
    cursor: not-allowed;
    color: ${themeGet6("colors.ink.2")};
  }
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
  }
  &:-webkit-contacts-auto-fill-button {
    visibility: hidden;
    display: none !important;
    pointer-events: none;
    position: absolute;
    right: 0;
  }
`;
Base2.defaultProps = {
  as: "textarea",
  bg: "sky.2",
  borderWidth: "1px",
  borderColor: "sky.2",
  borderStyle: "solid",
  borderRadius: "3px",
  color: "ink.1",
  minHeight: "150px",
  p: 2,
  fontWeight: "regular",
  resize: "none",
  _hover: {
    borderColor: "sky.1"
  },
  _focus: {
    borderColor: "sky.0"
  }
};
var Textarea = React18.forwardRef(
  ({ input, ...rest }, ref) => /* @__PURE__ */ jsx63(Base2, { ...input, ...rest, ref })
);
var Textarea_default = Textarea;

// src/components/Form/Textarea/TextareaAutosize.tsx
import { jsx as jsx64 } from "react/jsx-runtime";
function getLineHeight(el) {
  let lineHeight;
  if (el.currentStyle) {
    lineHeight = el.currentStyle["line-height"];
  } else if (window.getComputedStyle)
    lineHeight = document.defaultView.getComputedStyle(el, null).getPropertyValue("line-height");
  lineHeight = Number(lineHeight.replace("px", ""));
  return lineHeight;
}
var TextareaAutosize = React19.forwardRef(({ input, minRows = 1, maxRows = Infinity, ...rest }, ref) => {
  const inputRef = React19.useMemo(() => {
    if (ref) {
      return ref;
    }
    return React19.createRef();
  }, [ref]);
  const resize = useCallback2(() => {
    const textarea = inputRef.current;
    if (textarea) {
      const lineHeight = getLineHeight(textarea);
      textarea.rows = minRows;
      const currentRows = Math.floor(textarea.scrollHeight / lineHeight);
      textarea.rows = Math.min(Math.max(currentRows, minRows), maxRows);
    }
  }, [inputRef, minRows, maxRows]);
  useEffect7(() => {
    resize();
    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [resize]);
  const value = input?.value ?? "";
  useEffect7(() => {
    resize();
  }, [resize, value]);
  return /* @__PURE__ */ jsx64(
    Textarea_default,
    {
      ref: inputRef,
      minHeight: null,
      rows: minRows,
      ...input,
      ...rest
    }
  );
});
var TextareaAutosize_default = TextareaAutosize;

// src/components/Comments/Create.tsx
import { jsx as jsx65, jsxs as jsxs29 } from "react/jsx-runtime";
var initialState2 = {
  submitting: false,
  error: null,
  success: true,
  touched: false,
  valid: false,
  active: false,
  value: ""
};
function Create({
  currentUserName,
  onSubmit,
  validate = (v) => v?.length > 2,
  placeholder = "Write a comment\u2026",
  ...rest
}) {
  const reducer = useCallback3(
    (state, action) => {
      switch (action.type) {
        case "focus":
          return {
            ...state,
            touched: true,
            active: true
          };
        case "blur":
          return {
            ...state,
            touched: true,
            active: false
          };
        case "change":
          return {
            ...state,
            value: action.payload,
            valid: validate(action.payload)
          };
        case "submitting":
          return {
            ...state,
            submitting: true,
            error: null
          };
        case "error":
          return {
            ...state,
            submitting: false,
            error: action.payload
          };
        case "success":
          return {
            ...initialState2,
            success: true
          };
        case "reset":
          return initialState2;
        default:
          return state;
      }
    },
    [validate]
  );
  const [{ active: active2, valid, value, error, submitting }, dispatch] = useReducer(
    reducer,
    initialState2
  );
  async function handleSubmit() {
    if (valid) {
      dispatch({ type: "submitting" });
      try {
        await onSubmit(value);
        document.activeElement.blur();
        dispatch({ type: "success" });
      } catch (e) {
        dispatch({ type: "error", payload: e });
      }
    }
  }
  return /* @__PURE__ */ jsxs29(Flex_default, { alignItems: "flex-start", ...rest, children: [
    /* @__PURE__ */ jsx65(Avatar_default, { name: currentUserName, mt: 1, mr: 3 }),
    /* @__PURE__ */ jsxs29(View_default, { flex: "1", children: [
      /* @__PURE__ */ jsx65(
        TextareaAutosize_default,
        {
          width: "100%",
          minRows: 1,
          maxRows: 10,
          placeholder,
          fontSize: "14px",
          lineHeight: "20px",
          px: 2,
          py: "6px",
          p: null,
          input: {
            onFocus: () => dispatch({ type: "focus" }),
            onBlur: () => dispatch({ type: "blur" }),
            onChange: (e) => dispatch({ type: "change", payload: e.target.value }),
            value
          },
          onKeyDown: (e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              return handleSubmit();
            }
          },
          "data-testid": "comment-input"
        }
      ),
      !!error && /* @__PURE__ */ jsx65(Caption, { color: "red.2", my: 2, children: error?.message || "Woops, there was an error." }),
      (active2 || value) && /* @__PURE__ */ jsx65(
        Button_default,
        {
          sizeVariant: "sm",
          onClick: handleSubmit,
          loading: submitting,
          disabled: !valid,
          mt: 2,
          children: "Post"
        }
      )
    ] })
  ] });
}
var Create_default = Create;

// src/components/Comments/index.tsx
import { jsx as jsx66, jsxs as jsxs30 } from "react/jsx-runtime";
function Comments({
  comments,
  user,
  onSubmit,
  onDelete,
  validate,
  placeholder,
  ...rest
}) {
  return /* @__PURE__ */ jsxs30(View_default, { ...rest, children: [
    /* @__PURE__ */ jsx66(
      Create_default,
      {
        onSubmit,
        currentUserName: `${user?.firstName} ${user?.lastName}`,
        validate,
        placeholder
      }
    ),
    /* @__PURE__ */ jsx66(
      CommentList_default,
      {
        data: comments,
        onDelete,
        shouldDisplayDelete: (c) => c.userID === user?.id
      }
    )
  ] });
}
var Comments_default = Comments;

// src/components/Confirmation.tsx
import React21, { useEffect as useEffect8, useRef as useRef4, useState as useState7 } from "react";
import { Fragment as Fragment2, jsx as jsx67, jsxs as jsxs31 } from "react/jsx-runtime";
function Confirmation({
  content,
  children: children2,
  onConfirm,
  onReject,
  confirmText = "Yes",
  rejectText = "Cancel",
  onOpenChange,
  ...rest
}) {
  const [open, setOpen] = useState7(false);
  const ref = useRef4();
  useEffect8(() => {
    onOpenChange && onOpenChange(open);
  }, [onOpenChange, open]);
  return /* @__PURE__ */ jsxs31(Fragment2, { children: [
    /* @__PURE__ */ jsx67(
      Popover_default,
      {
        open,
        referenceElement: ref,
        onClickOut: () => setOpen(false),
        children: ({ arrowProps, update, forceUpdate, ...popper }) => /* @__PURE__ */ jsxs31(
          View_default,
          {
            bg: "white",
            border: 1,
            borderRadius: 1,
            boxShadow: 1,
            p: 4,
            ...popper,
            ...rest,
            display: popper?.["data-popper-reference-hidden"] ? "none" : void 0,
            children: [
              /* @__PURE__ */ jsx67(Prompt, { mb: 3, children: content }),
              /* @__PURE__ */ jsxs31(Flex_default, { justifyContent: "flex-start", children: [
                /* @__PURE__ */ jsx67(
                  Button_default,
                  {
                    sizeVariant: "sm",
                    variant: "secondary",
                    color: "red.3",
                    onClick: () => {
                      onConfirm && onConfirm();
                      setOpen(false);
                    },
                    mr: 3,
                    children: confirmText
                  }
                ),
                /* @__PURE__ */ jsx67(
                  Button_default,
                  {
                    sizeVariant: "sm",
                    variant: "secondary",
                    color: "ink.2",
                    onClick: () => {
                      onReject && onReject();
                      setOpen(false);
                    },
                    children: rejectText
                  }
                )
              ] }),
              /* @__PURE__ */ jsx67(
                Popover_default.Arrow,
                {
                  ...arrowProps,
                  _before: { bg: "white", borderTop: 1, borderLeft: 1 }
                }
              )
            ]
          }
        )
      }
    ),
    React21.cloneElement(children2, {
      ref,
      onClick: (e) => {
        setOpen(!open);
        children2.props.onClick && children2.props.onClick(e);
      }
    })
  ] });
}
var Confirmation_default = Confirmation;

// src/components/Container.tsx
import styled31 from "styled-components";
import { jsx as jsx68 } from "react/jsx-runtime";
var Wrap3 = styled31(View_default)`
  &:before,
  &:after {
    content: ' ';
    display: table;
  }
`;
var Content = styled31(View_default)``;
Content.defaultProps = {
  maxWidth: theme_default.maxWidths[0],
  width: "100%",
  mx: "auto"
};
var Container2 = ({
  children: children2,
  bg = "default.sky",
  wrapStyle,
  wrapProps,
  ...rest
}) => /* @__PURE__ */ jsx68(Wrap3, { bg, style: { height: "auto", ...wrapStyle }, ...wrapProps, children: /* @__PURE__ */ jsx68(Content, { ...rest, children: children2 }) });
var Container_default = Container2;

// src/components/DataTable/index.tsx
import PropTypes10 from "prop-types";
import {
  useCallback as useCallback8,
  useEffect as useEffect13,
  useMemo as useMemo4,
  useRef as useRef6,
  useState as useState14
} from "react";
import styled40 from "styled-components";

// src/hooks/useJSONQueryStringReducer.js
import { useCallback as useCallback5, useMemo as useMemo3 } from "react";

// src/hooks/useSearchQueryState.js
import { useCallback as useCallback4, useEffect as useEffect9, useState as useState8 } from "react";

// src/utils/queryString.js
import qs from "query-string";
var setQueryStringWithoutPageReload = (qsValue) => {
  const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${qsValue}`;
  window.history.pushState({ path: newurl }, "", newurl);
};
var getQueryStringValue = (key, queryString = window.location.search) => {
  const values = qs.parse(queryString);
  return values[key];
};
var setQueryStringValue = (key, value, queryString = window.location.search) => {
  const values = qs.parse(queryString);
  const newQsValue = qs.stringify({
    ...values,
    [key]: value
  });
  setQueryStringWithoutPageReload(`?${newQsValue}`);
};

// src/hooks/useSearchQueryState.js
function useSearchQueryState(key, initialValue) {
  const [value, setValue] = useState8(getQueryStringValue(key) || initialValue);
  const onSetValue = useCallback4(
    (newValue) => {
      setValue(newValue);
      setQueryStringValue(key, newValue);
    },
    [key]
  );
  useEffect9(() => {
    function popState() {
      setValue(getQueryStringValue(key) || initialValue);
    }
    window.addEventListener("popstate", popState);
    return () => {
      window.removeEventListener("popstate", popState);
    };
  }, [key, initialValue]);
  return [value, onSetValue];
}
var useSearchQueryState_default = useSearchQueryState;

// src/hooks/useJSONQueryStringReducer.js
function useJSONQueryStringReducer(key, reducer, initialValue) {
  const [jsonString, setJsonString] = useSearchQueryState_default(
    key,
    JSON.stringify(initialValue)
  );
  const state = useMemo3(() => {
    try {
      return JSON.parse(jsonString);
    } catch (e) {
      return {};
    }
  }, [jsonString]);
  const dispatch = useCallback5(
    (action) => {
      const newState = reducer(state, action);
      setJsonString(JSON.stringify(newState));
    },
    [reducer, state, setJsonString]
  );
  return [state, dispatch];
}
var useJSONQueryStringReducer_default = useJSONQueryStringReducer;

// src/utils/debounce.js
function debounce(fn, wait = 0, options = {}) {
  let lastCallAt;
  let deferred;
  let timer;
  let pendingArgs = [];
  return function debounced(...args) {
    const currentWait = getWait(wait);
    const currentTime = (/* @__PURE__ */ new Date()).getTime();
    const isCold = !lastCallAt || currentTime - lastCallAt > currentWait;
    lastCallAt = currentTime;
    if (isCold && options.leading) {
      return options.accumulate ? Promise.resolve(fn.call(this, [args])).then((result) => result[0]) : Promise.resolve(fn.call(this, ...args));
    }
    if (deferred) {
      clearTimeout(timer);
    } else {
      deferred = defer();
    }
    pendingArgs.push(args);
    timer = setTimeout(flush.bind(this), currentWait);
    if (options.accumulate) {
      const argsIndex = pendingArgs.length - 1;
      return deferred.promise.then((results) => results[argsIndex]);
    }
    return deferred.promise;
  };
  function flush() {
    const thisDeferred = deferred;
    clearTimeout(timer);
    Promise.resolve(
      options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1])
    ).then(thisDeferred.resolve, thisDeferred.reject);
    pendingArgs = [];
    deferred = null;
  }
}
function getWait(wait) {
  return typeof wait === "function" ? wait() : wait;
}
function defer() {
  const deferred = {};
  deferred.promise = new Promise((resolve, reject) => {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
}
var debounce_default = debounce;

// src/components/DataTable/ActiveFilters.tsx
import PropTypes from "prop-types";
import { jsx as jsx69, jsxs as jsxs32 } from "react/jsx-runtime";
function ActiveFilters({
  values = {},
  onChange,
  filters,
  ...rest
}) {
  function handleDelete(name, value) {
    const { value: previousValue } = values[name];
    const isArray = Array.isArray(previousValue);
    const change = {
      name,
      value: isArray ? previousValue.filter((v) => v.value !== value) : void 0
    };
    onChange(change);
  }
  const filterNames = Object.keys(values);
  const filterLabels = filters.reduce(
    (mem, item) => ({
      ...mem,
      [item.name]: item.label
    }),
    {}
  );
  const hasSelectedFilter = filterNames.find((n) => {
    const { value } = values[n];
    const fields = Array.isArray(value) ? value : value !== void 0 ? [value] : [];
    const validFields = fields.filter((f) => f !== null);
    return validFields.length;
  });
  if (!hasSelectedFilter) {
    return null;
  }
  return filterNames.length ? /* @__PURE__ */ jsx69(
    Flex_default,
    {
      justifyContent: "flex-start",
      flexWrap: "wrap",
      mt: 4,
      mb: "-12px",
      display: ["none", "flex"],
      ...rest,
      children: filterNames.map((name) => {
        const { value } = values[name];
        const fields = Array.isArray(value) ? value : value !== void 0 ? [value] : [];
        const validFields = fields.filter((f) => f !== null);
        const { renderActiveLabel } = filters.find((f) => f.name === name) || {};
        return !!validFields.length && /* @__PURE__ */ jsxs32(View_default, { mr: 2, children: [
          /* @__PURE__ */ jsx69(Subheading, { color: "ink.2", fontSize: "10px", mb: 1, minHeight: "10px", children: renderActiveLabel ? renderActiveLabel({
            ...values[name]
          }) : filterLabels[name] }),
          validFields.map((field) => /* @__PURE__ */ jsxs32(
            Flex_default,
            {
              bg: "sky.3",
              border: 1,
              display: "inline-flex",
              borderRadius: 1,
              mr: 3,
              mb: 3,
              alignItems: "unset",
              overflow: "hidden",
              children: [
                /* @__PURE__ */ jsx69(Flex_default, { children: /* @__PURE__ */ jsx69(
                  Caption,
                  {
                    flex: "1",
                    borderRight: 1,
                    color: "ink.2",
                    px: 2,
                    py: 1,
                    children: field.label
                  }
                ) }),
                /* @__PURE__ */ jsx69(
                  Flex_default,
                  {
                    onClick: () => handleDelete(name, field.value),
                    cursor: "pointer",
                    _hover: {
                      bg: "sky.2"
                    },
                    children: /* @__PURE__ */ jsx69(Close_default, { fill: "ink.2" })
                  }
                )
              ]
            },
            field.value
          ))
        ] }, name);
      })
    }
  ) : null;
}
ActiveFilters.propTypes = {
  onChange: PropTypes.func.isRequired,
  values: PropTypes.object,
  filters: PropTypes.array
};
var ActiveFilters_default = ActiveFilters;

// src/components/DataTable/context.tsx
import { createContext as createContext2, useContext as useContext4 } from "react";
var dataTableCtx = createContext2({
  items: [],
  state: {},
  resource: {},
  dispatch: () => {
  }
});
var context_default = dataTableCtx;
var useDataTable = () => useContext4(dataTableCtx);

// src/components/DataTable/FilterSelect.tsx
import PropTypes3 from "prop-types";
import { useCallback as useCallback7, useRef as useRef5, useState as useState12 } from "react";

// src/hooks/useMatchMedia.js
import { useState as useState9, useEffect as useEffect10 } from "react";
function matchQuery(query) {
  const mediaQueryList = window.matchMedia(query);
  return mediaQueryList.matches;
}
function useMatchMedia(query) {
  const [match, setMatch] = useState9(() => matchQuery(query));
  useEffect10(() => {
    const onChange = () => {
      const result = matchQuery(query);
      if (match !== result) {
        setMatch(result);
      }
    };
    window.addEventListener("resize", onChange);
    return () => {
      window.removeEventListener("resize", onChange);
    };
  }, [query, match]);
  return match;
}
var mobileQuery = `(max-width: ${Number(theme_default.breakpoints[0].replace("px", "")) - 1}px)`;
function useMobile() {
  return useMatchMedia(mobileQuery);
}
var desktopQuery = `(min-width: ${theme_default.breakpoints[0]})`;
function useDesktop() {
  return useMatchMedia(desktopQuery);
}
var useMatchMedia_default = useMatchMedia;

// src/components/InteractiveForm/Select/index.tsx
import React25, { forwardRef, useCallback as useCallback6, useEffect as useEffect11, useState as useState11 } from "react";

// src/hooks/useFormInput.js
import React22 from "react";
function useFormInput(initialValue) {
  const [value, setValue] = React22.useState(initialValue);
  function handleChange(e) {
    setValue(e.target.value);
  }
  return {
    value,
    onChange: handleChange
  };
}
var useFormInput_default = useFormInput;

// src/components/DataTable/assets/NotFoundSvg.tsx
import { jsx as jsx70, jsxs as jsxs33 } from "react/jsx-runtime";
var NotFoundSvg = (props) => /* @__PURE__ */ jsx70(
  "svg",
  {
    width: "133",
    height: "112",
    viewBox: "0 0 133 112",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx70("g", { fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ jsx70("g", { transform: "translate(-18 -25)", children: /* @__PURE__ */ jsxs33("g", { transform: "translate(13 25)", children: [
      /* @__PURE__ */ jsx70("g", { fillRule: "evenodd", transform: "translate(0 0)", fill: "#F4F6F8", children: /* @__PURE__ */ jsx70(
        "path",
        {
          d: "M7.407 91.808C5.75 89.935 4.52 88.112 3.598 86.5-10.363 60.399 26.367-21.457 97.648 5.703c5.498 2.095 7.988 4.059 9.635 6.121.615.082 4.758 3.927 4.669 4.377C178.822 80.24 47.132 136.709 7.407 91.808z",
          fillRule: "nonzero"
        }
      ) }),
      /* @__PURE__ */ jsx70("circle", { stroke: "#637381", strokeWidth: "2", cx: "79", cy: "76", r: "38" }),
      /* @__PURE__ */ jsx70("circle", { fill: "#FFFFFF", fillRule: "evenodd", cx: "79", cy: "76", r: "30" }),
      /* @__PURE__ */ jsx70(
        "path",
        {
          d: "M110.5 105.5L141 132",
          stroke: "#454F5B",
          strokeWidth: "2",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ jsx70(
        "rect",
        {
          fill: "#C4CDD5",
          fillRule: "evenodd",
          transform: "translate(128.4079 120.9775) rotate(41) translate(-128.4079 -120.9775)",
          x: "107.9079",
          y: "114.9775",
          width: "41",
          height: "12",
          rx: "5"
        }
      ),
      /* @__PURE__ */ jsx70("g", { transform: "translate(59 56)", children: /* @__PURE__ */ jsx70(
        "path",
        {
          d: "M20 16.29L27.42 8.87c1.024-1.024 2.685-1.024 3.71 0 1.024 1.025 1.024 2.686 0 3.71L23.71 20l7.42 7.42c1.024 1.024 1.024 2.685 0 3.71-1.025 1.024-2.686 1.024-3.71 0L20 23.71l-7.42 7.42c-1.024 1.024-2.685 1.024-3.71 0-1.024-1.025-1.024-2.686 0-3.71L16.29 20l-7.42-7.42c-1.024-1.025-1.024-2.686 0-3.71 1.025-1.025 2.686-1.025 3.71 0L20 16.29z",
          fill: "currentColor",
          fillRule: "evenodd"
        }
      ) })
    ] }) }) })
  }
);
var NotFoundSvg_default = NotFoundSvg;

// src/components/Form/Input.tsx
import { themeGet as themeGet7 } from "@styled-system/theme-get";
import PropTypes2 from "prop-types";
import { Component } from "react";
import TextMask from "react-text-mask";
import styled32, { css as css5 } from "styled-components";

// src/utils/propTypes.js
import { number, string, node, oneOfType, arrayOf } from "prop-types";
var children = (
  /** @type {any} */
  oneOfType([arrayOf(node), node])
);
var responsiveStyleProps = oneOfType([
  number,
  string,
  arrayOf(oneOfType([number, string]))
]);
var propTypes_default = {
  children,
  responsiveStyleProps
};

// src/components/Form/Input.tsx
import { jsx as jsx71, jsxs as jsxs34 } from "react/jsx-runtime";
var Base3 = styled32(View_default)`
  ${variants_default({
  variant: {
    normal: {
      py: "7px"
    },
    outline: {
      py: "6px",
      border: 1,
      borderColor: "sky.1",
      transition: "border-color 200ms linear",
      "&:after": {
        display: "none"
      }
    },
    "outline-v2": {
      py: "8px",
      border: 1,
      borderColor: "sky.1",
      transition: "border-color 200ms linear",
      "&:after": {
        display: "none"
      }
    }
  }
})}

  cursor: text;
  position: relative;
  outline: none;

  input {
    height: 24px;
  }

  ${(p) => p.disabled && css5`
      background-color: ${themeGet7("colors.sky.3")};
      cursor: not-allowed;
    `}

  ${(p) => p.variant === "normal" && css5`
      &:after {
        content: ' ';
        width: 100%;
        height: 3px;
        position: absolute;
        left: 0;
        bottom: 0;
        border-radius: 0 0 4px 4px;
        background: ${themeGet7("colors.ink.2")};
        transition: background-color 200ms linear;
        ${(p2) => p2.meta.focus && css5`
            background-color: ${themeGet7("colors.ink.0")};
          `}
        ${(p2) => p2.meta.touched && !p2.meta.error && css5`
            background-color: ${themeGet7("colors.default.primary")};
          `}
    ${(p2) => p2.meta.error && p2.meta.touched && css5`
            background-color: ${themeGet7("colors.default.red")};
          `}
    ${(p2) => p2.disabled && css5`
            background-color: ${themeGet7("colors.sky.0")};
          `}
      }
    `}

  ${(p) => p.variant === "outline" && css5`
      ${(p2) => p2.meta.focus && css5`
          border-color: ${themeGet7("colors.sky.0")};
        `}
      ${(p2) => p2.meta.touched && !p2.meta.error && css5`
          border-color: ${themeGet7("colors.default.primary")};
        `}
    ${(p2) => p2.meta.error && p2.meta.touched && css5`
          border-color: ${themeGet7("colors.default.red")};
        `}
    ${(p2) => p2.disabled && css5`
          border-color: ${themeGet7("colors.sky.0")};
        `}
    `}

  ${(p) => p.variant === "outline-v2" && css5`
      border-color: ${themeGet7("colors.sky.0")};
      background-color: ${themeGet7("colors.sky.3")};
      &:hover {
        background-color: ${themeGet7("colors.sky.2")};
      }
      ${(p2) => p2.meta.focus && css5`
          border-color: ${themeGet7("colors.blue.3")};
          box-shadow: 0 0 0 1px ${themeGet7("colors.blue.3")},
            0 0 0 1px ${themeGet7("colors.blue.3")};
        `}
      ${(p2) => p2.meta.touched && !p2.meta.error && !p2.meta.focus && css5`
          border-color: ${themeGet7("colors.ink.1")};
        `}
    ${(p2) => p2.meta.error && p2.meta.touched && !p2.meta.focus && css5`
          border-color: ${themeGet7("colors.default.red")};
        `}
    ${(p2) => p2.disabled && css5`
          border-color: ${themeGet7("colors.sky.1")};
        `}
    `}
`;
Base3.defaultProps = {
  maxWidth: ["100%", "350px"],
  minWidth: "130px",
  bg: "sky.2",
  px: 3,
  borderRadius: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  variant: "outline-v2"
};
var HtmlInput = styled32(Text_default)`
  background: none;
  border: none;
  min-width: 1px;
  width: 100%;
  outline: none;
  padding: 0;
  &::placeholder {
    color: ${themeGet7("colors.ink.2")};
  }
  &:disabled {
    cursor: not-allowed;
    color: ${themeGet7("colors.ink.2")};
  }
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
  }
  &:-webkit-contacts-auto-fill-button {
    visibility: hidden;
    display: none !important;
    pointer-events: none;
    position: absolute;
    right: 0;
  }
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;
HtmlInput.defaultProps = {
  as: "input",
  fontWeight: "regular",
  type: "text",
  color: "default.ink"
};
var MaskedInput = styled32(HtmlInput)``;
MaskedInput.defaultProps = {
  guide: false,
  as: TextMask
};
var Left = styled32.div`
  margin-right: 12px;
`;
var Right = styled32.div`
  margin-left: 12px;
`;
var Input = class extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      focus: false
    };
    this.handleFocus = () => {
      this.setState({
        focus: true
      });
    };
    this.handleBlur = () => {
      const {
        input: { onBlur }
      } = this.props;
      this.setState({
        focus: false
      });
      onBlur && onBlur();
    };
    this.handleClear = () => {
      const { input } = this.props;
      input?.value && input?.onChange && input?.onChange("");
    };
  }
  render() {
    const {
      left: LeftContent,
      right: RightContent,
      placeholder,
      type,
      inputMode,
      pattern,
      input,
      meta,
      disabled: disabled2,
      mask,
      clearable,
      onClear,
      pipe,
      ...rest
    } = this.props;
    const { focus: focus2 } = this.state;
    const Component17 = mask ? MaskedInput : HtmlInput;
    return /* @__PURE__ */ jsxs34(
      Base3,
      {
        onClick: () => {
          this.input && this.input.focus();
        },
        disabled: disabled2,
        meta: {
          focus: focus2,
          ...meta
        },
        ...rest,
        children: [
          LeftContent && /* @__PURE__ */ jsx71(Left, { children: LeftContent }),
          /* @__PURE__ */ jsx71(
            Component17,
            {
              ref: (inputRef) => {
                this.input = mask ? inputRef && inputRef.inputElement : inputRef;
              },
              placeholder,
              type,
              inputMode,
              pattern,
              disabled: disabled2,
              mask,
              pipe,
              ...input,
              onBlur: this.handleBlur,
              onFocus: this.handleFocus
            }
          ),
          clearable && input?.value && /* @__PURE__ */ jsx71(
            Clear_default,
            {
              width: 20,
              height: 20,
              fill: "ink.3",
              onClick: disabled2 ? null : onClear || this.handleClear,
              cursor: disabled2 ? "not-allowed" : "pointer"
            }
          ),
          RightContent && /* @__PURE__ */ jsx71(Right, { children: RightContent })
        ]
      }
    );
  }
};
Input.propTypes = {
  left: children,
  right: children,
  input: PropTypes2.object,
  placeholder: PropTypes2.string,
  disabled: PropTypes2.bool,
  type: PropTypes2.string,
  inputMode: PropTypes2.string,
  pattern: PropTypes2.string,
  meta: PropTypes2.object,
  mask: PropTypes2.oneOfType([PropTypes2.array, PropTypes2.func]),
  pipe: PropTypes2.func
};
Input.defaultProps = {
  input: {},
  meta: {}
};
var Input_default = Input;

// src/components/InteractiveForm/Select/Container.tsx
import { themeGet as themeGet8 } from "@styled-system/theme-get";
import styled33 from "styled-components";
var Container3 = styled33(View_default)`
  :focus {
    outline: none;
  }

  @media (max-width: ${themeGet8("breakpoints.0")}) {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
  }
`;
Container3.defaultProps = {
  display: ["flex", "inline-flex"],
  flexDirection: "column",
  bg: "white",
  boxShadow: 1,
  borderRadius: 1,
  border: [0, 1],
  height: ["100vh", "unset"]
};
var Container_default2 = Container3;

// src/components/InteractiveForm/Select/Hoverable.tsx
import React24, { useState as useState10 } from "react";
function Hoverable({ children: children2 }) {
  const [hover2, setHover] = useState10(false);
  return React24.cloneElement(children2(hover2), {
    onMouseOver: () => setHover(true),
    onMouseLeave: () => setHover(false),
    // @ts-ignore
    ...children2.props
  });
}
var Hoverable_default = Hoverable;

// src/components/InteractiveForm/Select/index.tsx
import { jsx as jsx72, jsxs as jsxs35 } from "react/jsx-runtime";
var Select = forwardRef(
  ({
    loadOptions,
    options,
    filtering,
    value,
    renderItem,
    onChange,
    onClose,
    onHitsUpdate,
    placeholder,
    selectedFirst,
    disabledValues = [],
    onBlur = () => {
    },
    onFocus = () => {
    },
    mode: controlledMode,
    modeOptions,
    ...rest
  }, ref) => {
    const desktop = useDesktop();
    const input = useFormInput_default("");
    const [selected2, setSelected] = useState11(
      value
    );
    const [items, setItems] = useState11(options || []);
    const [mode, setMode] = useState11(controlledMode);
    const [loading, setLoading] = useState11();
    const handleClick = (option, newMode = mode) => {
      let newSelected;
      if (option && Array.isArray(selected2)) {
        const index = selected2.findIndex((item) => item.value === option.value);
        if (index === -1) {
          newSelected = [...selected2, option];
        } else {
          newSelected = [
            ...selected2.slice(0, index),
            ...selected2.slice(index + 1)
          ];
        }
      } else if (option) {
        newSelected = selected2?.value === option.value ? null : option;
      } else {
        newSelected = selected2;
      }
      setSelected(newSelected);
      if (desktop) {
        handleChange(newSelected, newMode);
      }
    };
    const isSelected = (option) => {
      if (Array.isArray(selected2)) {
        return selected2.findIndex((item) => item.value === option.value) !== -1;
      }
      return selected2?.value === option.value;
    };
    const handleChange = useCallback6(
      (selected3, mode2) => {
        onFocus();
        onChange(selected3, mode2);
        onBlur();
      },
      [onFocus, onChange, onBlur]
    );
    const previousValue = React25.useRef(value);
    useEffect11(() => {
      const loader = async (query) => {
        if (loadOptions) {
          setLoading(true);
          const newOptions = await loadOptions(query);
          setLoading(false);
          setItems(newOptions || []);
        } else {
          setItems(options || []);
        }
      };
      if (previousValue.current !== input.value) {
        loader(input.value);
      }
      previousValue.current = input.value;
    }, [input.value, loadOptions, options]);
    useEffect11(() => {
      onHitsUpdate && onHitsUpdate();
    }, [items.length, onHitsUpdate]);
    useEffect11(() => {
      setSelected(value);
    }, [value]);
    useEffect11(() => {
      setMode(controlledMode);
    }, [controlledMode]);
    const render = (item) => renderItem ? /* @__PURE__ */ jsx72(Hoverable_default, { children: (hover2) => renderItem(item, {
      hover: hover2,
      selected: isSelected(item),
      // @ts-ignore
      disabled: disabledValues.indexOf(item.value) !== -1,
      onClick: () => {
        setTimeout(() => handleClick(item), 0);
      },
      cursor: "pointer",
      _notLast: {
        borderBottom: 1
      },
      _last: {
        borderBottom: [1, 0]
      }
    }) }, item.value) : null;
    return /* @__PURE__ */ jsxs35(Container_default2, { ref, maxHeight: ["100%", "280px"], ...rest, children: [
      !!modeOptions?.length && /* @__PURE__ */ jsx72(Flex_default, { p: 3, borderBottom: 1, children: modeOptions.map((mo) => /* @__PURE__ */ jsx72(
        View_default,
        {
          flex: "1",
          onClick: () => {
            setMode(mo.value);
            handleClick(null, mo.value);
          },
          bg: mo.value === mode ? "primary.3" : "sky.2",
          color: mo.value === mode ? "white" : "ink.2",
          borderColor: mo.value === mode ? "primary.3" : "sky.1",
          borderTopWidth: 1,
          borderBottomWidth: 1,
          borderStyle: "solid",
          textAlign: "center",
          p: 2,
          _first: {
            borderLeftWidth: 1,
            borderTopLeftRadius: 1,
            borderBottomLeftRadius: 1
          },
          _last: {
            borderRightWidth: 1,
            borderTopRightRadius: 1,
            borderBottomRightRadius: 1
          },
          cursor: "pointer",
          children: /* @__PURE__ */ jsx72(Text_default, { color: "currentColor", fontSize: 0, fontWeight: "semibold", children: mo.label })
        },
        mo.value
      )) }),
      filtering && /* @__PURE__ */ jsx72(View_default, { p: 3, borderBottom: 1, children: /* @__PURE__ */ jsx72(
        Input_default,
        {
          ...input,
          ref: (node2) => {
            if (node2?.input) {
              node2.input.focus();
            }
          },
          variant: "outline",
          left: /* @__PURE__ */ jsx72(Search_default, { fill: "ink.2" }),
          placeholder,
          maxWidth: "100%"
        }
      ) }),
      /* @__PURE__ */ jsxs35(View_default, { flex: "1", overflowY: "auto", children: [
        loading && /* @__PURE__ */ jsx72(Flex_default, { height: "100px", justifyContent: "center", children: /* @__PURE__ */ jsx72(Spinner_default, { spinning: true }) }),
        !loading && items.length === 0 && /* @__PURE__ */ jsxs35(View_default, { children: [
          /* @__PURE__ */ jsx72(Flex_default, { justifyContent: "center", children: /* @__PURE__ */ jsx72(
            View_default,
            {
              as: NotFoundSvg_default,
              color: "primary.3",
              transform: "scale(0.7)"
            }
          ) }),
          /* @__PURE__ */ jsx72(Text_default, { textAlign: "center", pb: 5, px: 5, children: "No results found" })
        ] }),
        selectedFirst && !loading && !input.value && [
          ...Array.isArray(selected2) ? selected2 : selected2 ? [selected2] : []
        ].map(render),
        !loading && items.sort(
          (a, b) => selectedFirst ? isSelected(a) ? isSelected(b) ? 0 : -1 : 1 : 0
        ).filter(
          (i) => selectedFirst ? !input.value ? !isSelected(i) : true : true
        ).map(render)
      ] }),
      /* @__PURE__ */ jsx72(View_default, { display: ["block", "none"], p: [5], children: /* @__PURE__ */ jsxs35(ButtonGroup_default, { children: [
        /* @__PURE__ */ jsx72(
          Button_default,
          {
            onClick: () => {
              handleChange(selected2, mode);
              onClose?.();
            },
            children: "Save"
          }
        ),
        /* @__PURE__ */ jsx72(Button_default, { variant: "secondary", onClick: onClose, children: "Cancel" })
      ] }) })
    ] });
  }
);
var Select_default = Select;

// src/components/DataTable/FilterSelect.tsx
import { jsx as jsx73, jsxs as jsxs36 } from "react/jsx-runtime";
function CustomFilterWrapper({
  children: children2,
  label,
  value,
  ...rest
}) {
  const [open, setOpen] = useState12(false);
  const ref = useRef5();
  return /* @__PURE__ */ jsxs36(View_default, { display: "inline-block", width: ["100%", "unset"], ...rest, children: [
    /* @__PURE__ */ jsx73(
      Popover_default,
      {
        open,
        onClickOut: () => setOpen(false),
        placement: "bottom-start",
        referenceElement: ref,
        offset: [0, 4],
        children: ({ ref: ref2, style: style6, placement }) => children2({
          containerProps: { ref: ref2, style: style6, placement },
          open,
          setOpen
        })
      }
    ),
    /* @__PURE__ */ jsxs36(
      Flex_default,
      {
        ref,
        onClick: () => {
          setOpen(!open);
        },
        cursor: "pointer",
        minHeight: "36px",
        alignItems: "center",
        display: "inline-flex",
        width: "100%",
        px: 3,
        children: [
          /* @__PURE__ */ jsxs36(Subheading, { color: "ink.2", children: [
            /* @__PURE__ */ jsx73(
              Text_default,
              {
                display: ["inline-block", "none"],
                fontSize: "12px",
                color: "default.primary",
                fontWeight: "semibold",
                mr: 3,
                ml: 1,
                children: value
              }
            ),
            label
          ] }),
          /* @__PURE__ */ jsx73(
            ArrowDown_default,
            {
              transform: ["rotate(-90deg)", "unset"],
              width: "14px",
              fill: "ink.2",
              ml: 1
            }
          )
        ]
      }
    )
  ] });
}
function FilterSelect({
  name,
  loadOptions,
  modifyValue,
  options,
  onChange,
  value,
  onFocus,
  onBlur,
  label,
  filtering,
  selectProps = {},
  mode,
  modeOptions,
  renderActiveLabel,
  ...rest
}) {
  const [open, setOpen] = useState12(false);
  const ref = useRef5();
  const mobile = useMobile();
  const loadOptionsCallback = useCallback7(
    (query) => loadOptions?.(query, { mode }),
    [loadOptions, mode]
  );
  return /* @__PURE__ */ jsxs36(View_default, { display: "inline-block", width: ["100%", "unset"], ...rest, children: [
    /* @__PURE__ */ jsx73(
      Popover_default,
      {
        open,
        onClickOut: () => setOpen(false),
        placement: "bottom-start",
        referenceElement: ref,
        offset: [0, 4],
        children: ({ ref: ref2, style: style6, placement, update }) => /* @__PURE__ */ jsx73(
          Select_default,
          {
            ref: ref2,
            style: mobile ? { zIndex: 1e3 } : style6,
            "data-placement": placement,
            onHitsUpdate: update,
            onBlur,
            onFocus,
            placeholder: "Search",
            loadOptions: loadOptions ? loadOptionsCallback : void 0,
            options,
            filtering,
            selectedFirst: filtering,
            modeOptions,
            value,
            mode,
            onChange: (value2, mode2) => {
              if (!Array.isArray(value2)) {
                setOpen(false);
              }
              const modifiedValue = modifyValue ? modifyValue({ value: value2, mode: mode2 }) : value2;
              onChange({ name, value: modifiedValue, mode: mode2 });
            },
            ...selectProps,
            onClose: () => setOpen(false),
            renderItem: (item, { hover: hover2, selected: selected2, ...rest2 }) => /* @__PURE__ */ jsxs36(
              Flex_default,
              {
                justifyContent: "flex-start",
                px: [5, 3],
                py: [5, 3],
                bg: hover2 ? "default.primary" : void 0,
                color: hover2 ? "white" : void 0,
                ...rest2,
                children: [
                  /* @__PURE__ */ jsx73(
                    Text_default,
                    {
                      color: hover2 ? "white" : "default.ink",
                      fontSize: [null, "14px"],
                      minHeight: "22px",
                      children: item.label
                    }
                  ),
                  /* @__PURE__ */ jsx73(Flex_default, { flex: "1" }),
                  selected2 && /* @__PURE__ */ jsx73(Tick_default, { light: true, fill: hover2 ? "white" : void 0 })
                ]
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ jsxs36(
      Flex_default,
      {
        ref,
        onClick: () => {
          setOpen(!open);
        },
        cursor: "pointer",
        minHeight: "36px",
        alignItems: "center",
        display: "inline-flex",
        width: "100%",
        px: 3,
        children: [
          /* @__PURE__ */ jsxs36(Subheading, { color: "ink.2", children: [
            /* @__PURE__ */ jsx73(
              Text_default,
              {
                display: ["inline-block", "none"],
                fontSize: "12px",
                color: "default.primary",
                fontWeight: "semibold",
                mr: 3,
                ml: 1,
                children: value ? value?.length ?? 1 : 0
              }
            ),
            mobile && renderActiveLabel ? renderActiveLabel({ value, mode }) : label
          ] }),
          /* @__PURE__ */ jsx73(
            ArrowDown_default,
            {
              transform: ["rotate(-90deg)", "unset"],
              width: "14px",
              fill: "ink.2",
              ml: 1
            }
          )
        ]
      }
    )
  ] });
}
FilterSelect.propTypes = {
  loadOptions: PropTypes3.func,
  options: PropTypes3.array,
  onChange: PropTypes3.func,
  onFocus: PropTypes3.func,
  onBlur: PropTypes3.func,
  value: PropTypes3.oneOfType([
    PropTypes3.object,
    PropTypes3.string,
    PropTypes3.array
  ]),
  invalid: PropTypes3.bool,
  filtering: PropTypes3.bool,
  label: PropTypes3.string,
  selectProps: PropTypes3.object,
  name: PropTypes3.string.isRequired,
  mode: PropTypes3.string,
  modeOptions: PropTypes3.array,
  renderActiveLabel: PropTypes3.func,
  modifyValue: PropTypes3.func
};
var FilterSelect_default = FilterSelect;

// src/components/DataTable/GridTableRow.tsx
import { themeGet as themeGet9 } from "@styled-system/theme-get";
import PropTypes4 from "prop-types";
import styled35 from "styled-components";

// src/components/GridTable.tsx
import styled34 from "styled-components";
import { style as style4 } from "styled-system";
var templateColumns = style4({
  prop: "templateColumns",
  cssProperty: "gridTemplateColumns"
});
var gap = style4({
  prop: "gap",
  cssProperty: "gridGap"
});
var GridTable = styled34(View_default)`
  ${gap};
  ${templateColumns};
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    display: table;
  }
`;
GridTable.defaultProps = {
  display: "grid",
  width: "100%"
};
var GridTableRow = styled34(View_default)`
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    display: table-row;
  }
`;
GridTableRow.defaultProps = {
  display: "contents"
};
var GridTableCell = styled34(Caption)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &:first-of-type {
    padding-left: ${(p) => p.px ? `calc(${String(p.px)}*2)` : "16px"};
  }
  &:last-of-type {
    padding-right: ${(p) => p.px ? `calc(${String(p.px)}*2)` : "16px"};
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    display: table-cell;
  }
`;
GridTableCell.defaultProps = {
  // @ts-ignore
  "data-role": "cell",
  py: 3,
  px: "8px",
  color: "ink.0",
  fontWeight: "regular"
};

// src/components/Selector/assets/Active.tsx
import { jsx as jsx74, jsxs as jsxs37 } from "react/jsx-runtime";
var Active = (props) => /* @__PURE__ */ jsx74(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    ...props,
    children: /* @__PURE__ */ jsxs37("g", { fill: "none", fillRule: "evenodd", children: [
      /* @__PURE__ */ jsx74("circle", { fill: "#2C9FA5", cx: "10", cy: "10", r: "10" }),
      /* @__PURE__ */ jsx74(
        "path",
        {
          fill: "#FFF",
          d: "M8.603 13.012l-2.97-2.969c-.178-.178-.178-.467 0-.646l.647-.646c.178-.178.467-.178.646 0l2 2 4.284-4.284c.179-.178.468-.178.646 0l.646.646c.179.179.179.468 0 .646L9.25 13.012c-.178.179-.468.179-.646 0z"
        }
      )
    ] })
  }
);
var Active_default = Active;

// src/components/Selector/assets/Empty.tsx
import { jsx as jsx75 } from "react/jsx-runtime";
var Empty = (props) => /* @__PURE__ */ jsx75(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    ...props,
    children: /* @__PURE__ */ jsx75("g", { fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ jsx75(
      "path",
      {
        fill: "#2C9FA5",
        d: "M10 .833C4.937.833.833 4.937.833 10S4.937 19.167 10 19.167s9.167-4.104 9.167-9.167S15.063.833 10 .833zM10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0z"
      }
    ) })
  }
);
var Empty_default = Empty;

// src/components/Selector/assets/SemiActive.tsx
import { jsx as jsx76, jsxs as jsxs38 } from "react/jsx-runtime";
var SemiActive = (props) => /* @__PURE__ */ jsx76(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    ...props,
    children: /* @__PURE__ */ jsxs38("g", { fill: "none", fillRule: "evenodd", children: [
      /* @__PURE__ */ jsx76("circle", { fill: "#2C9FA5", cx: "10", cy: "10", r: "10" }),
      /* @__PURE__ */ jsx76(
        "path",
        {
          fill: "#FFF",
          d: "M5.197 8.667h8.788c.293 0 .53.237.53.53v1.212c0 .293-.237.53-.53.53H5.197c-.293 0-.53-.237-.53-.53V9.197c0-.293.237-.53.53-.53z"
        }
      )
    ] })
  }
);
var SemiActive_default = SemiActive;

// src/components/Selector/index.tsx
import { jsx as jsx77 } from "react/jsx-runtime";
function Selector({ state, ...rest }) {
  if (state === "active") {
    return /* @__PURE__ */ jsx77(View_default, { as: Active_default, display: "flex", cursor: "pointer", ...rest });
  }
  if (state === "semiActive") {
    return /* @__PURE__ */ jsx77(View_default, { as: SemiActive_default, display: "flex", cursor: "pointer", ...rest });
  }
  return /* @__PURE__ */ jsx77(View_default, { as: Empty_default, display: "flex", cursor: "pointer", ...rest });
}
var Selector_default = Selector;

// src/components/DataTable/GridTableRow.tsx
import { jsx as jsx78, jsxs as jsxs39 } from "react/jsx-runtime";
var Row2 = styled35(GridTableRow)`
  & > * {
    border-top: 1px solid ${themeGet9("colors.sky.1")};
    background: ${(p) => p.selected ? themeGet9("colors.sky.3") : "white"};
  }
  &:hover > * {
    background: ${themeGet9("colors.sky.3")};
  }
`;
var SelectableGridTableRow = ({
  children: children2,
  id,
  selectorCellProps,
  ...rest
}) => {
  const { state, dispatch } = useDataTable();
  const isSelected = state.selected?.includes(id);
  function toggleSelected(e) {
    e.stopPropagation();
    const selected2 = isSelected ? state.selected?.filter((s) => s !== id) : [...state.selected || [], id];
    dispatch({
      type: "selectedChange",
      payload: selected2
    });
  }
  return /* @__PURE__ */ jsxs39(Row2, { selected: isSelected, ...rest, children: [
    /* @__PURE__ */ jsx78(GridTableCell, { onClick: toggleSelected, ...selectorCellProps, children: /* @__PURE__ */ jsx78(
      Selector_default,
      {
        state: isSelected ? "active" : "idle",
        width: "16px",
        height: "100%"
      }
    ) }),
    children2
  ] });
};
SelectableGridTableRow.propTypes = {
  children,
  id: PropTypes4.oneOfType([PropTypes4.string, PropTypes4.number]).isRequired,
  selectorCellProps: PropTypes4.object
};
var GridTableRow2 = styled35(GridTableRow)`
  & > * {
    border-top: ${(p) => p.borderTop !== 0 ? themeGet9("borders.1") : "unset"};
    background: ${(p) => p.bg ? themeGet9(`colors.${String(p.bg)}`) : "white"};
  }
  &:hover > * {
    background: ${themeGet9("colors.sky.3")};
  }
`;
var GridTableRow_default = GridTableRow2;

// src/components/DataTable/Head.tsx
import PropTypes6 from "prop-types";

// src/components/DataTable/HeadListItem.tsx
import PropTypes5 from "prop-types";
import { useEffect as useEffect12, useState as useState13 } from "react";

// src/components/DataTable/assets/sorting-down.svg
var sorting_down_default = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">%0A    <g fill="none" fill-rule="evenodd">%0A        <g>%0A            <g>%0A                <g>%0A                    <path fill="%232C9FA5" d="M7.998 12.249L4.995 9.097l-.088-.077c-.254-.185-.6-.154-.821.077-.248.26-.248.68 0 .94l3.84 4.032h.145l3.841-4.032.069-.085c.178-.27.15-.626-.069-.855l-.081-.072c-.26-.19-.608-.159-.828.072L7.998 12.25z" transform="translate(-850 -148) translate(703 144) translate(147 4)"/>%0A                    <path fill="%23C4CDD5" d="M7.998 5.249L4.995 2.097l-.088-.077c-.254-.185-.6-.154-.821.077-.248.26-.248.68 0 .94l3.84 4.032h.145l3.841-4.032.069-.085c.178-.27.15-.626-.069-.855l-.081-.072c-.26-.19-.608-.159-.828.072L7.998 5.25z" transform="translate(-850 -148) translate(703 144) translate(147 4) matrix(1 0 0 -1 0 8.969)"/>%0A                </g>%0A            </g>%0A        </g>%0A    </g>%0A</svg>%0A';

// src/components/DataTable/assets/sorting-idle.svg
var sorting_idle_default = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">%0A    <g fill="none" fill-rule="evenodd">%0A        <g fill="%23C4CDD5">%0A            <g>%0A                <g>%0A                    <g>%0A                        <path d="M7.998 12.249L4.995 9.097l-.088-.077c-.254-.185-.6-.154-.821.077-.248.26-.248.68 0 .94l3.84 4.032h.145l3.841-4.032.069-.085c.178-.27.15-.626-.069-.855l-.081-.072c-.26-.19-.608-.159-.828.072L7.998 12.25z" transform="translate(-648 -148) translate(220 136) translate(311 12) translate(117)"/>%0A                        <path d="M7.998 5.249L4.995 2.097l-.088-.077c-.254-.185-.6-.154-.821.077-.248.26-.248.68 0 .94l3.84 4.032h.145l3.841-4.032.069-.085c.178-.27.15-.626-.069-.855l-.081-.072c-.26-.19-.608-.159-.828.072L7.998 5.25z" transform="translate(-648 -148) translate(220 136) translate(311 12) translate(117) matrix(1 0 0 -1 0 8.969)"/>%0A                    </g>%0A                </g>%0A            </g>%0A        </g>%0A    </g>%0A</svg>%0A';

// src/components/DataTable/assets/sorting-up.svg
var sorting_up_default = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">%0A    <g fill="none" fill-rule="evenodd">%0A        <g>%0A            <g>%0A                <g>%0A                    <path fill="%23C4CDD5" d="M7.998 12.249L4.995 9.097l-.088-.077c-.254-.185-.6-.154-.821.077-.248.26-.248.68 0 .94l3.84 4.032h.145l3.841-4.032.069-.085c.178-.27.15-.626-.069-.855l-.081-.072c-.26-.19-.608-.159-.828.072L7.998 12.25z" transform="translate(-850 -148) translate(703 144) translate(147 4)"/>%0A                    <path fill="%232C9FA5" d="M7.998 5.249L4.995 2.097l-.088-.077c-.254-.185-.6-.154-.821.077-.248.26-.248.68 0 .94l3.84 4.032h.145l3.841-4.032.069-.085c.178-.27.15-.626-.069-.855l-.081-.072c-.26-.19-.608-.159-.828.072L7.998 5.25z" transform="translate(-850 -148) translate(703 144) translate(147 4) matrix(1 0 0 -1 0 8.969)"/>%0A                </g>%0A            </g>%0A        </g>%0A    </g>%0A</svg>%0A';

// src/components/DataTable/assets/SwitchHorisontal.tsx
import { jsx as jsx79, jsxs as jsxs40 } from "react/jsx-runtime";
var SwitchHorisontal = (props) => /* @__PURE__ */ jsxs40(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    ...props,
    children: [
      /* @__PURE__ */ jsx79("defs", { children: /* @__PURE__ */ jsx79(
        "path",
        {
          id: "a",
          d: "M5.587 8.22a.812.812 0 0 1 1.111 0 .725.725 0 0 1 0 1.06l-1.015.97h4.388c.434 0 .786.336.786.75s-.352.75-.786.75H5.683l1.015.97a.725.725 0 0 1 0 1.06.81.81 0 0 1-1.11 0L3.23 11.53C3.083 11.39 3 11.2 3 11s.083-.39.23-.53zm3.715-6a.81.81 0 0 1 1.11 0l2.358 2.25c.147.14.23.331.23.53s-.083.39-.23.53l-2.357 2.25a.812.812 0 0 1-1.111 0 .725.725 0 0 1 0-1.06l1.015-.97H5.93c-.434 0-.786-.336-.786-.75s.352-.75.786-.75h4.388l-1.015-.97a.725.725 0 0 1 0-1.06z"
        }
      ) }),
      /* @__PURE__ */ jsxs40("g", { fill: "none", fillRule: "evenodd", children: [
        /* @__PURE__ */ jsx79("mask", { id: "b", fill: "#fff", children: /* @__PURE__ */ jsx79("use", { xlinkHref: "#a" }) }),
        /* @__PURE__ */ jsx79("use", { xlinkHref: "#a", fill: "#C4CDD5" }),
        /* @__PURE__ */ jsx79(
          "path",
          {
            fill: "#C4CDD5",
            d: "M10.071 11.75c.434 0 .786-.336.786-.75s-.352-.75-.786-.75H5.683l1.015-.97a.725.725 0 0 0 0-1.06.81.81 0 0 0-1.11 0L3.23 10.47c-.147.14-.23.331-.23.53s.083.39.23.53l2.357 2.25a.812.812 0 0 0 1.111 0 .725.725 0 0 0 0-1.06l-1.015-.97h4.388z",
            mask: "url(#b)"
          }
        ),
        /* @__PURE__ */ jsx79(
          "path",
          {
            fill: "#919EAB",
            d: "M5.929 4.25c-.434 0-.786.336-.786.75s.352.75.786.75h4.388l-1.015.97a.725.725 0 0 0 0 1.06.81.81 0 0 0 1.11 0l2.358-2.25c.147-.14.23-.331.23-.53s-.083-.39-.23-.53l-2.357-2.25a.812.812 0 0 0-1.111 0 .725.725 0 0 0 0 1.06l1.015.97H5.93z",
            mask: "url(#b)"
          }
        ),
        /* @__PURE__ */ jsx79(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h16v16H0z",
            mask: "url(#b)",
            style: {
              mixBlendMode: "overlay"
            }
          }
        )
      ] })
    ]
  }
);
var SwitchHorisontal_default = SwitchHorisontal;

// src/components/DataTable/HeadListItem.tsx
import { jsx as jsx80, jsxs as jsxs41 } from "react/jsx-runtime";
function HeadListItem({ column }) {
  const {
    items,
    state: { orderBy },
    dispatch
  } = useDataTable();
  const isMultiColumn = Array.isArray(column);
  const [currentIndex, setColumnIndex] = useState13(0);
  function handleOrderByChange(change) {
    dispatch({
      type: "orderByChange",
      payload: change
    });
  }
  const currentColumn = isMultiColumn ? column[currentIndex] : column;
  function toggleColumn() {
    const nextIndex = column.length % currentIndex + 2 === column.length ? 0 : currentIndex + 1;
    setColumnIndex(nextIndex);
    handleOrderByChange({
      field: column[nextIndex].orderBy,
      direction: orderBy?.direction || "asc"
    });
  }
  function toggleOrderBy() {
    const nextDirection = orderBy?.direction === "asc" ? "desc" : "asc";
    handleOrderByChange({
      field: currentColumn.orderBy,
      direction: nextDirection
    });
  }
  useEffect12(() => {
    if (isMultiColumn) {
      const fields = column.map((c) => c.orderBy);
      if (!fields.includes(orderBy.field) && currentIndex !== 0) {
        setColumnIndex(0);
      }
    }
  }, [orderBy, isMultiColumn, currentColumn, column, currentIndex]);
  if (!currentColumn) {
    return /* @__PURE__ */ jsx80(View_default, {});
  }
  if (currentColumn?.type === "selectAll") {
    return /* @__PURE__ */ jsx80(
      Caption,
      {
        onClick: () => dispatch({
          type: "selectedChange",
          payload: items.map(
            (i) => currentColumn.getId ? currentColumn.getId(i) : i?.id
          )
        }),
        children: /* @__PURE__ */ jsx80(Selector_default, { state: "idle", width: "16px", height: "100%" })
      }
    );
  }
  return /* @__PURE__ */ jsxs41(Flex_default, { justifyContent: "flex-end", children: [
    /* @__PURE__ */ jsxs41(
      Flex_default,
      {
        onClick: isMultiColumn ? toggleColumn : currentColumn.orderBy ? toggleOrderBy : null,
        cursor: currentColumn.orderBy ? "pointer" : null,
        color: "ink.2",
        borderRadius: 1,
        mr: 1,
        _hover: isMultiColumn ? {
          bg: "sky.2",
          color: "primary.3",
          p: 1,
          m: "-4px",
          mr: 0
        } : {},
        children: [
          isMultiColumn && /* @__PURE__ */ jsx80(
            View_default,
            {
              as: SwitchHorisontal_default,
              transform: currentIndex % 2 === 1 ? "rotate(180deg)" : "rotate(0deg)"
            }
          ),
          /* @__PURE__ */ jsx80(Subheading, { color: "currentColor", ml: isMultiColumn ? "2px" : "0px", children: currentColumn.label })
        ]
      }
    ),
    currentColumn.orderBy && /* @__PURE__ */ jsx80(
      View_default,
      {
        onClick: toggleOrderBy,
        display: "inline-flex",
        cursor: currentColumn.orderBy ? "pointer" : null,
        p: 1,
        my: "-4px",
        children: orderBy?.field !== currentColumn.orderBy ? /* @__PURE__ */ jsx80(View_default, { as: "img", src: sorting_idle_default }) : orderBy.direction === "asc" ? /* @__PURE__ */ jsx80(View_default, { as: "img", src: sorting_up_default }) : /* @__PURE__ */ jsx80(View_default, { as: "img", src: sorting_down_default })
      }
    )
  ] });
}
HeadListItem.propTypes = {
  column: PropTypes5.any
};
var HeadListItem_default = HeadListItem;

// src/components/DataTable/Head.tsx
import { jsx as jsx81 } from "react/jsx-runtime";
function Head({ columns, ...rest }) {
  const { state } = useDataTable();
  return /* @__PURE__ */ jsx81(
    GridTableRow,
    {
      display: [state.selected?.length ? "none" : "contents", "contents"],
      ...rest,
      children: columns.map((c, i) => /* @__PURE__ */ jsx81(
        GridTableCell,
        {
          display: "flex",
          height: "52px",
          ...c.cellProps,
          children: /* @__PURE__ */ jsx81(HeadListItem_default, { column: c })
        },
        i
      ))
    }
  );
}
Head.propTypes = {
  columns: PropTypes6.array
};
var Head_default = Head;

// src/components/DataTable/List.tsx
import PropTypes7 from "prop-types";
import styled36 from "styled-components";

// src/components/DataTable/assets/table-placeholder.svg
var table_placeholder_default = 'data:image/svg+xml,<?xml version="1.0" encoding="UTF-8"?>%0A<svg width="780px" height="440px" viewBox="0 0 780 440" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="none">%0A    <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->%0A    <title>Group 3</title>%0A    <desc>Created with Sketch.</desc>%0A    <defs>%0A        <rect id="path-1" x="0.499358974" y="0.398148148" width="778.001282" height="42.2037037"></rect>%0A        <rect id="path-3" x="0.628225806" y="0.390909091" width="777.743548" height="42.2181818"></rect>%0A        <rect id="path-5" x="0.499358974" y="0.398148148" width="778.001282" height="42.2037037"></rect>%0A        <rect id="path-7" x="0.628225806" y="0.390909091" width="777.743548" height="42.2181818"></rect>%0A        <rect id="path-9" x="0.499358974" y="0.398148148" width="778.001282" height="42.2037037"></rect>%0A        <rect id="path-11" x="0.628225806" y="0.390909091" width="777.743548" height="42.2181818"></rect>%0A        <rect id="path-13" x="0.499358974" y="0.398148148" width="778.001282" height="42.2037037"></rect>%0A        <rect id="path-15" x="0.628225806" y="0.390909091" width="777.743548" height="42.2181818"></rect>%0A        <rect id="path-17" x="0.499358974" y="0.398148148" width="778.001282" height="42.2037037"></rect>%0A        <rect id="path-19" x="0.628225806" y="0.390909091" width="777.743548" height="42.2181818"></rect>%0A        <rect id="path-21" x="0.499358974" y="0.398148148" width="778.001282" height="42.2037037"></rect>%0A        <rect id="path-23" x="0.628225806" y="0.390909091" width="777.743548" height="42.2181818"></rect>%0A        <rect id="path-25" x="0.499358974" y="0.398148148" width="778.001282" height="42.2037037"></rect>%0A        <rect id="path-27" x="0.628225806" y="0.390909091" width="777.743548" height="42.2181818"></rect>%0A        <rect id="path-29" x="0.499358974" y="0.398148148" width="778.001282" height="42.2037037"></rect>%0A        <rect id="path-31" x="0.628225806" y="0.390909091" width="777.743548" height="42.2181818"></rect>%0A        <rect id="path-33" x="0.499358974" y="0.398148148" width="778.001282" height="42.2037037"></rect>%0A        <rect id="path-35" x="0.628225806" y="0.390909091" width="777.743548" height="42.2181818"></rect>%0A        <rect id="path-37" x="0.499358974" y="0.398148148" width="778.001282" height="42.2037037"></rect>%0A        <path d="M0.628225806,0.390909091 L778.371774,0.390909091 L778.371774,38.6090909 C778.371774,40.8182299 776.580913,42.6090909 774.371774,42.6090909 L4.62822581,42.6090909 C2.41908681,42.6090909 0.628225806,40.8182299 0.628225806,38.6090909 L0.628225806,0.390909091 Z" id="path-39"></path>%0A    </defs>%0A    <g id="Components" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">%0A        <g id="Search" transform="translate(-100.000000, -168.000000)">%0A            <g id="Group-3" transform="translate(100.000000, 168.000000)">%0A                <g id="\u{1F5A5}-/-Lists-/-Transaction">%0A                    <g id="Group" stroke-width="1" fill-rule="evenodd" transform="translate(0.500000, 0.500000)">%0A                        <mask id="mask-2" fill="white">%0A                            <use xlink:href="%23path-1"></use>%0A                        </mask>%0A                        <g id="Rectangle"></g>%0A                        <g id="\u{1F5A5}-/-List-/-9-Component-/-Background-/-2-Middle" mask="url(%23mask-2)">%0A                            <mask id="mask-4" fill="white">%0A                                <use xlink:href="%23path-3"></use>%0A                            </mask>%0A                            <g id="Rectangle"></g>%0A                            <g id="1-Color" mask="url(%23mask-4)" fill="%23FFFFFF" fill-rule="evenodd">%0A                                <g id="2-Colors-/-9-Greys-/-3-White">%0A                                    <polygon id="Screen" points="0 0 779 0 779 43 0 43"></polygon>%0A                                </g>%0A                            </g>%0A                        </g>%0A                    </g>%0A                    <g id="Atoms-/-Panel-/-Components-/-Divider-/-Horiontal" transform="translate(0.000000, 43.000000)" stroke="%23DFE3E8" stroke-width="1">%0A                        <path d="M1.70530257e-13,1 L780,1" id="Line-Copy-6"></path>%0A                    </g>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="20" y="12" width="181" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="241" y="12" width="182" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="463" y="12" width="111" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="614" y="12" width="126" height="20" rx="10"></rect>%0A                </g>%0A                <g id="\u{1F5A5}-/-Lists-/-Transaction" transform="translate(0.000000, 176.000000)">%0A                    <g id="Group" stroke-width="1" fill-rule="evenodd" transform="translate(0.500000, 0.500000)">%0A                        <mask id="mask-6" fill="white">%0A                            <use xlink:href="%23path-5"></use>%0A                        </mask>%0A                        <g id="Rectangle"></g>%0A                        <g id="\u{1F5A5}-/-List-/-9-Component-/-Background-/-2-Middle" mask="url(%23mask-6)">%0A                            <mask id="mask-8" fill="white">%0A                                <use xlink:href="%23path-7"></use>%0A                            </mask>%0A                            <g id="Rectangle"></g>%0A                            <g id="1-Color" mask="url(%23mask-8)" fill="%23FFFFFF" fill-rule="evenodd">%0A                                <g id="2-Colors-/-9-Greys-/-3-White">%0A                                    <polygon id="Screen" points="0 0 779 0 779 43 0 43"></polygon>%0A                                </g>%0A                            </g>%0A                        </g>%0A                    </g>%0A                    <g id="Atoms-/-Panel-/-Components-/-Divider-/-Horiontal" transform="translate(0.000000, 43.000000)" stroke="%23DFE3E8" stroke-width="1">%0A                        <path d="M1.70530257e-13,1 L780,1" id="Line-Copy-6"></path>%0A                    </g>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="20" y="12" width="181" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="241" y="12" width="182" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="463" y="12" width="111" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="614" y="12" width="126" height="20" rx="10"></rect>%0A                </g>%0A                <g id="\u{1F5A5}-/-Lists-/-Transaction" transform="translate(0.000000, 88.000000)">%0A                    <g id="Group" stroke-width="1" fill-rule="evenodd" transform="translate(0.500000, 0.500000)">%0A                        <mask id="mask-10" fill="white">%0A                            <use xlink:href="%23path-9"></use>%0A                        </mask>%0A                        <g id="Rectangle"></g>%0A                        <g id="\u{1F5A5}-/-List-/-9-Component-/-Background-/-2-Middle" mask="url(%23mask-10)">%0A                            <mask id="mask-12" fill="white">%0A                                <use xlink:href="%23path-11"></use>%0A                            </mask>%0A                            <g id="Rectangle"></g>%0A                            <g id="1-Color" mask="url(%23mask-12)" fill="%23FFFFFF" fill-rule="evenodd">%0A                                <g id="2-Colors-/-9-Greys-/-3-White">%0A                                    <polygon id="Screen" points="0 0 779 0 779 43 0 43"></polygon>%0A                                </g>%0A                            </g>%0A                        </g>%0A                    </g>%0A                    <g id="Atoms-/-Panel-/-Components-/-Divider-/-Horiontal" transform="translate(0.000000, 43.000000)" stroke="%23DFE3E8" stroke-width="1">%0A                        <path d="M1.70530257e-13,1 L780,1" id="Line-Copy-6"></path>%0A                    </g>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="20" y="12" width="181" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="241" y="12" width="182" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="463" y="12" width="111" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="614" y="12" width="126" height="20" rx="10"></rect>%0A                </g>%0A                <g id="\u{1F5A5}-/-Lists-/-Transaction" transform="translate(0.000000, 264.000000)">%0A                    <g id="Group" stroke-width="1" fill-rule="evenodd" transform="translate(0.500000, 0.500000)">%0A                        <mask id="mask-14" fill="white">%0A                            <use xlink:href="%23path-13"></use>%0A                        </mask>%0A                        <g id="Rectangle"></g>%0A                        <g id="\u{1F5A5}-/-List-/-9-Component-/-Background-/-2-Middle" mask="url(%23mask-14)">%0A                            <mask id="mask-16" fill="white">%0A                                <use xlink:href="%23path-15"></use>%0A                            </mask>%0A                            <g id="Rectangle"></g>%0A                            <g id="1-Color" mask="url(%23mask-16)" fill="%23FFFFFF" fill-rule="evenodd">%0A                                <g id="2-Colors-/-9-Greys-/-3-White">%0A                                    <polygon id="Screen" points="0 0 779 0 779 43 0 43"></polygon>%0A                                </g>%0A                            </g>%0A                        </g>%0A                    </g>%0A                    <g id="Atoms-/-Panel-/-Components-/-Divider-/-Horiontal" transform="translate(0.000000, 43.000000)" stroke="%23DFE3E8" stroke-width="1">%0A                        <path d="M1.70530257e-13,1 L780,1" id="Line-Copy-6"></path>%0A                    </g>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="20" y="12" width="181" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="241" y="12" width="182" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="463" y="12" width="111" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="614" y="12" width="126" height="20" rx="10"></rect>%0A                </g>%0A                <g id="\u{1F5A5}-/-Lists-/-Transaction" transform="translate(0.000000, 308.000000)">%0A                    <g id="Group" stroke-width="1" fill-rule="evenodd" transform="translate(0.500000, 0.500000)">%0A                        <mask id="mask-18" fill="white">%0A                            <use xlink:href="%23path-17"></use>%0A                        </mask>%0A                        <g id="Rectangle"></g>%0A                        <g id="\u{1F5A5}-/-List-/-9-Component-/-Background-/-2-Middle" mask="url(%23mask-18)">%0A                            <mask id="mask-20" fill="white">%0A                                <use xlink:href="%23path-19"></use>%0A                            </mask>%0A                            <g id="Rectangle"></g>%0A                            <g id="1-Color" mask="url(%23mask-20)" fill="%23FFFFFF" fill-rule="evenodd">%0A                                <g id="2-Colors-/-9-Greys-/-3-White">%0A                                    <polygon id="Screen" points="0 0 779 0 779 43 0 43"></polygon>%0A                                </g>%0A                            </g>%0A                        </g>%0A                    </g>%0A                    <g id="Atoms-/-Panel-/-Components-/-Divider-/-Horiontal" transform="translate(0.000000, 43.000000)" stroke="%23DFE3E8" stroke-width="1">%0A                        <path d="M1.70530257e-13,1 L780,1" id="Line-Copy-6"></path>%0A                    </g>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="20" y="12" width="181" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="241" y="12" width="182" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="463" y="12" width="111" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="614" y="12" width="126" height="20" rx="10"></rect>%0A                </g>%0A                <g id="\u{1F5A5}-/-Lists-/-Transaction" transform="translate(0.000000, 352.000000)">%0A                    <g id="Group" stroke-width="1" fill-rule="evenodd" transform="translate(0.500000, 0.500000)">%0A                        <mask id="mask-22" fill="white">%0A                            <use xlink:href="%23path-21"></use>%0A                        </mask>%0A                        <g id="Rectangle"></g>%0A                        <g id="\u{1F5A5}-/-List-/-9-Component-/-Background-/-2-Middle" mask="url(%23mask-22)">%0A                            <mask id="mask-24" fill="white">%0A                                <use xlink:href="%23path-23"></use>%0A                            </mask>%0A                            <g id="Rectangle"></g>%0A                            <g id="1-Color" mask="url(%23mask-24)" fill="%23FFFFFF" fill-rule="evenodd">%0A                                <g id="2-Colors-/-9-Greys-/-3-White">%0A                                    <polygon id="Screen" points="0 0 779 0 779 43 0 43"></polygon>%0A                                </g>%0A                            </g>%0A                        </g>%0A                    </g>%0A                    <g id="Atoms-/-Panel-/-Components-/-Divider-/-Horiontal" transform="translate(0.000000, 43.000000)" stroke="%23DFE3E8" stroke-width="1">%0A                        <path d="M1.70530257e-13,1 L780,1" id="Line-Copy-6"></path>%0A                    </g>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="20" y="12" width="181" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="241" y="12" width="182" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="463" y="12" width="111" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="614" y="12" width="126" height="20" rx="10"></rect>%0A                </g>%0A                <g id="\u{1F5A5}-/-Lists-/-Transaction" transform="translate(0.000000, 44.000000)">%0A                    <g id="Group" stroke-width="1" fill-rule="evenodd" transform="translate(0.500000, 0.500000)">%0A                        <mask id="mask-26" fill="white">%0A                            <use xlink:href="%23path-25"></use>%0A                        </mask>%0A                        <g id="Rectangle"></g>%0A                        <g id="\u{1F5A5}-/-List-/-9-Component-/-Background-/-2-Middle" mask="url(%23mask-26)">%0A                            <mask id="mask-28" fill="white">%0A                                <use xlink:href="%23path-27"></use>%0A                            </mask>%0A                            <g id="Rectangle"></g>%0A                            <g id="1-Color" mask="url(%23mask-28)" fill="%23FFFFFF" fill-rule="evenodd">%0A                                <g id="2-Colors-/-9-Greys-/-3-White">%0A                                    <polygon id="Screen" points="0 0 779 0 779 43 0 43"></polygon>%0A                                </g>%0A                            </g>%0A                        </g>%0A                    </g>%0A                    <g id="Atoms-/-Panel-/-Components-/-Divider-/-Horiontal" transform="translate(0.000000, 43.000000)" stroke="%23DFE3E8" stroke-width="1">%0A                        <path d="M1.70530257e-13,1 L780,1" id="Line-Copy-6"></path>%0A                    </g>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="20" y="12" width="181" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="241" y="12" width="182" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="463" y="12" width="111" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="614" y="12" width="126" height="20" rx="10"></rect>%0A                </g>%0A                <g id="\u{1F5A5}-/-Lists-/-Transaction" transform="translate(0.000000, 220.000000)">%0A                    <g id="Group" stroke-width="1" fill-rule="evenodd" transform="translate(0.500000, 0.500000)">%0A                        <mask id="mask-30" fill="white">%0A                            <use xlink:href="%23path-29"></use>%0A                        </mask>%0A                        <g id="Rectangle"></g>%0A                        <g id="\u{1F5A5}-/-List-/-9-Component-/-Background-/-2-Middle" mask="url(%23mask-30)">%0A                            <mask id="mask-32" fill="white">%0A                                <use xlink:href="%23path-31"></use>%0A                            </mask>%0A                            <g id="Rectangle"></g>%0A                            <g id="1-Color" mask="url(%23mask-32)" fill="%23FFFFFF" fill-rule="evenodd">%0A                                <g id="2-Colors-/-9-Greys-/-3-White">%0A                                    <polygon id="Screen" points="0 0 779 0 779 43 0 43"></polygon>%0A                                </g>%0A                            </g>%0A                        </g>%0A                    </g>%0A                    <g id="Atoms-/-Panel-/-Components-/-Divider-/-Horiontal" transform="translate(0.000000, 43.000000)" stroke="%23DFE3E8" stroke-width="1">%0A                        <path d="M1.70530257e-13,1 L780,1" id="Line-Copy-6"></path>%0A                    </g>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="20" y="12" width="181" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="241" y="12" width="182" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="463" y="12" width="111" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="614" y="12" width="126" height="20" rx="10"></rect>%0A                </g>%0A                <g id="\u{1F5A5}-/-Lists-/-Transaction" transform="translate(0.000000, 132.000000)">%0A                    <g id="Group" stroke-width="1" fill-rule="evenodd" transform="translate(0.500000, 0.500000)">%0A                        <mask id="mask-34" fill="white">%0A                            <use xlink:href="%23path-33"></use>%0A                        </mask>%0A                        <g id="Rectangle"></g>%0A                        <g id="\u{1F5A5}-/-List-/-9-Component-/-Background-/-2-Middle" mask="url(%23mask-34)">%0A                            <mask id="mask-36" fill="white">%0A                                <use xlink:href="%23path-35"></use>%0A                            </mask>%0A                            <g id="Rectangle"></g>%0A                            <g id="1-Color" mask="url(%23mask-36)" fill="%23FFFFFF" fill-rule="evenodd">%0A                                <g id="2-Colors-/-9-Greys-/-3-White">%0A                                    <polygon id="Screen" points="0 0 779 0 779 43 0 43"></polygon>%0A                                </g>%0A                            </g>%0A                        </g>%0A                    </g>%0A                    <g id="Atoms-/-Panel-/-Components-/-Divider-/-Horiontal" transform="translate(0.000000, 43.000000)" stroke="%23DFE3E8" stroke-width="1">%0A                        <path d="M1.70530257e-13,1 L780,1" id="Line-Copy-6"></path>%0A                    </g>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="20" y="12" width="181" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="241" y="12" width="182" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="463" y="12" width="111" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" fill-rule="evenodd" x="614" y="12" width="126" height="20" rx="10"></rect>%0A                </g>%0A                <g id="\u{1F5A5}-/-Lists-/-Transaction" transform="translate(0.000000, 396.000000)">%0A                    <g id="Group" stroke-width="1" transform="translate(0.500000, 0.500000)">%0A                        <mask id="mask-38" fill="white">%0A                            <use xlink:href="%23path-37"></use>%0A                        </mask>%0A                        <g id="Rectangle"></g>%0A                        <g id="\u{1F5A5}-/-List-/-9-Component-/-Background-/-3-Bottom" mask="url(%23mask-38)">%0A                            <mask id="mask-40" fill="white">%0A                                <use xlink:href="%23path-39"></use>%0A                            </mask>%0A                            <g id="Rectangle"></g>%0A                            <g id="1-Color" mask="url(%23mask-40)" fill="%23FFFFFF" fill-rule="evenodd">%0A                                <g id="2-Colors-/-1-White">%0A                                    <polygon id="Screen" points="0 0 779 0 779 43 0 43"></polygon>%0A                                </g>%0A                            </g>%0A                        </g>%0A                    </g>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" x="20" y="12" width="181" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" x="241" y="12" width="182" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" x="463" y="12" width="111" height="20"></rect>%0A                    <rect id="Rectangle-2" fill="%23F4F6F8" x="614" y="12" width="126" height="20" rx="10"></rect>%0A                </g>%0A            </g>%0A        </g>%0A    </g>%0A</svg>';

// src/components/DataTable/List.tsx
import { Fragment as Fragment3, jsx as jsx82, jsxs as jsxs42 } from "react/jsx-runtime";
var Placeholder = styled36(View_default)``;
Placeholder.defaultProps = {
  as: "img",
  src: table_placeholder_default,
  width: "100%",
  borderTop: 1
};
var Container4 = styled36(View_default)`
  overflow: auto;
  -webkit-overflow-scrolling: touch;
`;
var List = ({
  items,
  state,
  renderTable,
  renderEmpty,
  dispatch,
  resource,
  emptyWrapperProps
}) => {
  const { searchQuery } = state;
  const renderProps = {
    items: items || [],
    // searchQuery is deprecated since we pass `state`
    searchQuery,
    resource,
    state,
    dispatch
  };
  return items === null || items.length > 0 ? /* @__PURE__ */ jsxs42(Fragment3, { children: [
    /* @__PURE__ */ jsx82(Container4, { position: "relative", children: renderTable(renderProps) }),
    items === null && /* @__PURE__ */ jsx82(Placeholder, { maxHeight: "440px" })
  ] }) : renderEmpty ? renderEmpty(renderProps) : /* @__PURE__ */ jsx82(
    Flex_default,
    {
      minHeight: "440px",
      height: "1px",
      flexDirection: "column",
      justifyContent: "center",
      ...emptyWrapperProps,
      children: /* @__PURE__ */ jsxs42(View_default, { textAlign: "center", children: [
        /* @__PURE__ */ jsx82(View_default, { as: NotFoundSvg_default, color: "primary.3", mb: 1 }),
        /* @__PURE__ */ jsx82(Heading, { mb: 1, children: "No results found" }),
        !!searchQuery && /* @__PURE__ */ jsx82(Text_default, { fontSize: "14px", color: "ink.2", children: "Try broadening your search" })
      ] })
    }
  );
};
List.propTypes = {
  items: PropTypes7.array,
  state: PropTypes7.object.isRequired,
  renderTable: PropTypes7.func,
  renderEmpty: PropTypes7.func,
  dispatch: PropTypes7.func,
  resource: PropTypes7.any,
  emptyWrapperProps: PropTypes7.any
};
var List_default = List;

// src/components/DataTable/Loader.tsx
import { Component as Component2 } from "react";
import styled37 from "styled-components";
import { jsx as jsx83 } from "react/jsx-runtime";
var ANIMATION_DURATION = 800;
var LoadingWrap = styled37(View_default)`
  position: absolute;
  top: 0px;
  left: 0;
  overflow: hidden;
  height: 1px;
  width: 100%;
`;
var LoadingLine = styled37(View_default)`
  position: relative;
  height: 1px;
  width: 100%;
  left: 0;
  background: linear-gradient(
    to left,
    #0dab76,
    #0ae199 28%,
    #dfe3e8 53%,
    #dfe3e8
  );
  display: ${(p) => p.loading ? "block" : "none"};
  animation-name: ${(p) => p.loading ? "slide" : "none"};
  animation-duration: ${ANIMATION_DURATION}ms;
  animation-iteration-count: infinite;

  @keyframes slide {
    from {
      left: -780px;
    }
    to {
      left: 280px;
    }
  }
`;
var Loader = class extends Component2 {
  constructor() {
    super(...arguments);
    this.state = {
      isAnimating: false
    };
    this.mounted = true;
    this.timerStart = 0;
  }
  componentDidUpdate() {
    const { loading } = this.props;
    const { isAnimating } = this.state;
    if (!isAnimating && loading) {
      this.timerStart = setTimeout(() => {
        this.mounted && this.setState({ isAnimating: true });
        setTimeout(() => {
          this.mounted && this.setState({ isAnimating: false });
        }, ANIMATION_DURATION - 50);
      }, 1e3);
    }
    if (!loading && !isAnimating) {
      clearTimeout(this.timerStart);
    }
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    const { isAnimating } = this.state;
    return /* @__PURE__ */ jsx83(LoadingWrap, { children: /* @__PURE__ */ jsx83(LoadingLine, { loading: isAnimating }) });
  }
};
var Loader_default = Loader;

// src/components/DataTable/Pagination.tsx
import PropTypes8 from "prop-types";
import { useTranslation } from "react-i18next";
import styled38 from "styled-components";
import { jsx as jsx84, jsxs as jsxs43 } from "react/jsx-runtime";
var Placeholder2 = () => /* @__PURE__ */ jsx84(View_default, { width: "22px", height: "22px" });
var Page = styled38(Caption)`
  user-select: none;
`;
var Pagination = ({
  limit,
  offset,
  items,
  totalCount,
  onChange,
  ...rest
}) => {
  const { t: t2 } = useTranslation();
  const numberOfPages = Math.ceil(totalCount / limit);
  const pages = Array.from(Array(numberOfPages).keys());
  const currentPage = offset / limit;
  return totalCount > limit ? /* @__PURE__ */ jsxs43(Flex_default, { borderTop: 1, p: 3, ...rest, "data-testid": "pagination", children: [
    /* @__PURE__ */ jsx84(View_default, { flex: "1", display: ["block", "none"] }),
    /* @__PURE__ */ jsx84(Caption, { flex: "1", display: ["none", "block"], children: t2("Showing {{visibleItems}} of {{totalItems}} results", {
      visibleItems: items?.length,
      totalItems: totalCount
    }) }),
    /* @__PURE__ */ jsxs43(Flex_default, { children: [
      currentPage > 0 ? /* @__PURE__ */ jsx84(
        ArrowLeft_default,
        {
          onClick: () => onChange((currentPage - 1) * limit),
          cursor: "pointer"
        }
      ) : /* @__PURE__ */ jsx84(Placeholder2, {}),
      pages.map(
        (p) => p < currentPage - 4 || p > currentPage + 4 ? null : /* @__PURE__ */ jsx84(
          View_default,
          {
            bg: currentPage === p ? "default.primary" : "white",
            onClick: () => onChange(p * limit),
            borderRadius: 1,
            mx: 1,
            cursor: "pointer",
            children: /* @__PURE__ */ jsx84(
              Page,
              {
                color: currentPage === p ? "white" : "ink.2",
                textAlign: "center",
                width: "24px",
                lineHeight: "24px",
                children: p + 1
              }
            )
          },
          p
        )
      ),
      currentPage < numberOfPages - 1 ? /* @__PURE__ */ jsx84(
        ArrowRight_default,
        {
          onClick: () => onChange((currentPage + 1) * limit),
          cursor: "pointer"
        }
      ) : /* @__PURE__ */ jsx84(Placeholder2, {})
    ] }),
    /* @__PURE__ */ jsx84(View_default, { flex: "1" })
  ] }) : null;
};
Pagination.propTypes = {
  onChange: PropTypes8.func.isRequired,
  limit: PropTypes8.number,
  offset: PropTypes8.number,
  items: PropTypes8.array,
  totalCount: PropTypes8.number
};
var Pagination_default = Pagination;

// src/components/DataTable/Search.tsx
import { Component as Component3 } from "react";
import styled39 from "styled-components";

// src/components/DataTable/assets/looking-glass.svg
var looking_glass_default = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="22" viewBox="0 0 22 22">%0A    <defs>%0A        <path id="a" d="M9 13a4 4 0 1 1 0-8 4 4 0 0 1 0 8m9.707 4.293l-4.82-4.82A5.968 5.968 0 0 0 15 9 6 6 0 0 0 3 9a6 6 0 0 0 6 6 5.968 5.968 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414"/>%0A    </defs>%0A    <g fill="none" fill-rule="evenodd">%0A        <mask id="b" fill="%23fff">%0A            <use xlink:href="%23a"/>%0A        </mask>%0A        <g fill="%23919EAB" mask="url(%23b)">%0A            <path d="M0 0h22v22H0z"/>%0A        </g>%0A    </g>%0A</svg>%0A';

// src/components/DataTable/Search.tsx
import { jsx as jsx85 } from "react/jsx-runtime";
var Icon2 = styled39(View_default)``;
Icon2.defaultProps = {
  as: "img",
  src: looking_glass_default
};
var SearchInput = styled39(Input_default)`
  flex: 1;
  border: none;
  border-radius: 4px 0 0 4px;
  padding-top: 6px;
  padding-bottom: 6px;
  &:after {
    display: none;
  }
  input::placeholder {
    font-size: 14px;
    font-weight: 400;
  }
`;
SearchInput.defaultProps = {
  bg: "transparent"
};
var Search2 = class extends Component3 {
  constructor() {
    super(...arguments);
    this.handleChange = (e) => {
      const { onChange } = this.props;
      const { value } = e.target;
      onChange?.(value);
    };
  }
  render() {
    const { placeholder, onChange, value, ...rest } = this.props;
    return /* @__PURE__ */ jsx85(View_default, { flex: "1", ...rest, children: /* @__PURE__ */ jsx85("form", { autoComplete: "off", onSubmit: (e) => e.preventDefault(), children: /* @__PURE__ */ jsx85(
      SearchInput,
      {
        input: { onChange: this.handleChange, value },
        autoComplete: "false",
        maxWidth: "100%",
        left: /* @__PURE__ */ jsx85(View_default, { maxHeight: "24px", children: /* @__PURE__ */ jsx85(Icon2, {}) }),
        placeholder,
        variant: "outline"
      }
    ) }) });
  }
};
Search2.defaultProps = {
  onChange: () => {
  }
};
var Search_default2 = Search2;

// src/components/DataTable/SelectionActions.tsx
import { jsx as jsx86 } from "react/jsx-runtime";
function SelectionActions(props) {
  const { state } = useDataTable();
  if (!state.selected?.length) {
    return null;
  }
  return /* @__PURE__ */ jsx86(
    Flex_default,
    {
      position: ["relatice", "absolute"],
      height: ["auto", "52px"],
      mb: [4, 0],
      px: [4, 2],
      bg: "white",
      width: "100%",
      zIndex: "20",
      ...props
    }
  );
}
var SelectionActions_default = SelectionActions;

// src/components/DataTable/SelectionBulkToggleButton.tsx
import { jsx as jsx87, jsxs as jsxs44 } from "react/jsx-runtime";
function SelectionBulkToggleButton(props) {
  const { items, state, dispatch } = useDataTable();
  if (!state.selected?.length) {
    return null;
  }
  return /* @__PURE__ */ jsx87(
    Button_default,
    {
      leftIcon: () => /* @__PURE__ */ jsx87(
        Selector_default,
        {
          state: items?.length === state?.selected?.length ? "active" : "semiActive",
          width: "16px",
          height: "16px",
          ml: "7px",
          mr: 3
        }
      ),
      variant: "secondary",
      sizeVariant: "sm",
      onClick: () => {
        dispatch({
          type: "selectedChange",
          payload: []
        });
      },
      ...props,
      children: /* @__PURE__ */ jsxs44(Caption, { color: "ink.1", fontWeight: "semibold", children: [
        state.selected?.length,
        " Selected"
      ] })
    }
  );
}
var SelectionBulkToggleButton_default = SelectionBulkToggleButton;

// src/components/DataTable/Tabs.tsx
import PropTypes9 from "prop-types";
import { jsx as jsx88, jsxs as jsxs45 } from "react/jsx-runtime";
function Tabs({
  labels: labels2 = [],
  onClick = (e) => e,
  activeIndexes = [],
  totalCount,
  ...rest
}) {
  return /* @__PURE__ */ jsxs45(
    Flex_default,
    {
      px: 4,
      pt: 2,
      pb: 1,
      justifyContent: "flex-start",
      flexWrap: "wrap",
      ...rest,
      children: [
        labels2.map((label, index) => /* @__PURE__ */ jsx88(
          Subheading,
          {
            mr: 2,
            py: 1,
            px: 2,
            color: activeIndexes.includes(index) ? "coal.3" : "ink.2",
            bg: activeIndexes.includes(index) ? "sky.1" : "transparent",
            onClick: () => onClick(index),
            cursor: "pointer",
            "data-testid": "tab",
            borderRadius: 1,
            children: label
          },
          index
        )),
        !!totalCount && /* @__PURE__ */ jsxs45(Caption, { style: { marginLeft: "auto" }, children: [
          totalCount,
          " results"
        ] })
      ]
    }
  );
}
Tabs.propTypes = {
  labels: PropTypes9.array.isRequired,
  activeIndexes: PropTypes9.array.isRequired,
  onClick: PropTypes9.func.isRequired
};
var Tabs_default = Tabs;

// src/components/DataTable/index.tsx
import { jsx as jsx89, jsxs as jsxs46 } from "react/jsx-runtime";
var Container5 = styled40(View_default)`
  overflow: hidden;
`;
var Controls = styled40(View_default)`
  position: relative;
`;
function DataTable({
  tabs = [],
  filters = [],
  mapStateToParams = (s) => s,
  itemsFilter = (i) => i,
  resourceHook: useResourceHook,
  searchPlaceholder,
  paginationLimit = 10,
  id = "",
  children: children2,
  renderEmpty,
  initialState: initialState3,
  onStateChange,
  emptyWrapperProps,
  ...rest
}) {
  const mergedInitialState = useMemo4(
    () => ({
      activeTabIndexes: [0],
      activeTabs: tabs.length ? [tabs[0]] : [],
      activeFilters: {},
      searchQuery: "",
      offset: 0,
      orderBy: {},
      selected: [],
      metadata: {},
      ...initialState3
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [tabs]
  );
  const lastStateChange = useRef6();
  const reducer = useCallback8(
    (state2, { type, payload }) => {
      lastStateChange.current = { type, payload };
      switch (type) {
        case "tabChange": {
          const tab = tabs[payload];
          const currentTabGroup = tab.group;
          const sameGroupTabs = state2.activeTabIndexes?.filter(
            (index) => tabs[index].group === currentTabGroup
          );
          const updatedIndexes = state2.activeTabIndexes?.includes(payload) ? sameGroupTabs?.filter((i) => payload !== i) : [...sameGroupTabs || [], payload];
          if (!updatedIndexes?.length) {
            return state2;
          }
          return {
            ...state2,
            offset: mergedInitialState.offset,
            activeTabIndexes: updatedIndexes,
            activeTabs: tabs.filter(
              (t2, tabIndex) => updatedIndexes?.includes(tabIndex)
            ),
            selected: []
          };
        }
        case "filterChange":
          return {
            ...state2,
            offset: mergedInitialState.offset,
            activeFilters: {
              ...state2.activeFilters,
              [payload.name]: {
                value: payload.value,
                mode: payload.mode || state2.activeFilters?.[payload.name]?.mode
              }
            },
            selected: []
          };
        case "search":
          return {
            ...state2,
            offset: mergedInitialState.offset,
            searchQuery: payload,
            selected: []
          };
        case "paginate":
          return {
            ...state2,
            offset: payload,
            selected: []
          };
        case "orderByChange":
          return {
            ...state2,
            orderBy: payload,
            selected: []
          };
        case "selectedChange":
          return {
            ...state2,
            selected: payload
          };
        case "setMetadata":
          return {
            ...state2,
            metadata: payload
          };
        case "updateMetadata":
          return {
            ...state2,
            metadata: {
              ...state2.metadata,
              ...payload
            }
          };
        default:
          return state2;
      }
    },
    [mergedInitialState, tabs]
  );
  const [state, dispatch] = useJSONQueryStringReducer_default(
    `datatable${id ? `-${id}` : ""}`,
    reducer,
    mergedInitialState
  );
  const stateHash = JSON.stringify(state);
  useEffect13(() => {
    if (lastStateChange.current) {
      onStateChange?.(lastStateChange.current, dispatch);
    }
  }, [stateHash, onStateChange, dispatch]);
  const {
    data,
    error,
    resource = {}
  } = useResourceHook(
    mapStateToParams({
      limit: paginationLimit,
      ...state
      // Todo: We might want to pass this later, but needs migration
      // selected: undefined,
    })
  );
  const { items, totalCount } = data || {};
  const filteredItems = items?.filter((i) => itemsFilter(i, state)) || null;
  const handleSearch = useCallback8(
    debounce_default((query) => {
      dispatch({ type: "search", payload: query });
    }, 400),
    [dispatch]
  );
  const [searchInputValue, setSearchInputValue] = useState14(state.searchQuery);
  if (error) {
    throw error;
  }
  return /* @__PURE__ */ jsx89(
    context_default.Provider,
    {
      value: {
        state,
        dispatch,
        resource,
        items: filteredItems
      },
      children: /* @__PURE__ */ jsxs46(Container5, { bg: "white", borderRadius: 1, border: 1, boxShadow: 1, ...rest, children: [
        /* @__PURE__ */ jsxs46(
          Controls,
          {
            pt: tabs.length ? 2 : searchPlaceholder ? 5 : 0,
            pb: tabs.length || searchPlaceholder ? 3 : 0,
            children: [
              /* @__PURE__ */ jsx89(Loader_default, { loading: !filteredItems }),
              tabs.length ? /* @__PURE__ */ jsx89(
                Tabs_default,
                {
                  labels: tabs.map((s) => s.label),
                  onClick: (index) => {
                    dispatch({ type: "tabChange", payload: index });
                  },
                  activeIndexes: state.activeTabIndexes,
                  totalCount: totalCount || 0
                }
              ) : null,
              (searchPlaceholder || !!filters.length) && /* @__PURE__ */ jsxs46(
                Flex_default,
                {
                  mt: tabs.length ? 2 : 0,
                  border: [0, 1],
                  borderRadius: [0, 1],
                  mx: 4,
                  flexDirection: ["column", "row"],
                  overflow: "hidden",
                  children: [
                    searchPlaceholder && /* @__PURE__ */ jsx89(
                      Search_default2,
                      {
                        onChange: (query) => {
                          setSearchInputValue(query);
                          handleSearch(query);
                        },
                        value: searchInputValue,
                        placeholder: searchPlaceholder,
                        bg: "sky.3",
                        border: [1, 0],
                        borderRadius: [1, 0],
                        width: "100%"
                      }
                    ),
                    !!filters.length && /* @__PURE__ */ jsx89(
                      Flex_default,
                      {
                        flexDirection: ["column", "row"],
                        width: ["100%", "unset"],
                        border: [1, 0],
                        borderRadius: [1, 0],
                        overflow: "hidden",
                        bg: ["white", "sky.3"],
                        mt: [4, 0],
                        children: filters.map(
                          ({ initialValue, initialMode, component, ...filter2 }) => {
                            const Component17 = component || FilterSelect_default;
                            const value = state.activeFilters?.[filter2.name]?.value || initialValue;
                            const mode = state.activeFilters?.[filter2.name]?.mode || initialMode;
                            return /* @__PURE__ */ jsx89(
                              Component17,
                              {
                                ...filter2,
                                value,
                                mode: component ? mode : void 0,
                                onChange: (change) => {
                                  dispatch({ type: "filterChange", payload: change });
                                },
                                borderLeft: [0, 1],
                                _notLast: {
                                  borderBottom: [1, 0]
                                }
                              },
                              filter2.name
                            );
                          }
                        )
                      }
                    )
                  ]
                }
              ),
              !!filters.length && /* @__PURE__ */ jsx89(
                ActiveFilters_default,
                {
                  mx: 4,
                  filters,
                  values: state.activeFilters,
                  onChange: (change) => dispatch({ type: "filterChange", payload: change })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx89(
          List_default,
          {
            state,
            dispatch,
            items: filteredItems,
            renderTable: children2,
            renderEmpty,
            resource,
            emptyWrapperProps
          }
        ),
        /* @__PURE__ */ jsx89(
          Pagination_default,
          {
            limit: paginationLimit,
            offset: state.offset,
            items: filteredItems,
            totalCount: totalCount || 0,
            onChange: (offset) => dispatch({ type: "paginate", payload: offset })
          }
        )
      ] })
    }
  );
}
DataTable.propTypes = {
  resourceHook: PropTypes10.func.isRequired,
  tabs: PropTypes10.array,
  filters: PropTypes10.array,
  searchPlaceholder: PropTypes10.string,
  paginationLimit: PropTypes10.number,
  mapStateToParams: PropTypes10.func,
  itemsFilter: PropTypes10.func,
  id: PropTypes10.string,
  children: PropTypes10.func,
  renderEmpty: PropTypes10.func,
  initialState: PropTypes10.object,
  onStateChange: PropTypes10.func,
  emptyWrapperProps: PropTypes10.any
};
DataTable.Head = Head_default;
DataTable.GridTableRow = GridTableRow_default;
DataTable.SelectionActions = SelectionActions_default;
DataTable.SelectionBulkToggleButton = SelectionBulkToggleButton_default;
DataTable.SelectableGridTableRow = SelectableGridTableRow;
DataTable.CustomFilterWrapper = CustomFilterWrapper;
var DataTable_default = DataTable;

// src/components/DescriptionList.tsx
import React30 from "react";
import { jsx as jsx90, jsxs as jsxs47 } from "react/jsx-runtime";
function Item3({ gridCols = 3, ...rest }) {
  return /* @__PURE__ */ jsx90(
    View_default,
    {
      display: ["block", "grid"],
      gridTemplateColumns: `repeat(${gridCols}, minmax(0,1fr))`,
      gridGap: 4,
      py: 4,
      borderBottom: 1,
      ...rest
    }
  );
}
function DT({ ...rest }) {
  return /* @__PURE__ */ jsx90(Caption, { as: "dt", ...rest });
}
function DD({ colSpan = 2, ...rest }) {
  return /* @__PURE__ */ jsx90(
    Flex_default,
    {
      as: "dd",
      gridColumn: `span ${colSpan}/span ${colSpan}`,
      mt: [1, 0],
      alignItems: ["flex-start", "center"],
      ...rest
    }
  );
}
function Value({ ...rest }) {
  return /* @__PURE__ */ jsx90(Caption, { color: "ink.0", ...rest });
}
function Actions2({ ...rest }) {
  return /* @__PURE__ */ jsx90(Flex_default, { ml: 4, ...rest });
}
function Action2({ onClick, disabled: disabled2, ...rest }) {
  const [handleClick, status] = usePromise_default(onClick);
  return status.pending ? /* @__PURE__ */ jsx90(
    Spinner_default,
    {
      height: "20px",
      width: "20px",
      fill: "primary.3",
      spinning: true,
      mx: 3,
      ...rest
    }
  ) : /* @__PURE__ */ jsx90(
    Clickable,
    {
      onClick: !disabled2 ? handleClick : void 0,
      color: !disabled2 ? "primary.3" : "ink.3",
      cursor: !disabled2 ? "pointer" : "not-allowed",
      fontSize: 1,
      ...rest
    }
  );
}
function Separator({ ...rest }) {
  return /* @__PURE__ */ jsx90(View_default, { mx: 3, borderLeft: 1, height: "20px", ...rest });
}
function ItemBuilder({ data: d, ...rest }) {
  if (!(d.value || d.placeholder || d.actions?.length)) {
    return null;
  }
  return /* @__PURE__ */ jsxs47(Item3, { ...rest, children: [
    /* @__PURE__ */ jsx90(DT, { children: d.label }),
    /* @__PURE__ */ jsxs47(DD, { children: [
      /* @__PURE__ */ jsx90(Value, { children: d.value ? d.formattedValue || d.value : d.placeholder }),
      /* @__PURE__ */ jsx90(Actions2, { children: d.actions?.reduce(
        (acc, curr) => acc.length ? [...acc, /* @__PURE__ */ jsx90(Separator, {}), /* @__PURE__ */ jsx90(Action2, { ...curr })] : [/* @__PURE__ */ jsx90(Action2, { ...curr })],
        []
      ) })
    ] })
  ] });
}
function DescriptionList({ data, children: children2, ...rest }) {
  if (children2) {
    return /* @__PURE__ */ jsx90(View_default, { as: "dl", ...rest, children: children2 });
  }
  if (data) {
    return /* @__PURE__ */ jsx90(View_default, { as: "dl", ...rest, children: data.map((d) => {
      if (React30.isValidElement(d)) {
        return d;
      }
      return /* @__PURE__ */ jsx90(ItemBuilder, { data: d }, d.label);
    }) });
  }
  throw new Error("One of props 'children' or 'data' is required");
}
DD.Value = Value;
DD.Action = Action2;
DD.Actions = Actions2;
DD.Separator = Separator;
DescriptionList.Item = Item3;
DescriptionList.DT = DT;
DescriptionList.DD = DD;
var DescriptionList_default = DescriptionList;

// src/components/ExpansionPanel.tsx
import React31 from "react";
import { jsx as jsx91, jsxs as jsxs48 } from "react/jsx-runtime";
function ExpansionPanel({
  children: children2,
  isOpenByDefault = false,
  header,
  title,
  ...rest
}) {
  const [isOpen, setOpen] = React31.useState(isOpenByDefault);
  const height = isOpen ? "auto" : 0;
  return /* @__PURE__ */ jsxs48(
    View_default,
    {
      p: 3,
      border: 1,
      borderColor: "sky.1",
      bg: "sky.3",
      borderRadius: 1,
      ...rest,
      children: [
        /* @__PURE__ */ jsxs48(Flex_default, { cursor: "pointer", onClick: () => setOpen(!isOpen), children: [
          header || /* @__PURE__ */ jsx91(Text_default, { fontWeight: "semibold", children: title }),
          /* @__PURE__ */ jsx91(
            Flex_default,
            {
              transform: isOpen ? `rotate(-90deg)` : `rotate(0deg)`,
              transition: "transform 200ms linear",
              ml: 2,
              onClick: () => setOpen(!isOpen),
              children: /* @__PURE__ */ jsx91(ArrowLeft_default, { fill: "ink.1" })
            }
          )
        ] }),
        /* @__PURE__ */ jsx91(AnimateHeight_default, { duration: 200, height, children: /* @__PURE__ */ jsx91(View_default, { mt: 2, children: children2 }) })
      ]
    }
  );
}
var ExpansionPanel_default = ExpansionPanel;

// src/components/Feed/Builder.tsx
import React32 from "react";
import { jsx as jsx92 } from "react/jsx-runtime";
var Context2 = React32.createContext({});
function Builder({ items = [], itemBuilders, context, ...rest }) {
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    /* @__PURE__ */ jsx92(Context2.Provider, { value: { items, ...context }, children: /* @__PURE__ */ jsx92(View_default, { p: 4, ...rest, children: items.map((item, index) => {
      const ItemBuilder2 = itemBuilders[item.type];
      if (!ItemBuilder2) {
        if (process.env !== "production") {
          console.warn(`Builder missing for type ${item?.type}`, { item });
        }
        return null;
      }
      return /* @__PURE__ */ jsx92(
        ItemBuilder2,
        {
          data: item.data,
          index,
          isLastItem: index === items.length - 1
        },
        `${item.type}-${item.id}`
      );
    }) }) })
  );
}
Builder.Context = Context2;
var Builder_default = Builder;

// src/components/Feed/Item/Code.tsx
import { themeGet as themeGet10 } from "@styled-system/theme-get";
import styled41 from "styled-components";
var Code = styled41(Text_default)`
  font-family: ${themeGet10("monospace")};
`;
Code.defaultProps = {
  fontSize: 0,
  color: "ink.2",
  bg: "sky.2",
  px: 1,
  pb: "2px",
  borderRadius: 1,
  maxWidth: "fit-content"
};
var Code_default = Code;

// src/components/Feed/Item/Comment.tsx
import PropTypes11 from "prop-types";
import styled42 from "styled-components";
import { jsx as jsx93 } from "react/jsx-runtime";
var Content2 = styled42(Text_default)`
  white-space: pre-line;

  /* Forcing break */
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  word-break: break-all;
  word-break: break-word;
`;
Content2.defaultProps = {
  fontSize: 1,
  p: 3,
  borderRadius: 1,
  bg: "sky.2"
};
function Comment2({ children: children2, ...rest }) {
  return /* @__PURE__ */ jsx93(Content2, { ...rest, children: linkify(children2) });
}
Comment2.propTypes = {
  children: PropTypes11.any
};
var Comment_default2 = Comment2;

// src/components/Feed/Item/Date.tsx
import styled43 from "styled-components";
var Date2 = styled43(Caption)``;
Date2.defaultProps = {
  color: "ink.2",
  fontSize: 0
};
var Date_default = Date2;

// src/components/Feed/Item/Title.tsx
import styled44 from "styled-components";
var Title4 = styled44(Caption)`
  b {
    font-weight: 500;
  }
  i {
    font-style: italic;
  }
`;
Title4.defaultProps = {
  color: "ink.0"
};
var Title_default = Title4;

// src/components/Feed/Item/index.tsx
import { jsx as jsx94, jsxs as jsxs49 } from "react/jsx-runtime";
function Item4({
  icon,
  children: children2,
  isLastItem,
  frameWrapperProps,
  contentWrapperProps,
  ...rest
}) {
  return /* @__PURE__ */ jsxs49(
    Flex_default,
    {
      alignItems: "stretch",
      _notFirst: {
        mt: "6px"
      },
      _last: {
        mb: -3
      },
      ...rest,
      children: [
        /* @__PURE__ */ jsxs49(Flex_default, { flexDirection: "column", mr: 3, ...frameWrapperProps, children: [
          icon(),
          !isLastItem && /* @__PURE__ */ jsx94(View_default, { width: "2px", bg: "sky.1", flex: "1", borderRadius: "2px", mt: "6px" })
        ] }),
        /* @__PURE__ */ jsx94(View_default, { flex: "1", mb: 3, ...contentWrapperProps, children: children2 })
      ]
    }
  );
}
Item4.Comment = Comment_default2;
Item4.Title = Title_default;
Item4.Date = Date_default;
Item4.Code = Code_default;
var Item_default2 = Item4;

// src/components/Feed/index.tsx
import { jsx as jsx95, jsxs as jsxs50 } from "react/jsx-runtime";
function Feed({
  history,
  renderIcon,
  renderTitle,
  renderState,
  renderDate,
  ...rest
}) {
  return /* @__PURE__ */ jsx95(View_default, { p: 4, ...rest, children: history.map((h, index) => /* @__PURE__ */ jsxs50(
    Flex_default,
    {
      alignItems: "stretch",
      _notFirst: {
        mt: "6px"
      },
      _last: {
        mb: -3
      },
      children: [
        /* @__PURE__ */ jsxs50(Flex_default, { flexDirection: "column", mr: 3, children: [
          renderIcon(h),
          index < history.length - 1 && /* @__PURE__ */ jsx95(
            View_default,
            {
              width: "2px",
              bg: "sky.1",
              flex: "1",
              borderRadius: "2px",
              mt: "6px"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs50(View_default, { flex: "1", mb: 3, children: [
          renderTitle(h),
          renderState && renderState(h),
          renderDate(h)
        ] })
      ]
    },
    h.id
  )) });
}
Feed.Item = Item_default2;
Feed.Builder = Builder_default;
Feed.TitleCaption = Feed.Item.Title;
Feed.DateCaption = Feed.Item.Date;
Feed.Code = Feed.Item.Code;
var Feed_default = Feed;

// src/components/Form/AddressSelect/index.tsx
import PropTypes13 from "prop-types";
import { Component as Component6 } from "react";
import { useTranslation as useTranslation3 } from "react-i18next";

// src/components/Form/Select.tsx
import { themeGet as themeGet11 } from "@styled-system/theme-get";
import { Component as Component4 } from "react";
import { useTranslation as useTranslation2 } from "react-i18next";
import ReactSelect from "react-select/lib/Select";
import Async from "react-select/lib/Async";
import styled45, { css as css6 } from "styled-components";
import { jsx as jsx96 } from "react/jsx-runtime";
var Select2 = styled45(View_default)`
  ${variants_default({
  variant: {
    outline: {
      transition: "border-color 200ms linear",
      "&:after": {
        display: "none"
      }
    },
    "outline-v2": {
      transition: "border-color 200ms linear",
      "&:after": {
        display: "none"
      }
    }
  }
})}
  font-family: ${themeGet11("font", "Arial")};
  letter-spacing: 0.4px;
  line-height: 1.5 !important;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .Select-control:hover {
    box-shadow: none;
    background-color: ${themeGet11("colors.sky.2")};
  }

  .Select-control {
    border: 1px solid ${themeGet11("colors.sky.0")};
    background-color: ${themeGet11("colors.sky.2")};
    ${(p) => p.variant === "outline-v2" && css6`
        background-color: ${themeGet11("colors.sky.3")};
      `}
    ${(p) => p.invalid && css6`
        border: 1px solid ${themeGet11("colors.default.red")} !important;
      `}
    border-radius: 4px;
    cursor: ${(p) => p.disabled ? "not-allowed" : "pointer"};
    height: 38px;
    ${(p) => p.variant === "outline-v2" && css6`
        height: 42px;
      `}
    box-shadow: none;
  }

  &.is-open,
  &.is-focused {
    .Select-control {
      background-color: ${themeGet11("colors.sky.2")} !important;
      border: 1px solid ${themeGet11("colors.sky.0")} !important;
      .Select-input {
        background-color: ${themeGet11("colors.sky.2")} !important;
        border-radius: 4px;
      }
    }
  }

  &.is-focused {
    .Select-control {
      box-shadow: none !important;
    }
  }

  &.is-open.is-focused {
    .Select-control {
      box-shadow: -1px 1px 2px 0px rgba(0, 0, 0, 0.2) !important;
      overflow: auto;
    }
  }

  &.is-disabled {
    .Select-control {
      background-color: ${themeGet11("colors.sky.3")} !important;
    }
    .Select-arrow-zone {
      opacity: 1;
    }
  }

  .Select-placeholder,
  .Select-value {
    padding: 7px 11px;
    line-height: 1.5 !important;
  }

  .Select-placeholder {
    font-weight: 400;
  }

  .Select-menu-outer {
    box-shadow: -1px 1px 2px 0px rgba(0, 0, 0, 0.2);
    max-height: ${({ selectMenuStyle }) => selectMenuStyle?.maxHeight ? `calc(${selectMenuStyle.maxHeight} + 9px)` : "229px"};
    .Select-menu {
      max-height: ${({ selectMenuStyle }) => selectMenuStyle?.maxHeight ? selectMenuStyle.maxHeight : "220px"};
    }
    z-index: 10;
  }

  .Select-option {
    font-weight: 400;
    &.is-selected {
      background-color: ${themeGet11("colors.primary.5")};
    }
    &.is-selected.is-focused,
    &.is-focused {
      background-color: ${themeGet11("colors.primary.3")};
      color: white;
    }
  }

  .Select-placeholder {
    color: ${themeGet11("colors.ink.2")};
  }

  .Select-loading {
    border: 2px solid transparent;
    border-right-color: ${themeGet11("colors.ink.2")};
    border-top-color: ${themeGet11("colors.ink.2")};
  }

  input::-webkit-contacts-auto-fill-button {
    visibility: hidden;
    display: none !important;
    pointer-events: none;
    position: absolute;
    right: 0;
  }

  ${(p) => p.isAsync && css6`
      .Select-loading-zone {
        padding-right: 12px !important;
      }
      .Select-input > input {
        padding: 8px 0;
        line-height: 1.5 !important;
        font-weight: 400;
      }
      .Select-placeholder,
      .Select-value {
        padding: 6px 11px;
      }

      ${(p2) => p2.variant === "outline-v2" && css6`
          .Select-placeholder,
          .Select-value {
            padding: 8px 11px;
          }
        `}

      ${(p2) => p2.variant === "normal" && css6`
          &:not(.is-open) {
            .Select-control {
              border-color: transparent !important;
            }
          }
        `}
      &:not(.is-open):after {
        content: ' ';
        width: 100%;
        height: 3px;
        position: absolute;
        left: 0;
        bottom: 0;
        border-radius: 0 0 4px 4px;
        background: ${themeGet11("colors.ink.2")};
        transition: background-color 200ms linear;
        ${(p2) => p2.variant === "normal" && css6`
            ${(p3) => p3.meta.focus && css6`
                background-color: ${themeGet11("colors.ink.2")};
              `}
            ${(p3) => p3.meta.touched && !p3.meta.error && css6`
                background-color: ${themeGet11("colors.default.primary")};
              `}
          ${(p3) => p3.meta.error && p3.meta.touched && css6`
                background-color: ${themeGet11("colors.default.red")};
              `}
            ${(p3) => p3.disabled && css6`
                background-color: ${themeGet11("colors.sky.0")};
              `}
          `}
      }

      ${(p2) => p2.variant === "outline" && css6`
          .Select-control {
            border-color: ${themeGet11("colors.sky.1")};
            ${(p3) => p3.meta.focus && css6`
                border-color: ${themeGet11("colors.sky.0")};
              `}
            ${(p3) => p3.meta.touched && !p3.meta.error && css6`
                border-color: ${themeGet11("colors.default.primary")};
              `}
        ${(p3) => p3.meta.error && p3.meta.touched && css6`
                border-color: ${themeGet11("colors.default.red")};
              `}
        ${(p3) => p3.disabled && css6`
                border-color: ${themeGet11("colors.sky.0")};
              `}
          }
        `}

      ${(p2) => p2.variant === "outline-v2" && css6`
          .Select-control {
            ${(p3) => p3.meta.focus && css6`
                border-color: ${themeGet11("colors.blue.3")};
                box-shadow: 0 0 0 1px ${themeGet11("colors.blue.3")},
                  0 0 0 1px ${themeGet11("colors.blue.3")};
              `}
            ${(p3) => p3.meta.touched && !p3.meta.error && !p3.meta.focus && css6`
                border-color: ${themeGet11("colors.ink.1")};
              `}
          ${(p3) => p3.meta.error && p3.meta.touched && !p3.meta.focus && css6`
                border-color: ${themeGet11("colors.default.red")};
              `}
          ${(p3) => p3.disabled && css6`
                border-color: ${themeGet11("colors.sky.0")};
              `}
          }
        `}
    `}
`;
Select2.defaultProps = {
  as: ReactSelect,
  clearable: false,
  searchable: false,
  required: false,
  simpleValue: true,
  joinValues: true,
  maxWidth: ["100%", "350px"]
};
var AsyncSelect = ({ ...props }) => /* @__PURE__ */ jsx96(Select2, { as: Async, ...props });
var arrow = (invalid2, disabled2) => {
  const color2 = disabled2 ? "sky.0" : invalid2 ? "default.red" : "default.primary";
  return /* @__PURE__ */ jsx96(DoubleArrow_default, { fill: color2 });
};
var Wrap4 = class extends Component4 {
  constructor() {
    super(...arguments);
    this.state = {
      query: "",
      options: []
    };
    this.mounted = false;
    this.handleOptionsLoad = async (nextQuery) => {
      const {
        loadOptions,
        onError = () => {
        },
        autoload,
        onOptionsLoaded,
        onOptionsLoad
      } = this.props;
      const { query, options } = this.state;
      const shouldLoad = (nextQuery || autoload) && nextQuery !== query || autoload && nextQuery === query && !options.length;
      this.mounted && this.setState({
        query: nextQuery
      });
      if (shouldLoad) {
        try {
          onOptionsLoad?.();
          const { options: newOptions } = await loadOptions(nextQuery);
          this.mounted && this.setState({
            options: newOptions
          });
          onOptionsLoaded?.(newOptions);
          return { options: newOptions };
        } catch (e) {
          this.mounted && this.setState({
            options: []
          });
          onError(e);
        }
      } else {
        return { options };
      }
    };
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    const {
      input,
      meta,
      disabled: disabled2,
      loadOptions,
      async,
      flex,
      placeholder,
      autoload,
      variant = "outline-v2",
      ...rest
    } = this.props;
    const invalid2 = meta.error && meta.touched;
    const isAsync = loadOptions || async;
    const asyncDefaultProps = isAsync ? {
      onSelectResetsInput: false,
      onBlurResetsInput: false,
      searchable: true,
      autoload: false,
      cache: false,
      filterOptions: (options) => options
    } : {};
    const SelectVersion = loadOptions ? AsyncSelect : Select2;
    return /* @__PURE__ */ jsx96(
      View_default,
      {
        flex,
        "data-no-track": rest["data-no-track"] ? true : void 0,
        children: /* @__PURE__ */ jsx96(
          SelectVersion,
          {
            meta,
            invalid: invalid2,
            arrowRenderer: () => isAsync ? null : arrow(invalid2, disabled2),
            disabled: disabled2,
            loadOptions: loadOptions ? this.handleOptionsLoad : void 0,
            isAsync,
            placeholder,
            variant,
            ...input,
            ...asyncDefaultProps,
            autoload,
            ...rest
          }
        )
      }
    );
  }
};
var I18nWrap = ({ placeholder, ...rest }) => {
  const { t: t2 } = useTranslation2();
  return /* @__PURE__ */ jsx96(Wrap4, { placeholder: placeholder || t2("Select from the list..."), ...rest });
};
var Select_default2 = I18nWrap;

// src/components/Form/AddressSelect/AddressListItem.js
import PropTypes12 from "prop-types";
import React33, { Component as Component5 } from "react";
import styled46 from "styled-components";
import { jsx as jsx97, jsxs as jsxs51 } from "react/jsx-runtime";
var AddressLine1 = styled46(Caption).attrs(({ isFocused }) => ({
  color: isFocused ? "white" : "ink.2"
}))``;
var AddressLine2 = styled46.div.attrs(({ isFocused }) => ({
  color: isFocused ? "white" : "colors.default.primary"
}))`
  text-transform: uppercase;
  font-size: 10px;
  margin-top: 5px;
`;
var Option = styled46.div.attrs(({ className }) => ({
  className: `Select-option${className}`,
  role: "option"
}))`
  :not(:last-of-type) {
    border-bottom: 1px solid #e2e2e2;
  }
`;
var ListItem = class extends Component5 {
  constructor(props) {
    super(props);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
  }
  handleMouseEnter(event) {
    const { option } = this.props;
    this.onFocus(option, event);
  }
  handleMouseMove(event) {
    const { isFocused, option } = this.props;
    if (isFocused)
      return;
    this.onFocus(option, event);
  }
  handleMouseDown(event) {
    const { onSelect, option, onBeforeSelect } = this.props;
    event.preventDefault();
    event.stopPropagation();
    if (onBeforeSelect) {
      return onBeforeSelect(option, event, onSelect);
    }
    onSelect(option, event);
  }
  handleTouchEnd(event) {
    if (this.dragging)
      return;
    this.handleMouseDown(event);
  }
  handleTouchMove() {
    this.dragging = true;
  }
  handleTouchStart() {
    this.dragging = false;
  }
  onFocus(event) {
    const { isFocused, onFocus, option } = this.props;
    if (!isFocused) {
      onFocus(option, event);
    }
  }
  render() {
    const {
      option,
      className,
      instancePrefix,
      optionIndex,
      isFocused,
      onBeforeSelect,
      ...rest
    } = this.props;
    const optionObject = option.value && JSON.parse(option.value);
    let addressLine1;
    let addressLine2;
    if (optionObject.Label) {
      const addressArray = optionObject.Label.split(", ");
      addressLine1 = addressArray.splice(0, addressArray.length - 3).join(", ");
      addressLine2 = addressArray.reverse().splice(0, 3).reverse().join(", ");
    } else {
      addressLine1 = optionObject.Text;
      addressLine2 = optionObject.Description;
    }
    return /* @__PURE__ */ jsxs51(
      Option,
      {
        className,
        onMouseDown: this.handleMouseDown,
        onMouseEnter: this.handleMouseEnter,
        onMouseMove: this.handleMouseMove,
        onTouchStart: this.handleTouchStart,
        onTouchMove: this.handleTouchMove,
        onTouchEnd: this.handleTouchEnd,
        id: `${instancePrefix}-option-${optionIndex}`,
        onClick: this.handleMouseDown,
        ...rest,
        children: [
          /* @__PURE__ */ jsx97(AddressLine1, { isFocused, children: addressLine1 }),
          /* @__PURE__ */ jsx97(AddressLine2, { isFocused, children: addressLine2 })
        ]
      }
    );
  }
};
ListItem.propTypes = {
  option: PropTypes12.object,
  className: PropTypes12.string,
  onSelect: PropTypes12.func.isRequired,
  onBeforeSelect: PropTypes12.func.isRequired,
  isFocused: PropTypes12.bool,
  optionIndex: PropTypes12.number,
  instancePrefix: PropTypes12.string,
  onFocus: PropTypes12.func
};
var AddressListItem_default = ListItem;

// src/components/Form/AddressSelect/pca.js
var ADDRESS_BASE_URL = "https://services.postcodeanywhere.co.uk/Capture/Interactive";
var getAddressSuggestions = async (pcaKey, addressString, countryCode = "gb") => {
  const endpoint = `${ADDRESS_BASE_URL}/Find/v1.00/json3.ws?Key=${pcaKey}&Text=${encodeURI(
    addressString
  )}&Countries=${countryCode}`;
  const res = await fetch(endpoint);
  const { Items } = await res.json();
  return Items;
};
var getAddressSuggestionOptions = async (pcaKey, addressContainer, countryCode = "gb") => {
  const endpoint = `${ADDRESS_BASE_URL}/Find/v1.00/json3.ws?Key=${pcaKey}&Container=${encodeURI(
    addressContainer
  )}&Countries=${countryCode}`;
  const res = await fetch(endpoint);
  const { Items } = await res.json();
  return Items;
};
var getAddressDetails = async (pcaKey, addressId, countryCode = "gb") => {
  const endpoint = `${ADDRESS_BASE_URL}/Retrieve/v1.00/json3.ws?Key=${pcaKey}&Id=${encodeURI(
    addressId
  )}&Countries=${countryCode}`;
  const res = await fetch(endpoint);
  const { Items } = await res.json();
  return Items[0];
};

// src/components/Form/AddressSelect/index.tsx
import { jsx as jsx98 } from "react/jsx-runtime";
var AddressSelect = class extends Component6 {
  constructor() {
    super();
    this.state = {
      options: [],
      isFetching: false,
      query: null
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleOptionSearch = this.handleOptionSearch.bind(this);
    this.handleAddressDetailLookup = this.handleAddressDetailLookup.bind(this);
    this.handleAddressListItemSelect = this.handleAddressListItemSelect.bind(this);
    this.OptionComponent = createOptionComponent(
      this.handleAddressListItemSelect
    );
  }
  componentDidMount() {
    const { input, initialOptions = [] } = this.props;
    const i = input.value ? JSON.parse(input.value) : {};
    i.Id && initialOptions.push({
      label: i.Label,
      value: input.value
    });
    this.setState({
      options: [...initialOptions]
    });
  }
  // This method gets called when the user first starts to type an address into the input filed
  handleSearch(input) {
    const { countryCode, pcaKey } = this.props;
    if (!input.trim()) {
      return this.setState({ isFetching: false, query: null });
    }
    this.setState({
      isFetching: true,
      query: input
    });
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      getAddressSuggestions(pcaKey, input.trim(), countryCode).then((data) => {
        const payload = {
          options: data.map((i) => ({
            value: JSON.stringify(i),
            label: i.Text + (i.Description ? ` - ${i.Description}` : "")
          })),
          isFetching: false
        };
        this.setState(payload);
      });
    }, 500);
  }
  // This method gets called if the selected address is part of a group address container
  handleOptionSearch(containerId) {
    const { countryCode, pcaKey } = this.props;
    this.setState({
      // Uncommented to fix dropdown closing when fetching addresses in for the group
      // options: [],
      isFetching: true
    });
    getAddressSuggestionOptions(pcaKey, containerId, countryCode).then(
      (data) => {
        const payload = {
          options: data.map((i) => ({
            value: JSON.stringify(i),
            label: i.Text + (i.Description ? ` - ${i.Description}` : "")
          })),
          isFetching: false
        };
        this.setState(payload);
      }
    );
  }
  // This method gets called when the final address is found to fetch all details of it
  handleAddressDetailLookup(id) {
    const { countryCode, pcaKey } = this.props;
    this.setState({
      isFetching: false
    });
    return getAddressDetails(pcaKey, id, countryCode).then((response) => {
      response.Label = response.Label.replace(/\r?\n|\r/g, ", ");
      const payload = {
        label: response.Label,
        value: JSON.stringify(response)
      };
      this.setState({
        isFetching: false,
        options: [payload]
      });
      return payload;
    });
  }
  // Custom handler when a list item gets clicked
  handleAddressListItemSelect(option, event, onSelect) {
    const { countryCode } = this.props;
    const optionObject = JSON.parse(option.value);
    if (!optionObject.Line1 && optionObject.Type !== "Address") {
      this.handleOptionSearch(optionObject.Id, countryCode);
    } else if (optionObject.Type === "Address") {
      this.handleAddressDetailLookup(optionObject.Id, countryCode).then(
        (option2) => onSelect(option2)
      );
    } else {
      onSelect(option);
    }
  }
  render() {
    const { options, isFetching, query } = this.state;
    const { t: t2 } = this.props;
    let noResultsText;
    if (!query) {
      noResultsText = t2("Type to search");
    } else if (isFetching) {
      noResultsText = t2("Loading...");
    } else {
      noResultsText = t2("No results found");
    }
    return /* @__PURE__ */ jsx98(
      Select_default2,
      {
        placeholder: t2("Enter address or postcode here..."),
        ...this.props,
        async: true,
        onSelectResetsInput: true,
        onInputChange: this.handleSearch,
        isLoading: isFetching,
        options,
        noResultsText: /* @__PURE__ */ jsx98(Text_default, { color: "ink.2", children: noResultsText }),
        onInputKeyDown: (e) => {
          if (e.keyCode === 9 || e.keyCode === 13 || e.keyCode === 38 || e.keyCode === 40) {
            e.stopPropagation();
            e.preventDefault();
          }
          if (e.keyCode === 8 || e.keyCode === 46) {
            this.setState({
              options: []
            });
          }
        },
        optionComponent: this.OptionComponent
      }
    );
  }
};
AddressSelect.propTypes = {
  input: PropTypes13.object,
  t: PropTypes13.func,
  initialOptions: PropTypes13.array,
  countryCode: PropTypes13.string
};
var createOptionComponent = (onBeforeSelect) => (
  // eslint-disable-next-line react/prefer-stateless-function
  class Option extends Component6 {
    render() {
      return /* @__PURE__ */ jsx98(AddressListItem_default, { onBeforeSelect, ...this.props });
    }
  }
);
var AddressSelect_default = (p) => {
  const { countryCode, pcaKey } = useScarfContext();
  const { t: t2 } = useTranslation3();
  return /* @__PURE__ */ jsx98(AddressSelect, { countryCode, pcaKey, t: t2, ...p });
};

// src/components/Form/Checkbox/index.tsx
import { Component as Component7 } from "react";
import PropTypes15 from "prop-types";
import styled48 from "styled-components";

// src/components/Form/Checkbox/Dot.js
import React35 from "react";
import PropTypes14 from "prop-types";
import styled47, { withTheme as withTheme2 } from "styled-components";
import { themeGet as themeGet12 } from "@styled-system/theme-get";
import { jsx as jsx99, jsxs as jsxs52 } from "react/jsx-runtime";
var Unselected = ({ fillColor = "#919EAB" }) => /* @__PURE__ */ jsxs52("svg", { width: "22", height: "22", viewBox: "0 0 22 22", children: [
  /* @__PURE__ */ jsxs52("defs", { children: [
    /* @__PURE__ */ jsx99("rect", { id: "a", width: "22", height: "22", rx: "11" }),
    /* @__PURE__ */ jsxs52(
      "filter",
      {
        id: "b",
        width: "109.1%",
        height: "109.1%",
        x: "-4.5%",
        y: "-4.5%",
        filterUnits: "objectBoundingBox",
        children: [
          /* @__PURE__ */ jsx99("feOffset", { dx: "-2", dy: "2", in: "SourceAlpha", result: "shadowOffsetInner1" }),
          /* @__PURE__ */ jsx99(
            "feComposite",
            {
              in: "shadowOffsetInner1",
              in2: "SourceAlpha",
              k2: "-1",
              k3: "1",
              operator: "arithmetic",
              result: "shadowInnerInner1"
            }
          ),
          /* @__PURE__ */ jsx99(
            "feColorMatrix",
            {
              in: "shadowInnerInner1",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            }
          )
        ]
      }
    )
  ] }),
  /* @__PURE__ */ jsxs52("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ jsx99("use", { fill: "#FFF", xlinkHref: "#a" }),
    /* @__PURE__ */ jsx99("use", { fill: "#000", filter: "url(#b)", xlinkHref: "#a" }),
    /* @__PURE__ */ jsx99("rect", { width: "21", height: "21", x: ".5", y: ".5", stroke: fillColor, rx: "10.5" })
  ] })
] });
Unselected.propTypes = {
  fillColor: PropTypes14.string
};
var Selected = ({ fillColor = "#2C9FA5" }) => /* @__PURE__ */ jsx99("svg", { width: "22", height: "22", viewBox: "0 0 22 22", children: /* @__PURE__ */ jsx99("g", { fill: fillColor, children: /* @__PURE__ */ jsx99("path", { d: "M11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 Z M14.8669595,7.42408153 L9.49717816,12.5790717 L7.56868463,10.8258957 C7.11916125,10.4172381 6.4234681,10.4503664 6.01481048,10.8998897 C5.60615286,11.3494131 5.63928111,12.0451063 6.08880449,12.4537639 L8.77769337,14.8982083 C9.20575491,15.2873552 9.86208984,15.2784358 10.2794185,14.8778003 L16.3905296,9.01113364 C16.8287819,8.59041139 16.8429929,7.89407491 16.4222706,7.45582257 C16.0015484,7.01757024 15.3052119,7.00335929 14.8669595,7.42408153 Z" }) }) });
Selected.propTypes = {
  fillColor: PropTypes14.string
};
var Dot = ({ selected: selected2, disabled: disabled2, error, ...rest }) => {
  const primary = themeGet12("colors.default.primary")(rest);
  const grey = themeGet12("colors.sky.0")(rest);
  const red2 = themeGet12("colors.default.red")(rest);
  const fillColor = disabled2 ? grey : error ? red2 : primary;
  return /* @__PURE__ */ jsx99(Flex_default, { ...rest, children: selected2 ? /* @__PURE__ */ jsx99(Selected, { fillColor }) : /* @__PURE__ */ jsx99(Unselected, { fillColor }) });
};
Dot.propTypes = {
  selected: PropTypes14.bool,
  error: PropTypes14.bool,
  disabled: PropTypes14.bool
};
var Dot_default = styled47(withTheme2(Dot))``;

// src/components/Form/Checkbox/index.tsx
import { jsx as jsx100, jsxs as jsxs53 } from "react/jsx-runtime";
var Container6 = styled48(Flex_default)`
  outline: none;
  cursor: ${(p) => p.disabled ? "not-allowed" : "pointer"};
`;
var Checkbox = class extends Component7 {
  constructor() {
    super(...arguments);
    this.state = {};
    this.handleChange = () => {
      const {
        input: { onChange },
        disabled: disabled2
      } = this.props;
      const { value } = this.state;
      !disabled2 && this.setState({ value: !value }, () => onChange(!value));
    };
    this.handleKeyDown = (event) => {
      event.keyCode === 13 && this.handleChange(event);
    };
  }
  componentDidMount() {
    const {
      input: { value }
    } = this.props;
    if (value) {
      this.setState({ value });
    }
  }
  componentDidUpdate(previousProps) {
    const {
      input: { value }
    } = this.props;
    if (value !== previousProps.input.value) {
      this.setState({
        value
      });
    }
  }
  render() {
    const {
      children: children2,
      render,
      disabled: disabled2,
      meta: { error, touched },
      ...rest
    } = this.props;
    const { value } = this.state;
    const selected2 = !!value;
    const renderProps = {
      onMouseDown: (event) => this.handleChange(event),
      onKeyDown: (event) => this.handleKeyDown(event),
      tabIndex: 0,
      selected: selected2,
      disabled: disabled2,
      children: children2
    };
    return render ? render(renderProps) : /* @__PURE__ */ jsxs53(
      Container6,
      {
        alignItems: "flex-start",
        justifyContent: "flex-start",
        ...renderProps,
        ...rest,
        children: [
          /* @__PURE__ */ jsx100(
            Dot_default,
            {
              selected: selected2,
              disabled: disabled2,
              error: !!error && touched,
              mr: 3
            }
          ),
          typeof children2 === "string" ? /* @__PURE__ */ jsx100(Text_default, { color: disabled2 ? "ink.2" : void 0, textAlign: "left", children: children2 }) : children2
        ]
      }
    );
  }
};
Checkbox.propTypes = {
  input: PropTypes15.shape({
    value: PropTypes15.oneOfType([
      PropTypes15.number,
      PropTypes15.string,
      PropTypes15.bool
    ]),
    onChange: PropTypes15.func
  }),
  meta: PropTypes15.shape({
    error: PropTypes15.string,
    touched: PropTypes15.bool
  }),
  render: PropTypes15.func,
  disabled: PropTypes15.bool,
  children: PropTypes15.oneOfType([PropTypes15.string, children])
};
Checkbox.defaultProps = {
  input: {
    onChange: () => {
    },
    value: false
  },
  meta: {}
};
var Checkbox_default = Checkbox;

// src/components/Form/CompanySelect.tsx
import { useTranslation as useTranslation4 } from "react-i18next";
import { jsx as jsx101 } from "react/jsx-runtime";
var API_BASE_URLS = {
  development: "development.api.tabeo.co.uk/v1",
  staging: "staging.api.tabeo.co.uk/v1",
  demo: "demo.api.tabeo.co.uk/v1",
  production: "api.tabeo.co.uk/v1"
};
var getCompanies = async (name, env = "production") => {
  if (!name || name.length < 3) {
    return [];
  }
  const res = await fetch(`https://${API_BASE_URLS[env]}/companies`, {
    body: JSON.stringify({
      name
    }),
    method: "post"
  });
  if (!res.ok) {
    throw {
      name: "NetworkError",
      message: `Request failed with status code: ${res.status}`,
      status: res.status,
      query: name
    };
  }
  const { data } = await res.json();
  if (!data || !data.length) {
    throw {
      name: "SearchError",
      message: `No company found for: ${name}`,
      status: 404,
      query: name
    };
  }
  const options = data.map((i) => ({
    ...i,
    label: i.title,
    value: i.companyNumber
  }));
  return { options };
};
var CompanySelect = ({ env, ...props }) => {
  const debounced = debounce_default(getCompanies, 200);
  const { t: t2 } = useTranslation4();
  return /* @__PURE__ */ jsx101(
    Select_default2,
    {
      ...props,
      loadOptions: (name) => debounced(name, env),
      placeholder: t2("Enter company name")
    }
  );
};
var CompanySelect_default = CompanySelect;

// src/components/Form/ConditionalFields.tsx
import { jsx as jsx102, jsxs as jsxs54 } from "react/jsx-runtime";
function ConditionalFields({ children: children2, ...rest }) {
  return /* @__PURE__ */ jsxs54(View_default, { display: "flex", alignItems: "stretch", mb: 5, ...rest, children: [
    /* @__PURE__ */ jsx102(View_default, { width: "4px", mr: 3, bg: "primary.5" }),
    /* @__PURE__ */ jsx102(View_default, { mb: "-20px", flex: "1", children: children2 })
  ] });
}
var ConditionalFields_default = ConditionalFields;

// src/components/Form/Currency.tsx
import PropTypes16 from "prop-types";
import { useEffect as useEffect14, useState as useState15 } from "react";
import CurrencyInput, { formatValue } from "react-currency-input-field";

// src/utils/polyfill-formatToParts.js
Intl.NumberFormat.prototype.formatToParts = Intl.NumberFormat.prototype.formatToParts || function formatToParts(number2) {
  const t2 = this.format(1234.56);
  const group = t2[1];
  const decimal = t2[5];
  const formatted = this.format(number2);
  return formatted.split("").reduce((acc, curr) => {
    if (curr === group) {
      return [...acc, { type: "group", value: curr }];
    }
    if (curr === decimal) {
      return [...acc, { type: "decimal", value: curr }];
    }
    const lastPart = acc[acc.length - 1];
    if (lastPart?.type === "decimal") {
      return [...acc, { type: "fraction", value: curr }];
    }
    if (["integer", "fraction"].includes(lastPart?.type)) {
      return [
        ...acc.slice(0, -1),
        { ...lastPart, value: lastPart.value + curr }
      ];
    }
    return [...acc, { type: "integer", value: curr }];
  }, []);
};

// src/components/Form/Currency.tsx
import { jsx as jsx103, jsxs as jsxs55 } from "react/jsx-runtime";
var labels = {
  gb: {
    symbol: "\xA3",
    ticker: "GBP",
    locale: "en-GB"
  },
  nl: {
    symbol: "\u20AC",
    ticker: "EUR",
    locale: "nl-NL"
  },
  it: {
    symbol: "\u20AC",
    ticker: "EUR",
    locale: "it-IT"
  },
  fr: {
    symbol: "\u20AC",
    ticker: "EUR",
    locale: "fr-FR"
  },
  es: {
    symbol: "\u20AC",
    ticker: "EUR",
    locale: "fr-FR"
  },
  de: {
    symbol: "\u20AC",
    ticker: "EUR",
    locale: "de-DE"
  }
};
function Currency(props) {
  const { countryCode } = useScarfContext();
  const locale = labels[countryCode]?.locale || "en-GB";
  const {
    meta,
    input,
    showTicker,
    allowDecimals = true,
    disabled: disabled2,
    type = "tel",
    inputMode,
    clearable,
    ...rest
  } = props;
  const { value, onChange, ...inputProps } = input;
  const [internalValue, setInternalValue] = useState15(
    value !== void 0 ? String(value / 100) : ""
  );
  const handleClear = () => {
    handleValueChange("");
  };
  const handleValueChange = (value2) => {
    setInternalValue(value2);
    if (value2) {
      const transformedValue = Math.round(Number(value2.replace(",", ".")) * 100);
      onChange?.(transformedValue);
    } else {
      onChange?.(value2);
    }
  };
  const formatOptions = {
    allowDecimals,
    decimalScale: allowDecimals ? 2 : 0,
    decimalsLimit: allowDecimals ? 2 : 0,
    disableAbbreviations: true,
    intlConfig: { locale }
  };
  useEffect14(() => {
    if (!value || !internalValue) {
      if (value || value === 0) {
        setInternalValue(
          formatValue({
            value: String(value / 100),
            ...formatOptions,
            disableGroupSeparators: true
          })
        );
      } else {
        setInternalValue("");
      }
    }
  }, [value, internalValue, formatOptions]);
  return (
    // @ts-ignore
    /* @__PURE__ */ jsxs55(Base3, { meta, ...rest, children: [
      /* @__PURE__ */ jsx103(Text_default, { color: "ink.1", fontWeight: "regular", mr: 3, children: labels[countryCode]?.symbol || "\xA3" }),
      /* @__PURE__ */ jsx103(
        HtmlInput,
        {
          as: CurrencyInput,
          value: internalValue,
          onValueChange: handleValueChange,
          placeholder: "0.00",
          type,
          inputMode,
          disabled: disabled2,
          ...formatOptions,
          ...inputProps
        }
      ),
      clearable && internalValue && /* @__PURE__ */ jsx103(
        Clear_default,
        {
          width: 20,
          height: 20,
          fill: "ink.3",
          onClick: handleClear,
          cursor: "pointer"
        }
      ),
      showTicker && /* @__PURE__ */ jsx103(Text_default, { color: "ink.1", fontWeight: "regular", ml: 3, children: labels[countryCode]?.ticker || "GBP" })
    ] })
  );
}
Currency.propTypes = {
  meta: PropTypes16.object,
  input: PropTypes16.object,
  disabled: PropTypes16.bool,
  showTicker: PropTypes16.bool,
  countryCode: PropTypes16.string,
  allowDecimals: PropTypes16.bool,
  type: PropTypes16.string,
  inputMode: PropTypes16.string,
  clearable: PropTypes16.bool
};
var Currency_default = Currency;

// src/components/Form/Date.tsx
import { themeGet as themeGet13 } from "@styled-system/theme-get";
import PropTypes17 from "prop-types";
import { Component as Component8 } from "react";
import styled49 from "styled-components";
import { jsx as jsx104, jsxs as jsxs56 } from "react/jsx-runtime";
var HtmlInput2 = styled49(HtmlInput).attrs(() => ({
  type: "tel"
}))`
  font-variant-numeric: tabular-nums;
  font-weight: ${themeGet13("fontWeights.regular")};
`;
var SmallInput = styled49(HtmlInput2)`
  width: 26px;
  flex-basis: auto;
`;
var MediumInput = styled49(HtmlInput2)`
  width: 28px;
  flex-basis: auto;
`;
var LargeInput = styled49(HtmlInput2)`
  width: 44px;
  flex-basis: auto;
`;
var isDateValid = (date) => {
  const d = new Date(date);
  if (Object.prototype.toString.call(d) === "[object Date]") {
    if (!Number.isNaN(Number(d.getTime()))) {
      return true;
    }
  }
};
var DateInput = class extends Component8 {
  constructor() {
    super(...arguments);
    this.state = {
      focus: false,
      dd: "",
      mm: "",
      yyyy: ""
    };
    // eslint-disable-next-line class-methods-use-this
    this.parseValueString = (value = "") => {
      if (!isDateValid(value)) {
        return {
          dd: "",
          mm: "",
          yyyy: ""
        };
      }
      const date = new Date(value);
      const day = parseInt(date.getUTCDate(), 10);
      const month = parseInt(date.getUTCMonth(), 10) + 1;
      return {
        dd: day < 10 ? `0${day}` : `${day}`,
        mm: month < 10 ? `0${month}` : `${month}`,
        yyyy: `${date.getUTCFullYear()}`
      };
    };
    this.handleChange = ({ currentTarget: { id, value } }) => {
      const {
        input: { onChange }
      } = this.props;
      let normalizedValue = value;
      if (id === "dd") {
        normalizedValue = this.normalizeDD(value);
      }
      if (id === "mm") {
        normalizedValue = this.normalizeMM(value);
      }
      if (id === "yyyy") {
        normalizedValue = this.normalizeYYYY(value);
      }
      this.setState(
        {
          [id]: normalizedValue
        },
        () => {
          const { dd, mm, yyyy } = this.state;
          if (Number(dd) > 0 && Number(mm) > 0 && Number(yyyy) > 999) {
            const date = new Date(Date.UTC(yyyy, mm - 1, dd)).toISOString();
            onChange && onChange(date);
          } else {
            onChange && onChange(null);
          }
        }
      );
    };
    this.normalizeDD = (value) => {
      let normalizedValue = value.replace(/[^0-9.]+/g, "");
      const possibleFirstChars = ["0", "1", "2", "3"];
      if (normalizedValue[0] && !possibleFirstChars.includes(normalizedValue[0])) {
        normalizedValue = `0${value}`;
      }
      if (normalizedValue[0] === "3" && normalizedValue[1] && !["0", "1"].includes(normalizedValue[1])) {
        normalizedValue = normalizedValue.slice(0, 1);
      }
      if (value.length > 2) {
        normalizedValue = normalizedValue.slice(0, 2);
      }
      if (normalizedValue === "00") {
        normalizedValue = "0";
      }
      if (normalizedValue.length === 2) {
        const { mm } = this.state;
        this.mm.focus();
        this.mm.setSelectionRange(mm.length, mm.length);
      }
      return normalizedValue;
    };
    this.normalizeMM = (value) => {
      let normalizedValue = value.replace(/[^0-9.]+/g, "");
      const possibleFirstChars = ["0", "1"];
      if (normalizedValue[0] && !possibleFirstChars.includes(normalizedValue[0])) {
        normalizedValue = `0${value}`;
      }
      if (normalizedValue[0] && normalizedValue[0] !== "0" && normalizedValue[1] && !["0", "1", "2"].includes(normalizedValue[1])) {
        normalizedValue = normalizedValue.slice(0, 1);
      }
      if (value.length > 2) {
        normalizedValue = normalizedValue.slice(0, 2);
      }
      if (normalizedValue === "00") {
        normalizedValue = "0";
      }
      if (normalizedValue.length === 2) {
        const { yyyy } = this.state;
        this.yyyy.focus();
        this.yyyy.setSelectionRange(yyyy.length, yyyy.length);
      }
      return normalizedValue;
    };
    // eslint-disable-next-line class-methods-use-this
    this.normalizeYYYY = (value) => {
      let normalizedValue = value.replace(/[^0-9.]+/g, "");
      if (normalizedValue[0] && !["1", "2"].includes(normalizedValue[0])) {
        normalizedValue = `19${normalizedValue[0]}`;
      }
      if (value.length > 4) {
        normalizedValue = normalizedValue.slice(0, 4);
      }
      return normalizedValue;
    };
    this.handleCursorMove = (event) => {
      const {
        target: { id, selectionEnd },
        key
      } = event;
      if (["Backspace", "ArrowLeft"].includes(key) && id === "yyyy" && selectionEnd === 0) {
        this.mm.focus();
        this.mm.setSelectionRange(2, 2);
      }
      if (["Backspace", "ArrowLeft"].includes(key) && id === "mm" && selectionEnd === 0) {
        this.dd.focus();
        this.dd.setSelectionRange(2, 2);
      }
      if (["ArrowRight"].includes(key) && id === "dd" && selectionEnd === 2) {
        this.mm.focus();
        this.mm.setSelectionRange(0, 0);
      }
      if (["ArrowRight"].includes(key) && id === "mm" && selectionEnd === 2) {
        this.yyyy.focus();
        this.yyyy.setSelectionRange(0, 0);
      }
    };
    this.setFocus = () => this.setState({
      focus: true
    });
    this.removeFocus = () => {
      const {
        input: { onBlur }
      } = this.props;
      const { dd, mm, yyyy } = this.state;
      this.setState({
        focus: false
      });
      if (dd && mm && yyyy) {
        const date = new Date(Date.UTC(yyyy, mm - 1, dd));
        onBlur && onBlur(date);
      }
    };
  }
  componentDidMount() {
    const {
      input: { value }
    } = this.props;
    const { dd, mm, yyyy } = this.parseValueString(value);
    this.setState({
      focus: false,
      dd,
      mm,
      yyyy
    });
  }
  componentDidUpdate() {
  }
  render() {
    const { disabled: disabled2, meta, inputProps = {}, ...rest } = this.props;
    const { focus: focus2, dd, mm, yyyy } = this.state;
    return /* @__PURE__ */ jsxs56(
      Base3,
      {
        justifyContent: "flex-start",
        width: "155px",
        minWidth: "auto",
        pr: "7px",
        disabled: disabled2,
        ...rest,
        meta: {
          ...meta,
          focus: focus2
        },
        children: [
          /* @__PURE__ */ jsx104(
            SmallInput,
            {
              id: "dd",
              ref: (dd2) => {
                this.dd = dd2;
              },
              onChange: this.handleChange,
              onFocus: this.setFocus,
              onBlur: this.removeFocus,
              value: dd,
              onKeyDown: this.handleCursorMove,
              disabled: disabled2,
              placeholder: "DD",
              ...inputProps?.dd
            }
          ),
          /* @__PURE__ */ jsx104(Text_default, { px: "6px", color: "sky.0", children: "/" }),
          /* @__PURE__ */ jsx104(
            MediumInput,
            {
              id: "mm",
              ref: (mm2) => {
                this.mm = mm2;
              },
              onChange: this.handleChange,
              onFocus: this.setFocus,
              onBlur: this.removeFocus,
              onKeyDown: this.handleCursorMove,
              disabled: disabled2,
              value: mm,
              placeholder: "MM",
              ...inputProps?.mm
            }
          ),
          /* @__PURE__ */ jsx104(Text_default, { px: "6px", color: "sky.0", children: "/" }),
          /* @__PURE__ */ jsx104(
            LargeInput,
            {
              id: "yyyy",
              ref: (yyyy2) => {
                this.yyyy = yyyy2;
              },
              onChange: this.handleChange,
              onFocus: this.setFocus,
              onBlur: this.removeFocus,
              onKeyDown: this.handleCursorMove,
              disabled: disabled2,
              value: yyyy,
              placeholder: "YYYY",
              ...inputProps?.yyyy
            }
          )
        ]
      }
    );
  }
};
DateInput.propTypes = {
  input: PropTypes17.object,
  meta: PropTypes17.object,
  disabled: PropTypes17.bool,
  inputProps: PropTypes17.object
};
DateInput.defaultProps = {
  input: {},
  meta: {}
};
var Date_default2 = DateInput;

// src/components/Form/DatePicker.tsx
import { themeGet as themeGet14 } from "@styled-system/theme-get";
import PropTypes18 from "prop-types";
import { Component as Component9 } from "react";
import DayPickerInput from "react-day-picker-v7/DayPickerInput";
import MomentLocaleUtils, {
  formatDate as formatDateMoment,
  parseDate
} from "react-day-picker-v7/moment";
import { useTranslation as useTranslation5 } from "react-i18next";
import styled50 from "styled-components";
import { jsx as jsx105, jsxs as jsxs57 } from "react/jsx-runtime";
var Picker = styled50(Base3).attrs((p) => ({
  py: "6px",
  width: p.width ?? ["100%", p.clearable ? "fit-content" : "160px"]
}))`
  min-width: auto;
  outline: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  .DayPickerInput {
    flex: 1 0 auto;
    display: block;
    width: auto;
    input {
      font-family: ${themeGet14("font", "Arial")};
      font-size: 16px;
      line-height: 1.5;
      background: none;
      border: none;
      width: 100%;
      min-width: auto;
      outline: none;
      font-weight: ${themeGet14("fontWeights.regular")};
      &::placeholder {
        color: ${themeGet14("colors.ink.2")};
      }
      &:disabled {
        cursor: not-allowed;
        color: ${themeGet14("colors.ink.2")};
      }
      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active {
        transition: background-color 5000s ease-in-out 0s;
      }
      &:-webkit-contacts-auto-fill-button {
        visibility: hidden;
        display: none !important;
        pointer-events: none;
        position: absolute;
        right: 0;
      }
    }

    .DayPickerInput-OverlayWrapper {
      font-family: ${themeGet14("font", "Arial")};
      font-size: 16px;
      line-height: 1.5;
      ${(p) => p.alignPopupToTop ? "top: -330px;" : ""} .DayPickerInput-Overlay {
        border-radius: 4px;

        @media (max-width: ${themeGet14("breakpoints.0")}) {
          left: 50%;
          transform: translate(-50%, 0);
        }

        .DayPicker-Day--today:not(.DayPicker-Day--disabled):not(
            .DayPicker-Day--selected
          ) {
          color: ${themeGet14("colors.primary.3")};
        }

        .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(
            .DayPicker-Day--outside
          ) {
          background-color: ${themeGet14("colors.primary.3")};
          border-radius: 0;
        }

        .DayPicker:not(.DayPicker--interactionDisabled)
          .DayPicker-Day:not(.DayPicker-Day--disabled):not(
            .DayPicker-Day--selected
          ):not(.DayPicker-Day--outside):hover {
          background-color: ${themeGet14("colors.primary.6")};
          border-radius: 0;
        }
      }
    }
  }
`;
function formatDate2(value, format) {
  if (!value) {
    return "";
  }
  return formatDateMoment(value, format);
}
var DatePicker = class extends Component9 {
  constructor() {
    super(...arguments);
    // https://github.com/gpbl/react-day-picker/issues/600
    this.monthChanged = false;
    this.state = {
      focus: false,
      value: ""
    };
    this.handleChange = (value) => {
      const {
        input: { onChange }
      } = this.props;
      this.setState(
        {
          value
        },
        () => {
          const date = new Date(value);
          const day = parseInt(date.getUTCDate(), 10);
          const month = parseInt(date.getUTCMonth(), 10);
          const year = `${date.getUTCFullYear()}`;
          const stringifiedValue = new Date(
            Date.UTC(year, month, day)
          ).toISOString();
          onChange && onChange(stringifiedValue);
        }
      );
      return value;
    };
    this.handleFocus = () => {
      const { disabled: disabled2 } = this.props;
      if (!disabled2) {
        this.picker.input.focus();
        this.setState({
          focus: true
        });
      }
    };
    this.handleBlur = () => {
      const {
        input: { onBlur }
      } = this.props;
      this.setState({
        focus: false
      });
      setTimeout(() => {
        const { value } = this.state;
        if (!this.monthChanged || value) {
          onBlur && onBlur();
        }
      }, 200);
    };
    this.setMonthChangedFlag = () => {
      this.monthChanged = true;
    };
    this.handleClear = () => {
      this.setState({
        value: ""
      });
    };
  }
  componentDidMount() {
    const {
      input: { value },
      format
    } = this.props;
    this.setState({
      value: formatDate2(value, format)
    });
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps({ input: { value: nextValue } }) {
    const {
      input: { value },
      format
    } = this.props;
    if (value !== nextValue) {
      this.setState({
        value: formatDate2(nextValue, format)
      });
    }
  }
  render() {
    const {
      t: t2,
      meta,
      input,
      datePickerProps,
      disabled: disabled2,
      placeholder = t2("DD / MM / YYYY"),
      alignPopupToTop,
      locale,
      format,
      clearable,
      ...rest
    } = this.props;
    const { focus: focus2, value } = this.state;
    return /* @__PURE__ */ jsxs57(
      Picker,
      {
        ...rest,
        meta: {
          ...meta,
          focus: focus2
        },
        disabled: disabled2,
        tabIndex: "-1",
        onFocus: this.handleFocus,
        alignPopupToTop,
        clearable,
        children: [
          disabled2 ? /* @__PURE__ */ jsx105(HtmlInput, { disabled: true, placeholder }) : /* @__PURE__ */ jsx105(
            DayPickerInput,
            {
              ref: (picker) => {
                this.picker = picker;
              },
              formatDate: formatDate2,
              parseDate,
              placeholder,
              onDayChange: this.handleChange,
              keepFocus: true,
              onChange: (e) => e.preventDefault(),
              value,
              dayPickerProps: {
                onMonthChange: this.setMonthChangedFlag,
                locale,
                localeUtils: MomentLocaleUtils,
                ...datePickerProps
              },
              format,
              inputProps: {
                onBlur: this.handleBlur,
                onKeyDown: (e) => e.preventDefault()
              }
            }
          ),
          clearable && value && /* @__PURE__ */ jsx105(
            Clear_default,
            {
              width: 20,
              height: 20,
              fill: "ink.3",
              onClick: disabled2 ? null : this.handleClear,
              cursor: disabled2 ? "not-allowed" : "pointer"
            }
          )
        ]
      }
    );
  }
};
DatePicker.propTypes = {
  disabled: PropTypes18.bool,
  placeholder: PropTypes18.string,
  input: PropTypes18.object,
  meta: PropTypes18.object,
  datePickerProps: PropTypes18.object,
  alignPopupToTop: PropTypes18.bool,
  locale: PropTypes18.string,
  t: PropTypes18.func.isRequired,
  format: PropTypes18.string
};
DatePicker.defaultProps = {
  input: {},
  meta: {},
  format: "DD / MM / YYYY"
};
var DatePicker_default = (props) => {
  const locale = useLocale();
  const { t: t2 } = useTranslation5();
  return /* @__PURE__ */ jsx105(DatePicker, { ...props, locale, t: t2 });
};

// src/components/Form/DateTime.tsx
import PropTypes20 from "prop-types";
import { Component as Component11 } from "react";

// src/components/Form/Time.tsx
import PropTypes19 from "prop-types";
import { Component as Component10 } from "react";
import styled51 from "styled-components";
import { jsx as jsx106, jsxs as jsxs58 } from "react/jsx-runtime";
var HtmlInput3 = styled51(HtmlInput).attrs(() => ({
  type: "tel"
}))``;
var MediumInput2 = styled51(HtmlInput3)`
  width: 22px;
  flex-basis: auto;
  font-variant-numeric: tabular-nums;
`;
var TimeInput = class extends Component10 {
  constructor(props) {
    super(props);
    this.handleChange = ({ currentTarget: { id, value } }) => {
      const {
        input: { onChange }
      } = this.props;
      let normalizedValue = value;
      if (id === "hhLocal") {
        normalizedValue = this.normalizeHH(value);
      }
      if (id === "mm") {
        normalizedValue = this.normalizeMM(value);
      }
      this.setState(
        ({ hh }) => ({
          [id]: normalizedValue,
          hh: id === "hhLocal" ? this.getUTCHour(value) : `${hh}`
        }),
        () => {
          const { hh, mm } = this.state;
          if (hh && mm) {
            onChange && onChange({ hh, mm });
          }
        }
      );
    };
    this.handleBlur = ({ currentTarget: { id, value } }) => {
      if (id === "hhLocal") {
        this.setState({ hhLocal: this.prefix(value) });
      }
      if (id === "mm") {
        this.setState({ mm: this.prefix(value) });
      }
      this.removeFocus();
    };
    // eslint-disable-next-line class-methods-use-this
    this.prefix = (value) => value !== "" ? `00${value}`.slice(-2) : value;
    // eslint-disable-next-line class-methods-use-this
    this.getUTCHour = (localHour) => {
      const date = /* @__PURE__ */ new Date();
      date.setHours(localHour);
      return `${date.getUTCHours()}`;
    };
    // eslint-disable-next-line class-methods-use-this
    this.getLocalHour = (utcHour) => {
      const date = /* @__PURE__ */ new Date();
      date.setUTCHours(utcHour);
      return `${date.getHours()}`;
    };
    this.normalizeHH = (value) => {
      let normalizedValue = value.replace(/[^0-9.]+/g, "");
      const possibleFirstChars = ["0", "1", "2"];
      if (normalizedValue[0] && !possibleFirstChars.includes(normalizedValue[0])) {
        normalizedValue = `0${value}`;
      }
      if (value.length > 2) {
        normalizedValue = normalizedValue.slice(0, 2);
      }
      if (normalizedValue.length === 2 && this.mm) {
        this.mm.focus();
        const { mm } = this.state;
        this.mm.setSelectionRange(mm.length, mm.length);
      }
      return normalizedValue;
    };
    this.normalizeMM = (value) => {
      let normalizedValue = value.replace(/[^0-9.]+/g, "");
      const isMidnight = this.hh && this.hh.value === "24";
      const possibleFirstChars = isMidnight ? ["0"] : ["0", "1", "2", "3", "4", "5"];
      if (normalizedValue[0] && !possibleFirstChars.includes(normalizedValue[0])) {
        normalizedValue = `0${isMidnight ? "0" : value}`;
      }
      if (value.length > 2) {
        normalizedValue = normalizedValue.slice(0, 2);
      }
      return normalizedValue;
    };
    this.handleCursorMove = (event) => {
      const {
        target: { id, selectionEnd },
        key
      } = event;
      if (["Backspace", "ArrowLeft"].includes(key) && id === "mm" && selectionEnd === 0) {
        this.hh.focus();
        this.hh.setSelectionRange(2, 2);
      }
      if (["ArrowRight"].includes(key) && id === "hhLocal" && selectionEnd === 2) {
        this.mm.focus();
        this.mm.setSelectionRange(0, 0);
      }
    };
    this.setFocus = () => this.setState({
      focus: true
    });
    this.removeFocus = () => {
      const {
        input: { onBlur }
      } = this.props;
      const { hh, mm } = this.state;
      if (hh && mm) {
        this.setState({
          focus: false
        });
        if (hh && mm) {
          onBlur && onBlur({ mm, hh });
        }
      }
    };
    const {
      input: { value: { hh, mm } = { hh: "", mm: "" } }
    } = props;
    this.state = {
      focus: false,
      hh: `${hh}`,
      hhLocal: hh !== "" ? this.prefix(this.getLocalHour(hh)) : `${hh}`,
      mm: mm !== "" ? this.prefix(mm) : `${mm}`
    };
  }
  render() {
    const { disabled: disabled2, meta } = this.props;
    const { focus: focus2, hhLocal, mm } = this.state;
    return /* @__PURE__ */ jsxs58(
      Base3,
      {
        justifyContent: "flex-start",
        display: "inline-flex",
        minWidth: "auto",
        ...this.props,
        meta: {
          ...meta,
          focus: focus2
        },
        children: [
          /* @__PURE__ */ jsx106(
            MediumInput2,
            {
              id: "hhLocal",
              ref: (hh) => {
                this.hh = hh;
              },
              onChange: this.handleChange,
              onFocus: this.setFocus,
              onBlur: this.handleBlur,
              value: hhLocal,
              onKeyDown: this.handleCursorMove,
              disabled: disabled2,
              placeholder: "00"
            }
          ),
          /* @__PURE__ */ jsx106(Text_default, { px: "2px", color: "ink.2", children: ":" }),
          /* @__PURE__ */ jsx106(
            MediumInput2,
            {
              id: "mm",
              ref: (mm2) => {
                this.mm = mm2;
              },
              onChange: this.handleChange,
              onFocus: this.setFocus,
              onBlur: this.handleBlur,
              onKeyDown: this.handleCursorMove,
              disabled: disabled2,
              value: mm,
              placeholder: "00"
            }
          )
        ]
      }
    );
  }
};
TimeInput.propTypes = {
  input: PropTypes19.object,
  meta: PropTypes19.object,
  disabled: PropTypes19.bool
};
TimeInput.defaultProps = {
  input: {},
  meta: {}
};
var Time_default = TimeInput;

// src/components/Form/DateTime.tsx
import { jsx as jsx107, jsxs as jsxs59 } from "react/jsx-runtime";
var dateComponents = {
  dateinput: Date_default2,
  datepicker: DatePicker_default
};
var DateTime = class extends Component11 {
  constructor(props) {
    super(props);
    this.state = {
      date: null,
      time: {
        hh: "",
        mm: ""
      }
    };
    this.handleDateChange = (value) => {
      const { time } = this.state;
      const date = /* @__PURE__ */ new Date();
      date.setHours(0);
      date.setMinutes(0);
      const hh = date.getUTCHours();
      const mm = date.getUTCMinutes();
      this.setState(
        { date: value, time: time.mm ? time : { hh, mm } },
        () => this.handleOnChange()
      );
    };
    this.handleTimeChange = (value) => {
      this.setState({ time: value }, () => this.handleOnChange());
    };
    this.handleOnChange = () => {
      const { input } = this.props;
      const {
        date: dateStr,
        time: { hh, mm }
      } = this.state;
      if (dateStr) {
        const date = new Date(dateStr);
        const time = /* @__PURE__ */ new Date();
        time.setUTCHours(hh, mm);
        const day = date.getDate();
        const month = date.getMonth();
        const year = date.getFullYear();
        const hour = time.getHours();
        const minute = time.getMinutes();
        const output = new Date(year, month, day, hour, minute).toISOString();
        input.onChange(output);
      }
    };
    const {
      input: { value }
    } = props;
    if (value) {
      const date = new Date(value);
      this.state = {
        time: {
          hh: date.getUTCHours(),
          mm: date.getUTCMinutes()
        },
        date: date.toISOString()
      };
    }
  }
  render() {
    const { type, alignPopupToTop, meta, variant, ...rest } = this.props;
    const { date, time } = this.state;
    const DateComponent = dateComponents[type] || DatePicker_default;
    return /* @__PURE__ */ jsxs59(Flex_default, { display: "inline-flex", ...rest, children: [
      /* @__PURE__ */ jsx107(
        DateComponent,
        {
          input: {
            onChange: this.handleDateChange,
            value: date || void 0
          },
          meta,
          mr: 5,
          alignPopupToTop,
          width: "152px",
          variant
        }
      ),
      /* @__PURE__ */ jsx107(
        Time_default,
        {
          input: { onChange: this.handleTimeChange, value: time },
          meta,
          variant
        },
        date
      )
    ] });
  }
};
DateTime.propTypes = {
  input: PropTypes20.object,
  meta: PropTypes20.object,
  type: PropTypes20.string,
  alignPopupToTop: PropTypes20.bool
};
DateTime.defaultProps = {
  input: {
    onChange: () => {
    }
  },
  type: "datepicker"
};
var DateTime_default = DateTime;

// src/components/Form/DayPicker.tsx
import { themeGet as themeGet15 } from "@styled-system/theme-get";
import { useRef as useRef7, useState as useState16 } from "react";
import ReactDayPicker from "react-day-picker-v7";
import MomentLocaleUtils2 from "react-day-picker-v7/moment";
import styled52 from "styled-components";
import { Fragment as Fragment4, jsx as jsx108, jsxs as jsxs60 } from "react/jsx-runtime";
var PickerWrapper = styled52(View_default)`
  :focus {
    outline: none;
  }

  .DayPicker {
    color: ${themeGet15("colors.default.ink")};
    font-family: ${themeGet15("font", "Arial")};
    font-size: 16px;
    line-height: 1.5;

    :focus {
      outline: none;
    }

    ${(p) => p.alignPopupToTop ? "top: -330px;" : ""}

    .DayPicker-wrapper {
      border-radius: 4px;

      :focus {
        outline: none;
      }

      @media (max-width: ${themeGet15("breakpoints.0")}) {
        left: 50%;
        transform: translate(-50%, 0);
      }

      .DayPicker-Day--today:not(.DayPicker-Day--disabled):not(
          .DayPicker-Day--selected
        ) {
        color: ${themeGet15("colors.primary.3")};
      }

      .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(
          .DayPicker-Day--outside
        ) {
        background-color: ${themeGet15("colors.primary.3")};
        border-radius: 0;
      }

      .DayPicker-Day:not(.DayPicker-Day--disabled):not(
          .DayPicker-Day--selected
        ):not(.DayPicker-Day--outside):hover {
        background-color: ${themeGet15("colors.primary.6")};
        border-radius: 0;
      }
    }
  }
`;
var Container7 = styled52(View_default)`
  :focus {
    outline: none;
  }
`;
Container7.defaultProps = {
  bg: "white",
  boxShadow: 1,
  borderRadius: 1,
  border: [0, 1]
};
function DayPicker({
  onBlur,
  onFocus,
  onChange,
  value,
  placement = "bottom-start",
  children: children2,
  modifiers,
  ...rest
}) {
  const [open, setOpen] = useState16();
  const ref = useRef7();
  const parsedValue = value ? new Date(value) : null;
  const locale = useLocale();
  return /* @__PURE__ */ jsxs60(Fragment4, { children: [
    /* @__PURE__ */ jsx108(
      Popover_default,
      {
        open,
        onClickOut: () => setOpen(false),
        placement,
        referenceElement: ref,
        offset: [0, 4],
        children: ({ ref: ref2, style: style6, placement: placement2 }) => /* @__PURE__ */ jsx108(
          Container7,
          {
            ref: ref2,
            style: style6,
            "data-placement": placement2,
            tabIndex: "0",
            onBlur,
            onFocus,
            children: /* @__PURE__ */ jsx108(PickerWrapper, { children: /* @__PURE__ */ jsx108(
              ReactDayPicker,
              {
                onDayClick: (e) => {
                  const date = e;
                  date.setHours(0, 0, 0, 0);
                  onChange(date.toISOString());
                  onBlur && onBlur();
                  setOpen(false);
                },
                selectedDays: parsedValue || void 0,
                month: parsedValue || void 0,
                locale,
                localeUtils: MomentLocaleUtils2,
                firstDayOfWeek: 1,
                modifiers
              }
            ) })
          }
        )
      }
    ),
    children2?.({
      open,
      setOpen,
      ref,
      props: rest
    })
  ] });
}
var DayPicker_default = DayPicker;

// src/components/Form/Field.tsx
import { themeGet as themeGet16 } from "@styled-system/theme-get";
import React42 from "react";
import styled53 from "styled-components";
import { jsx as jsx109, jsxs as jsxs61 } from "react/jsx-runtime";
var FieldContainer = styled53(View_default)`
  &:last-of-type + button {
    margin-top: 4px;
  }
`;
var ErrorMessage = styled53(Text_default)``;
ErrorMessage.defaultProps = {
  lineHeight: 2,
  color: "red.2"
};
var AlertIcon = styled53(Alert_default).attrs((props) => ({
  color: themeGet16("colors.default.red")(props),
  width: 22,
  height: 22
}))`
  display: inline-block;
  vertical-align: bottom;
  margin-right: 4px;
`;
var Field = React42.forwardRef(
  ({
    label,
    subLabel,
    description,
    component: Component17,
    meta = {},
    containerProps = {},
    errorProps = {},
    actions,
    ...rest
  }, ref) => /* @__PURE__ */ jsxs61(FieldContainer, { mb: 5, ...containerProps, "data-testid": "field", children: [
    label && /* @__PURE__ */ jsx109(Prompt, { mb: 1, fontWeight: "semibold", children: label }),
    subLabel && /* @__PURE__ */ jsx109(Caption, { mb: 2, children: subLabel }),
    /* @__PURE__ */ jsx109(Component17, { ref, meta, ...rest }),
    (meta.error && meta.touched || meta.submitError && !meta.dirtySinceLastSubmit) && /* @__PURE__ */ jsxs61(
      Flex_default,
      {
        justifyContent: "flex-start",
        alignItems: "flex-start",
        mt: 1,
        ...errorProps,
        children: [
          /* @__PURE__ */ jsx109(AlertIcon, { fill: "default.red" }),
          /* @__PURE__ */ jsx109(ErrorMessage, { children: meta.error || meta.submitError })
        ]
      }
    ),
    actions && !rest?.input?.value && /* @__PURE__ */ jsx109(Flex_default, { justifyContent: "flex-start", mt: 2, children: actions({ meta, disabled: rest?.disabled }) }),
    description && /* @__PURE__ */ jsx109(Caption, { mt: 2, children: description })
  ] })
);
var Field_default = Field;

// src/components/Form/FieldGroup.tsx
import { Children as Children2, cloneElement as cloneElement2, isValidElement as isValidElement2 } from "react";
import { jsx as jsx110 } from "react/jsx-runtime";
var FieldGroup = ({ children: children2, spacing = 5, ...rest }) => {
  const validChildrenArray = Children2.toArray(children2).filter(isValidElement2);
  return /* @__PURE__ */ jsx110(
    Flex_default,
    {
      justifyContent: ["stretch", "flex-start"],
      alignItems: ["stretch", "center"],
      flexDirection: ["column", "row"],
      mb: 5,
      ...rest,
      children: validChildrenArray.map((child, index) => {
        const isLastChild = validChildrenArray.length === index + 1;
        const props = {
          maxWidth: "100%",
          containerProps: {
            mr: isLastChild ? null : [0, spacing],
            mb: isLastChild ? null : [spacing, 0],
            flex: 1
          }
        };
        return cloneElement2(child, props);
      })
    }
  );
};
var FieldGroup_default = FieldGroup;

// src/components/Form/FileInput.tsx
import get4 from "lodash.get";
import PropTypes21 from "prop-types";
import React44 from "react";
import { withTranslation } from "react-i18next";
import styled54 from "styled-components";
import { jsx as jsx111, jsxs as jsxs62 } from "react/jsx-runtime";
var HtmlFileInput = styled54(View_default)`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  & + label {
    display: inline-block;
  }
`;
HtmlFileInput.defaultProps = { as: "input", type: "file" };
var Name = styled54(Text_default)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
Name.defaultProps = {
  fontSize: ["16px", "14px"],
  color: "default.primary",
  flex: "1 1 auto",
  fontWeight: "regular",
  pl: 3
};
var Wrap5 = styled54(Flex_default)`
  overflow: hidden;
  background-image: linear-gradient(to bottom, #f9fafb, #f4f6f8);
`;
var FilePreview = ({ name, onRemove, loading, uploaded, file, ...rest }) => {
  const previewLink = URL.createObjectURL(file);
  const previewLinkProps = previewLink ? {
    as: "a",
    href: previewLink,
    target: "_blank",
    cursor: "pointer",
    _hover: {
      textDecoration: "underline"
    }
  } : {};
  return /* @__PURE__ */ jsxs62(
    Wrap5,
    {
      display: "inline-flex",
      border: 1,
      borderColor: "#c4cdd5",
      borderRadius: 1,
      boxShadow: 2,
      height: ["53px", "42px"],
      maxWidth: ["auto", "225px"],
      width: ["100%", "auto"],
      ...rest,
      children: [
        /* @__PURE__ */ jsx111(View_default, { borderRight: 1, bg: "white", flex: "0 0 auto", p: 2, children: /* @__PURE__ */ jsx111(
          View_default,
          {
            as: "svg",
            width: ["42px", "31px"],
            height: ["30px", "22px"],
            viewBox: "0 0 31 22",
            children: /* @__PURE__ */ jsx111(
              "path",
              {
                fill: "#C4CDD5",
                fillRule: "nonzero",
                d: "M2.054 1.119a.933.933 0 0 0-.934.932v17.898c0 .515.419.932.934.932h26.892a.933.933 0 0 0 .934-.932V2.051a.933.933 0 0 0-.934-.932H2.054zm0-1.119h26.892C30.08 0 31 .918 31 2.05v17.9c0 1.132-.92 2.05-2.054 2.05H2.054A2.053 2.053 0 0 1 0 19.95V2.05C0 .919.92 0 2.054 0zm15.8 14.316l4.075-2.745a1.309 1.309 0 0 1 1.46-.001l7.363 4.94-.625.93-7.363-4.942a.187.187 0 0 0-.209 0l-4.723 3.182-6.896-4.963a.187.187 0 0 0-.206-.007L.853 16.767l-.586-.953 9.876-6.057a1.309 1.309 0 0 1 1.449.053l6.261 4.506zm.634-4.994a2.799 2.799 0 0 1-2.801-2.797 2.799 2.799 0 0 1 2.801-2.796 2.799 2.799 0 0 1 2.801 2.796 2.799 2.799 0 0 1-2.801 2.797zm0-1.119a1.68 1.68 0 0 0 1.68-1.678 1.68 1.68 0 0 0-1.68-1.678 1.68 1.68 0 0 0-1.68 1.678 1.68 1.68 0 0 0 1.68 1.678z"
              }
            )
          }
        ) }),
        /* @__PURE__ */ jsx111(Name, { ...previewLinkProps, children: name }),
        uploaded ? /* @__PURE__ */ jsx111(Tick_default, { fill: "primary.3", width: "22px", height: "22px", mx: 2, light: true }) : loading ? /* @__PURE__ */ jsx111(Spinner_default, { fill: "primary.3", width: "22px", height: "22px", mx: 2, spinning: true }) : onRemove ? /* @__PURE__ */ jsx111(
          View_default,
          {
            flex: "0 0 auto",
            onClick: (e) => {
              e.stopPropagation();
              onRemove(e);
            },
            height: "22px",
            cursor: "pointer",
            children: /* @__PURE__ */ jsx111(X_default, { fill: "ink.2", width: "22px", height: "22px", mx: 2 })
          }
        ) : null
      ]
    }
  );
};
FilePreview.propTypes = {
  name: PropTypes21.string.isRequired,
  onRemove: PropTypes21.func.isRequired,
  loading: PropTypes21.bool,
  uploaded: PropTypes21.bool,
  file: PropTypes21.object
};
var FileInput = class extends React44.Component {
  constructor() {
    super();
    this.state = {
      file: null
    };
    this.handleFileSelect = (event) => {
      const file = get4(event, "target.files.0", null);
      if (file) {
        this.handleStateChange({
          file
        });
      }
    };
    this.handleClearFile = () => {
      this.handleStateChange({
        file: null
      });
    };
    this.handleStateChange = (newState) => {
      const { input } = this.props;
      this.setState(newState, () => {
        const { onChange } = input || {};
        const { file } = this.state;
        if (onChange) {
          onChange(file);
        }
      });
    };
    this.id = `${(/* @__PURE__ */ new Date()).getTime() + Math.floor(Math.random() * 100)}`;
  }
  componentDidMount() {
    const {
      input: { value }
    } = this.props;
    if (value) {
      this.setState({
        file: value
      });
    }
  }
  render() {
    const {
      accept = ".png, .jpg, .jpeg",
      buttonLabel,
      input,
      uploaded,
      variant = "secondary",
      t: t2,
      ...rest
    } = this.props;
    const { file } = this.state;
    return file ? /* @__PURE__ */ jsx111(
      FilePreview,
      {
        name: file.name,
        file,
        onRemove: this.handleClearFile,
        uploaded,
        ...rest
      }
    ) : /* @__PURE__ */ jsxs62(View_default, { display: "inline-block", width: ["100%", "auto"], ...rest, children: [
      /* @__PURE__ */ jsx111(
        HtmlFileInput,
        {
          id: `file-${this.id}`,
          accept,
          onChange: this.handleFileSelect
        }
      ),
      /* @__PURE__ */ jsx111(
        Button_default,
        {
          as: "label",
          htmlFor: `file-${this.id}`,
          variant,
          width: "100%",
          children: buttonLabel || t2("Choose file")
        }
      )
    ] });
  }
};
FileInput.propTypes = {
  accept: PropTypes21.string,
  name: PropTypes21.string,
  variant: PropTypes21.string,
  buttonLabel: PropTypes21.string,
  input: PropTypes21.shape({
    onChange: PropTypes21.func,
    value: PropTypes21.any
  }),
  uploaded: PropTypes21.bool,
  t: PropTypes21.func
};
var FileInput_default = withTranslation()(
  FileInput
);

// src/components/Form/NativeSelect.tsx
import PropTypes22 from "prop-types";
import { useTranslation as useTranslation6 } from "react-i18next";
import styled55 from "styled-components";
import { Fragment as Fragment5, jsx as jsx112, jsxs as jsxs63 } from "react/jsx-runtime";
var Select3 = styled55(Text_default)`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
`;
Select3.defaultProps = {
  as: "select",
  backgroundColor: "sky.2",
  borderStyle: "solid",
  borderWidth: "1px",
  width: "100%",
  height: "38px",
  pl: 3,
  pr: "36px",
  cursor: "pointer",
  fontSize: "16px",
  borderRadius: "3px"
};
function NativeSelect({
  input,
  meta,
  options,
  placeholder: placeholderProp,
  width = ["100%"],
  maxWidth = ["100%", "350px"],
  autoBlur = false,
  children: children2,
  variant = "outline-v2",
  disabled: disabled2 = false,
  ...rest
}) {
  const { t: t2 } = useTranslation6();
  const placeholder = placeholderProp || t2("Select from the list...");
  const selectedIndex = options?.findIndex((o) => o.value === input?.value);
  const outlineV2Props = variant === "outline-v2" ? {
    height: "42px",
    backgroundColor: "sky.3",
    borderRadius: "4px",
    _hover: disabled2 ? {} : { bg: "sky.2" }
  } : {};
  return /* @__PURE__ */ jsxs63(View_default, { width, maxWidth, position: "relative", children: [
    /* @__PURE__ */ jsx112(
      DoubleArrow_default,
      {
        position: "absolute",
        transform: "translateY(-50%)",
        top: "50%",
        right: "8px",
        cursor: "pointer",
        style: { pointerEvents: "none" },
        fill: disabled2 ? "ink.2" : void 0
      }
    ),
    /* @__PURE__ */ jsx112(
      Select3,
      {
        color: input?.value ? "ink.0" : "ink.2",
        borderColor: meta?.error && meta?.touched ? "red.3" : meta?.touched && variant === "outline-v2" ? "ink.2" : "sky.0",
        ...input,
        value: children2 ? input?.value : selectedIndex > -1 ? `${selectedIndex}` : "",
        onChange: ({ target: { value } }) => {
          const selectedValue = children2 ? value : options[+value]?.value;
          if (input) {
            if (input.onChange)
              input.onChange(selectedValue);
            if (autoBlur && input.onBlur)
              input.onBlur(selectedValue);
          }
        },
        disabled: disabled2,
        cursor: disabled2 ? "not-allowed" : "pointer",
        ...outlineV2Props,
        ...rest,
        children: children2 || /* @__PURE__ */ jsxs63(Fragment5, { children: [
          /* @__PURE__ */ jsx112("option", { value: "", disabled: true, children: placeholder }),
          options.map(({ value, label, ...option }, index) => /* @__PURE__ */ jsx112(
            "option",
            {
              value: `${index}`,
              className: disabled2 && "text-tabeo-sky-0",
              ...option,
              children: label || value
            },
            `${value}`
          ))
        ] })
      }
    )
  ] });
}
NativeSelect.propTypes = {
  input: PropTypes22.object.isRequired,
  meta: PropTypes22.object.isRequired,
  options: PropTypes22.array.isRequired,
  placeholder: PropTypes22.string,
  autoBlur: PropTypes22.bool,
  children
};

// src/components/Form/Password/index.tsx
import { themeGet as themeGet17 } from "@styled-system/theme-get";
import PropTypes26 from "prop-types";
import { Component as Component12 } from "react";
import { useTranslation as useTranslation7, withTranslation as withTranslation2 } from "react-i18next";
import styled59, { css as css7 } from "styled-components";

// src/components/Form/Password/Circle.js
import React45 from "react";
import PropTypes23 from "prop-types";
import styled56 from "styled-components";
import { jsx as jsx113 } from "react/jsx-runtime";
var Circle3 = ({
  color: color2 = "#c4cdd5",
  width = "22",
  height = "22",
  ...rest
}) => /* @__PURE__ */ jsx113("svg", { width, height, viewBox: "0 0 22 22", ...rest, children: /* @__PURE__ */ jsx113("g", { fill: color2, children: /* @__PURE__ */ jsx113("circle", { cx: "11", cy: "11", r: "5" }) }) });
Circle3.propTypes = {
  color: PropTypes23.string,
  width: PropTypes23.number,
  height: PropTypes23.number
};
var Circle_default = styled56(Circle3)``;

// src/components/Form/Password/Invalid.js
import React46 from "react";
import PropTypes24 from "prop-types";
import styled57 from "styled-components";
import { jsx as jsx114 } from "react/jsx-runtime";
var X2 = ({ color: color2 = "#FF6966", width = "22", height = "22", ...rest }) => /* @__PURE__ */ jsx114("svg", { width, height, viewBox: "0 0 22 22", ...rest, children: /* @__PURE__ */ jsx114("g", { fill: color2, mask: "url(#b)", children: /* @__PURE__ */ jsx114("path", { d: "M11.121 10.414L9.354 8.646a.5.5 0 1 0-.708.708l1.768 1.767-1.768 1.768a.5.5 0 0 0 .708.707l1.767-1.768 1.768 1.768a.5.5 0 0 0 .707-.707l-1.768-1.768 1.768-1.767a.5.5 0 0 0-.707-.708l-1.768 1.768zM11 16a5 5 0 1 1 0-10 5 5 0 0 1 0 10z" }) }) });
X2.propTypes = {
  color: PropTypes24.string,
  width: PropTypes24.number,
  height: PropTypes24.number
};
var Invalid_default = styled57(X2)``;

// src/components/Form/Password/Tick.js
import React47 from "react";
import PropTypes25 from "prop-types";
import styled58 from "styled-components";
import { jsx as jsx115 } from "react/jsx-runtime";
var X3 = ({ color: color2 = "#FF6966", width = "22", height = "22", ...rest }) => /* @__PURE__ */ jsx115("svg", { width, height, viewBox: "0 0 22 22", ...rest, children: /* @__PURE__ */ jsx115("g", { fill: color2, mask: "url(#b)", children: /* @__PURE__ */ jsx115("path", { d: "M11 16a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm1.654-6.36l-2.441 2.342-.877-.796a.5.5 0 0 0-.672.74l1.222 1.11a.5.5 0 0 0 .682-.009l2.778-2.666a.5.5 0 0 0-.692-.722z" }) }) });
X3.propTypes = {
  color: PropTypes25.string,
  width: PropTypes25.number,
  height: PropTypes25.number
};
var Tick_default2 = styled58(X3)``;

// src/components/Form/Password/index.tsx
import { jsx as jsx116, jsxs as jsxs64 } from "react/jsx-runtime";
var LockIcon = styled59(Lock_default).attrs((props) => ({
  color: themeGet17("colors.ink.2")(props),
  width: 22,
  height: 22
}))``;
var TickIcon = styled59(Tick_default2).attrs((props) => ({
  color: themeGet17("colors.default.primary")(props)
}))``;
var Toggle = styled59(Subheading).attrs(() => ({
  color: "default.primary"
}))`
  cursor: pointer;
  white-space: nowrap;
  ${(p) => p.disabled && css7`
      color: ${themeGet17("colors.ink.2")};
      cursor: not-allowed;
    `}
`;
var Criteria = ({ touched, valid, label }) => {
  if (!touched && !valid) {
    return /* @__PURE__ */ jsxs64(Flex_default, { justifyContent: "flex-start", children: [
      /* @__PURE__ */ jsx116(Circle_default, {}),
      /* @__PURE__ */ jsx116(Caption, { ml: 1, fontWeight: "normal", children: label })
    ] });
  }
  if (!valid) {
    return /* @__PURE__ */ jsxs64(Flex_default, { justifyContent: "flex-start", children: [
      /* @__PURE__ */ jsx116(Invalid_default, {}),
      /* @__PURE__ */ jsx116(Caption, { ml: 1, color: "red.2", fontWeight: "normal", children: label })
    ] });
  }
  return /* @__PURE__ */ jsxs64(Flex_default, { justifyContent: "flex-start", children: [
    /* @__PURE__ */ jsx116(TickIcon, {}),
    /* @__PURE__ */ jsx116(Caption, { ml: 1, color: "default.primary", fontWeight: "normal", children: label })
  ] });
};
Criteria.propTypes = {
  touched: PropTypes26.bool,
  valid: PropTypes26.bool,
  label: PropTypes26.string.isRequired
};
var Criterias = ({ value = "", touched }) => {
  const minLength8 = (value2) => !(value2.length < 8);
  const containsNumber = (value2) => !!value2.match(/\d+/g);
  const containsUpperCase = (value2) => !!value2.match(/(?=.*[A-Z])+/g);
  const containsLowerCase = (value2) => !!value2.match(/(?=.*[a-z])+/g);
  const { t: t2 } = useTranslation7();
  return /* @__PURE__ */ jsxs64(View_default, { mb: 1, children: [
    /* @__PURE__ */ jsx116(
      Criteria,
      {
        label: t2("Is 8 characters long"),
        touched,
        valid: minLength8(value)
      }
    ),
    /* @__PURE__ */ jsx116(
      Criteria,
      {
        label: t2("Contains at least 1 number"),
        touched,
        valid: containsNumber(value)
      }
    ),
    /* @__PURE__ */ jsx116(
      Criteria,
      {
        label: t2("Contains at least 1 upper case letter"),
        touched,
        valid: containsUpperCase(value)
      }
    ),
    /* @__PURE__ */ jsx116(
      Criteria,
      {
        label: t2("Contains at least 1 lower case letter"),
        touched,
        valid: containsLowerCase(value)
      }
    )
  ] });
};
Criterias.propTypes = {
  touched: PropTypes26.bool,
  value: PropTypes26.string
};
var Password = class extends Component12 {
  constructor() {
    super(...arguments);
    this.state = {
      inputType: "password"
    };
    this.toggleInputType = () => {
      const { disabled: disabled2 } = this.props;
      !disabled2 && this.setState(({ inputType }) => ({
        inputType: inputType === "password" ? "text" : "password"
      }));
    };
  }
  render() {
    const { inputType } = this.state;
    const {
      disabled: disabled2,
      criterias,
      input = {},
      meta = {},
      t: t2,
      tReady,
      ...rest
    } = this.props;
    return /* @__PURE__ */ jsxs64(View_default, { children: [
      criterias && /* @__PURE__ */ jsx116(Criterias, { value: input.value, touched: meta.touched }),
      /* @__PURE__ */ jsx116(
        Input_default,
        {
          type: inputType,
          left: /* @__PURE__ */ jsx116(LockIcon, { fill: "ink.2" }),
          disabled: disabled2,
          input,
          meta,
          right: /* @__PURE__ */ jsx116(Toggle, { onClick: this.toggleInputType, disabled: disabled2, children: inputType === "password" ? t2("SHOW") : t2("HIDE") }),
          ...rest
        }
      )
    ] });
  }
};
Password.propTypes = {
  disabled: PropTypes26.bool,
  criterias: PropTypes26.bool,
  input: PropTypes26.object,
  meta: PropTypes26.object,
  t: PropTypes26.func,
  tReady: PropTypes26.bool
};
var Password_default = withTranslation2()(Password);

// src/components/Form/Percentage.tsx
import { jsx as jsx117 } from "react/jsx-runtime";
var Percentage = (props) => {
  const {
    meta = {},
    input = {},
    disabled: disabled2,
    placeholder = "0.00",
    type = "tel",
    clearable,
    ...rest
  } = props;
  const { value, onChange, ...inputProps } = input;
  const handleValueChange = (e) => {
    const value2 = e?.target?.value;
    if (value2 === "") {
      onChange?.("");
    } else if (!Number.isNaN(Number(value2))) {
      onChange?.(Number(value2));
    }
  };
  const handleClear = () => {
    onChange?.("");
  };
  return /* @__PURE__ */ jsx117(
    Input_default,
    {
      meta,
      clearable,
      onClear: handleClear,
      left: /* @__PURE__ */ jsx117(Text_default, { color: "ink.1", fontWeight: "regular", mr: 3, children: "%" }),
      placeholder,
      type,
      disabled: disabled2,
      input: {
        value,
        onChange: handleValueChange,
        ...inputProps
      },
      ...rest
    }
  );
};
var Percentage_default = Percentage;

// src/components/Form/Phone.tsx
import PropTypes27 from "prop-types";
import { jsx as jsx118 } from "react/jsx-runtime";
var countryPrefixes = {
  gb: "+44",
  nl: "+31",
  it: "+39",
  fr: "+33",
  es: "+34",
  de: "+49"
};
var countryTrunkPrefixes = {
  gb: "(0)",
  nl: "(0)",
  it: "",
  fr: "(0)",
  es: "",
  de: "(0)"
};
var masks = {
  gb: [/[1-9]/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
  nl: [/[1-9]/, /\d/, " ", /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, /\d/],
  it: [/\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/],
  fr: [
    /[1-9]/,
    " ",
    /\d/,
    /\d/,
    " ",
    /\d/,
    /\d/,
    " ",
    /\d/,
    /\d/,
    " ",
    /\d/,
    /\d/
  ],
  es: [/\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/],
  de: [/\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
};
var Phone2 = ({ input, ...rest }) => {
  const { value, onChange } = input || {};
  const { countryCode } = useScarfContext();
  const prefix = countryPrefixes[countryCode];
  const trunk = countryTrunkPrefixes[countryCode];
  function handleChange(value2) {
    onChange?.(formatValue2(value2));
  }
  function parseValue(value2) {
    return value2?.replace(prefix, "");
  }
  function formatValue2(value2) {
    if (!value2) {
      return value2;
    }
    return prefix + value2.replace(/\D/g, "");
  }
  const handleClear = () => {
    handleChange("");
  };
  return /* @__PURE__ */ jsx118(
    Input_default,
    {
      left: /* @__PURE__ */ jsx118(Text_default, { whiteSpace: "nowrap", color: "ink.2", mr: "-4px", children: [prefix, trunk].filter(Boolean).join(" ") }),
      mask: masks[countryCode],
      type: "tel",
      ...rest,
      input: {
        ...input,
        value: parseValue(value),
        onChange: (e) => handleChange(e.target.value)
      },
      onClear: handleClear
    }
  );
};
Phone2.propTypes = {
  input: PropTypes27.object
};
var Phone_default2 = Phone2;

// src/components/Form/Radio/index.tsx
import PropTypes30 from "prop-types";
import React52, { Component as Component13 } from "react";

// src/components/Form/Radio/RadioItem.tsx
import { createContext as createContext3, useContext as useContext5, useMemo as useMemo5 } from "react";

// src/components/Form/Radio/Item.js
import React50 from "react";
import PropTypes29 from "prop-types";
import styled61 from "styled-components";

// src/components/Form/Radio/Dot.js
import { themeGet as themeGet18 } from "@styled-system/theme-get";
import PropTypes28 from "prop-types";
import React49 from "react";
import styled60, { withTheme as withTheme3 } from "styled-components";
import { jsx as jsx119, jsxs as jsxs65 } from "react/jsx-runtime";
var Flex2 = styled60(Flex_default)`
  ${(p) => p.outline && `
    box-shadow: 0 0px 12px 2px rgba(80, 80, 80, 0.2);
    border-radius: 20px;
 `};
`;
var Unselected2 = ({ fillColor = "#919EAB" }) => /* @__PURE__ */ jsxs65("svg", { width: "22", height: "22", viewBox: "0 0 22 22", children: [
  /* @__PURE__ */ jsxs65("defs", { children: [
    /* @__PURE__ */ jsx119("circle", { id: "radio-item-default-a", cx: "11", cy: "11", r: "11" }),
    /* @__PURE__ */ jsxs65(
      "filter",
      {
        id: "radio-item-default-b",
        width: "109.1%",
        height: "109.1%",
        x: "-4.5%",
        y: "-4.5%",
        filterUnits: "objectBoundingBox",
        children: [
          /* @__PURE__ */ jsx119("feOffset", { dx: "2", dy: "-2", in: "SourceAlpha", result: "shadowOffsetInner1" }),
          /* @__PURE__ */ jsx119(
            "feComposite",
            {
              in: "shadowOffsetInner1",
              in2: "SourceAlpha",
              k2: "-1",
              k3: "1",
              operator: "arithmetic",
              result: "shadowInnerInner1"
            }
          ),
          /* @__PURE__ */ jsx119(
            "feColorMatrix",
            {
              in: "shadowInnerInner1",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            }
          )
        ]
      }
    )
  ] }),
  /* @__PURE__ */ jsxs65("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ jsx119("use", { fill: "#FFF", xlinkHref: "#radio-item-default-a" }),
    /* @__PURE__ */ jsx119(
      "use",
      {
        fill: "#000",
        filter: "url(#radio-item-default-b)",
        xlinkHref: "#radio-item-default-a"
      }
    ),
    /* @__PURE__ */ jsx119("circle", { cx: "11", cy: "11", r: "10.5", stroke: fillColor })
  ] })
] });
Unselected2.propTypes = {
  fillColor: PropTypes28.string
};
var Selected2 = ({ fillColor = "#2C9FA5" }) => /* @__PURE__ */ jsxs65("svg", { width: "22", height: "22", viewBox: "0 0 22 22", children: [
  /* @__PURE__ */ jsxs65("defs", { children: [
    /* @__PURE__ */ jsx119("circle", { id: "radio-item-default-a", cx: "11", cy: "11", r: "11" }),
    /* @__PURE__ */ jsxs65(
      "filter",
      {
        id: "radio-item-default-b",
        width: "109.1%",
        height: "109.1%",
        x: "-4.5%",
        y: "-4.5%",
        filterUnits: "objectBoundingBox",
        children: [
          /* @__PURE__ */ jsx119("feOffset", { dx: "2", dy: "-2", in: "SourceAlpha", result: "shadowOffsetInner1" }),
          /* @__PURE__ */ jsx119(
            "feComposite",
            {
              in: "shadowOffsetInner1",
              in2: "SourceAlpha",
              k2: "-1",
              k3: "1",
              operator: "arithmetic",
              result: "shadowInnerInner1"
            }
          ),
          /* @__PURE__ */ jsx119(
            "feColorMatrix",
            {
              in: "shadowInnerInner1",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx119("circle", { id: "radio-item-default-c", cx: "11", cy: "11", r: "6" }),
    /* @__PURE__ */ jsxs65(
      "filter",
      {
        id: "radio-item-default-d",
        width: "108.3%",
        height: "108.3%",
        x: "-4.2%",
        y: "-4.2%",
        filterUnits: "objectBoundingBox",
        children: [
          /* @__PURE__ */ jsx119("feOffset", { dx: "1", dy: "-1", in: "SourceAlpha", result: "shadowOffsetInner1" }),
          /* @__PURE__ */ jsx119(
            "feComposite",
            {
              in: "shadowOffsetInner1",
              in2: "SourceAlpha",
              k2: "-1",
              k3: "1",
              operator: "arithmetic",
              result: "shadowInnerInner1"
            }
          ),
          /* @__PURE__ */ jsx119(
            "feColorMatrix",
            {
              in: "shadowInnerInner1",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            }
          )
        ]
      }
    )
  ] }),
  /* @__PURE__ */ jsxs65("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ jsxs65("g", { children: [
      /* @__PURE__ */ jsx119("use", { fill: "#FFF", xlinkHref: "#radio-item-default-a" }),
      /* @__PURE__ */ jsx119(
        "use",
        {
          filter: "url(#radio-item-default-b)",
          xlinkHref: "#radio-item-default-a"
        }
      ),
      /* @__PURE__ */ jsx119("circle", { cx: "11", cy: "11", r: "10.5", stroke: fillColor })
    ] }),
    /* @__PURE__ */ jsx119("g", { children: /* @__PURE__ */ jsx119("use", { fill: fillColor, xlinkHref: "#radio-item-default-c" }) })
  ] })
] });
Selected2.propTypes = {
  fillColor: PropTypes28.string
};
var Dot2 = ({ selected: selected2, disabled: disabled2, focus: focus2, ...rest }) => {
  const primary = themeGet18("colors.default.primary")(rest);
  const grey = themeGet18("colors.sky.0")(rest);
  return /* @__PURE__ */ jsx119(Flex2, { outline: focus2 && !selected2, ...rest, children: selected2 ? /* @__PURE__ */ jsx119(Selected2, { fillColor: disabled2 ? grey : primary }) : /* @__PURE__ */ jsx119(Unselected2, { fillColor: disabled2 ? grey : void 0 }) });
};
Dot2.propTypes = {
  selected: PropTypes28.bool,
  focus: PropTypes28.bool,
  disabled: PropTypes28.bool
};
var Dot_default2 = styled60(withTheme3(Dot2))``;

// src/components/Form/Radio/Item.js
import { jsx as jsx120, jsxs as jsxs66 } from "react/jsx-runtime";
var Container8 = styled61(Flex_default).attrs(({ horizontal, index, ml, mt }) => ({
  ml: ml ?? (horizontal && index > 0) ? 5 : void 0,
  mt: mt ?? (!horizontal && index > 0) ? 3 : void 0
}))`
  outline: none;
  cursor: ${(p) => p.disabled ? "not-allowed" : "pointer"};
`;
var Item5 = ({
  item: { label, props = {}, index },
  selected: selected2,
  disabled: disabled2,
  horizontal,
  focus: focus2,
  ...rest
}) => /* @__PURE__ */ jsxs66(
  Container8,
  {
    ...rest,
    justifyContent: "flex-start",
    disabled: disabled2,
    horizontal,
    index,
    ...props,
    children: [
      /* @__PURE__ */ jsx120(Dot_default2, { selected: selected2, disabled: disabled2, focus: focus2, mr: 2 }),
      /* @__PURE__ */ jsx120(Prompt, { color: disabled2 ? "ink.2" : void 0, children: label })
    ]
  }
);
Item5.propTypes = {
  item: PropTypes29.shape({
    props: PropTypes29.object,
    index: PropTypes29.any,
    label: PropTypes29.oneOfType([PropTypes29.string, PropTypes29.element]).isRequired
  }).isRequired,
  selected: PropTypes29.bool,
  disabled: PropTypes29.bool,
  focus: PropTypes29.bool,
  horizontal: PropTypes29.bool
};
var Item_default3 = Item5;

// src/components/Form/Radio/RadioItem.tsx
import { jsx as jsx121 } from "react/jsx-runtime";
var RadioItemInput = () => {
  const { renderProps } = useRadioContext();
  return /* @__PURE__ */ jsx121(
    "input",
    {
      type: "radio",
      name: renderProps.name,
      id: renderProps.id,
      style: {
        opacity: 0,
        position: "absolute",
        pointerEvents: "none"
      },
      onMouseDown: renderProps.onMouseDown,
      onKeyDown: renderProps.onKeyDown,
      onFocus: renderProps.onFocus,
      onBlur: renderProps.onBlur,
      value: renderProps.item.value
    }
  );
};
var RadioItemLabel = (props) => {
  const { renderProps } = useRadioContext();
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    /* @__PURE__ */ jsx121("label", { htmlFor: renderProps.id, children: /* @__PURE__ */ jsx121(Item_default3, { ...renderProps, ...props }) })
  );
};
var RadioContext = createContext3({
  renderProps: {
    item: { index: 0, label: "", value: "" },
    onMouseDown: () => {
    },
    onKeyDown: () => {
    },
    onBlur: () => {
    },
    onFocus: () => {
    },
    selected: false,
    focus: false,
    id: "",
    disabled: false,
    loading: false,
    name: ""
  }
});
var useRadioContext = () => useContext5(RadioContext);
var RadioItemWrapper = ({
  children: children2,
  renderProps
}) => {
  const value = useMemo5(() => ({ renderProps }), [renderProps]);
  return /* @__PURE__ */ jsx121(RadioContext.Provider, { value, children: children2 });
};

// src/components/Form/Radio/index.tsx
import { jsx as jsx122, jsxs as jsxs67 } from "react/jsx-runtime";
var Radio = class extends Component13 {
  constructor() {
    super(...arguments);
    this.state = {
      value: "",
      nextValue: null
    };
    this.handleChange = async (newValue) => {
      const {
        input: { onChange, value: propValue },
        disabled: disabled2
      } = this.props;
      const { value: stateValue } = this.state;
      const isControlled = propValue !== void 0;
      if (isControlled && !disabled2) {
        onChange(newValue);
      } else if (!disabled2 && stateValue !== newValue) {
        this.setState({
          nextValue: newValue
        });
        try {
          await onChange(newValue);
          this.setState({ value: newValue, nextValue: null });
        } catch (e) {
          this.setState({ nextValue: null });
          throw e;
        }
      }
    };
    this.handleKeyDown = (event, value) => {
      if (event.keyCode === 13) {
        event.preventDefault();
        event.stopPropagation();
        this.handleChange(value);
      }
    };
    this.handleFocus = (index) => {
      this.setState({ focusIndex: index });
    };
    this.handleOnblur = () => {
      this.setState({ focusIndex: null });
    };
  }
  componentDidMount() {
    const {
      input: { value },
      defaultValue
    } = this.props;
    if (value || defaultValue) {
      this.setState({ value: value || defaultValue });
    }
  }
  render() {
    const {
      input: { value: propValue, name },
      items,
      renderItem,
      horizontal,
      disabled: disabled2,
      ...rest
    } = this.props;
    const { value: stateValue, focusIndex, nextValue } = this.state;
    const isControlled = propValue !== void 0;
    return /* @__PURE__ */ jsx122(
      Flex_default,
      {
        flexDirection: horizontal ? "row" : "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        ...rest,
        children: items.map((i, index) => {
          const value = isControlled ? propValue : stateValue;
          const itemKey = `${i.value}${index}`;
          const itemDisabled = disabled2 || i?.disabled || nextValue !== null && i.value !== nextValue && i.value !== value;
          const renderProps = {
            item: {
              ...i,
              index
            },
            onMouseDown: () => !itemDisabled && this.handleChange(i.value),
            onKeyDown: (event) => !itemDisabled && this.handleKeyDown(event, i.value),
            onBlur: () => !itemDisabled && this.handleOnblur(index),
            onFocus: () => !itemDisabled && this.handleFocus(index),
            selected: i.value === value,
            focus: index === focusIndex,
            id: `${name || "radio"}-${itemKey}`,
            disabled: itemDisabled,
            loading: i.value === nextValue,
            horizontal,
            name
          };
          return renderItem ? /* @__PURE__ */ jsx122(React52.Fragment, { children: renderItem(renderProps) }, itemKey) : /* @__PURE__ */ jsxs67(RadioItemWrapper, { renderProps, children: [
            /* @__PURE__ */ jsx122(RadioItemInput, {}),
            /* @__PURE__ */ jsx122(RadioItemLabel, {})
          ] }, itemKey);
        })
      }
    );
  }
};
Radio.propTypes = {
  input: PropTypes30.shape({
    name: PropTypes30.string,
    value: PropTypes30.oneOfType([
      PropTypes30.string,
      PropTypes30.number,
      PropTypes30.bool
    ]),
    onChange: PropTypes30.func
  }),
  items: PropTypes30.array.isRequired,
  renderItem: PropTypes30.func,
  horizontal: PropTypes30.bool,
  disabled: PropTypes30.bool,
  defaultValue: PropTypes30.oneOfType([
    PropTypes30.string,
    PropTypes30.number,
    PropTypes30.bool
  ])
};
Radio.defaultProps = {
  input: {
    onChange: () => {
    }
  }
};
Radio.ItemInput = RadioItemInput;
Radio.ItemLabel = RadioItemLabel;
Radio.ItemWrapper = RadioItemWrapper;
var Radio_default = Radio;

// src/components/Form/Radio/TabbedItem.js
import React53 from "react";
import PropTypes31 from "prop-types";
import styled62 from "styled-components";
import { jsx as jsx123 } from "react/jsx-runtime";
var Item6 = styled62(View_default)`
  border: 1px solid ${(p) => p.theme.colors.sky[1]};
  padding: 10px 8px;
  outline: none;
  cursor: pointer;
  flex: 1 0;
  align-self: stretch;
  text-align: center;
  line-height: 1 !important;
  &:first-of-type {
    border-radius: 4px 0 0 4px;
  }
  &:last-of-type {
    border-radius: 0 4px 4px 0;
  }
  &:not(:last-of-type) {
    border-right: none;
  }
  &[data-selected='true'] {
    border: 1px solid ${(p) => p.theme.colors.default.primary};
    background: ${(p) => p.theme.colors.default.primary};
  }
  &[data-selected='true'] + & {
    border-left: none;
  }
`;
function TabbedRadioItem({ item, selected: selected2, ...rest }) {
  return /* @__PURE__ */ jsx123(Item6, { "data-selected": selected2, bg: "sky.2", ...rest, children: /* @__PURE__ */ jsx123(Prompt, { color: selected2 ? "white" : "ink.1", children: item.label }) });
}
TabbedRadioItem.propTypes = {
  item: PropTypes31.object,
  selected: PropTypes31.bool
};
var TabbedItem_default = TabbedRadioItem;

// src/components/Form/StripeInput.tsx
import PropTypes32 from "prop-types";
import React54, { Component as Component14 } from "react";
import { jsx as jsx124 } from "react/jsx-runtime";
var style5 = {
  base: {
    color: colors_default.default.ink,
    fontSize: "16px",
    fontFamily: "Roboto",
    fontWeight: 400,
    lineHeight: "24px",
    fontSmoothing: "antialiased",
    "::placeholder": {
      color: colors_default.ink[3]
    }
  },
  invalid: {
    color: colors_default.default.ink
  }
};
var StripeInput = class extends Component14 {
  constructor() {
    super(...arguments);
    this.state = {
      focus: false,
      touched: false,
      error: null
    };
    this.handleFocus = () => {
      this.setState({
        focus: true
      });
    };
    this.handleBlur = () => {
      this.setState({
        focus: false,
        touched: true
      });
    };
    this.handleOnChange = ({ error, complete }) => {
      const {
        input: { onChange }
      } = this.props;
      if (error) {
        this.setState({
          error: error.type
        });
      } else {
        this.setState({
          error: null
        });
      }
      if (complete) {
        onChange && onChange(`complete-${(/* @__PURE__ */ new Date()).getTime()}`);
      } else {
        onChange && onChange("");
      }
    };
  }
  render() {
    const { children: children2, meta = {}, ...rest } = this.props;
    const { focus: focus2, touched, error } = this.state;
    return /* @__PURE__ */ jsx124(
      Base3,
      {
        display: "block",
        meta: {
          focus: focus2,
          touched: meta.touched || touched,
          error: meta.error || error
        },
        ...rest,
        children: React54.cloneElement(children2, {
          style: style5,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          onChange: this.handleOnChange
        })
      }
    );
  }
};
StripeInput.propTypes = {
  meta: PropTypes32.object,
  input: PropTypes32.object,
  children
};
StripeInput.defaultProps = {
  input: {}
};
var StripeInput_default = StripeInput;

// src/components/Form/Switch.tsx
import { useState as useState17 } from "react";
import styled63 from "styled-components";
import { jsx as jsx125 } from "react/jsx-runtime";
var Container9 = styled63(View_default)`
  position: relative;
  width: 44px;
  height: 24px;
  border-radius: 12px;
  transition: background-color 120ms;
`;
var Handle = styled63(View_default)`
  width: 20px;
  height: 20px;
  border-radius: 10px;
  box-shadow: 0px 0 5px 0px rgba(0, 0, 0, 0.15);
  background: white;
  position: absolute;
  transition: left 200ms;
  top: 50%;
  transform: translateY(-50%);
`;
function Switch({
  input: { value: controlledValue, onChange } = {},
  defaultValue = false,
  disabled: disabled2,
  loading,
  ...rest
}) {
  const isControlled = controlledValue !== void 0;
  const [selfValue, setSelfValue] = useState17(defaultValue);
  const value = isControlled ? controlledValue : selfValue;
  async function handleChange() {
    if (isControlled) {
      onChange?.(!value);
    } else {
      setSelfValue(!value);
      if (onChange) {
        try {
          await onChange(!value);
        } catch (e) {
          setSelfValue(value);
          throw e;
        }
      }
    }
  }
  return /* @__PURE__ */ jsx125(
    Container9,
    {
      onClick: () => !disabled2 && !loading && handleChange(),
      cursor: disabled2 ? "not-allowed" : loading ? "wait" : "pointer",
      bg: !value ? disabled2 ? "sky.2" : "sky.1" : disabled2 ? "primary.4" : "primary.3",
      flexShrink: "0",
      ...rest,
      children: /* @__PURE__ */ jsx125(Handle, { left: !value ? "2px" : "calc(100% - 2px - 20px)" })
    }
  );
}
var Switch_default = Switch;

// src/components/Funnelbar.tsx
import { Fragment as Fragment6 } from "react";
import styled64 from "styled-components";
import { jsx as jsx126, jsxs as jsxs68 } from "react/jsx-runtime";
var Step = styled64(Flex_default).attrs(() => ({
  as: Subheading
}))`
  &:first-of-type {
    padding-left: 8px;
    border-radius: 16px 0 0 16px;
  }
  &:last-of-type {
    padding-right: 8px;
    border-radius: 0 16px 16px 0;
  }
`;
Step.defaultProps = {
  flex: "1 0",
  height: "32px",
  justifyContent: "center"
};
var SeperatorEnd = ({ fill: fill2 }) => /* @__PURE__ */ jsx126(
  Base_default,
  {
    width: "9px",
    height: "32px",
    viewBox: "0 0 9 32",
    fill: fill2,
    style: { display: "block" },
    children: /* @__PURE__ */ jsx126("g", { transform: "translate(-408.000000, 0.000000)", children: /* @__PURE__ */ jsx126("path", { d: "M408,0 L408,32 L416.125134,18.591176 C417.090213,16.9985161 417.090213,15.0014839 416.125134,13.408824 L408,0 Z" }) })
  }
);
var SeperatorStart = ({ fill: fill2 }) => /* @__PURE__ */ jsx126(
  Base_default,
  {
    width: "10px",
    height: "32px",
    viewBox: "0 0 10 32",
    style: { marginLeft: "-5px", display: "block" },
    fill: fill2,
    children: /* @__PURE__ */ jsx126("g", { transform: "translate(-410.000000, 0.000000)", children: /* @__PURE__ */ jsx126("path", { d: "M410.330859,0 L420.330859,0 L420.330859,16 L420.330859,32 L410.330859,32 L418.444232,18.5879792 C419.40673,16.9968962 419.40673,15.0031038 418.444232,13.4120208 L410.330859,0 Z" }) })
  }
);
var Funnelbar = ({ steps, ...rest }) => /* @__PURE__ */ jsx126(Flex_default, { ...rest, children: steps.map((s, i) => /* @__PURE__ */ jsxs68(Fragment6, { children: [
  i > 0 && /* @__PURE__ */ jsx126(SeperatorStart, { fill: s.props.bg }),
  /* @__PURE__ */ jsx126(Step, { ...s.props, children: s.children ? s.children : s.label ? s.label : null }),
  i < steps.length - 1 && /* @__PURE__ */ jsx126(SeperatorEnd, { fill: s.props.bg })
] }, `${s.label}-${i}`)) });
var Funnelbar_default = Funnelbar;

// src/components/InteractiveForm/AssigneeSelector.tsx
import { useRef as useRef8, useState as useState18 } from "react";

// src/components/InteractiveForm/mapFormToProps.tsx
import React57 from "react";
import { jsx as jsx127 } from "react/jsx-runtime";
function mapFormToProps(WrappedComponent) {
  const hocComponent = React57.forwardRef(({ input, meta, ...rest }, ref) => /* @__PURE__ */ jsx127(WrappedComponent, { ref, ...input, invalid: !!meta?.error, ...rest }));
  hocComponent.displayName = `MapFormToProps(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;
  return hocComponent;
}
var mapFormToProps_default = mapFormToProps;

// src/components/InteractiveForm/Placeholder.tsx
import styled65 from "styled-components";
import { jsx as jsx128, jsxs as jsxs69 } from "react/jsx-runtime";
var DashedContainer = styled65(View_default)``;
DashedContainer.defaultProps = {
  borderWidth: "1px",
  borderStyle: "dashed",
  borderColor: "sky.0",
  borderRadius: 1
};
var StyledCaption = styled65(Caption)`
  white-space: nowrap;
`;
function Placeholder3({
  children: children2,
  icon,
  color: color2 = "sky.0",
  invalid: invalid2,
  ...rest
}) {
  return /* @__PURE__ */ jsxs69(
    DashedContainer,
    {
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      height: ["40px", "25px"],
      borderColor: invalid2 ? "default.red" : void 0,
      ...rest,
      children: [
        icon && icon({
          fill: invalid2 ? "default.red" : color2,
          height: ["30px", "22px"],
          width: ["30px", "22px"]
        }),
        /* @__PURE__ */ jsx128(
          StyledCaption,
          {
            color: invalid2 ? "default.red" : color2,
            fontSize: ["16px", "14px"],
            pl: icon ? "2px" : 2,
            pr: 2,
            children: children2
          }
        )
      ]
    }
  );
}
var PlaceholderField = mapFormToProps_default(
  Placeholder3
);
var Placeholder_default = PlaceholderField;

// src/components/InteractiveForm/AssigneeSelector.tsx
import { Fragment as Fragment7, jsx as jsx129, jsxs as jsxs70 } from "react/jsx-runtime";
function AssigneeSelector({
  loadOptions,
  onChange,
  value = [],
  invalid: invalid2,
  onFocus,
  onBlur,
  children: children2,
  ...rest
}) {
  const mobile = useMobile();
  const [open, setOpen] = useState18(false);
  const ref = useRef8();
  return /* @__PURE__ */ jsxs70(Fragment7, { children: [
    /* @__PURE__ */ jsx129(
      Popover_default,
      {
        open,
        onClickOut: () => setOpen(false),
        placement: "bottom-start",
        referenceElement: ref,
        offset: [0, 4],
        children: ({ ref: ref2, style: style6, placement, update }) => /* @__PURE__ */ jsx129(
          Select_default,
          {
            ref: ref2,
            onBlur,
            onFocus,
            style: mobile ? { zIndex: 1e3 } : style6,
            "data-placement": placement,
            onHitsUpdate: update,
            placeholder: "Search by name",
            loadOptions,
            filtering: true,
            selectedFirst: true,
            value: Array.isArray(value) ? value.map((v) => ({ value: v.id, data: v })) : value ? (
              // @ts-ignore
              { value: value.id, data: value }
            ) : value,
            onChange: (value2) => {
              if (!value2) {
                onChange(value2);
                return setOpen(false);
              }
              if (!Array.isArray(value2)) {
                setOpen(false);
                return onChange({
                  type: "admins",
                  id: value2.data.id,
                  name: value2.data.name,
                  data: value2.data
                });
              }
              onChange(
                value2.map(({ data }) => ({
                  type: "admins",
                  id: data.id,
                  name: data.name,
                  data
                }))
              );
            },
            onClose: () => setOpen(false),
            renderItem: ({ data: { name, label } = {} }, { hover: hover2, selected: selected2, ...rest2 }) => /* @__PURE__ */ jsxs70(
              Flex_default,
              {
                justifyContent: "flex-start",
                px: [5, 3],
                py: [3, 2],
                bg: hover2 ? "default.primary" : void 0,
                color: hover2 ? "white" : void 0,
                ...rest2,
                children: [
                  name && /* @__PURE__ */ jsx129(
                    Avatar_default,
                    {
                      bg: "transparent",
                      color: hover2 ? "white" : "default.primary",
                      borderColor: hover2 ? "white" : void 0,
                      name,
                      mr: 3
                    }
                  ),
                  /* @__PURE__ */ jsx129(
                    Text_default,
                    {
                      color: hover2 ? "white" : "default.ink",
                      fontSize: [null, "14px"],
                      "data-testid": "assignee-item",
                      children: name || label
                    }
                  ),
                  /* @__PURE__ */ jsx129(Flex_default, { flex: "1" }),
                  selected2 && /* @__PURE__ */ jsx129(Tick_default, { light: true, fill: hover2 ? "white" : void 0 })
                ]
              }
            ),
            "data-testid": "assignee-selector"
          }
        )
      }
    ),
    children2 ? children2({
      ref,
      open,
      setOpen,
      value,
      props: rest
    }) : /* @__PURE__ */ jsxs70(
      View_default,
      {
        ...rest,
        ref,
        onClick: () => {
          setOpen(!open);
        },
        cursor: "pointer",
        display: "inline-block",
        children: [
          !value.length && /* @__PURE__ */ jsx129(
            Placeholder_default,
            {
              icon: (props) => /* @__PURE__ */ jsx129(AddAssignee_default, { ...props }),
              invalid: invalid2,
              _hover: {
                bg: "sky.3"
              },
              children: "Assign person"
            }
          ),
          !!value.length && /* @__PURE__ */ jsxs70(Flex_default, { alignItems: "center", children: [
            /* @__PURE__ */ jsx129(AvatarList_default, { children: value.map(({ id, name }) => /* @__PURE__ */ jsx129(
              Avatar_default,
              {
                borderColor: invalid2 ? "default.red" : void 0,
                color: invalid2 ? "default.red" : "default.primary",
                name
              },
              id
            )) }),
            /* @__PURE__ */ jsx129(Hoverable_default, { children: (hover2) => /* @__PURE__ */ jsx129(
              RoundPlus_default,
              {
                fill: "ink.1",
                bg: hover2 ? "sky.3" : "white",
                border: "sky.0",
                width: ["36px", "25px"],
                height: ["36px", "25px"],
                ml: 1
              }
            ) })
          ] })
        ]
      }
    )
  ] });
}
var AssigneeSelectorField = mapFormToProps_default(
  AssigneeSelector
);
var AssigneeSelector_default = AssigneeSelectorField;

// src/components/InteractiveForm/BasicValue.tsx
import PropTypes33 from "prop-types";
import styled66 from "styled-components";
import { jsx as jsx130, jsxs as jsxs71 } from "react/jsx-runtime";
var Container10 = styled66(View_default)`
  ${variants_default({
  sizeVariant: {
    md: {
      height: ["40px", "25px"]
    },
    fixed: {
      height: ["25px", "25px"]
    }
  }
})}
`;
Container10.defaultProps = {
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "sky.0",
  borderRadius: 1,
  sizeVariant: "md"
};
var StyledCaption2 = styled66(Caption)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
function BasicValue({
  children: children2,
  icon,
  color: color2 = "ink.2",
  invalid: invalid2,
  loading,
  onDelete,
  sizeVariant,
  _hover: hover2,
  ...rest
}) {
  return /* @__PURE__ */ jsxs71(
    Container10,
    {
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      sizeVariant,
      borderColor: invalid2 ? "default.red" : void 0,
      overflow: "hidden",
      ...rest,
      children: [
        /* @__PURE__ */ jsxs71(
          Flex_default,
          {
            justifyContent: "center",
            alignItems: "center",
            minWidth: 0,
            _hover: hover2,
            children: [
              loading ? /* @__PURE__ */ jsx130(
                Spinner_default,
                {
                  spinning: true,
                  mx: sizeVariant === "fixed" ? [1] : ["6px", 1],
                  height: sizeVariant === "fixed" ? ["14px"] : ["16px", "14px"],
                  width: sizeVariant === "fixed" ? ["14px"] : ["16px", "14px"]
                }
              ) : icon?.({
                fill: invalid2 ? "default.red" : "default.primary",
                height: sizeVariant === "fixed" ? ["22px"] : ["30px", "22px"],
                width: sizeVariant === "fixed" ? ["22px"] : ["30px", "22px"]
              }),
              /* @__PURE__ */ jsx130(
                StyledCaption2,
                {
                  color: invalid2 ? "default.red" : color2,
                  fontSize: sizeVariant === "fixed" ? ["14px"] : ["16px", "14px"],
                  pl: icon || loading ? "2px" : 2,
                  pr: 2,
                  minWidth: 0,
                  children: children2
                }
              )
            ]
          }
        ),
        !loading && onDelete && /* @__PURE__ */ jsx130(
          Flex_default,
          {
            borderLeft: 1,
            height: "100%",
            px: sizeVariant === "fixed" ? ["5px"] : ["10px", "5px"],
            borderColor: invalid2 ? "default.red" : void 0,
            cursor: "pointer",
            onClick: onDelete,
            bg: "white",
            _hover: {
              bg: "sky.3"
            },
            children: /* @__PURE__ */ jsx130(
              X_default,
              {
                height: sizeVariant === "fixed" ? ["12px"] : ["13px", "12px"],
                width: sizeVariant === "fixed" ? ["12px"] : ["13px", "12px"],
                fill: "ink.2"
              }
            )
          }
        )
      ]
    }
  );
}
BasicValue.propTypes = {
  children: PropTypes33.string.isRequired,
  icon: PropTypes33.func,
  color: PropTypes33.string,
  invalid: PropTypes33.bool,
  loading: PropTypes33.bool,
  onDelete: PropTypes33.func,
  sizeVariant: PropTypes33.string,
  _hover: PropTypes33.any
};
BasicValue.defaultProps = {
  sizeVariant: "md"
};
var BasicValueField = mapFormToProps_default(
  BasicValue
);
var BasicValue_default = BasicValueField;

// src/components/InteractiveForm/DateSelector.tsx
import { useRef as useRef9, useState as useState19 } from "react";
import { Fragment as Fragment8, jsx as jsx131, jsxs as jsxs72 } from "react/jsx-runtime";
function formatToTime(date) {
  return date.toLocaleTimeString().substring(0, 5);
}
function DateSelector({
  value,
  onChange,
  onFocus,
  onBlur,
  invalid: invalid2,
  hasTime,
  ...rest
}) {
  const [timeOpen, setTimeOpen] = useState19(false);
  const timeRef = useRef9();
  const mobile = useMobile();
  const parsedValue = value ? new Date(value) : null;
  return /* @__PURE__ */ jsxs72(View_default, { display: "inline-flex", children: [
    /* @__PURE__ */ jsx131(
      DayPicker_default,
      {
        value,
        onChange,
        onFocus,
        onBlur,
        children: ({ setOpen, open, ref }) => /* @__PURE__ */ jsxs72(
          View_default,
          {
            ...rest,
            ref,
            onClick: () => {
              setOpen(!open);
            },
            cursor: "pointer",
            mr: value && 2,
            children: [
              !value && /* @__PURE__ */ jsx131(
                Placeholder_default,
                {
                  icon: (props) => /* @__PURE__ */ jsx131(Calendar_default, { ...props }),
                  invalid: invalid2,
                  _hover: {
                    bg: "sky.3"
                  },
                  children: "Set date"
                }
              ),
              !!value && /* @__PURE__ */ jsx131(Flex_default, { alignItems: "center", children: /* @__PURE__ */ jsx131(
                BasicValue_default,
                {
                  icon: (props) => /* @__PURE__ */ jsx131(Calendar_default, { ...props }),
                  invalid: invalid2,
                  onDelete: () => {
                    onFocus && onFocus();
                    onChange();
                    onFocus && onBlur();
                  },
                  _hover: {
                    bg: "sky.3"
                  },
                  children: formatDate_default(value)
                }
              ) })
            ]
          }
        )
      }
    ),
    value && hasTime && /* @__PURE__ */ jsxs72(Fragment8, { children: [
      /* @__PURE__ */ jsx131(
        Popover_default,
        {
          open: timeOpen,
          onClickOut: () => setTimeOpen(false),
          placement: "bottom-start",
          referenceElement: timeRef,
          offset: [0, 4],
          children: ({ ref, style: style6, placement }) => /* @__PURE__ */ jsx131(
            Select_default,
            {
              ref,
              style: mobile ? { zIndex: 1e3 } : style6,
              "data-placement": placement,
              options: [...new Array(48)].map((_, i) => {
                const date = /* @__PURE__ */ new Date(+parsedValue);
                date.setHours(0, 0, 0, 0);
                const time = new Date(
                  +date - +/* @__PURE__ */ new Date(0) + +new Date(0 + i * 1e3 * 60 * 30)
                );
                return {
                  label: formatToTime(time),
                  value: time.toISOString()
                };
              }),
              value: { value: parsedValue.toISOString() },
              onChange: (e) => {
                onChange(e.value);
                onBlur && onBlur();
                setTimeOpen(false);
              },
              onBlur,
              onFocus,
              onClose: () => setTimeOpen(false),
              renderItem: (item, { selected: selected2, hover: hover2, ...rest2 }) => /* @__PURE__ */ jsxs72(
                Flex_default,
                {
                  justifyContent: "flex-start",
                  px: [5, 3],
                  py: [3, 2],
                  bg: hover2 ? "default.primary" : void 0,
                  color: hover2 ? "white" : void 0,
                  ...rest2,
                  children: [
                    /* @__PURE__ */ jsx131(
                      Text_default,
                      {
                        color: hover2 ? "white" : "default.ink",
                        fontSize: [null, "14px"],
                        children: item.label
                      }
                    ),
                    /* @__PURE__ */ jsx131(Flex_default, { flex: "1" }),
                    selected2 && /* @__PURE__ */ jsx131(
                      Tick_default,
                      {
                        light: true,
                        fill: hover2 ? "white" : void 0,
                        ml: 2
                      }
                    )
                  ]
                }
              )
            }
          )
        }
      ),
      /* @__PURE__ */ jsx131(
        View_default,
        {
          ...rest,
          ref: timeRef,
          onClick: () => {
            setTimeOpen(!timeOpen);
          },
          cursor: "pointer",
          children: formatToTime(parsedValue) === "00:00" ? /* @__PURE__ */ jsx131(
            Placeholder_default,
            {
              icon: (props) => /* @__PURE__ */ jsx131(Clock_default, { ...props }),
              invalid: invalid2,
              _hover: {
                bg: "sky.3"
              },
              children: "Set time"
            }
          ) : /* @__PURE__ */ jsx131(Flex_default, { alignItems: "center", children: /* @__PURE__ */ jsx131(
            BasicValue_default,
            {
              icon: (props) => /* @__PURE__ */ jsx131(Clock_default, { ...props }),
              invalid: invalid2,
              onDelete: () => {
                onFocus && onFocus();
                const date = /* @__PURE__ */ new Date(+parsedValue);
                date.setHours(0, 0, 0, 0);
                onChange(date.toISOString());
                onFocus && onBlur();
              },
              _hover: {
                bg: "sky.3"
              },
              children: formatToTime(parsedValue)
            }
          ) })
        }
      )
    ] })
  ] });
}
var DateSelectorField = mapFormToProps_default(
  DateSelector
);
var DateSelector_default = DateSelectorField;

// src/components/InteractiveForm/EntitySelector/index.tsx
import PropTypes37 from "prop-types";
import styled71 from "styled-components";

// src/components/InteractiveForm/EntitySelector/DashedContainer.tsx
import styled67 from "styled-components";
var DashedContainer2 = styled67(View_default)`
  :focus {
    outline: none;
  }
`;
DashedContainer2.defaultProps = {
  borderWidth: "1px",
  borderStyle: "dashed",
  borderColor: "sky.0",
  borderRadius: 1,
  overflow: "hidden"
};
var DashedContainer_default = DashedContainer2;

// src/components/InteractiveForm/EntitySelector/SingleEntitySelector.tsx
import { themeGet as themeGet21 } from "@styled-system/theme-get";
import PropTypes36 from "prop-types";
import { useEffect as useEffect15, useState as useState20 } from "react";
import styled70 from "styled-components";

// src/components/InteractiveForm/EntitySelector/EntitySelect.tsx
import { themeGet as themeGet19 } from "@styled-system/theme-get";
import PropTypes34 from "prop-types";
import { useRef as useRef10 } from "react";
import styled68 from "styled-components";
import { Fragment as Fragment9, jsx as jsx132, jsxs as jsxs73 } from "react/jsx-runtime";
var StyledFlex2 = styled68(Flex_default)`
  :hover {
    background: ${themeGet19("colors.sky.3")};
  }
`;
StyledFlex2.defaultProps = {
  height: "100%",
  flex: "1"
};
function EntitySelect({
  open,
  toggle,
  value,
  onChange,
  type,
  disabledValues,
  ...rest
}) {
  const mobile = useMobile();
  const ref = useRef10();
  const width = ref.current?.clientWidth;
  return /* @__PURE__ */ jsxs73(Fragment9, { children: [
    /* @__PURE__ */ jsx132(
      Popover_default,
      {
        open,
        onClickOut: () => toggle(),
        placement: "bottom-start",
        referenceElement: ref,
        offset: [0, 4],
        children: ({ ref: ref2, style: style6, placement, update }) => /* @__PURE__ */ jsx132(
          Select_default,
          {
            ref: ref2,
            style: mobile ? { zIndex: 1e3 } : style6,
            "data-placement": placement,
            placeholder: "Search by id or name",
            value,
            width: ["100%", `${width}px`],
            onHitsUpdate: update,
            onChange: (e) => {
              onChange(e);
              toggle();
            },
            onClose: () => toggle(),
            renderItem: type?.renderItem,
            loadOptions: type?.loader,
            disabledValues,
            filtering: true,
            selectedFirst: true,
            "data-testid": "entity-select"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx132(
      StyledFlex2,
      {
        ref,
        justifyContent: !value ? "center" : "flex-start",
        onClick: () => {
          toggle();
        },
        minWidth: "0px",
        cursor: "pointer",
        ...rest,
        children: value ? type?.renderItem(value, { linked: true }) : /* @__PURE__ */ jsx132(Caption, { fontSize: ["16px", "14px"], children: type?.placeholder || "ID or name" })
      }
    )
  ] });
}
EntitySelect.propTypes = {
  open: PropTypes34.bool,
  toggle: PropTypes34.func,
  value: PropTypes34.shape({
    value: PropTypes34.oneOfType([PropTypes34.string, PropTypes34.number])
  }),
  onChange: PropTypes34.func,
  type: PropTypes34.shape({
    renderItem: PropTypes34.func,
    loader: PropTypes34.func,
    placeholder: PropTypes34.string
  }),
  disabledValues: PropTypes34.array
};
var EntitySelect_default = EntitySelect;

// src/components/InteractiveForm/EntitySelector/EntityTypeSelect.tsx
import { themeGet as themeGet20 } from "@styled-system/theme-get";
import PropTypes35 from "prop-types";
import { useRef as useRef11 } from "react";
import styled69 from "styled-components";
import { Fragment as Fragment10, jsx as jsx133, jsxs as jsxs74 } from "react/jsx-runtime";
var StyledFlex3 = styled69(Flex_default)`
  :hover {
    background: ${themeGet20("colors.sky.3")};
  }
`;
StyledFlex3.defaultProps = {
  height: "100%",
  flex: "1",
  maxWidth: "100px",
  justifyContent: "center"
};
function EntityTypeSelect({
  open,
  toggle,
  value,
  onChange,
  options,
  ...rest
}) {
  const mobile = useMobile();
  const ref = useRef11();
  const width = ref.current?.clientWidth;
  return /* @__PURE__ */ jsxs74(Fragment10, { children: [
    /* @__PURE__ */ jsx133(
      Popover_default,
      {
        open,
        onClickOut: () => toggle(),
        placement: "bottom-start",
        referenceElement: ref,
        offset: [0, 4],
        children: ({ ref: ref2, style: style6, placement, update }) => /* @__PURE__ */ jsx133(
          Select_default,
          {
            ref: ref2,
            style: mobile ? { zIndex: 1e3 } : style6,
            "data-placement": placement,
            minWidth: [`${width}px`],
            options,
            value,
            onHitsUpdate: update,
            onChange: (e) => {
              onChange(e);
              toggle();
            },
            onClose: () => toggle(),
            renderItem: (item, { selected: selected2, hover: hover2, ...rest2 }) => /* @__PURE__ */ jsxs74(
              Flex_default,
              {
                justifyContent: "flex-start",
                px: [5, 3],
                py: [3, 2],
                bg: hover2 ? "default.primary" : void 0,
                color: hover2 ? "white" : void 0,
                ...rest2,
                children: [
                  /* @__PURE__ */ jsx133(
                    Text_default,
                    {
                      color: hover2 ? "white" : "default.ink",
                      fontSize: [null, "14px"],
                      "data-testid": "entity-type-item",
                      children: item.label
                    }
                  ),
                  /* @__PURE__ */ jsx133(Flex_default, { flex: "1" }),
                  selected2 && /* @__PURE__ */ jsx133(Tick_default, { light: true, fill: hover2 ? "white" : void 0, ml: 2 })
                ]
              }
            ),
            "data-testid": "entity-type-select"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx133(
      StyledFlex3,
      {
        ref,
        onClick: () => {
          toggle();
        },
        cursor: "pointer",
        minWidth: "100px",
        ...rest,
        children: /* @__PURE__ */ jsx133(Caption, { fontSize: ["16px", "14px"], children: value?.label || "Entity" })
      }
    )
  ] });
}
EntityTypeSelect.propTypes = {
  open: PropTypes35.bool,
  toggle: PropTypes35.func,
  value: PropTypes35.shape({
    value: PropTypes35.oneOfType([PropTypes35.string, PropTypes35.number]),
    label: PropTypes35.string
  }),
  onChange: PropTypes35.func,
  options: PropTypes35.array
};
var EntityTypeSelect_default = EntityTypeSelect;

// src/components/InteractiveForm/EntitySelector/SingleEntitySelector.tsx
import { jsx as jsx134, jsxs as jsxs75 } from "react/jsx-runtime";
var Actions3 = styled70(Flex_default)`
  z-index: 1;
  right: ${themeGet21("space.1")}px;
  position: absolute;

  cursor: pointer;
`;
var StyledDashedContainer = styled70(DashedContainer_default)`
  @media (min-width: ${themeGet21("breakpoints.0")}) {
    ${Actions3} {
      opacity: 0;
      transition: 0.2s all;
    }

    :hover {
      ${Actions3} {
        opacity: 1;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 0px 0px 8px 8px rgba(255, 255, 255, 0.9);
      }
    }
  }

  overflow: hidden;
`;
function SingleEntitySelector({
  types,
  onChange,
  value,
  onFocus,
  disabledValues,
  ...rest
}) {
  const [entityTypeOpen, setEntityTypeOpen] = useState20(false);
  const [entityOpen, setEntityOpen] = useState20(false);
  useEffect15(() => {
    if (!value?.type) {
      setEntityTypeOpen(true);
    }
    if (value?.type && !value?.data) {
      setTimeout(() => setEntityOpen(true), 0);
    }
  }, [value]);
  const { type, id, data } = value || {};
  const selectedType = types.find((o) => o.type === type);
  return /* @__PURE__ */ jsx134(
    StyledDashedContainer,
    {
      width: "100%",
      height: "40px",
      tabIndex: "0",
      position: "relative",
      onFocus,
      borderStyle: data ? "solid" : "dashed",
      borderColor: data ? "sky.1" : "sky.0",
      ...rest,
      children: /* @__PURE__ */ jsxs75(Flex_default, { height: "100%", children: [
        /* @__PURE__ */ jsx134(
          EntityTypeSelect_default,
          {
            options: types.map((o) => ({ label: o.label, value: o.type })),
            value: type ? {
              value: type,
              label: selectedType?.label
            } : void 0,
            onChange: (e) => {
              onChange({
                type: e?.value,
                id: null,
                data: null
              });
            },
            open: entityTypeOpen,
            toggle: () => setEntityTypeOpen(!entityTypeOpen),
            borderRight: 1,
            borderStyle: type ? "solid" : "dashed",
            borderColor: type ? "sky.2" : "sky.0"
          }
        ),
        /* @__PURE__ */ jsx134(
          EntitySelect_default,
          {
            value: id && data && {
              value: id,
              data
            },
            onChange: (item) => {
              if (type) {
                if (item) {
                  const { data: data2 } = item;
                  onChange({ type, id: data2.id, data: data2 });
                } else {
                  onChange({ type, id: null, data: null });
                }
              }
            },
            open: entityOpen,
            toggle: () => setEntityOpen(!entityOpen),
            disabledValues: [
              ...disabledValues,
              ...selectedType?.disabledValues || []
            ],
            type: selectedType,
            mr: ["56px", 0]
          }
        ),
        /* @__PURE__ */ jsxs75(Actions3, { children: [
          /* @__PURE__ */ jsx134(
            Popout_default,
            {
              fill: "ink.2",
              onClick: () => selectedType?.link?.(value),
              height: "16px",
              width: "16px",
              mr: 2,
              mt: "2px"
            }
          ),
          /* @__PURE__ */ jsx134(Trash_default, { fill: "ink.2", onClick: () => onChange() })
        ] })
      ] })
    }
  );
}
SingleEntitySelector.propTypes = {
  types: PropTypes36.arrayOf(
    PropTypes36.shape({
      type: PropTypes36.string,
      label: PropTypes36.string,
      renderItem: PropTypes36.func,
      loader: PropTypes36.func,
      placeholder: PropTypes36.string,
      disabledValues: PropTypes36.array
    })
  ),
  disabledValues: PropTypes36.array,
  value: PropTypes36.shape({
    id: PropTypes36.number,
    type: PropTypes36.string,
    data: PropTypes36.any
  }),
  onChange: PropTypes36.func,
  onFocus: PropTypes36.func
};
var SingleEntitySelector_default = SingleEntitySelector;

// src/components/InteractiveForm/EntitySelector/index.tsx
import { jsx as jsx135, jsxs as jsxs76 } from "react/jsx-runtime";
var Container11 = styled71(View_default)`
  :focus {
    outline: none;
  }
`;
function EntitySelector({
  types,
  onChange,
  value = [],
  onFocus,
  onBlur,
  ...rest
}) {
  const handleChange = (entity, index) => {
    if (!entity || entity.data) {
      onFocus && onFocus();
    }
    if (entity) {
      onChange([...value.slice(0, index), entity, ...value.slice(index + 1)]);
    } else {
      onChange([...value.slice(0, index), ...value.slice(index + 1)]);
    }
    if (!entity || entity.data) {
      onBlur && onBlur();
    }
  };
  const hasAddItem = value[value.length - 1]?.id || value.length === 0;
  return /* @__PURE__ */ jsxs76(Container11, { ...rest, children: [
    value.map?.((entity, i) => /* @__PURE__ */ jsx135(
      SingleEntitySelector_default,
      {
        types,
        onChange: (e) => handleChange(e, i),
        value: entity,
        disabledValues: value.filter((v) => v.type === entity.type && v.id !== entity.id).map((v) => v.id),
        mb: i !== value?.length - 1 || hasAddItem ? 2 : void 0
      },
      `${entity.type ? entity.type : "new"}${entity.id || ""}`
    )),
    hasAddItem && /* @__PURE__ */ jsx135(DashedContainer_default, { width: "100%", height: "40px", children: /* @__PURE__ */ jsxs76(
      Flex_default,
      {
        height: "100%",
        justifyContent: "center",
        onClick: () => {
          onFocus && onFocus();
          onChange([...value, {}]);
          onBlur && onBlur();
        },
        cursor: "pointer",
        _hover: {
          bg: "sky.3"
        },
        children: [
          /* @__PURE__ */ jsx135(Plus_default, { light: true, mb: "2px", height: "18px", fill: "sky.0" }),
          /* @__PURE__ */ jsx135(Caption, { color: "sky.0", fontSize: ["16px", "14px"], children: "Add link" })
        ]
      }
    ) })
  ] });
}
EntitySelector.propTypes = {
  types: PropTypes37.arrayOf(
    PropTypes37.shape({
      type: PropTypes37.string,
      label: PropTypes37.string,
      renderItem: PropTypes37.func,
      loader: PropTypes37.func,
      placeholder: PropTypes37.string,
      disabledValues: PropTypes37.array
    })
  ),
  value: PropTypes37.arrayOf(
    PropTypes37.shape({
      id: PropTypes37.number,
      type: PropTypes37.string
    })
  ),
  onChange: PropTypes37.func,
  invalid: PropTypes37.bool,
  onBlur: PropTypes37.func,
  onFocus: PropTypes37.func
};
var EntitySelectorField = mapFormToProps_default(
  EntitySelector
);
var EntitySelector_default = EntitySelectorField;

// src/components/InteractiveForm/FileUpload/index.tsx
import { useRef as useRef12 } from "react";
import styled72 from "styled-components";

// src/components/InteractiveForm/FileUpload/File.tsx
import PropTypes38 from "prop-types";
import { useCallback as useCallback9, useEffect as useEffect16, useState as useState21 } from "react";
function File({ value, upload, onChange, children: children2, ...rest }) {
  const [{ loading, error, uploaded }, setState] = useState21({
    loading: false,
    error: null,
    uploaded: !(value instanceof window.File)
  });
  const handleUpload = useCallback9(async () => {
    try {
      setState((state) => ({ ...state, loading: true }));
      const uploadedFile = await upload(value);
      setState((state) => ({ ...state, loading: false, uploaded: true }));
      onChange(uploadedFile);
    } catch (e) {
      setState((state) => ({ ...state, loading: false, error: e }));
    }
  }, [onChange, upload, value]);
  useEffect16(() => {
    if (!loading && !error && !uploaded) {
      handleUpload();
    }
  }, [error, handleUpload, loading, uploaded]);
  const setLoading = (loading2) => setState((state) => ({ ...state, loading: loading2 }));
  const setError = (error2) => setState((state) => ({ ...state, error: error2 }));
  return children2({
    value,
    loading,
    error,
    uploaded,
    setValue: onChange,
    setLoading,
    setError,
    ...rest
  });
}
File.propTypes = {
  children: PropTypes38.func.isRequired,
  value: PropTypes38.any,
  onChange: PropTypes38.func,
  upload: PropTypes38.func
};
var File_default = File;

// src/components/InteractiveForm/FileUpload/index.tsx
import { jsx as jsx136, jsxs as jsxs77 } from "react/jsx-runtime";
var HtmlFileInput2 = styled72(View_default)`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;
HtmlFileInput2.defaultProps = { as: "input", type: "file" };
var Container12 = styled72(Flex_default)`
  :focus {
    outline: none;
  }
`;
Container12.defaultProps = {
  display: "inline-flex",
  cursor: "pointer",
  flexWrap: "wrap",
  justifyContent: "flex-start"
};
function FileUpload({
  onChange,
  value = [],
  invalid: invalid2,
  onFocus,
  onBlur,
  upload,
  accept,
  renderItem,
  ...rest
}) {
  const ref = useRef12({
    id: (/* @__PURE__ */ new Date()).getTime() + Math.floor(Math.random() * 100)
  });
  const handleSelect = async (event) => {
    const file = event?.target?.files?.[0];
    if (file) {
      onChange([...value, file]);
    }
  };
  const handleChange = (file, index) => {
    onFocus && onFocus();
    if (file) {
      onChange([...value.slice(0, index), file, ...value.slice(index + 1)]);
    } else {
      onChange([...value.slice(0, index), ...value.slice(index + 1)]);
    }
    onBlur && onBlur();
  };
  return /* @__PURE__ */ jsxs77(Container12, { maxWidth: "100%", ...rest, children: [
    !!value.length && value.map((file, i) => /* @__PURE__ */ jsx136(
      File_default,
      {
        value: file,
        onChange: (v) => handleChange(v, i),
        upload,
        spacing: {
          mr: 2,
          mb: 2
        },
        children: renderItem
      },
      file?.id || file.name
    )),
    /* @__PURE__ */ jsx136(
      HtmlFileInput2,
      {
        id: `file-${ref.current.id}`,
        onChange: handleSelect,
        accept
      }
    ),
    /* @__PURE__ */ jsx136(
      Placeholder_default,
      {
        as: "label",
        htmlFor: `file-${ref.current.id}`,
        icon: (props) => /* @__PURE__ */ jsx136(Clip_default, { ...props }),
        cursor: "pointer",
        invalid: invalid2,
        mb: 2,
        _hover: {
          bg: "sky.3"
        },
        children: "Upload document"
      }
    )
  ] });
}
var FileUploadField = mapFormToProps_default(
  FileUpload
);
var FileUpload_default = FileUploadField;

// src/components/InteractiveForm/InteractiveField.tsx
import React64 from "react";
import { jsx as jsx137, jsxs as jsxs78 } from "react/jsx-runtime";
var InteractiveField = React64.forwardRef(
  ({ label, component: Component17, meta = {}, containerProps = {}, ...rest }, ref) => /* @__PURE__ */ jsxs78(View_default, { ...containerProps, children: [
    label && /* @__PURE__ */ jsx137(
      Subheading,
      {
        fontSize: "10px",
        color: meta.error ? "default.red" : "ink.2",
        mb: 1,
        children: label
      }
    ),
    /* @__PURE__ */ jsx137(Component17, { ref, meta, ...rest })
  ] })
);
var InteractiveField_default = InteractiveField;

// src/components/InteractiveForm/TypeSelector.tsx
import { useRef as useRef13, useState as useState22 } from "react";
import { jsx as jsx138, jsxs as jsxs79 } from "react/jsx-runtime";
function TypeSelector({
  loadOptions,
  onChange,
  value,
  invalid: invalid2,
  onFocus,
  onBlur,
  ...rest
}) {
  const [open, setOpen] = useState22(false);
  const ref = useRef13();
  const mobile = useMobile();
  return /* @__PURE__ */ jsxs79(View_default, { display: "inline-block", children: [
    /* @__PURE__ */ jsx138(
      Popover_default,
      {
        open,
        onClickOut: () => setOpen(false),
        placement: "bottom-start",
        referenceElement: ref,
        offset: [0, 4],
        children: ({ ref: ref2, style: style6, placement, update }) => /* @__PURE__ */ jsx138(
          Select_default,
          {
            ref: ref2,
            onBlur,
            onFocus,
            style: mobile ? { zIndex: 1e3 } : style6,
            "data-placement": placement,
            onHitsUpdate: update,
            placeholder: "Search by type",
            loadOptions,
            filtering: true,
            selectedFirst: true,
            value,
            maxHeight: "360px",
            onChange: (e) => {
              setOpen(false);
              onChange(e);
            },
            onClose: () => setOpen(false),
            renderItem: (item, { hover: hover2, selected: selected2, ...rest2 }) => /* @__PURE__ */ jsxs79(
              Flex_default,
              {
                justifyContent: "flex-start",
                px: [5, 3],
                py: [5, 3],
                bg: hover2 ? "default.primary" : void 0,
                color: hover2 ? "white" : void 0,
                ...rest2,
                children: [
                  /* @__PURE__ */ jsx138(
                    Text_default,
                    {
                      color: hover2 ? "white" : "default.ink",
                      fontSize: [null, "14px"],
                      minHeight: "22px",
                      "data-testid": "type-item",
                      children: item.label
                    }
                  ),
                  /* @__PURE__ */ jsx138(Flex_default, { flex: "1" }),
                  selected2 && /* @__PURE__ */ jsx138(Tick_default, { light: true, fill: hover2 ? "white" : void 0 })
                ]
              }
            ),
            "data-testid": "type-selector"
          }
        )
      }
    ),
    /* @__PURE__ */ jsxs79(
      View_default,
      {
        ...rest,
        ref,
        onClick: () => {
          setOpen(!open);
        },
        cursor: "pointer",
        children: [
          !value?.label && /* @__PURE__ */ jsx138(
            Placeholder_default,
            {
              icon: (props) => /* @__PURE__ */ jsx138(Tag_default, { ...props }),
              invalid: invalid2,
              _hover: {
                bg: "sky.3"
              },
              children: "Set type"
            }
          ),
          !!value?.label && /* @__PURE__ */ jsx138(Flex_default, { alignItems: "center", children: /* @__PURE__ */ jsx138(
            BasicValue_default,
            {
              icon: (props) => /* @__PURE__ */ jsx138(Tag_default, { ...props }),
              invalid: invalid2,
              _hover: {
                bg: "sky.3"
              },
              children: value.label
            }
          ) })
        ]
      }
    )
  ] });
}
var TypeSelectorField = mapFormToProps_default(
  TypeSelector
);
var TypeSelector_default = TypeSelectorField;

// src/components/Modal/index.tsx
import React66 from "react";
import styled73 from "styled-components";
import { jsx as jsx139 } from "react/jsx-runtime";
var Overlay = styled73(View_default)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
  z-index: 500;

  display: flex;

  background: rgba(75, 75, 75, 0.3);

  opacity: 0;
  pointer-events: none;
  transition: opacity 0.25s;

  min-height: 100vh;
  min-height: -webkit-fill-available;

  overflow: auto;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  ${({ isOpen }) => isOpen && `
    opacity: 1;
    pointer-events: all;
  `};
`;
Overlay.defaultProps = {
  alignItems: ["flex-start", "center"],
  pb: [0]
};
var Container13 = styled73(View_default).attrs(({ isOpen }) => ({
  mt: isOpen ? ["auto", 0] : "-99999px"
}))``;
Container13.defaultProps = {
  onClick: () => (evt) => evt.stopPropagation(),
  maxHeight: ["unset", "100vh"],
  maxWidth: "100%",
  py: [5],
  mb: 3,
  flex: "1",
  position: "relative",
  transition: "margin 0.5s",
  width: "100%"
};
var Modal = class extends React66.Component {
  constructor(props) {
    super(props);
    this.mounted = false;
    // eslint-disable-next-line class-methods-use-this
    this.setBodyPositions = () => {
      document.body.style.overflow = "hidden";
    };
    // eslint-disable-next-line class-methods-use-this
    this.cleanup = () => {
      document.body.style.overflow = "unset";
    };
    this.handleKeyUp = ({ key }) => {
      const { closable } = this.props;
      const isClosableFunction = typeof closable === "function";
      if (key === "Escape" && (closable === true || isClosableFunction && closable())) {
        this.close();
      }
    };
    this.close = () => {
      const { onClose } = this.props;
      onClose && onClose();
      this.mounted && this.setState({ isOpen: false });
      this.cleanup();
    };
    this.open = (data) => {
      this.setBodyPositions();
      this.mounted && this.setState({ isOpen: true, data });
    };
    this.state = {
      isOpen: props.isOpenByDefault || false
    };
    if (props.isOpenByDefault) {
      this.setBodyPositions();
    }
  }
  componentDidMount() {
    this.mounted = true;
    window.addEventListener("keyup", this.handleKeyUp);
  }
  componentWillUnmount() {
    this.mounted = false;
    window.removeEventListener("keyup", this.handleKeyUp);
    this.cleanup();
  }
  render() {
    const { children: children2, closable, render, containerProps, overlayProps } = this.props;
    const { isOpen, data } = this.state;
    const renderProps = {
      isOpen,
      closable,
      close: this.close,
      open: this.open,
      data
    };
    const isClosableFunction = typeof closable === "function";
    return /* @__PURE__ */ jsx139(
      Overlay,
      {
        isOpen,
        onMouseDown: () => {
          if (closable === true || isClosableFunction && closable()) {
            this.close();
          }
        },
        ...overlayProps,
        children: /* @__PURE__ */ jsx139(
          Container13,
          {
            id: "tmodal-container",
            isOpen,
            onMouseDown: (e) => {
              const isSelfClick = e.target.id === "tmodal-container";
              if ((closable === true || isClosableFunction && closable()) && isSelfClick) {
                this.close();
              } else {
                e.stopPropagation();
              }
            },
            ...containerProps,
            children: render ? render(renderProps) : children2 ? children2(renderProps) : null
          }
        )
      }
    );
  }
};
Modal.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  closable: true
};

// src/components/Modal/Simple.tsx
import styled74 from "styled-components";
import { useTranslation as useTranslation8 } from "react-i18next";
import { jsx as jsx140, jsxs as jsxs80 } from "react/jsx-runtime";
var Container14 = styled74(Box_default)`
  overflow: auto;
`;
var SimpleModal = ({
  title,
  children: children2,
  innerRef,
  closeButtonProps = {},
  ...rest
}) => {
  const { t: t2 } = useTranslation8();
  return /* @__PURE__ */ jsx140(Modal, { ref: innerRef, children: ({ isOpen, close }) => isOpen && /* @__PURE__ */ jsxs80(
    Container14,
    {
      maxWidth: ["95%", "460px"],
      mx: "auto",
      boxShadow: 1,
      p: 7,
      ...rest,
      children: [
        /* @__PURE__ */ jsx140(Title, { mb: 4, children: title }),
        /* @__PURE__ */ jsx140(View_default, { mb: 4, children: children2 }),
        /* @__PURE__ */ jsx140(Button_default, { onClick: close, ...closeButtonProps, children: t2("Close") })
      ]
    }
  ) });
};
var Simple_default = SimpleModal;

// src/components/Module/index.tsx
import { useState as useState23 } from "react";

// src/components/Module/components/Collapsible.tsx
import { useContext as useContext6 } from "react";

// src/components/Module/ModuleContext.tsx
import React67 from "react";
var ModuleContext = React67.createContext({
  collapsible: {},
  open: () => {
  },
  close: () => {
  },
  toggle: () => {
  },
  closeAll: () => {
  },
  color: ""
});
var ModuleContext_default = ModuleContext;

// src/components/Module/components/Collapsible.tsx
import { jsx as jsx141 } from "react/jsx-runtime";
function Collapsible({
  id = "default",
  isOpen: controlledIsOpen,
  ...rest
}) {
  const { collapsible } = useContext6(ModuleContext_default);
  const isOpen = controlledIsOpen !== void 0 ? controlledIsOpen : collapsible[id];
  const height = isOpen ? "auto" : 0;
  return /* @__PURE__ */ jsx141(AnimateHeight_default, { duration: 200, height, ...rest });
}
var Collapsible_default = Collapsible;

// src/components/Module/components/Container.tsx
import { jsx as jsx142 } from "react/jsx-runtime";
function Container15({ ...rest }) {
  return /* @__PURE__ */ jsx142(
    View_default,
    {
      position: "relative",
      borderRadius: [0, 1],
      borderLeft: [0, 1],
      borderRight: [0, 1],
      borderTop: 1,
      borderBottom: 1,
      bg: "white",
      ...rest
    }
  );
}
var Container_default3 = Container15;

// src/components/Module/components/Header.tsx
import { useContext as useContext7 } from "react";
import { jsx as jsx143, jsxs as jsxs81 } from "react/jsx-runtime";
function Header2({
  children: children2,
  defaultCollapse,
  collapseId = "default",
  onToggle,
  isOpen: controlledIsOpen,
  ...rest
}) {
  const { collapsible, toggle } = useContext7(ModuleContext_default);
  const isOpen = controlledIsOpen !== void 0 ? controlledIsOpen : collapsible[collapseId];
  const handleClick = () => {
    if (onToggle) {
      onToggle(collapseId);
    } else {
      toggle(collapseId);
    }
  };
  const hasControl = defaultCollapse || collapseId !== "default" || onToggle;
  return /* @__PURE__ */ jsxs81(
    Flex_default,
    {
      py: [4],
      px: [5],
      onClick: hasControl && handleClick,
      cursor: hasControl && "pointer",
      ...rest,
      children: [
        children2,
        hasControl && /* @__PURE__ */ jsx143(
          ArrowRight_default,
          {
            transform: isOpen ? `rotate(-90deg)` : `rotate(90deg)`,
            transition: "transform 200ms linear",
            mr: "-8px"
          }
        )
      ]
    }
  );
}
var Header_default = Header2;

// src/components/Module/components/Highlight.tsx
import { useContext as useContext8 } from "react";
import { jsx as jsx144 } from "react/jsx-runtime";
function Highlight({ ...rest }) {
  const { color: color2 } = useContext8(ModuleContext_default);
  return /* @__PURE__ */ jsx144(
    View_default,
    {
      bg: color2,
      height: "3px",
      width: ["100%", "calc(100% + 2px)"],
      position: "absolute",
      top: "-1px",
      left: [0, "-1px"],
      right: [0, "-1px"],
      zIndex: "1",
      borderTopRightRadius: [0, 1],
      borderTopLeftRadius: [0, 1],
      ...rest
    }
  );
}
var Highlight_default = Highlight;

// src/components/Module/components/Row.tsx
import { jsx as jsx145 } from "react/jsx-runtime";
function Row3({ ...rest }) {
  return /* @__PURE__ */ jsx145(View_default, { py: [4], px: [5], borderTop: 1, ...rest });
}
var Row_default = Row3;

// src/components/Module/index.tsx
import { jsx as jsx146 } from "react/jsx-runtime";
function Module({
  color: color2 = "sky.1",
  children: children2,
  initialCollapsible = {},
  ...rest
}) {
  const [collapsible, setCollapsible] = useState23(initialCollapsible);
  const handleChange = (id = "default", value = !collapsible[id]) => {
    setCollapsible((prev) => ({
      ...prev,
      [id]: value
    }));
  };
  const handleCloseAll = () => {
    setCollapsible(
      (state) => Object.keys(state).reduce((acc, key) => ({ ...acc, [key]: false }), {})
    );
  };
  return /* @__PURE__ */ jsx146(
    ModuleContext_default.Provider,
    {
      value: {
        collapsible,
        open: (id) => handleChange(id, true),
        close: (id) => handleChange(id, false),
        toggle: (id) => handleChange(id),
        closeAll: handleCloseAll,
        color: color2
      },
      children: /* @__PURE__ */ jsx146(Container_default3, { boxShadow: [null, 1], ...rest, children: typeof children2 === "function" ? (
        // @ts-ignore
        /* @__PURE__ */ jsx146(ModuleContext_default.Consumer, { children: children2 })
      ) : children2 })
    }
  );
}
Module.Header = Header_default;
Module.Row = Row_default;
Module.Collapsible = Collapsible_default;
Module.Highlight = Highlight_default;
Module.Context = ModuleContext_default;
var Module_default = Module;

// src/components/MultiActionButton.tsx
import React72, { useEffect as useEffect17 } from "react";
import { jsx as jsx147, jsxs as jsxs82 } from "react/jsx-runtime";
var MultiActionButton = ({
  children: children2,
  secondaryActions,
  popOverPlacement = "bottom-end",
  variant = "secondary",
  sizeVariant = "md",
  onClick,
  ...rest
}) => {
  const [open, setOpen] = React72.useState(false);
  const buttonRef = React72.useRef();
  const arrowRef = React72.useRef(null);
  useEffect17(() => {
    function handleClick(e) {
      e.stopPropagation();
      setOpen((o) => !o);
    }
    const $arrow = arrowRef.current;
    if (arrowRef.current) {
      arrowRef.current.addEventListener("click", handleClick);
    }
    return () => {
      if ($arrow) {
        $arrow.removeEventListener("click", handleClick);
      }
    };
  }, [arrowRef, setOpen]);
  return /* @__PURE__ */ jsxs82(
    Button_default,
    {
      ref: buttonRef,
      right: /* @__PURE__ */ jsx147(
        View_default,
        {
          ref: arrowRef,
          px: sizeVariant === "md" ? 2 : 2,
          py: sizeVariant === "md" ? 2 : sizeVariant === "sm" ? "7px" : "5px",
          ml: sizeVariant === "md" ? 5 : 4,
          borderLeft: "1px solid",
          borderLeftColor: variant === "secondary" ? "sky.0" : "white",
          cursor: "pointer",
          children: /* @__PURE__ */ jsx147(
            ArrowDown_default,
            {
              fill: variant === "secondary" ? "primary.3" : "white",
              width: sizeVariant === "md" ? "20px" : "16px"
            }
          )
        }
      ),
      variant,
      sizeVariant,
      ...rest,
      onClick: (e) => onClick?.(e, { open, setOpen, ref: buttonRef }),
      children: [
        children2,
        /* @__PURE__ */ jsx147(
          Popover_default,
          {
            open,
            referenceElement: buttonRef,
            placement: popOverPlacement,
            onClickOut: () => setOpen(false),
            offset: [0, 8],
            children: ({ attributes, style: style6, ref }) => /* @__PURE__ */ jsx147(
              View_default,
              {
                bg: "white",
                boxShadow: 1,
                border: 1,
                borderRadius: 1,
                minWidth: `${buttonRef.current?.offsetWidth}px`,
                py: 1,
                ref,
                attributes,
                style: style6,
                children: secondaryActions.map(({ label, ...a }, i) => /* @__PURE__ */ jsx147(
                  Text_default,
                  {
                    px: 3,
                    py: 2,
                    fontSize: sizeVariant === "md" ? "16px" : "14px",
                    color: "ink.1",
                    _hover: {
                      bg: "sky.2"
                    },
                    _notLast: {
                      borderBottom: 1
                    },
                    cursor: "pointer",
                    display: "block",
                    ...a,
                    onClick: async (e) => {
                      e.stopPropagation();
                      setOpen(false);
                      await a?.onClick?.(e, { open, setOpen, ref: buttonRef });
                    },
                    children: label
                  },
                  label + i
                ))
              }
            )
          }
        )
      ]
    }
  );
};
var MultiActionButton_default = MultiActionButton;

// src/components/Panel.tsx
import styled75 from "styled-components";
import { jsx as jsx148, jsxs as jsxs83 } from "react/jsx-runtime";
var Title5 = styled75(Prompt)``;
Title5.defaultProps = {
  color: "ink.0",
  fontWeight: "semibold",
  mr: [1, 2]
};
var Panel = ({ title, Header: Header4, header, children: children2, ...rest }) => {
  if (Header4) {
    console.warn(
      "Using Header in Panel is depricated please use header instead."
    );
  }
  const headerElement = Header4 || header;
  return /* @__PURE__ */ jsxs83(
    View_default,
    {
      boxShadow: 1,
      borderRadius: 1,
      border: 1,
      overflow: "hidden",
      bg: "white",
      ...rest,
      children: [
        /* @__PURE__ */ jsx148(
          Flex_default,
          {
            bg: "white",
            minHeight: ["40px", "56px"],
            height: "1px",
            pl: [4, 5],
            pr: [3],
            borderRadius: "4px 4px 0 0",
            borderBottom: 1,
            children: headerElement || (typeof title === "string" ? /* @__PURE__ */ jsx148(Title5, { children: title }) : title)
          }
        ),
        children2
      ]
    }
  );
};
Panel.Title = Title5;
var Panel_default = Panel;

// src/components/Progressbar.tsx
import styled76 from "styled-components";
import { jsx as jsx149 } from "react/jsx-runtime";
var Container16 = styled76(View_default)`
  border-radius: 6px;
  overflow: hidden;
`;
Container16.defaultProps = {
  height: "4px",
  bg: "sky.2"
};
var Fill = styled76(View_default)`
  height: 100%;
  width: ${(p) => p.percent}%;
  transition: width 1s ease-in-out;
  border-radius: 6px;
`;
var Progressbar = ({
  percent = 0,
  color: color2 = "default.primary",
  ...rest
}) => /* @__PURE__ */ jsx149(Container16, { ...rest, children: /* @__PURE__ */ jsx149(Fill, { percent, bg: color2 }) });
var Progressbar_default = Progressbar;

// src/components/Settings/RadioGroupItem.tsx
import { jsx as jsx150, jsxs as jsxs84 } from "react/jsx-runtime";
var RadioGroupItem = ({
  item,
  selected: selected2,
  disabled: disabled2,
  loading,
  ...rest
}) => /* @__PURE__ */ jsxs84(
  Flex_default,
  {
    py: 3,
    px: 4,
    alignItems: "flex-start",
    width: "100%",
    bg: selected2 ? "primary.6" : "sky.3",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: selected2 ? "primary.3" : "sky.1",
    zIndex: selected2 ? "20" : "0",
    position: "relative",
    cursor: disabled2 ? "not-allowed" : "pointer",
    opacity: disabled2 ? "0.7" : "1",
    _notFirst: {
      borderTop: !selected2 ? 1 : void 0,
      mt: "-1px"
    },
    _first: {
      borderRadius: "4px 4px 0 0"
    },
    _last: {
      borderRadius: "0 0 4px 4px"
    },
    ...rest,
    children: [
      loading ? /* @__PURE__ */ jsx150(
        Spinner_default,
        {
          width: "18px",
          height: "18px",
          ml: "-2px",
          strokeWidth: "12px",
          spinning: true
        }
      ) : /* @__PURE__ */ jsx150(
        Flex_default,
        {
          bg: selected2 ? "primary.3" : "white",
          width: "16px",
          height: "16px",
          borderRadius: "50%",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: selected2 ? "primary.3" : "ink.2",
          display: "inline-flex",
          justifyContent: "center",
          boxShadow: selected2 ? "none" : "inset 2px -2px 0 0 rgba(0, 0, 0, 0.1)",
          children: /* @__PURE__ */ jsx150(
            View_default,
            {
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              bg: selected2 ? "white" : "transparent"
            }
          )
        }
      ),
      /* @__PURE__ */ jsxs84(View_default, { ml: 3, flex: "1", children: [
        /* @__PURE__ */ jsx150(Caption, { fontWeight: "semibold", color: "ink.0", children: item.label }),
        /* @__PURE__ */ jsx150(Caption, { children: item.description }),
        item.attributes && /* @__PURE__ */ jsx150(Attributes_default, { ...item.attributes, mt: 2 })
      ] })
    ]
  }
);
var RadioGroupItem_default = RadioGroupItem;

// src/components/Settings/Section.tsx
import styled77 from "styled-components";
import { jsx as jsx151 } from "react/jsx-runtime";
var StyledSection = styled77(View_default)``;
StyledSection.defaultProps = {
  _notLast: {
    borderBottom: 1,
    pb: 6
  },
  _notFirst: {
    mt: 6
  }
};
function Section(props) {
  return /* @__PURE__ */ jsx151(StyledSection, { ...props });
}
var Header3 = styled77(Flex_default)`
  &:not(:only-child):not(:last-child) {
    padding-bottom: 16px;
  }
`;
Header3.defaultProps = {
  justifyContent: "space-between"
};
var Title6 = styled77(Prompt)``;
Title6.defaultProps = {
  color: "ink.0",
  fontWeight: "semibold"
};
var Description2 = styled77(Caption)``;
Description2.defaultProps = {
  color: "ink.2",
  mt: 1
};
var Body2 = styled77(View_default)``;
Body2.defaultProps = {
  mt: 5
};
Section.Header = Header3;
Section.Title = Title6;
Section.Description = Description2;
Section.Body = Body2;
var Section_default = Section;

// src/components/Settings/Stack.tsx
import styled78 from "styled-components";
import { jsx as jsx152 } from "react/jsx-runtime";
var StyledStack = styled78(View_default)``;
StyledStack.defaultProps = {
  bg: "sky.2",
  border: 1,
  borderRadius: 1
};
function Stack(props) {
  return /* @__PURE__ */ jsx152(StyledStack, { ...props });
}
var Item10 = styled78(View_default)``;
Item10.defaultProps = {
  p: 5,
  _notFirst: {
    borderTop: 1
  },
  _first: {
    minHeight: "56px",
    height: "1px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    py: 0,
    pr: 3
  }
};
Stack.Item = Item10;
var Stack_default = Stack;

// src/components/Settings/index.tsx
var Settings = () => null;
Settings.Stack = Stack_default;
Settings.Section = Section_default;
Settings.RadioGroupItem = RadioGroupItem_default;
var Settings_default = Settings;

// src/components/Spinner/index.tsx
import { jsx as jsx153 } from "react/jsx-runtime";
var Spinner2 = ({ icon, ...rest }) => /* @__PURE__ */ jsx153(Flex_default, { ...rest, justifyContent: "center", children: /* @__PURE__ */ jsx153(Spinner_default, { spinning: true, ...defaultIconProps, ...icon }) });
var defaultIconProps = {
  strokeWidth: "3px",
  size: "100px",
  fill: "default.primary"
};
Spinner2.defaultProps = {
  icon: defaultIconProps,
  // eslint-disable-next-line react/default-props-match-prop-types
  minHeight: "60vh",
  // ie 11 bug: https://github.com/philipwalton/flexbugs/issues/231
  // eslint-disable-next-line react/default-props-match-prop-types
  height: "1px"
};
var Spinner_default2 = Spinner2;

// src/components/StateFunnel.tsx
import { useState as useState24, useEffect as useEffect18 } from "react";
import { jsx as jsx154 } from "react/jsx-runtime";
function matchMobileQuery() {
  const mediaQueryList = window.matchMedia(
    `(max-width: ${theme_default.breakpoints[0] || "960px"})`
  );
  return mediaQueryList.matches;
}
function StateFunnel({
  states,
  currentIndex = 0,
  pastStepProps = { bg: "primary.4", color: "white" },
  activeStepProps = { bg: "primary.3", color: "white" },
  futureStepProps = { bg: "sky.2", color: "ink.2" },
  ...rest
}) {
  const [mobile, setMobile] = useState24(() => matchMobileQuery());
  const checkMobile = () => {
    const match = matchMobileQuery();
    setMobile(match);
  };
  useEffect18(() => {
    window.addEventListener("resize", checkMobile);
    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);
  const steps = states.map((state, index) => ({
    label: mobile ? index + 1 : state,
    props: index < currentIndex ? pastStepProps : index === currentIndex ? activeStepProps : futureStepProps,
    children: index < currentIndex ? /* @__PURE__ */ jsx154(Tick_default, { light: true, fill: pastStepProps.color }) : null
  }));
  return /* @__PURE__ */ jsx154(Funnelbar_default, { steps, ...rest });
}
var StateFunnel_default = StateFunnel;

// src/components/TabScreens.tsx
import React74, { useEffect as useEffect19 } from "react";
import { Fragment as Fragment11, jsx as jsx155, jsxs as jsxs85 } from "react/jsx-runtime";
function TabScreens({ tabs, id, defaultTab, context }) {
  const [tab, setTab] = useSearchQueryState_default(
    `${id ? `${id}-` : ""}tab`,
    defaultTab || tabs[0].key
  );
  const current = tabs.find((t2) => t2.key === tab);
  useEffect19(() => {
    if (!current) {
      setTab(defaultTab || tabs[0].key);
    }
  }, [current, defaultTab, setTab, tabs]);
  return /* @__PURE__ */ jsxs85(Fragment11, { children: [
    /* @__PURE__ */ jsx155(
      View_default,
      {
        borderBottom: 1,
        mb: 6,
        position: "sticky",
        top: "0",
        pt: 3,
        bg: "white",
        zIndex: "50",
        children: /* @__PURE__ */ jsx155(Flex_default, { as: "nav", justifyContent: "flex-start", mb: "-1px", overflowX: "auto", children: tabs.map((t2) => /* @__PURE__ */ jsx155(
          Caption,
          {
            as: "label",
            borderStyle: "solid",
            borderBottomWidth: "2px",
            borderColor: t2.key === tab ? "primary.3" : "transparent",
            color: t2.key === tab ? "primary.3" : "ink.2",
            fontWeight: "semibold",
            pb: 2,
            mr: 4,
            cursor: "pointer",
            tabIndex: t2.key === tab ? 0 : void 0,
            onClick: () => setTab(t2.key),
            onKeyDown: (e) => e.keyCode === 13 && setTab(t2.key),
            _focus: {
              outline: "none",
              borderColor: "primary.2",
              color: "primary.2"
            },
            _active: {
              outline: "none"
            },
            whiteSpace: "nowrap",
            ...t2.labelProps || {},
            children: t2.label
          },
          t2.label
        )) })
      }
    ),
    current ? React74.createElement(current?.component, {
      ...context
    }) : null
  ] });
}
var TabScreens_default = TabScreens;

// src/components/TabbedPanel.tsx
import React76 from "react";
import { themeGet as themeGet22 } from "@styled-system/theme-get";
import styled79, { css as css8 } from "styled-components";

// src/components/Tabs.tsx
import { Component as Component15 } from "react";
var Tabs2 = class extends Component15 {
  constructor(props) {
    super(props);
    this.changeActiveIndex = (index) => new Promise((resolve) => {
      this.setState(
        {
          activeIndex: index
        },
        () => {
          resolve();
        }
      );
    });
    const { initialIndex } = props;
    this.state = {
      activeIndex: initialIndex || 0
    };
  }
  render() {
    const { children: children2 } = this.props;
    const { activeIndex } = this.state;
    return children2({
      activeIndex,
      changeActiveIndex: this.changeActiveIndex
    });
  }
};
var Tabs_default2 = Tabs2;

// src/components/TabbedPanel.tsx
import { Fragment as Fragment12, jsx as jsx156, jsxs as jsxs86 } from "react/jsx-runtime";
var Tab = styled79(View_default).attrs(() => ({
  flex: 1,
  textAlign: "center",
  borderBottom: 1,
  py: 3
}))`
  cursor: pointer;
  border-left: ${themeGet22("borders.1")};
  background: ${themeGet22("colors.sky.2")};
  &:first-of-type {
    border-left: 0;
  }
  &:last-of-type {
    border-right: 0;
  }
  ${(p) => p.active && css8`
      background: ${themeGet22("colors.sky.3")};
      border-radius: 5px 5px 0 0;
      border-bottom-color: ${themeGet22("colors.sky.3")};
      border-right: ${themeGet22("borders.1")};
    `}
  ${(p) => p.isPreviousActive && `
    border-left: 0;
  `}
`;
var TabbedPanel = ({
  initialIndex,
  onChange,
  children: children2,
  ...rest
}) => /* @__PURE__ */ jsx156(
  View_default,
  {
    boxShadow: 1,
    borderRadius: 1,
    border: 1,
    style: { overflow: "hidden" },
    ...rest,
    children: /* @__PURE__ */ jsx156(View_default, { children: /* @__PURE__ */ jsx156(Tabs_default2, { initialIndex, children: ({ activeIndex, changeActiveIndex }) => {
      const currentTab = React76.Children.toArray(children2)[activeIndex];
      if (!React76.isValidElement(currentTab)) {
        return null;
      }
      return /* @__PURE__ */ jsxs86(Fragment12, { children: [
        /* @__PURE__ */ jsx156(Flex_default, { justifyContent: "strecth", bg: "sky.3", children: React76.Children.toArray(children2).map(
          (child, index) => React76.isValidElement(child) && /* @__PURE__ */ jsx156(
            Tab,
            {
              onClick: () => {
                changeActiveIndex(index);
                onChange && onChange(index, child.props.title);
              },
              active: activeIndex === index,
              isPreviousActive: activeIndex === index - 1,
              children: /* @__PURE__ */ jsx156(
                Heading,
                {
                  color: activeIndex === index ? "default.primary" : "ink.2",
                  children: child.props.title
                }
              )
            },
            index
          )
        ) }),
        currentTab
      ] });
    } }) })
  }
);
var TabbedPanel_default = TabbedPanel;

// src/components/Table.tsx
import styled80 from "styled-components";
var Table = styled80(View_default).attrs(() => ({
  display: "table"
}))`
  border-collapse: collapse;
  border: none;
  width: 100%;
`;
Table.defaultProps = {
  minWidth: "768px"
};
var THead = styled80(View_default).attrs(() => ({
  bg: "sky.3",
  display: "table-row-group"
}))``;
THead.defaultProps = {};
var TBody = styled80(View_default).attrs(() => ({
  display: "table-row-group"
}))``;
var TR = styled80(View_default).attrs(() => ({
  display: "table-row"
}))``;
var TH = styled80(Subheading)`
  text-align: left;
  vertical-align: middle;
  padding-right: ${(p) => p.px ? String(p.px) : "20px"};

  &:first-of-type {
    padding-left: ${(p) => p.px ? String(p.px) : "20px"};
  }
`;
TH.defaultProps = {
  color: "ink.2",
  py: 2,
  display: "table-cell"
};
var TD = styled80(View_default)`
  vertical-align: middle;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: ${(p) => p.px ? String(p.px) : "16px"};

  &:first-of-type {
    padding-left: ${(p) => p.px ? String(p.px) : "16px"};
  }

  > div {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
TD.defaultProps = {
  py: 3,
  display: "table-cell"
};

// src/components/Tickets/Entity/components/Container.tsx
import { useContext as useContext9 } from "react";

// src/components/Tickets/Entity/EntityContext.tsx
import React77 from "react";
var EntityContext = React77.createContext({});
var EntityContext_default = EntityContext;

// src/components/Tickets/Entity/components/Container.tsx
import { jsx as jsx157 } from "react/jsx-runtime";
function Container17({ children: children2, ...rest }) {
  const { hover: hover2, disabled: disabled2, color: color2, linked } = useContext9(EntityContext_default);
  return /* @__PURE__ */ jsx157(
    Flex_default,
    {
      justifyContent: "flex-start",
      flexGrow: "1",
      bg: disabled2 ? "sky.2" : hover2 ? color2 : void 0,
      px: linked ? [2] : [3, 3],
      py: !linked && [3, 2],
      minWidth: "0px",
      ...rest,
      cursor: disabled2 ? "default" : rest.cursor,
      onClick: disabled2 ? null : rest.onClick,
      children: children2
    }
  );
}
var Container_default4 = Container17;

// src/components/Tickets/Entity/components/Content.tsx
import { useContext as useContext10 } from "react";
import { jsx as jsx158 } from "react/jsx-runtime";
function Content3({ children: children2, ...rest }) {
  const { hover: hover2, disabled: disabled2 } = useContext10(EntityContext_default);
  return /* @__PURE__ */ jsx158(
    Flex_default,
    {
      justifyContent: "flex-start",
      flexGrow: 1,
      color: disabled2 ? "sky.0" : hover2 ? "white" : "default.ink",
      minWidth: "0px",
      ...rest,
      children: children2
    }
  );
}
var Content_default = Content3;

// src/components/Tickets/Entity/components/Id.tsx
import { useContext as useContext11 } from "react";
import { jsx as jsx159, jsxs as jsxs87 } from "react/jsx-runtime";
function Id2({ children: children2, ...rest }) {
  const { color: color2, hover: hover2, disabled: disabled2 } = useContext11(EntityContext_default);
  return /* @__PURE__ */ jsxs87(
    Flex_default,
    {
      display: "inline-flex",
      justifyContent: "flex-start",
      color: disabled2 ? "sky.0" : hover2 ? "white" : color2,
      mr: 3,
      ...rest,
      children: [
        /* @__PURE__ */ jsx159(
          Id_default,
          {
            fill: "currentColor",
            height: ["25px", "22px"],
            width: ["25px", "22px"],
            bg: disabled2 ? "white" : hover2 ? color2 : "white",
            mb: ["1px", 0]
          }
        ),
        /* @__PURE__ */ jsx159(
          Text_default,
          {
            fontSize: ["16px", "14px"],
            color: "currentColor",
            minWidth: ["45px", "40px"],
            children: children2
          }
        )
      ]
    }
  );
}
var Id_default2 = Id2;

// src/components/Tickets/Entity/components/Text.tsx
import {
  useCallback as useCallback10,
  useContext as useContext12,
  useEffect as useEffect20,
  useRef as useRef14,
  useState as useState25
} from "react";
import { jsx as jsx160 } from "react/jsx-runtime";
function Text({ children: children2, color: color2 = "default.ink", ...rest }) {
  const ref = useRef14();
  const { hover: hover2, disabled: disabled2 } = useContext12(EntityContext_default);
  const [isOverflown, setIsOverflown] = useState25(true);
  const checkOverflow = useCallback10(() => {
    if (ref.current) {
      const { clientWidth, scrollWidth } = ref.current;
      setIsOverflown(scrollWidth > clientWidth);
    }
  }, []);
  useEffect20(() => {
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, [checkOverflow]);
  return /* @__PURE__ */ jsx160(Tooltip2_default, { title: isOverflown ? `${children2}` : "", children: /* @__PURE__ */ jsx160(
    Text_default,
    {
      ref,
      color: disabled2 ? "currentColor" : hover2 ? "white" : color2,
      fontSize: [null, "14px"],
      overflowX: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      ...rest,
      children: children2
    }
  ) });
}
var Text_default2 = Text;

// src/components/Tickets/Entity/components/Tick.tsx
import { useContext as useContext13 } from "react";
import { jsx as jsx161 } from "react/jsx-runtime";
function Tick2({ ...rest }) {
  const { hover: hover2, selected: selected2, color: color2 } = useContext13(EntityContext_default);
  if (!selected2) {
    return null;
  }
  return /* @__PURE__ */ jsx161(Tick_default, { light: true, fill: hover2 ? "white" : color2, ml: 3, ...rest });
}
var Tick_default3 = Tick2;

// src/components/Tickets/Entity/index.tsx
import { jsx as jsx162 } from "react/jsx-runtime";
function Entity({
  children: children2,
  color: color2 = "default.primary",
  selected: selected2,
  hover: hover2,
  disabled: disabled2,
  linked,
  ...rest
}) {
  return /* @__PURE__ */ jsx162(
    EntityContext_default.Provider,
    {
      value: { color: color2, selected: selected2, hover: hover2, disabled: disabled2, linked },
      children: /* @__PURE__ */ jsx162(Container_default4, { ...rest, children: children2 })
    }
  );
}
Entity.Id = Id_default2;
Entity.Content = Content_default;
Entity.Text = Text_default2;
Entity.Tick = Tick_default3;
var Entity_default = Entity;

// src/components/Tickets/Ticket/index.tsx
import { themeGet as themeGet23 } from "@styled-system/theme-get";
import styled82 from "styled-components";

// src/components/Tickets/Ticket/components/index.tsx
import styled81 from "styled-components";

// src/components/Tickets/Ticket/components/ActionIconButton.tsx
import React84, { useContext as useContext14 } from "react";

// src/components/Tickets/Ticket/TicketContext.tsx
import React83 from "react";
var TicketContext = React83.createContext({});
var TicketContext_default = TicketContext;

// src/components/Tickets/Ticket/components/ActionIconButton.tsx
import { jsx as jsx163 } from "react/jsx-runtime";
var ActionIconButton = React84.forwardRef(
  // eslint-disable-next-line react/prop-types
  ({ children: children2, ...rest }, ref) => {
    const { color: color2 } = useContext14(TicketContext_default);
    return /* @__PURE__ */ jsx163(
      Button_default,
      {
        ref,
        sizeVariant: "xs",
        variant: "secondary",
        px: ["5px", 1],
        height: ["38px", "32px"],
        color: color2,
        ...rest,
        children: children2
      }
    );
  }
);
var ActionIconButton_default = ActionIconButton;

// src/components/Tickets/Ticket/components/Highlight.tsx
import { useContext as useContext15 } from "react";
import { jsx as jsx164 } from "react/jsx-runtime";
function Highlight2({ ...rest }) {
  const { color: color2, isResolved } = useContext15(TicketContext_default);
  return /* @__PURE__ */ jsx164(
    View_default,
    {
      bg: isResolved ? "transparent" : color2,
      height: "calc(100% + 2px)",
      width: "5px",
      position: "absolute",
      top: "-1px",
      left: "-1px",
      bottom: "-1px",
      borderRadius: "4px 0 0 4px",
      ...rest
    }
  );
}
var Highlight_default2 = Highlight2;

// src/components/Tickets/Ticket/components/Id.tsx
import PropTypes39 from "prop-types";
import { jsx as jsx165, jsxs as jsxs88 } from "react/jsx-runtime";
function Id3({ children: children2, ...rest }) {
  return /* @__PURE__ */ jsxs88(Flex_default, { justifyContent: "flex-start", ...rest, children: [
    /* @__PURE__ */ jsx165(
      Id_default,
      {
        fill: "sky.0",
        viewBox: "5 5 12 12",
        height: "11px",
        width: "11px",
        mb: "1px",
        mr: 1
      }
    ),
    /* @__PURE__ */ jsx165(Text_default, { fontSize: "12px", color: "ink.2", children: children2 })
  ] });
}
Id3.propTypes = {
  children: PropTypes39.oneOfType([PropTypes39.number, PropTypes39.string])
};
var Id_default3 = Id3;

// src/components/Tickets/Ticket/components/Title.tsx
import { useContext as useContext16 } from "react";
import { jsx as jsx166 } from "react/jsx-runtime";
function Title7({ ...rest }) {
  const { isResolved } = useContext16(TicketContext_default);
  return /* @__PURE__ */ jsx166(
    Text_default,
    {
      fontWeight: "normal",
      color: isResolved ? "ink.2" : void 0,
      ...rest
    }
  );
}
var Title_default2 = Title7;

// src/components/Tickets/Ticket/components/index.tsx
var Actions4 = styled81(View_default)`
  white-space: nowrap;
`;
Actions4.defaultProps = {
  opacity: [1, 0],
  transition: "all 0.2s"
};
var Indicators = styled81(Flex_default)``;
Indicators.defaultProps = {
  alignSelf: ["unset", "flex-end"],
  justifyContent: "flex-start",
  flexWrap: "wrap",
  bg: "inherit"
};
var Line2 = styled81(Flex_default)``;
Line2.defaultProps = {
  flexDirection: ["column", "row"],
  alignItems: ["flex-start", "center"],
  bg: "inherit"
};

// src/components/Tickets/Ticket/DefaultBuilder.tsx
import { useContext as useContext17, useState as useState26 } from "react";
import { Fragment as Fragment13, jsx as jsx167, jsxs as jsxs89 } from "react/jsx-runtime";
function DefaultBuilder({ data, onAction }) {
  const { isStarHidden, isDeleteHidden } = useContext17(TicketContext_default);
  const [active2, setActive] = useState26();
  const {
    id,
    isStarred,
    isResolved,
    isOverdue,
    title,
    description,
    owners,
    overdueAt,
    overdueAtHumanized,
    uploads,
    typeLabel
  } = data;
  const hasIndicators = description || owners?.length || overdueAt || typeLabel;
  return /* @__PURE__ */ jsxs89(Fragment13, { children: [
    isStarred && /* @__PURE__ */ jsx167(Highlight_default2, {}),
    /* @__PURE__ */ jsx167(Line2, { mb: hasIndicators ? 2 : "-4px", children: /* @__PURE__ */ jsx167(Id_default3, { children: id }) }),
    hasIndicators && /* @__PURE__ */ jsx167(Title_default2, { mb: [3, 1], children: title }),
    /* @__PURE__ */ jsxs89(
      Line2,
      {
        alignItems: !hasIndicators ? ["flex-start", "flex-end"] : void 0,
        children: [
          !hasIndicators && /* @__PURE__ */ jsx167(Title_default2, { mt: 2, mb: [5, 0], children: title }),
          hasIndicators && /* @__PURE__ */ jsxs89(Indicators, { mb: [2, 0], children: [
            !!description && /* @__PURE__ */ jsx167(
              Description_default,
              {
                fill: "sky.0",
                mr: uploads?.length ? 1 : 3,
                mb: [3, 0]
              }
            ),
            !!uploads?.length && /* @__PURE__ */ jsx167(Clip_default, { fill: "sky.0", mr: 2, mb: [3, 0] }),
            !!owners?.length && /* @__PURE__ */ jsx167(AvatarList_default, { mr: 3, mb: [3, 0], children: owners.map((assignee) => /* @__PURE__ */ jsx167(
              Avatar_default,
              {
                name: assignee.name,
                sizeVariant: "fixed",
                bg: "inherit"
              },
              assignee.id
            )) }),
            !!typeLabel && /* @__PURE__ */ jsx167(
              BasicValue_default,
              {
                sizeVariant: "fixed",
                icon: ({ fill: fill2, ...rest }) => /* @__PURE__ */ jsx167(Tag_default, { fill: isResolved ? "sky.0" : fill2, ...rest }),
                mr: 3,
                mb: [3, 0],
                children: typeLabel
              }
            ),
            !!overdueAt && /* @__PURE__ */ jsx167(
              BasicValue_default,
              {
                sizeVariant: "fixed",
                icon: ({ fill: fill2, ...rest }) => /* @__PURE__ */ jsx167(
                  Calendar_default,
                  {
                    fill: isResolved ? "sky.0" : fill2,
                    ...rest
                  }
                ),
                mr: 3,
                invalid: isOverdue,
                mb: [3, 0],
                children: overdueAtHumanized
              }
            )
          ] }),
          /* @__PURE__ */ jsxs89(
            Actions4,
            {
              ...active2 && {
                opacity: 1,
                background: "rgba(255, 255, 255, 0.9)",
                boxShadow: "0px 0px 8px 8px rgba(255, 255, 255, 0.9)"
              },
              children: [
                !isDeleteHidden && /* @__PURE__ */ jsx167(
                  Confirmation_default,
                  {
                    content: "Are you sure you want to delete this ticket?",
                    confirmText: "Delete",
                    onClick: (e) => {
                      e.stopPropagation();
                    },
                    onConfirm: () => {
                      onAction("delete");
                    },
                    onOpenChange: setActive,
                    children: /* @__PURE__ */ jsx167(
                      ActionIconButton_default,
                      {
                        mr: 2,
                        onClick: (e) => {
                          e.stopPropagation();
                        },
                        children: /* @__PURE__ */ jsx167(
                          Trash_default,
                          {
                            fill: "ink.1",
                            height: ["26px", "22px"],
                            width: ["26px", "22px"]
                          }
                        )
                      }
                    )
                  }
                ),
                !isResolved && !isStarHidden && /* @__PURE__ */ jsx167(
                  ActionIconButton_default,
                  {
                    mr: 2,
                    onClick: (e) => {
                      onAction("star");
                      e.stopPropagation();
                    },
                    children: /* @__PURE__ */ jsx167(
                      Star_default,
                      {
                        active: isStarred,
                        fill: isStarred ? "currentColor" : "ink.1",
                        height: ["26px", "22px"],
                        width: ["26px", "22px"]
                      }
                    )
                  }
                ),
                /* @__PURE__ */ jsx167(
                  ActionIconButton_default,
                  {
                    onClick: (e) => {
                      onAction("resolve");
                      e.stopPropagation();
                    },
                    children: isResolved ? /* @__PURE__ */ jsx167(
                      Revert_default,
                      {
                        fill: "ink.1",
                        height: ["26px", "22px"],
                        width: ["26px", "22px"]
                      }
                    ) : /* @__PURE__ */ jsx167(
                      MarkAsDone_default,
                      {
                        fill: "ink.1",
                        height: ["26px", "22px"],
                        width: ["26px", "22px"]
                      }
                    )
                  }
                )
              ]
            }
          )
        ]
      }
    )
  ] });
}
var DefaultBuilder_default = DefaultBuilder;

// src/components/Tickets/Ticket/index.tsx
import { jsx as jsx168 } from "react/jsx-runtime";
var StyledBox = styled82(Box_default)`
  @media (min-width: ${themeGet23("breakpoints.0")}) {
    :hover {
      ${Actions4} {
        opacity: 1;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 0px 0px 8px 8px rgba(255, 255, 255, 0.9);
      }
    }
  }
`;
StyledBox.defaultProps = {
  p: null,
  px: 5,
  py: 3,
  position: "relative",
  boxShadow: 1,
  cursor: "pointer",
  transition: "all 0.2s"
};
function Ticket({
  children: children2,
  data,
  Builder: Builder2 = DefaultBuilder_default,
  color: color2 = "default.primary",
  isResolved,
  isStarHidden,
  isDeleteHidden,
  onAction,
  ...rest
}) {
  return /* @__PURE__ */ jsx168(
    TicketContext_default.Provider,
    {
      value: { color: color2, isResolved, isStarHidden, isDeleteHidden },
      children: /* @__PURE__ */ jsx168(
        StyledBox,
        {
          bg: isResolved ? "sky.3" : "white",
          _hover: {
            bg: isResolved ? "sky.3" : "sky.4"
          },
          ...rest,
          children: children2 || (data ? /* @__PURE__ */ jsx168(Builder2, { data, onAction: onAction || (() => {
          }) }) : null)
        }
      )
    }
  );
}
Ticket.Highlight = Highlight_default2;
Ticket.Id = Id_default3;
Ticket.Title = Title_default2;
Ticket.Indicators = Indicators;
Ticket.Actions = Actions4;
Ticket.Line = Line2;
Ticket.ActionIconButton = ActionIconButton_default;
Ticket.Context = TicketContext_default;
var Ticket_default = Ticket;

// src/components/Tickets/TicketDetails/components/index.tsx
import styled86 from "styled-components";

// src/components/Tickets/TicketDetails/components/Description.tsx
import styled83 from "styled-components";
import { jsx as jsx169 } from "react/jsx-runtime";
var Base4 = styled83(TextareaAutosize_default)`
  ${variants_default({
  variant: {
    filled: {},
    transparent: {
      "&:not(:focus):not(:hover):not(:placeholder-shown)": {
        bg: "white",
        borderColor: "transparent"
      }
    }
  }
})}
`;
Base4.defaultProps = {
  minRows: 2,
  maxRows: Infinity,
  width: "100%",
  fontSize: ["16px", "16px"],
  placeholder: "Enter a description...",
  variant: "transparent"
};
function Description3({ ...rest }) {
  return /* @__PURE__ */ jsx169(Base4, { ...rest });
}
var Description_default2 = Description3;

// src/components/Tickets/TicketDetails/components/Id.tsx
import { useState as useState27 } from "react";
import { jsx as jsx170, jsxs as jsxs90 } from "react/jsx-runtime";
function copy(text) {
  const el = document.createElement("textarea");
  el.value = text;
  el.setAttribute("readonly", "");
  el.style.position = "absolute";
  el.style.left = "-9999px";
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
}
function Id4({ children: children2, ...rest }) {
  const [text, setText] = useState27("Click to copy ticket URL");
  return /* @__PURE__ */ jsx170(Tooltip2_default, { placement: "right", title: text, children: /* @__PURE__ */ jsxs90(
    Flex_default,
    {
      display: "inline-flex",
      justifyContent: "flex-start",
      cursor: "pointer",
      onClick: () => {
        copy(window.location.href);
        const prevText = text;
        setText("Copied!");
        setTimeout(() => {
          setText(prevText);
        }, 2e3);
      },
      ...rest,
      children: [
        /* @__PURE__ */ jsx170(Id_default, { fill: "currentColor", mr: 1 }),
        /* @__PURE__ */ jsx170(Text_default, { fontSize: "14px", color: "currentColor", children: children2 })
      ]
    }
  ) });
}
var Id_default4 = Id4;

// src/components/Tickets/TicketDetails/components/MetaItem.tsx
import styled84 from "styled-components";
import { jsx as jsx171, jsxs as jsxs91 } from "react/jsx-runtime";
var StyledText = styled84(Text_default)`
  white-space: nowrap;
`;
function MetaItem({ title, children: children2, ...rest }) {
  return /* @__PURE__ */ jsxs91(View_default, { mb: 2, ...rest, children: [
    title && /* @__PURE__ */ jsx171(StyledText, { fontSize: ["14px", "12px"], color: "ink.2", mr: [0, 1], children: title }),
    /* @__PURE__ */ jsx171(StyledText, { fontSize: ["16px", "12px"], children: children2 })
  ] });
}
var MetaItem_default = MetaItem;

// src/components/Tickets/TicketDetails/components/Title.tsx
import styled85 from "styled-components";
var Title8 = styled85(TextareaAutosize_default)`
  ${variants_default({
  variant: {
    filled: {},
    transparent: {
      "&:not(:focus):not(:hover)": {
        bg: "white",
        borderColor: "transparent"
      }
    }
  }
})}
`;
Title8.defaultProps = {
  minRows: 1,
  maxRows: Infinity,
  maxLength: 100,
  width: "100%",
  fontSize: ["22px", "18px"],
  placeholder: "Enter a title\u2026",
  variant: "transparent",
  fontWeight: "semibold"
};
var Title_default3 = Title8;

// src/components/Tickets/TicketDetails/components/index.tsx
var Actions5 = styled86(View_default)``;
Actions5.defaultProps = {
  display: "flex",
  flexDirection: "column"
};
var ActionButton = styled86(Button_default)``;
ActionButton.defaultProps = {
  sizeVariant: "xs",
  variant: "secondary",
  color: "ink.1",
  width: "100%",
  maxWidth: ["100%", "200px"],
  mb: 2
};
var Main = styled86(View_default)``;
Main.defaultProps = {
  flex: [null, "1"],
  minWidth: 0
};
var Sidebar = styled86(View_default)``;
Sidebar.defaultProps = {
  flex: [null, "0"],
  display: "flex",
  minWidth: "160px"
};
var Meta = styled86(Flex_default)``;
Meta.defaultProps = {
  flexWrap: "wrap",
  alignItems: "flex-start",
  justifyContent: "flex-start"
};
var State2 = styled86(View_default)``;
State2.defaultProps = {
  pl: 2,
  pr: 3,
  py: "6px",
  border: 1,
  borderRadius: 1,
  display: "inline-flex",
  height: "36px",
  _notLast: {
    mr: 3
  }
};

// src/components/Tickets/TicketDetails/TicketContext.tsx
import React89 from "react";
var TicketContext2 = React89.createContext({});
var TicketContext_default2 = TicketContext2;

// src/components/Tickets/TicketDetails/index.tsx
import { jsx as jsx172 } from "react/jsx-runtime";
function TicketDetails({ children: children2, ...rest }) {
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    /* @__PURE__ */ jsx172(TicketContext_default2.Provider, { value: {}, children: /* @__PURE__ */ jsx172(Flex_default, { alignItems: "stretch", ...rest, children: children2 }) })
  );
}
TicketDetails.Id = Id_default4;
TicketDetails.Title = Title_default3;
TicketDetails.Description = Description_default2;
TicketDetails.Actions = Actions5;
TicketDetails.Main = Main;
TicketDetails.ActionButton = ActionButton;
TicketDetails.Meta = Meta;
TicketDetails.MetaItem = MetaItem_default;
TicketDetails.Sidebar = Sidebar;
TicketDetails.State = State2;
var TicketDetails_default = TicketDetails;

// src/components/Tickets/TicketList.tsx
import React90 from "react";
import { jsx as jsx173 } from "react/jsx-runtime";
function TicketList({ children: children2, spacing, ...rest }) {
  const validChildrenArray = React90.Children.toArray(children2).filter(
    React90.isValidElement
  );
  return /* @__PURE__ */ jsx173(View_default, { ...rest, children: validChildrenArray.map((child, i) => {
    const isFirstChild = i === 0;
    const isLastChild = i === validChildrenArray.length - 1;
    let styleProps;
    if (spacing) {
      styleProps = {
        mt: isFirstChild ? null : spacing
      };
    } else {
      styleProps = {
        mt: i !== 0 && "-1px",
        borderRadius: isFirstChild ? "4px 4px 0 0" : isLastChild ? "0 0 4px 4px" : 0
      };
    }
    return React90.cloneElement(child, {
      ...styleProps,
      ...child.props
    });
  }) });
}
var TicketList_default = TicketList;

// src/components/Toggle.tsx
import { Component as Component16 } from "react";
var Toggle2 = class extends Component16 {
  constructor(props) {
    super(props);
    this.handleToggle = () => {
      this.setState(({ value }) => ({ value: !value }));
    };
    this.state = {
      value: !!props.defaultValue
    };
  }
  componentDidUpdate({ defaultValue: prevDefaultValue }) {
    const { defaultValue } = this.props;
    if (defaultValue !== void 0 && defaultValue !== prevDefaultValue) {
      this.handleToggle();
    }
  }
  render() {
    const { children: children2 } = this.props;
    const { value } = this.state;
    return children2({
      value,
      toggle: this.handleToggle
    });
  }
};
var Toggle_default = Toggle2;

// src/components/Tooltip.tsx
import { Tooltip as BaseTooltip } from "react-tippy";
import { createGlobalStyle as createGlobalStyle2, ThemeProvider as ThemeProvider2, useTheme } from "styled-components";
import { Fragment as Fragment14, jsx as jsx174, jsxs as jsxs92 } from "react/jsx-runtime";
var TooltipStyle = createGlobalStyle2`
  [data-tooltipped]{
    display: inline-flex !important;
  }
  .tippy-tooltip {
    background: #f9fafb !important;
    border: 1px solid #c4cdd5 !important;
    padding: 12px 16px !important;
    color: #454f5b !important;
    border-radius: 4px !important;
    box-shadow: 0 4px 8px -4px rgba(0, 0, 0, 0.2) !important;
    max-width: none;
    pointer-events: auto;
  }
  .tippy-popper {
    ${({ tippyPopperStyle }) => tippyPopperStyle?.maxWidth && `max-width: ${tippyPopperStyle.maxWidth}`}
  }
  .tippy-popper .leave {
    opacity: 0;
  }
  .arrow-regular{
    width: 9px !important;
    height: 9px !important;
    background: #f9fafb !important;
    border-bottom: 1px solid #c4cdd5 !important;
    border-left: 1px solid #c4cdd5 !important;
    border-top: none !important;
    border-right: none !important;
  }
  .tippy-popper[x-placement^=top] [x-arrow] {
    transform: rotate(-45deg);
    bottom: -6px !important;
  }
  .tippy-popper[x-placement^=bottom] [x-arrow] {
    transform: rotate(135deg);
    top: -6px !important;
  }
  .tippy-popper[x-placement^=left] [x-arrow] {
    transform: rotate(225deg);
    right: -6px !important;
  }
  .tippy-popper[x-placement^=right] [x-arrow] {
    transform: rotate(45deg);
    left: -6px !important;
  }
  body.tippy-touch{
    cursor: default !important;
  }
`;
function Tooltip({
  children: children2,
  component,
  onShow = () => {
  },
  onHide = () => {
  },
  tippyPopperStyle,
  ...rest
}) {
  const theme2 = useTheme();
  return /* @__PURE__ */ jsxs92(Fragment14, { children: [
    /* @__PURE__ */ jsx174(TooltipStyle, { tippyPopperStyle }),
    /* @__PURE__ */ jsx174(
      BaseTooltip,
      {
        html: /* @__PURE__ */ jsx174(ThemeProvider2, { theme: theme2, children: component }),
        position: "bottom",
        arrow: true,
        animation: "none",
        duration: 0,
        hideDuration: 0,
        distance: 20,
        trigger: "mouseenter",
        useContext: true,
        onShow: () => {
          document.body.classList.contains("tippy-touch") && document.body.setAttribute("style", "cursor: pointer !important");
          onShow();
        },
        onHide: () => {
          document.body.classList.contains("tippy-touch") && document.body.setAttribute("style", "cursor: default !important");
          onHide();
        },
        ...rest,
        children: children2
      }
    )
  ] });
}
var Tooltip_default = Tooltip;

// src/index.ts
var Icons = Icons_exports;
var TableCard = TableCard_exports;
export {
  Accordion_default as Accordion,
  AddButton_default as AddButton,
  AddressSelect_default as AddressSelect,
  Alert_default2 as Alert,
  AnimateHeight_default as AnimateHeight,
  AssigneeSelector_default as AssigneeSelector,
  Attributes_default as Attributes,
  Avatar_default as Avatar,
  AvatarList_default as AvatarList,
  Banner_default as Banner,
  BasicValue_default as BasicValue,
  Box_default as Box,
  Breadcrumb_default as Breadcrumb,
  Button_default as Button,
  ButtonGroup_default as ButtonGroup,
  Caption,
  Card_default as Card,
  Checkbox_default as Checkbox,
  Clickable,
  CollapseSection_default as CollapseSection,
  Comment_default as Comment,
  CommentList_default as CommentList,
  Comments_default as Comments,
  CompanySelect_default as CompanySelect,
  ConditionalFields_default as ConditionalFields,
  Confirmation_default as Confirmation,
  Container_default as Container,
  Create_default as Create,
  Currency_default as CurrencyInput,
  DescriptionList as DL,
  DataTable_default as DataTable,
  Date_default2 as DateInput,
  DatePicker_default as DatePicker,
  DateSelector_default as DateSelector,
  DateTime_default as DateTime,
  DayPicker_default as DayPicker,
  DescriptionList_default as DescriptionList,
  Entity_default as Entity,
  EntitySelector_default as EntitySelector,
  ExpansionPanel_default as ExpansionPanel,
  Feed_default as Feed,
  Field_default as Field,
  FieldGroup_default as FieldGroup,
  FileInput_default as FileInput,
  FileUpload_default as FileUpload,
  Flex_default as Flex,
  Funnelbar_default as Funnelbar,
  GridTable,
  GridTableCell,
  GridTableRow,
  Heading,
  Icons,
  InteractiveField_default as InteractiveField,
  Modal,
  Module_default as Module,
  MultiActionButton_default as MultiActionButton,
  NativeSelect,
  Panel_default as Panel,
  Paragraph,
  Password_default as PasswordInput,
  Percentage_default as PercentageInput,
  Phone_default2 as PhoneInput,
  Placeholder_default as Placeholder,
  Popover_default as Popover,
  Progressbar_default as Progressbar,
  Prompt,
  Radio_default as Radio,
  default2 as ReactDayPicker,
  Context as ScarfContext,
  ScarfProvider_default as ScarfProvider,
  Select_default2 as Select,
  Selector_default as Selector,
  Settings_default as Settings,
  Simple_default as SimpleModal,
  Spinner_default2 as Spinner,
  StateFunnel_default as StateFunnel,
  StripeInput_default as StripeInput,
  Subheading,
  Subtitle,
  Switch_default as Switch,
  TBody,
  TD,
  TH,
  THead,
  TR,
  TabScreens_default as TabScreens,
  TabbedPanel_default as TabbedPanel,
  TabbedItem_default as TabbedRadioItem,
  Table,
  TableCard,
  Tabs_default2 as Tabs,
  Tag_default2 as Tag,
  Text_default as Text,
  Input_default as TextInput,
  Textarea_default as Textarea,
  TextareaAutosize_default as TextareaAutosize,
  Ticket_default as Ticket,
  TicketDetails_default as TicketDetails,
  TicketList_default as TicketList,
  Time_default as TimeInput,
  Title,
  Toggle_default as Toggle,
  Tooltip_default as Tooltip,
  Tooltip2_default as Tooltip2,
  TypeSelector_default as TypeSelector,
  View_default as View,
  alterColor_default as alterColor,
  debounce_default as debounce,
  propTypes_default as propTypes,
  theme_default as theme,
  themeGet24 as themeGet,
  useDataTable,
  useDesktop,
  useFormInput_default as useFormInput,
  useIntersection_default as useIntersection,
  useJSONQueryStringReducer_default as useJSONQueryStringReducer,
  useLocale,
  useMatchMedia_default as useMatchMedia,
  useMobile,
  usePromise_default as usePromise,
  useScarfContext,
  useSearchQueryState_default as useSearchQueryState
};
//# sourceMappingURL=index.es.js.map